 <template>
<div class="order-form-wrapper">
<div class="order-head cleared">
  <div style="font-size: 28px;font-weight: 600;display: none;">В заказе {{ products ? products.length : 0 }} товара</div>
            <div class="order-head__flex ft-lt cleared">
              
               <div class="left_head">

              
                <div class="order-num ft-lt">
                                            Заказ <span>{{formData && formData.number ? formData.number : ''}}</span>
                                    </div>
                                    <div class="s-and-a ft-lt">
                          <div class="order-sum">
                            <div class="s-and-a__discr gray italic">Сумма заказа</div>
                            <div class="red value">{{ grandTotal.toLocaleString() }}&nbsp;<span class="currency-symbol byn">руб.</span></div>
                        </div>
                    </div>
                    <div class="s-and-a ft-lt">
                        <div class="arr">
                            <div class="s-and-a__discr gray italic">Поступил</div>
                            <div class="value value_date" v-if="formData.createdAt">{{ getCurentDates(formData.createdAt) }}</div>
                        </div>
                    </div>
                    <div class="s-and-a ft-lt" v-if="callSiteLabel">
                        <div class="arr">
                            <div class="s-and-a__discr gray italic">Сайт звонка</div>
                            <div class="value">{{ callSiteLabel }}</div>
                        </div>
                    </div>
                    <div class="s-and-a ft-lt visitor-lookup-inline">
                        <div class="arr">
                            <div class="s-and-a__discr gray italic">Код клиента</div>
                            <div class="visitor-lookup-inline__row">
                              <input
                                id="visitorLookupCodeInput"
                                v-model="visitorLookupCode"
                                type="text"
                                class="visitor-lookup-inline__input"
                                maxlength="5"
                                placeholder="747A1"
                                autocomplete="off"
                                @keyup.enter="openVisitorLookup"
                              />
                              <button
                                type="button"
                                class="visitor-lookup-inline__btn"
                                @click="openVisitorLookup"
                              >Найти</button>
                            </div>
                        </div>
                    </div>

                    </div>

<div class="right_head">

<span
  v-if="hintMode"
  class="brak-hint-label"
  :class="{ 'brak-hint-label_ready': hasCallWithTranscription, 'brak-hint-label_loading': hintLoading }"
  :title="hintLabelTitle"
  @click="openCallHint"
>
  подсказка
</span>

<div>
    <!-- Блок, на который происходит клик -->
    <div 
      @click="togglePopupStatus" 
      class="message-indic dib align-middle" v-if="formData.statusComment"
    >
      <!-- Вложенный блок с комментариями -->
      <div 
        v-if="showPopupStatus && formData.statusComment" 
        class="popup-comment-box"
      >
        <div class="comment-date gray fs11 pb10">
          {{ formData.statusUpdatedAt }}
        </div>
        <div class="comment-text fs12 lh18 black">
          {{ formData.statusComment }}
        </div>
      </div>
    </div>
  </div>

  <div class="status head__col">
    <input
      type="hidden"
      id="intaro_crmbundle_ordertype_status"
      name="intaro_crmbundle_ordertype[status]"
      autocomplete="disabled"
      :value="selectedStatusOrder.value"
    />

    <div class="dib align-middle">
      <!-- Цветовые индикаторы статусов -->
     
<div :class="[selectedStatusOrder.class, 'pseudo-select']" :style="{ backgroundColor: selectedStatusOrder.color }">
  <div
    id="select"
    class="check"
    :class="{ 'is-opened': isOpen, 'status-locked': !isStatusChangeAllowed }"
    @click="toggleDropdownStatus"
  >
    <div class="stat-wrap">
      <div class="stat-img"></div>
      {{ selectedStatusOrder.label }}
      <div v-if="!isStatusChangeAllowed" class="status-lock-icon" title="Редактирование статуса запрещено">
        🔒
      </div>
    </div>
  </div>
  <ul v-if="isOpen" class="options">
    <ul
      v-for="(group, groupIndex) in filteredStatusGroupsOrder"
      :key="`group-${groupIndex}-${group.group}`"
      :class="[group.group, 'options__group']"
      :data-group-wrap="group.group"
      :style="{ backgroundColor: group.color }"
    >
      <li
        v-for="(option, optionIndex) in group.options"
        :key="`group-${groupIndex}-option-${optionIndex}-${option.value}`"
        :class="[option.class, 'options__status', { disabled: option.disabled }]"
        :data-status="option.value"
        :data-group="group.group"
        @click.stop="selectStatusOrder(option)"
      >
        {{ option.label }}
      </li>
    </ul>
  </ul>
</div>

    </div>
  </div>



 <!-- Модальное окно -->
    <div v-if="isModalStatusVisible" class="modal-overlay">
      <div class="omnica-modal-window omnica-modal-window_popup omnica-popper-container">
        <div class="omnica-modal-window__header"><!----> <div id="omnica-modal-window-24-title" class="omnica-modal-window__title">Смена статуса</div> <div aria-label="Esc" role="button" class="omnica-modal-window__close" @click="closeModalStatus"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="omnica-popper-target" style="width: 100%;"><path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg></div></div>



        <div class="omnica-modal-window__content"> 
          <div class="mb-6">
            <div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_small-QTWp UiText-text_accent-nhXJ text_X0OGL">
            Новый статус
        </div> 
        <div class="status_gL3ii status_complete_sa6B2 md_ZnSCb">
         
          <div class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp title_I6f5a">
        {{ pendingStatus.label }}
    </div>
  </div>
</div>
<div
  v-if="pendingStatus && isAgreementDateRequiredStatus(pendingStatus.value)"
  class="mb-6 status-modal-agreement-date"
>
  <div class="text_X0OGL text_comment_x9UJJ">
    <div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_small-QTWp UiText-text_accent-nhXJ">
      Дата согласования <span class="required">*</span>
    </div>
  </div>
  <date-picker
    v-model="statusModalAgreementDate"
    type="datetime"
    lang="ru"
    :format="'DD.MM.YYYY HH:mm'"
    placeholder="Дата и время"
    :input-class="'input-field' + (errors.dataSoglasovaniia ? ' is-invalid' : '')"
    @input="errors.dataSoglasovaniia = null"
  ></date-picker>
  <span v-if="errors.dataSoglasovaniia" class="error-message">{{ errors.dataSoglasovaniia }}</span>
</div>
<div>
  <div class="text_X0OGL text_comment_x9UJJ"><div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_small-QTWp UiText-text_accent-nhXJ">Комментарий</div> 
  <div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_tiny-1_wc">Опционально</div>
</div> 
<div class="UiTextarea-textarea-wrap-2K2Y" style="height: 192px;">
  <div class="UiTextarea-textarea-2DUR UiTextarea-textarea_default-26FY">


    <textarea id="ui-textarea-3"  rows="1" class="UiTextarea-textarea__area-1IwX" v-model="statusComment" placeholder="Введите комментарий"></textarea></div></div></div> 


    </div>

      <div class="omnica-modal-window__footer"><div><button type="button" class="omnica-button omnica-button_primary omnica-button_sm omnica-button_default omnica-button_success omnica-button_has-leading-icon omnica-button_ellipsis" @click="confirmStatus"><span class="omnica-button__inner"><span class="omnica-button__icon"><svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" title="" class="UiIcon-icon-2pR-"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.792 6.965a.77.77 0 01-.021 1.075l-9.815 9.607a1.224 1.224 0 01-1.714.006l-4.01-3.878a.77.77 0 01-.028-1.074l.684-.736a.735.735 0 011.053-.028l3.15 3.046 8.96-8.771a.735.735 0 011.053.022l.688.731z"></path></svg></span><span class="omnica-button__text">
                Сохранить
            </span></span></button> <button type="button" class="omnica-button omnica-button_primary omnica-button_sm omnica-button_default omnica-button_ellipsis" style="margin-left:20px" @click="confirmStatus(true)"><span class="omnica-button__inner"><span class="omnica-button__text">Сохранить и выйти</span></span></button> <button type="button" class="omnica-button omnica-button_secondary omnica-button_sm omnica-button_default omnica-button_ellipsis" @click="closeModalStatus"><span class="omnica-button__inner"><span class="omnica-button__text">
                Отменить
            </span></span></button></div></div>


      </div>
    </div>






 <div class="hm-right">
  <button
    class="white small btn-save-back btn_split-hov btn"
    @click="saveFormAndCollapse"
  >
    Свернуть
  </button>
  <button
    class=" btn-close-order "
    @click="deleteForm"
  >
   
  </button>
  </div>

</div>


 </div>
                    </div>



<div class="order-head-wrap">
  <div class="order-header">
    <div class="m-box simple head">
      
<div class="inside-task-manager">
    <!-- Панель задач -->
    <span v-if="tasks.length > 0" id="has-order-tasks-panel">
      <a
        title="Список задач"
        href="#"
        data-type="reminder-bk"
        class="independent-popup-open js-order-tasks-list-link inside-task-manager__link"
        @click="openTask"
      >
        <span data-type="reminder-add-bk" class="inside-task-manager-creator"></span>
        <span class="inside-task-manager__text">Задачи</span>
      </a>

      <span class="inside-task-manager-count">
        <span>{{ activeTasks.length }}</span> 
        <span >/{{ inactiveTasks.length }}</span>
      </span>
    </span>

    <!-- Панель "Нет задач" -->
    <span v-else id="no-order-tasks-panel">
      <span data-type="reminder-add-bk" class="inside-task-manager-creator"></span>
      <span class="inside-task-manager__text">Нет задач</span>
    </span>

    <span class="btn white btn_plus btn_plus_order_task_manager" @click="openSidebar"></span>
  </div>

  <!-- Блок печати -->
  <ul class="order-actions__list">
    <li class="print dropdown dropdown-children dropdown-down down left" @click.stop="togglePrintDropdown">
      <a href="javascript:void(0);" @click.stop="togglePrintDropdown">Печать</a>
      <div class="dropdown-wrapper ul-scroll-dropdown-wrapper" v-if="printDropdownOpen" style="display: block !important;">
        <ul>
          <li v-for="template in printTemplates" :key="template.id">
            <a 
              class="no-pjax" 
              target="_blank" 
              href="javascript:void(0);"
              @click="printDocument(template.id)"
            >
              {{ template.name }}
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>

  <!-- Кнопка истории -->
  <div class="attachments-btn" id="status-history-popup-link">
    <div class="attachments-icon attachments-icon_history attachments-btn__icon"></div>
    <span class="attachments-btn__text" @click="openModalhistory">История</span>
  </div>


<div class="order-viewers">
  <span v-if="orderViewers.length">
    Сейчас заказ просматривают: {{ orderViewers.length }}
    <template v-if="orderViewers.length === 1"> человек</template>
    <template v-else> человека</template>
    <!-- Вывод имен менеджеров -->
    <div class="viewers-list">
      (<span v-for="(viewer, index) in orderViewers" :key="`${viewer.id}-${index}`">
        {{ viewer.label }}<span v-if="index < orderViewers.length - 1">, </span>
      </span>)
    </div>
  </span>
  <span v-else>
    
  </span>
</div>
                        
<div class="copy_order" @click.stop="toggleCopyDropdown">
  Копировать заказ
  <div v-if="copyDropdownOpen" class="copy_order__dropdown" @click.stop>
    <button
      v-for="opt in copyOrderModes"
      :key="opt.id"
      type="button"
      class="copy_order__option"
      :title="opt.description"
      @click="copyOrder(opt.id)"
    >
      <span class="copy_order__option-title">{{ opt.title }}</span>
      <span class="copy_order__option-desc">{{ opt.description }}</span>
    </button>
  </div>
</div> 

<!-- Правая часть с статусом и кнопками -->
<div class="right_head_sticky">
  <div>
    <!-- Блок, на который происходит клик -->
    <div 
      @click="togglePopupStatus" 
      class="message-indic dib align-middle" v-if="formData.statusComment"
    >
      <!-- Вложенный блок с комментариями -->
      <div 
        v-if="showPopupStatus && formData.statusComment" 
        class="popup-comment-box"
      >
        <div class="comment-date gray fs11 pb10">
          {{ formData.statusUpdatedAt }}
        </div>
        <div class="comment-text fs12 lh18 black">
          {{ formData.statusComment }}
        </div>
      </div>
    </div>
  </div>

  <div class="status head__col">
    <input
      type="hidden"
      id="intaro_crmbundle_ordertype_status"
      name="intaro_crmbundle_ordertype[status]"
      autocomplete="disabled"
      :value="selectedStatusOrder.value"
    />

    <div class="dib align-middle">
      <!-- Цветовые индикаторы статусов -->
     
<div :class="[selectedStatusOrder.class, 'pseudo-select']" :style="{ backgroundColor: selectedStatusOrder.color }">
  <div
    id="select"
    class="check"
    :class="{ 'is-opened': isOpen, 'status-locked': !isStatusChangeAllowed }"
    @click="toggleDropdownStatus"
  >
    <div class="stat-wrap">
      <div class="stat-img"></div>
      {{ selectedStatusOrder.label }}
      <div v-if="!isStatusChangeAllowed" class="status-lock-icon" title="Редактирование статуса запрещено">
        🔒
      </div>
    </div>
  </div>
  <ul v-if="isOpen" class="options">
    <ul
      v-for="(group, groupIndex) in filteredStatusGroupsOrder"
      :key="`group-${groupIndex}-${group.group}`"
      :class="[group.group, 'options__group']"
      :data-group-wrap="group.group"
      :style="{ backgroundColor: group.color }"
    >
      <li
        v-for="(option, optionIndex) in group.options"
        :key="`group-${groupIndex}-option-${optionIndex}-${option.value}`"
        :class="[option.class, 'options__status', { disabled: option.disabled }]"
        :data-status="option.value"
        :data-group="group.group"
        @click.stop="selectStatusOrder(option)"
      >
        {{ option.label }}
      </li>
    </ul>
  </ul>
</div>

    </div>
  </div>

  <div class="hm-right">
    <button
      class="white small btn-save-back btn_split-hov btn"
      @click="saveFormAndCollapse"
    >
      Свернуть
    </button>
    <button
      class=" btn-close-order "
      @click="deleteForm"
    >
     
    </button>
  </div>
</div>
       

    </div>
  </div>
  
  <!-- Навигация по блокам -->
  <div class="order-navigation">
    <div class="order-navigation__order-number" v-if="isSticky">
      Заказ <span>{{ formData.number }}</span>
    </div>
    <div class="order-navigation__list">
      <a 
        v-for="section in navigationSections" 
        :key="section.id"
        :href="`#${section.id}`"
        :class="['order-navigation__item', { 'active': activeSection === section.id }]"
        @click.prevent="scrollToSection(section.id)"
      >
        {{ section.title }}
      </a>
    </div>
  </div>
</div>

<!-- Модальное окно для смены статуса -->
<div v-if="isModalStatusVisible" class="modal-overlay">
  <div class="omnica-modal-window omnica-modal-window_popup omnica-popper-container">
    <div class="omnica-modal-window__header"><!----> <div id="omnica-modal-window-24-title" class="omnica-modal-window__title">Смена статуса</div> <div aria-label="Esc" role="button" class="omnica-modal-window__close" @click="closeModalStatus"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="omnica-popper-target" style="width: 100%;"><path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg></div></div>

    <div class="omnica-modal-window__content"> 
      <div class="mb-6">
        <div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_small-QTWp UiText-text_accent-nhXJ text_X0OGL">
        Новый статус
      </div> 
      <div class="status_gL3ii status_complete_sa6B2 md_ZnSCb">
        <div class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp title_I6f5a">
          {{ pendingStatus ? pendingStatus.label : '' }}
        </div>
      </div>
    </div>
    <div
      v-if="pendingStatus && isAgreementDateRequiredStatus(pendingStatus.value)"
      class="mb-6 status-modal-agreement-date"
    >
      <div class="text_X0OGL text_comment_x9UJJ">
        <div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_small-QTWp UiText-text_accent-nhXJ">
          Дата согласования <span class="required">*</span>
        </div>
      </div>
      <date-picker
        v-model="statusModalAgreementDate"
        type="datetime"
        lang="ru"
        :format="'DD.MM.YYYY HH:mm'"
        placeholder="Дата и время"
        :input-class="'input-field' + (errors.dataSoglasovaniia ? ' is-invalid' : '')"
        @input="errors.dataSoglasovaniia = null"
      ></date-picker>
      <span v-if="errors.dataSoglasovaniia" class="error-message">{{ errors.dataSoglasovaniia }}</span>
    </div>
    <div>
      <div class="text_X0OGL text_comment_x9UJJ"><div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_small-QTWp UiText-text_accent-nhXJ">Комментарий</div> 
      <div class="UiText-text-2_z8 UiText-text_gray-3-JE UiText-text_tiny-1_wc">Опционально</div>
    </div> 
    <div class="UiTextarea-textarea-wrap-2K2Y" style="height: 192px;">
      <div class="UiTextarea-textarea-2DUR UiTextarea-textarea_default-26FY">
        <textarea id="ui-textarea-3" rows="1" class="UiTextarea-textarea__area-1IwX" v-model="statusComment" placeholder="Введите комментарий"></textarea>
      </div>
    </div> 
  </div>
  </div>

  <div class="omnica-modal-window__footer">
    <div>
      <button type="button" class="omnica-button omnica-button_primary omnica-button_sm omnica-button_default omnica-button_success omnica-button_has-leading-icon omnica-button_ellipsis" @click="confirmStatus">
        <span class="omnica-button__inner">
          <span class="omnica-button__icon"><svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" title="" class="UiIcon-icon-2pR-"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.792 6.965a.77.77 0 01-.021 1.075l-9.815 9.607a1.224 1.224 0 01-1.714.006l-4.01-3.878a.77.77 0 01-.028-1.074l.684-.736a.735.735 0 011.053-.028l3.15 3.046 8.96-8.771a.735.735 0 011.053.022l.688.731z"></path></svg></span>
          <span class="omnica-button__text">Сохранить</span>
        </span>
      </button>
      <button type="button" class="omnica-button omnica-button_primary omnica-button_sm omnica-button_default omnica-button_ellipsis" style="margin-left:20px" @click="confirmStatus(true)">
        <span class="omnica-button__inner">
          <span class="omnica-button__text">Сохранить и выйти</span>
        </span>
      </button>
      <button type="button" class="omnica-button omnica-button_secondary omnica-button_sm omnica-button_default omnica-button_ellipsis" @click="closeModalStatus">
        <span class="omnica-button__inner">
          <span class="omnica-button__text">Отменить</span>
        </span>
      </button>
    </div>
  </div>
  </div>
</div>

<OmnicaSidebar
  v-if="managers.length > 0" 
  :visible="sidebarVisible"
  :orderId="formData.number"
  :orderIds="formData.id"
  :managers="this.managers_update"
  @taskupdate="fetchTasks"
  @close="closeSidebar"
  @submit="handleSubmit"
/>


<DoubleModal
  :visible="showDoubleModal"
  :doubleArray="doubleArray"
  :stores="this.sites"
  :phone="formData.phone"
  @close="showDoubleModal = false"
/>    



<OmnicaTask
  v-if="tasks.length > 0"
  :visible="taskVisible"
  :orderId="formData.number"
  :tasks="tasks"
  :OrderIdtsk="this.$route.params.orderId"
  :openSidebar="openSidebar"
  :openEditTask="openEditTask"
  @taskupdate="fetchTasks"
  @close="closeTask"
/>




<OmnicaEditTask
  v-if="tasks.length > 0"
  :visible="taskEditVisible"
  :orderId="formData.number"
  :tasks="tasks"
  :idOrder="this.$route.params.orderId"
  :openSidebar="openSidebar"
  :editTaskid="editTaskid"
  :managers="this.managers_update"
  @close="closeEditTask"
/>


 <div class="m-box m-box__template-group-main mn-or-info">   
        <div id="order-common" class="collapse-section template-block" data-template-block-code="common">
        <div class="collapse-section__head">
            <div class="collapse-section__title">Основное</div>

            <div class="collapse-section__head-col">
                <div class="collapse-section__head-content"></div>
                <div class="section-error" v-if="error">
                    <div class="section-error__icon">
                        <svg class="svg-icon">
                            <use xlink:href="/build/icons.03e7bd82.svg#error_outlined"></use>
                        </svg>
                    </div>
                    <div class="section-error__text" v-if="!isFieldFilled">Не заполнено обязательное поле</div>
                </div>
                <div class="collapse-section__btn" @click="toggleSection">
                    <svg class="svg-icon">
                        <use :xlink:href="sectionExpanded ? '/build/icons.03e7bd82.svg#chevron_down' : '/build/icons.03e7bd82.svg#chevron_up'"></use>
                    </svg>
                </div>
            </div>

            
            <div class="whereClient" v-if="hasPageVisitHistory" @click="visibleWhere">
              <div>Посещение сайта</div>
              <div class="whereBlock" v-if="isVisibleWhere" @click.stop>
                <div v-if="pageHistoryCustomField" class="whereBlock__custom">
                  <div class="whereBlock__title">Страницы (vision_site):</div>
                  <pre class="whereBlock__pre">{{ pageHistoryCustomField }}</pre>
                </div>
                <div v-if="curWhereText(formData.customerComment)">Страницы из комментария:<br>
                {{ curWhereText(formData.customerComment) }}</div>
              </div>
            </div>
            


        </div>

        <div  class="collapse-section__body">
            <div class="bk">
                <!-- Страна -->
                <div id="country-text" class="input-group cleared" style="display:none;">
                    <label for="country">Страна</label>
                    <v-select :options="countries" v-model="formData.country" label="label" placeholder="Выберите страну"></v-select>
                </div>

             

                 <!-- Тип заказа -->
                <div class="input-group cleared">
                    <label for="orderType" class="required">Тип заказа</label>
                    <v-select 
                        :options="orderTypes" 
                        v-model="formData.orderType" 
                        label="label" 
                        placeholder="- Укажите тип -" 
                        :class="{ 'is-invalid': errors.orderType, 'is-valid': formData.orderType }"
                        @input="validateField('orderType')"
                    ></v-select>
                    <span v-if="errors.orderType" class="error-message">✖</span>
                    <span v-else-if="formData.orderType" class="success-message">✔</span>
                </div>

                <!-- Менеджер -->
                <div class="input-group cleared">
                    <label for="manager">Менеджер</label>
                    <v-select :options="manager_new" v-model="formData.manager_new" :get-option-label="formatManagerLabel" placeholder="- Укажите менеджера -"></v-select>
                </div>



                <!-- Магазин -->
                    <div class="input-group cleared">
                        <label for="site" class="required">Магазин</label>
                        <v-select 
                            :options="sites" 
                            v-model="formData.site" 
                            label="label" 
                            placeholder="- Укажите магазин -" 
                            :class="{ 'is-invalid': errors.site, 'is-valid': formData.site }"
                            @input="(value) => { onSiteChange(value); validateField('site'); }"
                        ></v-select>
                        <span v-if="errors.site" class="error-message">✖</span>
                        <span v-else-if="formData.site" class="success-message">✔</span>
                        <input type="hidden"  v-model="formData.magazin">
                        
                    </div>

                <!-- Способ -->
                <div class="input-group cleared">
                    <label for="orderMethod">Способ</label>
                    <v-select :options="orderMethods" v-model="formData.orderMethod" label="label" placeholder="- Укажите способ оформления -"></v-select>
                </div>
            </div>
            </div>
        </div>


     










        <!-- Блок "Клиент" -->
        <div id="order-customer" class="collapse-section template-block" data-template-block-code="customer">
    <div class="collapse-section__head">
        <div class="collapse-section__title">Клиент</div>
        <div class="collapse-section__head-col">
            <div class="collapse-section__head-content"></div>
            <div class="section-error">
                <div class="section-error__icon">
                    <svg class="svg-icon">
                        <use xlink:href="/build/icons.03e7bd82.svg#error_outlined"></use>
                    </svg>
                </div>
                <div class="section-error__text section-error__text_usual">Ошибка в блоке</div>
                <div class="section-error__text section-error__text_require">Не заполнено обязательное поле</div>
            </div>
           
        </div>
    </div>
    <div class="collapse-section__body" >





        
            
                <div class="bk">

                <div class="corporate-info-controls no-corp clear form-container" style="">
            <a :href="`https://1akb.retailcrm.ru/customers/${customerInfo.id}`"  target="_blank" class="tag-plank tag-plank_external-link corporate-info-controls__customer-plank corporate-info-controls__spacing">{{customerInfo.firstName}}</a>
            <a
              v-if="hasCustomerPurchaseHistory"
              class="customer-products-link bk__foot-item corporate-info-controls__spacing purchase-history-btn"
              href="#"
              @click.prevent="showCustomerModal"
              title="Что клиент покупал ранее"
            >
                <span>История покупок</span>
                <span v-if="previousCount" class="purchase-history-badge">{{ previousCount }}</span>
            </a>
            <div class="bk__client-orders bk__foot-item corporate-info-controls__spacing" title="Количество заказов, оформленных данным покупателем">
                <span class="bk__client-orders-item">Заказы:</span> {{ activeCount }} в работе / {{ previousCount }} ранее
            </div>
            <div v-if="clientBonusMessage" class="bonus-message bk__client-orders bk__foot-item corporate-info-controls__spacing">
              {{ clientBonusMessage }}
            </div>
        </div>


         <div v-if="isModalCustomerVisible" class="modal z purchase-history-modal" @click.self="closeCustomerModal">
  <div class="modal-content purchase-history-modal__content">
    <div class="hm-left purchase-history-modal__header">
      <h1>История покупок клиента</h1>
      <button type="button" class="btn-close-order" @click="closeCustomerModal" aria-label="Закрыть"></button>
    </div>

    <div v-if="isLoadingCustomerOrders" class="purchase-history-empty">
      Загрузка истории…
    </div>

    <template v-else>
      <div v-if="!activeOrders.length && !previousOrders.length" class="purchase-history-empty">
        У клиента пока нет других заказов
      </div>

      <div v-if="activeOrders.length" class="purchase-history-section">
        <div class="grid__title">В работе <span class="purchase-history-count">{{ activeOrders.length }}</span></div>
        <div v-for="order in activeOrders" :key="'a-' + order.id" class="grid__box purchase-history-card">
          <div class="purchase-history-card__top">
            <div class="purchase-history-card__meta">
              <a
                :href="orderEditUrl(order)"
                target="_blank"
                class="purchase-history-card__number"
              >№ {{ order.number }}</a>
              <span class="purchase-history-card__date">{{ formatCustomerOrderDate(order.createdAt) }}</span>
            </div>
            <div
              class="bill cleared mr10 purchase-history-card__status"
              :class="getStatusGroupClass(order.status)"
              :style="{ backgroundColor: getStatusColor(order.status) }"
              :title="curStatus(order.status) || order.status"
            >
              <span class="fs12 tbl-st-txt">{{ curStatus(order.status) || order.status }}</span>
            </div>
          </div>
          <div v-if="order.deliveryAddress" class="purchase-history-card__address">
            {{ order.deliveryAddress }}
          </div>
          <table class="customer-basket-table customer-basket-table_order">
            <tbody>
              <tr v-for="item in order.items" :key="item.id">
                <td class="customer-basket-table__td">
                  <div class="customer-basket-table-product">
                    <div class="customer-basket-table-product__main">
                      <strong>{{ item.offer && item.offer.name }}</strong>
                      <div v-if="item.offer && item.offer.article" class="customer-basket-table-product__info">
                        арт. {{ item.offer.article }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="customer-basket-table__td customer-basket-table__td_count">
                  {{ item.quantity }} шт.
                </td>
                <td class="customer-basket-table__td customer-basket-table__td_price">
                  {{ formatMoney(item.initialPrice) }}&nbsp;руб.
                </td>
              </tr>
            </tbody>
          </table>
          <div class="customer-basket-table-footer customer-basket-table-footer_order">
            <div class="customer-basket-table-footer__title">Итого</div>
            <div class="customer-basket-table-footer__price">
              <strong>{{ formatMoney(order.totalSumm) }} руб.</strong>
            </div>
          </div>
        </div>
      </div>

      <div v-if="previousOrders.length" class="purchase-history-section">
        <div class="grid__title">Ранее покупал <span class="purchase-history-count">{{ previousOrders.length }}</span></div>
        <div v-for="order in previousOrders" :key="'p-' + order.id" class="grid__box purchase-history-card">
          <div class="purchase-history-card__top">
            <div class="purchase-history-card__meta">
              <a
                :href="orderEditUrl(order)"
                target="_blank"
                class="purchase-history-card__number"
              >№ {{ order.number }}</a>
              <span class="purchase-history-card__date">{{ formatCustomerOrderDate(order.createdAt) }}</span>
            </div>
            <div
              class="bill cleared mr10 purchase-history-card__status"
              :class="getStatusGroupClass(order.status)"
              :style="{ backgroundColor: getStatusColor(order.status) }"
              :title="curStatus(order.status) || order.status"
            >
              <span class="fs12 tbl-st-txt">{{ curStatus(order.status) || order.status }}</span>
            </div>
          </div>
          <div v-if="order.deliveryAddress" class="purchase-history-card__address">
            {{ order.deliveryAddress }}
          </div>
          <table class="customer-basket-table customer-basket-table_order">
            <tbody>
              <tr v-for="item in order.items" :key="item.id">
                <td class="customer-basket-table__td">
                  <div class="customer-basket-table-product">
                    <div class="customer-basket-table-product__main">
                      <strong>{{ item.offer && item.offer.name }}</strong>
                      <div v-if="item.offer && item.offer.article" class="customer-basket-table-product__info">
                        арт. {{ item.offer.article }}
                      </div>
                    </div>
                  </div>
                </td>
                <td class="customer-basket-table__td customer-basket-table__td_count">
                  {{ item.quantity }} шт.
                </td>
                <td class="customer-basket-table__td customer-basket-table__td_price">
                  {{ formatMoney(item.initialPrice) }}&nbsp;руб.
                </td>
              </tr>
            </tbody>
          </table>
          <div class="customer-basket-table-footer customer-basket-table-footer_order">
            <div class="customer-basket-table-footer__title">Итого</div>
            <div class="customer-basket-table-footer__price">
              <strong>{{ formatMoney(order.totalSumm) }} руб.</strong>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</div>


 




                    <div class="input-group cleared">
                        <label  for="lastName">Фамилия</label>
                        <input type="text" id="lastName" v-model="formData.lastName" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="email">Email</label>
                        <input type="email" id="email" v-model="formData.email" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label class="required" for="firstName">Имя</label>
                        <input type="text" id="firstName" @input="validateField('firstName')" v-model="formData.firstName" :class="{ 'is-invalid': errors.firstName, 'is-valid': getFirstNameValue() }" class="input-field" required>
                         <span v-if="errors.firstName" class="error-message">✖</span>
                        <span v-else-if="getFirstNameValue()" class="success-message">✔</span>
                    </div>
                    
                    <div class="input-group cleared" style="position:relative;margin-bottom: 16px;">
                        <label  for="phone">Телефон</label>
                        <input type="text" id="phone" v-model="formData.phone" class="input-field">
                       
                       <!-- Подсказка с кнопкой -->
                      <div v-if="invalidPhone && formattedPhone" class="helper-block">
                        <small class="helper-text">
                          Приведите номер телефона в правильный формат. Правильный формат: <strong>{{ formattedPhone }}</strong><strong style="color:red">(-10%)</strong>
                        </small>
                        <button class="apply-button" @click="applyFormattedPhone">Применить исправление</button>
                      </div>

                      <!-- Ошибка, если номер вообще невалидный и не удалось привести -->
                      <small v-if="invalidPhone && !formattedPhone" class="error-text">
                        Неверный формат номера. Не удалось привести автоматически.
                      </small>



                        <div v-if="formData.phone" @click="makeCall" class="call-button">
                          
                        </div>

                        <div class="double_widget_btn border-box" @click="openDoubleHistory(doubleArray)"  v-if="countDouble" title="Имеются дубли"><span>{{countDouble}} <span class="double_widget__text">дубль</span></span></div>
                        <div class="phone-history-link controls" @click="fetchCallHistory(formData.phone)"><span>История звонков</span></div>

                    </div>


                    <div class="input-group cleared">
                        <label  for="patronymic">Отчество</label>
                        <input type="text" id="patronymic" v-model="formData.patronymic" class="input-field">
                    </div>




                    <div class="input-group cleared">
                        <label  for="additionalPhone">Доп. телефон</label>
                        <input type="text" id="additionalPhone" v-model="formData.additionalPhone" class="input-field">
                        <div v-if="formData.additionalPhone" @click="makeCallDop"  class="call-button"></div>
                    </div>





                    <div class="input-group cleared">
                        <label class="label-common">Бонус</label>
                        <div id="custom-field-dfhgodsf8g7" class="gray-bg fs13 static ellipsis">
                            {{formData.bonus}} <span v-if="errors.selectionLink" style="color:red">(-10%)</span>
                        </div>
                    </div>
                    <!--<div class="input-group cleared">
                        <label  for="email2">Email2</label>
                        <input type="email" id="email2" v-model="formData.email2" class="input-field">
                    </div>-->
                   <div class="input-group cleared" style="position: relative;margin-bottom: 16px;">
                      <label for="selectionLink">Ссылка на подбор</label>
                      <input
                        type="text"
                        id="selectionLink"
                        v-model="formData.selectionLink"
                        class="input-field"
                      />

                      <div class="podbor-actions-row">
                        <button
                          v-if="hasPopularBatteries"
                          class="btn-show-batteries"
                          @click="showModalPodborProduct = true"
                        >
                          Продавались на этот авто
                        </button>

                        <div v-if="loadingPopularBatteries" class="spinner_podbor"></div>

                        <div class="corpus-match-hints corpus-match-hints--inline">
                          <span
                            v-if="errors.selectionLink"
                            class="corpus-match-hint corpus-match-hint--bad"
                            title="Ссылка на подбор некорректна"
                          >
                            <span class="corpus-match-hint__icon" aria-hidden="true">✖</span>
                            <span class="corpus-match-hint__text">Подбор</span>
                          </span>
                          <span
                            v-else-if="formData.selectionLink"
                            class="corpus-match-hint corpus-match-hint--ok"
                            title="Ссылка на подбор заполнена"
                          >
                            <span class="corpus-match-hint__icon" aria-hidden="true">✔</span>
                            <span class="corpus-match-hint__text">Подбор</span>
                          </span>

                          <span
                            v-if="corpusMatchStatusData"
                            class="corpus-match-hint"
                            :class="corpusMatchStatusData.ok ? 'corpus-match-hint--ok' : 'corpus-match-hint--bad'"
                            :title="corpusMatchStatusData.text || ''"
                          >
                            <span class="corpus-match-hint__icon" aria-hidden="true">{{ corpusMatchStatusData.ok ? '✔' : '✖' }}</span>
                            <span class="corpus-match-hint__text">Проверка</span>
                          </span>

                          <span
                            v-if="aiFitStatusData"
                            class="corpus-match-hint"
                            :class="{
                              'corpus-match-hint--ok': aiFitStatusData.ok === true,
                              'corpus-match-hint--bad': aiFitStatusData.ok === false,
                              'corpus-match-hint--warn': aiFitStatusData.ok == null && !aiFitStatusData.loading,
                              'corpus-match-hint--loading': !!aiFitStatusData.loading
                            }"
                            :title="aiFitHoverTitle"
                          >
                            <span class="corpus-match-hint__icon" aria-hidden="true">
                              <template v-if="aiFitStatusData.loading">…</template>
                              <template v-else-if="aiFitStatusData.ok === true">✔</template>
                              <template v-else-if="aiFitStatusData.ok === false">✖</template>
                              <template v-else>?</template>
                            </span>
                            <span class="corpus-match-hint__text">ИИ</span>
                          </span>
                        </div>
                      </div>

                      <!-- Сообщение о стоимости установки -->
                      <div v-if="installationPriceError" class="helper-block">
                        <small class="error-text">
                          {{ installationPriceError }}
                        </small>
                        <button 
                          type="button"
                          @click="installationPriceError = null"
                          class="helper-close-button"
                          title="Закрыть"
                        >
                          ×
                        </button>
                      </div>

                      <div class="auto_podbor" @click="openCarSelector"></div>
                      <div class="auto_mark">
                        <a :href="formData.selectionLink" target="_blank">{{ formData.auto }}</a>
                      </div>
                    </div>

                    <div class="input-group cleared pomoshch-ii-group">
                        <label for="pomoshchIi">Помощь ИИ</label>
                        <div class="pomoshch-ii-wrap">
                          <battery-ai-assistant
                            embedded
                            :vehicle="vehicleContextForAi"
                            :order-context="orderContextForAi"
                            :initial-city="deliveryCityLabel"
                            @recommendation="onBatteryAiRecommendation"
                          >
                            <template #trigger="{ open, carLabel }">
                              <button
                                type="button"
                                class="pomoshch-ii-ai-btn"
                                :title="'ИИ-подбор для: ' + carLabel"
                                @click="open"
                              >
                                Помощь ИИ
                              </button>
                            </template>
                          </battery-ai-assistant>
                          <textarea
                            id="pomoshchIi"
                            v-model="formData.pomoshchIi"
                            class="input-field pomoshch-ii-field"
                            rows="5"
                            placeholder="Рекомендация ИИ по подбору АКБ (сохраняется в RetailCRM)"
                          ></textarea>
                        </div>
                    </div>

                    <div class="input-group cleared">
                        <label  for="carBrand">Марка ТС</label>
                        <input type="text" id="carBrand" v-model="formData.carBrand" class="input-field">
                    </div>

                    <div class="input-group cleared">
                        <label  for="carModel">Модель ТС</label>
                        <input type="text" id="carModel" v-model="formData.carModel" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="carName">Название ТС</label>
                        <input type="text" id="carName" v-model="formData.carName" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="carYear">Год ТС</label>
                        <input type="text" id="carYear" v-model="formData.carYear" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="fuelType">Вид топлива</label>
                        <input type="text" id="fuelType" v-model="formData.fuelType" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="carBodyType">Тип корпуса в подборе ТС</label>
                        <input type="text" id="carBodyType" v-model="formData.carBodyType" class="input-field">
                    </div>
                    <div class="input-group cleared">
                        <label  for="wrongSelection">Неверный подбор на сайте</label>
                        <input type="checkbox" id="wrongSelection" v-model="formData.wrongSelection" class="input-field" value="1">
                    </div>
                    <div class="input-group cleared">
                        <label  for="seller">Продавец</label> 
                        <v-select :options="seller" v-model="formData.seller" label="label" placeholder="- Продавец -"></v-select>
                        
                    </div>
                </div>

                <div class="bk" data-order-section="customer">
                    <div class="bk-control cleared ml0">
                        <div class="red-tl fs10 ">Юридические реквизиты</div>
                    </div>
                     <div class="input-group cleared">
                        <label for="contractorType" class="required">Тип контрагента </label>
                        <v-select 
                            :options="contragentTypes" 
                            v-model="formData.contragentTypes" 
                            label="label" 
                            placeholder="--Выбрать тип контрагента--" 
                            :class="{ 'is-invalid': errors.contragentTypes, 'is-valid': formData.contragentTypes }"
                            @input="validateField('contragentTypes')"
                        ></v-select>
                        <span v-if="errors.contragentTypes" class="error-message">✖</span>
                        <span v-else-if="formData.contragentTypes" class="success-message">✔</span>
                    </div>
                    <div class="input-group cleared">
                        <label  for="invoiceDate">Счет-фактура от</label>
                        

                        <date-picker 
                            v-model="formData.invoiceDate" 
                            lang="ru" 
                            :format="'DD.MM.YYYY'" 
                            placeholder="Выберите дату" 
                            input-class="input-field"
                        ></date-picker>
                    </div>





                 



                     <div class="input-group cleared">
                    <label for="tradeInAmountNew">Сумма за аккумулятор в зачет</label>
                    <input type="text" id="tradeInAmountNew" v-model="formData.tradeInAmountNew" class="input-field" readonly>
                  </div>


                    <div class="input-group cleared" style="flex-wrap: wrap!important;">
                      <div class="capacity-buttons">
                        <button
                          v-for="value in [45 , 55, 60, 65, 70, 75, 80, 85, 95, 100]"
                          :key="value"
                          type="button"
                          class="capacity-btn"
                          @click="addCapacity(value)"
                        >
                          {{ value }}
                        </button>
                        <button
                          type="button"
                          class="capacity-btn capacity-btn-clear"
                          @click="clearCapacity"
                        >
                          ×
                        </button>
                      </div>
                      <div style="display:flex;flex-wrap:nowrap;width: 100%;">
                        <label  for="batteryCapacityNew">Ёмкость аккумулятора в зачет</label>
                        <input type="text" id="batteryCapacityNew" v-model="formData.batteryCapacityNew" class="input-field" @blur="updateTradeInAmount">
                      </div>
                      <small v-if="showLomSenderWarning" class="error-text">
                        Заполните фамилию, имя и отчество ломосдатчика полностью (имя и отчество — полными словами, не инициалами)
                      </small>
                      <small v-if="showLomSenderPreview" class="helper-text">
                        Пример в ведомости: {{ lomSenderDisplayNamePreview }}
                      </small>
                    </div>



                     







                    <!-- Поля для юридического лица и ИП -->
                    <div class="input-group cleared" v-if="formData.contragentTypes && (formData.contragentTypes.value === 'legal-entity' || formData.contragentTypes.value === 'enterpreneur')">
                        <label for="contragentINN">ИНН</label>
                        <input type="text" id="contragentINN" v-model="formData.contragentINN" class="input-field input-field-contragent">
                    </div>
                    
                    <div class="input-group cleared" v-if="formData.contragentTypes && (formData.contragentTypes.value === 'legal-entity' || formData.contragentTypes.value === 'enterpreneur')">
                        <label for="contragentLegalName">Полное наименование</label>
                        <textarea id="contragentLegalName" v-model="formData.contragentLegalName" class="input-field input-field-contragent"></textarea>
                    </div>
                    
                    <div class="input-group cleared" v-if="formData.contragentTypes && (formData.contragentTypes.value === 'legal-entity' || formData.contragentTypes.value === 'enterpreneur')">
                        <label for="contragentOKPO">ОКПО</label>
                        <input type="text" id="contragentOKPO" v-model="formData.contragentOKPO" class="input-field">
                    </div>
                    
                    <div class="input-group cleared" v-if="formData.contragentTypes && formData.contragentTypes.value === 'legal-entity'">
                        <label for="contragentKPP">КПП</label>
                        <input type="text" id="contragentKPP" v-model="formData.contragentKPP" class="input-field">
                    </div>
                    
                    <div class="input-group cleared" v-if="formData.contragentTypes && formData.contragentTypes.value === 'enterpreneur'">
                        <label for="contragentOGRNIP">ОГРНИП</label>
                        <input type="text" id="contragentOGRNIP" v-model="formData.contragentOGRNIP" class="input-field">
                    </div>
                    
                    <div class="input-group cleared" v-if="formData.contragentTypes && (formData.contragentTypes.value === 'legal-entity' || formData.contragentTypes.value === 'enterpreneur')">
                        <label for="contragentLegalAddress">Адрес регистрации</label>
                        <textarea id="contragentLegalAddress" v-model="formData.contragentLegalAddress" class="input-field"></textarea>
                    </div>
                    
                    <div class="input-group cleared" v-if="formData.contragentTypes && formData.contragentTypes.value === 'legal-entity'">
                        <label for="contragentOGRN">ОГРН</label>
                        <input type="text" id="contragentOGRN" v-model="formData.contragentOGRN" class="input-field">
                    </div>
                    
                    <div class="input-group cleared" v-if="formData.contragentTypes && formData.contragentTypes.value === 'enterpreneur'">
                        <label for="contragentCertificateNumber">Номер свидетельства</label>
                        <input type="text" id="contragentCertificateNumber" v-model="formData.contragentCertificateNumber" class="input-field">
                    </div>
                    
                    <div class="input-group cleared" v-if="formData.contragentTypes && formData.contragentTypes.value === 'enterpreneur'">
                        <label for="contragentCertificateDate">Дата свидетельства</label>
                        <date-picker 
                            v-model="formData.contragentCertificateDate" 
                            lang="ru" 
                            :format="'DD.MM.YYYY'" 
                            placeholder="Выберите дату" 
                            input-class="input-field"
                        ></date-picker>
                    </div>
                    
                    <div class="input-group cleared">
                        <label for="iuridicheskoe_naimenovanie">Юридическое наименование</label>
                        <input type="text" id="iuridicheskoe_naimenovanie" v-model="formData.iuridicheskoe_naimenovanie" class="input-field">
                    </div>
                    
                    <div class="input-group cleared">
                        <label  for="discountCard">Есть скидочная карта</label>
                        <input type="checkbox" id="discountCard" v-model="formData.discountCard" class="input-field" value="1">
                    </div>
                     <div class="input-group cleared">
                        <label  for="ncorrectBonus">Некорректный бонус?</label>
                        <input type="checkbox" id="ncorrectBonus" v-model="formData.ncorrectBonus" class="input-field" value="1">
                    </div>
                    <div class="input-group cleared">
                        <label  for="managerComments">Комментарии менеджера</label>
                        <textarea id="managerComments" v-model="formData.managerComments" class="input-field"></textarea>
                    </div>
                </div>
            
        
    </div>
</div>



<!-- Карточки АКБ + страницы, которые клиент смотрел на сайте -->
<div
  v-if="visitedProductsLoading || visitedProducts.length || visitedPages.length"
  class="collapse-section template-block visited-products-section"
  data-template-block-code="visited-products"
>
  <div class="collapse-section__head">
    <div class="collapse-section__title">
      <div class="order-table__title visited-products-title">
        Клиент смотрел на сайте
        <span v-if="visitedProducts.length" class="visited-products-title__count">{{ visitedProducts.length }}</span>
      </div>
    </div>
    <div
      v-if="!visitedProductsLoading && visitedProducts.length > 5"
      class="visited-products-nav"
    >
      <button type="button" class="visited-products-nav__btn" @click="scrollVisitedCarousel(-1)" aria-label="Назад">‹</button>
      <button type="button" class="visited-products-nav__btn" @click="scrollVisitedCarousel(1)" aria-label="Вперёд">›</button>
    </div>
  </div>
  <div class="collapse-section__body">
    <div v-if="visitedProductsLoading" class="visited-products-loading">Загружаем просмотренные АКБ…</div>
    <div
      v-else-if="visitedProducts.length"
      ref="visitedCarousel"
      class="visited-products-carousel"
    >
      <div
        v-for="product in visitedProducts"
        :key="'visited-' + product.id"
        class="visited-product-card"
        :class="{ 'visited-product-card--in-order': isProductInOrder(product.id) }"
      >
        <a :href="product.href || product.visitedUrl" target="_blank" rel="noopener" class="visited-product-card__image">
          <img :src="product.jpg_url || 'https://1akb.by/images/no-image_0.webp'" :alt="product.name" />
        </a>
        <a :href="product.href || product.visitedUrl" target="_blank" rel="noopener" class="visited-product-card__name">
          {{ product.name }}
        </a>
        <div class="visited-product-card__meta">
          <span v-if="product.emkost">{{ product.emkost }} А·ч</span>
          <span v-if="product.starttok">{{ product.starttok }} А</span>
          <span v-if="product.korpus">{{ product.korpus }}</span>
        </div>
        <div class="visited-product-card__price">
          <span class="visited-product-card__price-now">{{ product.price }} руб.</span>
          <span v-if="product.old_price" class="visited-product-card__old">{{ product.old_price }}</span>
        </div>
        <button
          v-if="isProductInOrder(product.id)"
          type="button"
          class="visited-product-card__btn visited-product-card__btn--in"
          @click="removeProduct(product.id)"
        >В заказе</button>
        <button
          v-else
          type="button"
          class="visited-product-card__btn"
          @click="addOrUpdateProduct(product)"
        >Добавить</button>
      </div>
    </div>

    <div v-if="visitedPages.length" class="visited-pages-block">
      <div class="visited-pages-block__title">
        Страницы сайта
        <span class="visited-products-title__count">{{ visitedPages.length }}</span>
      </div>
      <ol class="visited-pages-list">
        <li
          v-for="(page, idx) in visitedPages"
          :key="'visited-page-' + idx"
          class="visited-page-item"
        >
          <a :href="page.url" target="_blank" rel="noopener" class="visited-page-item__title">
            {{ page.label }}
          </a>
          <div class="visited-page-item__path" :title="page.url">{{ page.pathLabel || page.path || page.url }}</div>
        </li>
      </ol>
    </div>
  </div>
</div>

<div id="order-list" class="collapse-section template-block" data-template-block-code="list">
    <div class="collapse-section__head">
        <div class="collapse-section__title">
            <div class="order-table__title">Состав заказа
                <!--<sup class="order-table__count" id="product-available-count">0</sup>-->
            </div>
                        
        </div>
        <div class="collapse-section__head-col">
            <div class="collapse-section__head-content order-products-quick-search-wrap" style="margin-left: auto; display: flex; align-items: center; margin-right: 8px;">
                <QuickProductSearch
                  :isProductInOrder="isProductInOrder"
                  :getProductQuantity="getProductQuantityById"
                  @add-product="addOrUpdateProduct"
                  @increase-product="increaseProductQuantity"
                  @decrease-product="decreaseProductQuantity"
                  @open-full-search="openModalWithQuery"
                />
            </div>
            <div class="collapse-section__head-content" style="margin-left: 0; display: flex">
                <div class="bk-btn">
                    <a id="add-order-product-btn" class="btn small white" @click="openModal">
                        Добавить товары<span class="icon-new"></span>
                    </a>
                </div>
            </div>
            <div class="collapse-section__head-content" style="margin-left: 8px; display: flex">
                <div class="bk-btn">
                    <a id="add-order-product-btn-ms" class="btn small white" @click="openModalMS">
                        Добавить товары МС<span class="icon-new"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
    
    <div class="collapse-section__body" >
        <div class="order-list-with-client">
        <aside class="order-client-side" aria-label="Информация о клиенте">
          <div class="order-client-side__card">
            <div class="order-client-side__head">Клиент</div>

            <div class="order-client-side__grid">
              <div class="order-client-side__item order-client-side__item--name">
                <span class="order-client-side__label">Имя</span>
                <span class="order-client-side__value order-client-side__name">
                  <a
                    v-if="customerInfo.id"
                    :href="`https://1akb.retailcrm.ru/customers/${customerInfo.id}`"
                    target="_blank"
                    rel="noopener"
                  >{{ getFirstNameValue() || customerInfo.firstName || formData.firstName || 'Без имени' }}</a>
                  <span v-else>{{ getFirstNameValue() || formData.firstName || 'Без имени' }}</span>
                </span>
              </div>

              <div v-if="formData.phone" class="order-client-side__item">
                <span class="order-client-side__label">Телефон</span>
                <span class="order-client-side__value order-client-side__value--phone" @click="makeCall" title="Позвонить">{{ formData.phone }}</span>
              </div>
              <div v-if="formData.additionalPhone" class="order-client-side__item">
                <span class="order-client-side__label">Доп. телефон</span>
                <span class="order-client-side__value">{{ formData.additionalPhone }}</span>
              </div>

              <div v-if="clientSideCity" class="order-client-side__item">
                <span class="order-client-side__label">Город</span>
                <span class="order-client-side__value">{{ clientSideCity }}</span>
              </div>

              <div v-if="formData.visitor_code" class="order-client-side__item order-client-side__item--accent">
                <span class="order-client-side__label">Код посетителя</span>
                <span class="order-client-side__value order-client-side__code">{{ formData.visitor_code }}</span>
              </div>
              <div v-if="formData.personal_offer_discount !== '' && formData.personal_offer_discount != null" class="order-client-side__item order-client-side__item--accent">
                <span class="order-client-side__label">Товар дня</span>
                <span class="order-client-side__value">−{{ formData.personal_offer_discount }}%</span>
              </div>
              <div v-if="formData.forma_na_saite" class="order-client-side__item">
                <span class="order-client-side__label">Форма</span>
                <span class="order-client-side__value">{{ formData.forma_na_saite }}</span>
              </div>

              <div class="order-client-side__item">
                <span class="order-client-side__label">Заказы</span>
                <span class="order-client-side__value">{{ activeCount }} в работе / {{ previousCount }} ранее</span>
              </div>
              <div v-if="clientBonusMessage" class="order-client-side__item">
                <span class="order-client-side__label">Бонусы</span>
                <span class="order-client-side__value">{{ clientBonusMessage }}</span>
              </div>
              <div v-if="formData.auto" class="order-client-side__item order-client-side__item--wide">
                <span class="order-client-side__label">Авто</span>
                <span class="order-client-side__value">
                  <a v-if="formData.selectionLink" :href="formData.selectionLink" target="_blank" rel="noopener">{{ formData.auto }}</a>
                  <template v-else>{{ formData.auto }}</template>
                </span>
              </div>
            </div>

            <div v-if="managerComment || hasCustomerPurchaseHistory" class="order-client-side__footer">
              <div v-if="managerComment" class="order-client-side__comment">
                <div class="order-client-side__label">Комментарий оператора</div>
                <div class="order-client-side__comment-text">{{ managerComment }}</div>
              </div>
              <button
                v-if="hasCustomerPurchaseHistory"
                type="button"
                class="order-client-side__history-btn"
                @click="showCustomerModal"
              >
                История покупок
                <span v-if="previousCount" class="order-client-side__badge">{{ previousCount }}</span>
              </button>
            </div>
          </div>
        </aside>

        <div class="order-list-with-client__main">
        <div class="order-table-header" data-order-section="list">
            <div class="m-box order-products-table-box with-popups">
                <table class="modern-table order-products default modern-order-table ui-sortable nested-table" id="order-products-table">
                    <thead>
                        <tr>
                            <th class="order-products__counter-cell">№</th>
                            <th class="title order-products__image">Товар/услуга</th>
                            <th class="bord heading-th">&nbsp;</th>
                            <th></th>
                            <th>Статус</th>
                            <th class="properties-th bord nested-th">Свойства</th>
                            <th class="bord nested-th">Цена</th>
                            <th class="quantity nested-th_hide">Кол-во</th>
                            <th class="subtotal align-to-input">Стоимость</th>
                        </tr>
                    </thead>
                    <tbody v-for="(product, index) in products" :key="index" class="product-group order-products-tbody">
                        <tr :class="{ 'in-reserve-class': isCancelStatus(product.status) }">
                            <td>{{ index + 1 }}</td>
                            <td><div><img :src="product.jpg_url || 'https://1akb.by/images/no-image_0.webp'" alt="Фото товара" style="max-width:50px"/></div></td>
                             <td style="text-align:left;">
                              <p>{{ product.name }}</p>
                              <div v-if="product.gtd" class="order-product-gtd" :title="'Дата выпуска: ' + product.gtd">
                                <span class="order-product-gtd__label">Дата выпуска</span>
                                <span class="order-product-gtd__value">{{ product.gtd }}</span>
                              </div>
                              <span class="acc-tovar" @click="openAnalogModal(product)">Сопутствующие товары</span>
                            </td>
                            <td>
                              <Helper 
                            :product="product.name"
                            :brand="product.brand"
                            />
                          </td>
                            <!-- Здесь текущий статус -->
                         <td class="product-status-cell">
                            <div class="product-status-stack">
                              <div
                                v-if="isStockLookupProduct(product)"
                                class="product-status-karvata"
                                :class="{
                                  'product-status-karvata--zero': isProductStockLoaded(product) && getPrimaryStockAvailable(product) <= 0,
                                  'product-status-karvata--loading': !isProductStockLoaded(product)
                                }"
                                @mouseenter="openStockHover($event, product)"
                                @mouseleave="scheduleCloseStockHover"
                              >
                                <span class="product-status-karvata__icon" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" width="14" height="14"><path fill="currentColor" d="M4 7h16v2H4V7zm0 4h10v2H4v-2zm0 4h7v2H4v-2z"/></svg>
                                </span>
                                <span class="product-status-karvata__label">{{ getPrimaryStockLabel() }}</span>
                                <span v-if="getPrimaryStockState(product).loading" class="product-status-karvata__qty product-status-karvata__qty--loading">…</span>
                                <span
                                  v-else
                                  class="product-status-karvata__qty"
                                >{{ formatPrimaryStock(product) }}</span>
                              </div>

                              <button
                                type="button"
                                class="product-status-link"
                                @click="openProductStatusDropdown($event, product)"
                              >
                                {{ getProductStatusLabel(product.status) }}
                              </button>

                              <div
                                v-if="showSourcePicker(product)"
                                class="zakaz-source-picker"
                              >
                                <button
                                  type="button"
                                  class="zakaz-source-trigger"
                                  :class="{
                                    'zakaz-source-trigger--open': sourceDropdownProductId === String(product.id),
                                    'zakaz-source-trigger--filled': !!getSelectedSourcePick(product),
                                    'zakaz-source-trigger--compact': !getSelectedSourceQty(product)
                                  }"
                                  @click.stop="toggleSourceDropdown($event, product)"
                                >
                                  <span class="zakaz-source-trigger__leading" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" width="15" height="15"><path fill="currentColor" d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5z"/></svg>
                                  </span>
                                  <span class="zakaz-source-trigger__body">
                                    <span class="zakaz-source-trigger__caption">Источник</span>
                                    <span class="zakaz-source-trigger__value">{{ getSelectedSourceTriggerText(product) }}</span>
                                  </span>
                                  <span v-if="getSelectedSourceQty(product)" class="zakaz-source-trigger__badge">{{ getSelectedSourceQty(product) }} шт</span>
                                  <svg class="zakaz-source-trigger__chevron" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                    <path fill="currentColor" d="M7 10l5 5 5-5H7z"/>
                                  </svg>
                                </button>
                              </div>
                            </div>
                            </td>

                            <td></td>
                            <td @click="openPriceDropdown(product)" style="cursor: pointer;">
                            <div class="order-price__value order-price__value_column">
                                <span v-if="product.old_price" class="order-price__old">{{ product.old_price }} руб.</span>
                                <span class="discounted-price">{{ product.displayPrice }} руб.</span>
                                <span v-if="product.discountAmount || product.discountPercent" class="original-price">{{ product.originalPrice }} руб.</span>
                            </div>
                               
                            </td>
                            <td>
                                <div class="button_quantity">
                                    <button @click="decreaseQuantity(product)" class="qty-btn qty-btn-decrease">-</button>
                                    <input 
                                      type="number" 
                                      v-model.number="product.quantity" 
                                      @change="updateQuantity(product)" 
                                      class="min-input quantity"
                                      min="1"
                                    />
                                    <button @click="increaseQuantity(product)" class="qty-btn qty-btn-increase">+</button>
                                </div>
                            </td>
                            <td><span class="inline-tooltip__target js-subtotal-value">{{ Math.max(Math.round(product.total * 100) / 100, 0) }}&nbsp;<span class="currency-symbol byn">руб.</span></span>
                            <div class="info-btn-group info-btn-group_product" @click="removeProduct(product.id)"><div class="info-btn js-order-product-delete-button"><div class="info-btn__switch info-btn__switch_trash"></div><div class="info-btn__tooltip">Удалить позицию из заказа</div></div></div>

                            </td>
                        </tr>
                    </tbody>
                </table>

                 
                <!-- Выпадающее поле для редактирования цены -->
                <div v-if="priceDropdownVisible" class="order-price__dropdown" :style="{ top: dropdownPosition.top, left: dropdownPosition.left }">
                    <div class="order-price__main">
                        <label>
                            <span class="order-price__caption">Цена</span>
                            <div class="order-price__input-wrap">
                                <input v-model.number="priceInput" type="text" class="order-price__input" />
                                <span class="currency-symbol">руб.</span>
                            </div>
                        </label>
                    </div>
                    <div class="order-price__discount">
                        <p class="order-price__caption">Скидка</p>
                        <div class="order-price__controls">
                            <div class="order-price__input-wrap">
                                <input
                                  :value="discountAmount"
                                  @input="handleDiscountInput"
                                  type="text"
                                  class="order-price__input"
                                  placeholder="0"
                                />
                                <span class="currency-symbol">руб.</span>
                              </div>
                            <div class="order-price__input-wrap">
                                <input v-model.number="discountPercent" type="text" class="order-price__input" placeholder="0" />
                                <span>%</span>
                            </div>
                        </div>
                    </div>
                    <div class="order-price__controls">
                        <button @click="applyPriceChange" class="btn order-price__apply">Применить</button>
                        <button @click="closePriceDropdown" class="btn order-price__cancel">Отмена</button>
                    </div>
                </div>
                <div class="order-empty" v-if="products.length === 0">
                    <p>В заказе еще нет товаров или услуг,<br>добавьте их с помощью кнопки «Добавить» справа</p>
                </div>
            </div>
        </div>

        <div class="order-row">
            <div class="order-row__top">
                <p class="order-row__title">
                    Разовая скидка
                    
                </p>

                <div class="order-discount order-discount__inputs">
                    <!-- Поле ввода скидки в рублях -->
                    <div class="order-discount__input-wrap order-discount__input-wrap_rub">
                        <input 
  type="number" 
  v-model.number="oneTimeDiscountAmount"
  @blur="correctDiscountInput"
  class="order-discount__input order-disc-rub order-value-input" 
  placeholder="0"
/>
                        <span class="order-discount__currency"><span class="currency-symbol byn">руб.</span></span>
                    </div>

                    <!-- Поле ввода скидки в процентах -->
                    <div class="order-discount__input-wrap order-discount__input-wrap_percent">
                        <input 
                            type="number" 
                            v-model="oneTimeDiscountPercent" 
                            @input="updateTotalDiscount" 
                            class="order-discount__input order-disc-percent order-value-input" 
                            placeholder="0"
                        />
                        <span class="order-discount__currency">%</span>
                    </div>
                </div>
            </div>

            <div class="order-discount-errors patch-target" id="patch-order-discount-errors">
                <input type="hidden" id="intaro_crmbundle_ordertype_discountDividerFix" autocomplete="disabled" value="0">
            </div>
        </div>


        <div class="order-table-footer">

            <div class="order-table-footer__left patch-target">
              <!-- Блок разделен на две половины -->
              <div class="footer-delivery-split-container">
                <!-- Левая половина: Тип доставки и Комплекс -->
                <div class="footer-delivery-left-half">
                  <div class="footer-section-block">
                    <div class="footer-section-title">Тип доставки</div>
                    <div class="footer-section-content">
                      <v-select 
                        v-model="formData.deliveryTypes" 
                        :options="deliveryTypes" 
                        id="deliveryTypes" 
                        name="deliveryTypes" 
                        class="input-field footer-select-field" 
                        placeholder="- Не указан -"
                      ></v-select>
                    </div>
                  </div>
                  
                  <!-- Блок выбора комплекса (показывается при курьере, самовывозе или магазине) -->
                  <div class="footer-section-block" style="margin-top: 16px;" v-if="showInstallationBlock">
                    <div class="footer-section-title">Комплекс</div>
                    <div class="footer-section-content" style="position: relative;">
                      <button
                        type="button"
                        class="footer-complex-select-btn"
                        :class="{ 'is-active': formData.installationComplex }"
                        @click="toggleComplexSelectDropdown()"
                      >
                        <div class="footer-complex-select-btn-content">
                          <span v-if="formData.installationComplex" class="footer-complex-select-btn-title">
                            {{ getComplexName() }}
                          </span>
                          <span v-else class="footer-complex-select-btn-title">- Не выбран -</span>
                          <span v-if="formData.installationComplex" class="footer-complex-select-btn-desc">
                            {{ getComplexDescription(formData.installationComplex) }}
                          </span>
                        </div>
                        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 8px; flex-shrink: 0;">
                          <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                      
                      <div 
                        v-if="isComplexSelectDropdownOpen" 
                        class="footer-complex-select-dropdown" 
                        @click.stop
                      >
                        <button 
                          v-for="option in installationComplexOptions" 
                          :key="option.value" 
                          type="button"
                          class="footer-complex-select-option"
                          :class="{ 'is-active': formData.installationComplex === option.value }"
                          @click="selectComplexFromDropdown(option.value)"
                        >
                          <div class="footer-complex-option-main">
                            <span>{{ option.label }}</span>
                            <span class="footer-complex-option-price">{{ option.price }}</span>
                          </div>
                          <div class="footer-complex-option-desc">
                            {{ option.description }}
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Правая половина: Лейблы и пунктирные блоки -->
                <div class="footer-delivery-right-half">
                  <div class="footer-section-block">
                    <!-- Лейблы: За счет скидки и За счет клиента -->
                    <div class="footer-payment-labels">
                      <div class="footer-payment-label">За счет скидки</div>
                      <div class="footer-payment-label">За счет клиента</div>
                    </div>
                    
                    <!-- Пунктирные блоки "Доставка" (появляются при выборе типа доставки) -->
                    <div class="footer-dashed-blocks-row" v-if="showDeliveryBlock">
                      <div 
                        class="footer-dashed-block"
                        :class="{ 'footer-dashed-block-filled': formData.deliveryPaidBy === 'discount' }"
                        @click="toggleDeliveryPaidBy('discount', $event)"
                      >
                        Доставка - 0 руб.
                      </div>
                      <div 
                        class="footer-dashed-block"
                        :class="{ 'footer-dashed-block-filled': formData.deliveryPaidBy === 'client' }"
                        @click="toggleDeliveryPaidBy('client', $event)"
                      >
                        Доставка - {{ deliveryPrice }}
                      </div>
                    </div>
                    
                    <!-- Пунктирные блоки "Установка" (появляются при выборе комплекса и подходящем типе доставки) -->
                    <div class="footer-dashed-blocks-row" v-if="showInstallationBlock && formData.installationComplex">
                      <div 
                        class="footer-dashed-block"
                        :class="{
                          'footer-dashed-block-filled': formData.installationPaidBy === 'discount',
                          'footer-dashed-block-disabled': formData.installationPaidBy !== 'discount'
                        }"
                        :title="formData.installationPaidBy !== 'discount' ? 'Оплата комплекса за счет скидки отключена' : ''"
                        @click="toggleInstallationPaidBy('discount', $event)"
                      >
                        {{ getComplexName() }} - 0 руб.
                      </div>
                      <div 
                        class="footer-dashed-block"
                        :class="{ 'footer-dashed-block-filled': formData.installationPaidBy === 'client' }"
                        @click="toggleInstallationPaidBy('client', $event)"
                      >
                        {{ getComplexName() }} - {{ getComplexPrice() }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="order-table-footer__right patch-target">
  <ul class="order-table-footer__list order-table-footer__list_info">
    <li class="order-table-footer__list-item">
      <p class="order-table-footer__text order-table-footer__text_muted order-table-footer__text_full">
        Стоимость товаров
      </p>
      <p class="order-table-footer__text order-table-footer__text_price">
        {{ totalPrice.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} руб.
      </p>
    </li>
    <li
  class="order-table-footer__list-item"
  v-if="!isNaN(parseFloat(formData.tradeInAmountNew)) && parseFloat(formData.tradeInAmountNew) > 0"
>
  <p class="order-table-footer__text order-table-footer__text_muted order-table-footer__text_full">
    Скидка за старый аккумулятор
  </p>
  <p class="order-table-footer__text order-table-footer__text_price">
    {{
      parseFloat(formData.tradeInAmountNew).toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    }} руб.
  </p>
</li>
    
    <li class="order-table-footer__list-item" v-if="this.deliveryCost > 0">
      <p class="order-table-footer__text order-table-footer__text_muted order-table-footer__text_full">
        Стоимость доставки
      </p>
      <p class="order-table-footer__text order-table-footer__text_price">
        {{ this.deliveryCost.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} руб.
      </p>
    </li>
    <li class="order-table-footer__list-item">
      <p class="order-table-footer__text order-table-footer__text_muted order-table-footer__text_full">
        Сумма скидок
      </p>
      <p class="order-table-footer__text order-table-footer__text_price">
        {{ totalDiscount.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} руб.
      </p>
    </li>

  </ul>
  <p class="order-table-footer__total">
    Итого:
    <span>
      {{ grandTotal.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} руб.
    </span>
  </p>
  <!--<p class="order-table-footer__total"> 
    Итого:
 <input
  type="number"
  step="0.01"
  :value="displayGrandTotal"
  @input="manualTotalInput = $event.target.value"
  @blur="applyManualGrandTotal"
/>
    руб.
  </p>-->
  
  <!-- Блок "Взять с клиента" -->
  <div class="order-table-footer__client-amount" style="display: flex; align-items: center; gap: 10px; margin-top: 15px; padding-top: 15px; border-top: 1px solid #e9ecef;">
    <p class="order-table-footer__text order-table-footer__text_muted" style="margin: 0; min-width: 140px;">
      Взять с клиента:
    </p>
    <input
      type="number"
      step="0.01"
      v-model.number="takeFromClient"
      @keyup.enter="calculateClientAmount"
      class="input-field"
      style="width: 150px; padding: 6px 10px; border: 1px solid #dee2e6; border-radius: 4px; font-size: 14px;"
      placeholder="0.00"
    />
    <button
      type="button"
      @click="calculateClientAmount"
      class="btn btn-primary"
      style="padding: 6px 20px; font-size: 14px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; transition: background 0.2s;"
      :style="{ background: '#007bff' }"
      onmouseover="this.style.background='#0056b3'"
      onmouseout="this.style.background='#007bff'"
    >
      Рассчитать
    </button>
</div>

  <!-- Отображение дополнительной скидки -->
  <div v-if="additionalMainProductDiscount > 0" class="order-table-footer__additional-discount" style="margin-top: 10px; padding-top: 10px; border-top: 1px solid #e9ecef;">
    <p class="order-table-footer__text order-table-footer__text_muted" style="margin: 0; font-size: 13px; color: #868e96;">
      Дополнительная скидка: 
      <span style="color: #28a745; font-weight: 600;">
        {{ additionalMainProductDiscount.toFixed(2) }} руб.
      </span>
    </p>
  </div>
</div>

        </div>
        <!-- /order-list-with-client__main -->
        </div>
        <!-- /order-list-with-client -->

    </div>
</div>















</div>




      <div class="m-box m-box__template-group-main mn-or-info" v-if="isFieldVisible('control') && !isLogist">   
        <div id="order-control" class="collapse-section template-block" data-template-block-code="common">
          <div class="collapse-section__head">
              <div class="collapse-section__title">Контроль</div>
              <div class="collapse-section__head-col">
                  <div class="collapse-section__head-content"></div>
                  <div class="section-error" v-if="error">
                      <div class="section-error__icon">
                          <svg class="svg-icon">
                              <use xlink:href="/build/icons.03e7bd82.svg#error_outlined"></use>
                          </svg>
                      </div>
                      <div class="section-error__text" v-if="!isFieldFilled">Не заполнено обязательное поле</div>
                  </div>
                  <div class="collapse-section__btn" @click="toggleSection">
                      <svg class="svg-icon">
                          <use :xlink:href="sectionExpanded ? '/build/icons.03e7bd82.svg#chevron_down' : '/build/icons.03e7bd82.svg#chevron_up'"></use>
                      </svg>
                  </div>
              </div>
          </div>

        <div  class="collapse-section__body">
            <div class="bk">
                <div
                  class="input-group cleared tegi-dialoga-block"
                  v-if="tegiDialogaTags.length"
                >
                  <label>Теги диалога</label>
                  <div class="tegi-dialoga-tags">
                    <span v-for="tag in tegiDialogaTags" :key="tag" class="tag-item">{{ tag }}</span>
                  </div>
                </div>

                <div class="input-group cleared">
                    <label for="orderType" >Оценка менеджеру</label>
                    <v-select 
                        :options="ocenka_manageruList" 
                        v-model="formData.ocenka_manageru" 
                        label="label" 
                        placeholder="- Укажите значение -" 
                        :class="{ 'is-invalid': errors.ocenka_manageru, 'is-valid': formData.ocenka_manageru }"
                       
                    ></v-select>
                </div>

                <div class="input-group cleared">
                    <label for="orderType" >Оценка продавцу</label>
                    <v-select 
                        :options="ocenkaprodavcuList" 
                        v-model="formData.ocenkaprodavcu" 
                        label="label" 
                        placeholder="- Укажите значение -" 
                        :class="{ 'is-invalid': errors.ocenkaprodavcu, 'is-valid': formData.ocenkaprodavcu }"
                       
                    ></v-select>
                </div>


                <div class="input-group cleared">
                    <label for="orderType" >Оценка курьеру</label>
                    <v-select 
                        :options="ocenochka_kureruList" 
                        v-model="formData.ocenochka_kureru" 
                        label="label" 
                        placeholder="- Укажите значение -" 
                        :class="{ 'is-invalid': errors.ocenochka_kureru, 'is-valid': formData.ocenochka_kureru }"
                       
                    ></v-select>
                </div>

                <div class="input-group cleared">
                    <label for="orderType" >Приглашение на СТО</label>
                    <v-select 
                        :options="dgh66hhhhhhhList" 
                        v-model="formData.dgh66hhhhhhh" 
                        label="label" 
                        placeholder="- Укажите значение -" 
                        :class="{ 'is-invalid': errors.dgh66hhhhhhh, 'is-valid': formData.dgh66hhhhhhh }"
                       
                    ></v-select>
                </div>


               <div class="input-group cleared">
                    <label for="orderType" >Проверка заказа менеджер</label>
                    <v-select 
                        :options="proverkazakazamenedgeroList" 
                        v-model="formData.proverkazakazamenedgero" 
                        label="label" 
                        placeholder="- Укажите значение -" 
                        :class="{ 'is-invalid': errors.proverkazakazamenedgero, 'is-valid': formData.proverkazakazamenedgero }"
                       
                    ></v-select>
                </div>

                <div class="input-group cleared">
                    <label for="orderType">Обзвон клиента</label>
                    <v-select 
                        :options="obzvon_klientaList" 
                        v-model="formData.obzvon_klienta" 
                        label="label" 
                        placeholder="- Укажите значение -" 
                        :class="{ 'is-invalid': errors.obzvon_klienta, 'is-valid': formData.obzvon_klienta }"
                       
                    ></v-select>
                </div>

                <div class="input-group cleared">
                    <label class="label-common" for="zvonok_text_bot">Текст звонка (бот)</label>
                    <textarea id="zvonok_text_bot" v-model="formData.zvonok_text_bot" class="input-field" rows="4"></textarea>
                </div>

                 <!-- Поле выбора даты отгрузки -->
                <div class="input-group cleared">
                    <label class="label-common" for="shipmentDate">Дата обработки заказа</label>

                    <date-picker 
                        v-model="formData.datazakazaobrabotki" 
                        lang="ru" 
                        :format="'DD.MM.YYYY'" 
                        placeholder="Выберите дату" 
                        input-class="input-field"
                    ></date-picker>
                </div>

                <div class="input-group cleared">
                    <label class="label-common" for="dataSoglasovaniia">
                      Дата согласования
                      <span v-if="isAgreementDateRequiredStatus((selectedStatusOrder && selectedStatusOrder.value) || orderStatusFetch)" class="required">*</span>
                    </label>
                    <date-picker
                        v-model="formData.dataSoglasovaniia"
                        type="datetime"
                        lang="ru"
                        :format="'DD.MM.YYYY HH:mm'"
                        placeholder="Дата и время"
                        :input-class="'input-field' + (errors.dataSoglasovaniia ? ' is-invalid' : '')"
                        @input="errors.dataSoglasovaniia = null"
                    ></date-picker>
                    <span v-if="errors.dataSoglasovaniia" class="error-message">{{ errors.dataSoglasovaniia }}</span>
                </div>

                <!-- Менеджер -->
                <div class="input-group cleared">
                  <label class="label-common" for="sf_num">Корректировка заказа</label>
                  <input type="text" id="sf_num" v-model="formData.sf_num" class="input-field">
                </div>

            </div>
            </div>
        </div>
      </div>








  <div class="list-box-two">
  <div class=" m-box__left-side">

  <div id="order-delivery" class="collapse-section template-block" data-template-block-code="delivery">
    <div class="collapse-section__head">
      <div class="collapse-section__title">
        Отгрузка и доставка
      </div>
      
    </div>

    <div class="collapse-section__body" >
      <div class="bk no-top-border" data-order-section="shipment">
        <div class="bk-control cleared">
          <div class="red-tl">Склад</div>
          <div class="sl-lk sl-lk_gorizontal">
            
          </div>
        </div>

        <!-- Поле выбора склада -->
        <div class="input-group cleared">
          <label class="label-common" for="shipmentStore">Склад отгрузки</label>
          <v-select v-model="formData.shipmentStore" :options="shipmentStores"  id="shipmentStore" name="shipmentStore" class="input-field" placeholder="- Не указан -" @input="(value) => { onShipmentStoreChange(value); }"></v-select>
           <input type="hidden"  v-model="formData.store" >
                        
        </div>

        <!-- Поле выбора даты отгрузки -->
        <div class="input-group cleared">
            <label class="label-common" for="shipmentDate">Дата отгрузки</label>

            <date-picker 
                v-model="formData.shipmentDate" 
                lang="ru" 
                :format="'DD.MM.YYYY'" 
                placeholder="Выберите дату" 
                input-class="input-field"
            ></date-picker>
        </div>

        
      </div>

      <div class="bk" data-order-section="dimensions">
        <div class="bk-control cleared">
          <div class="red-tl">Габариты и вес</div>
        </div>
        <div class="input-group cleared">
          <label class="label-common" for="weight">Вес</label>
          <input type="text" id="weight" v-model="weight" class="input-field">
        </div>
        <div class="input-group cleared">
          <label class="label-common" for="dimensions">Габариты</label>
          <input type="text" id="length" v-model="length" placeholder="Длина" class="input-field" style="margin-right: 10px;">
          <input type="text" id="width" v-model="width" placeholder="Ширина" class="input-field" style="margin-right: 10px;">
          <input type="text" id="height" v-model="height" placeholder="Высота" class="input-field">
        </div>
      </div>

      <!-- Поля для адреса доставки -->
      <div class="bk" data-order-section="delivery">
        <div class="bk-control cleared">
          <div class="red-tl">Адрес доставки</div>
        </div>



        <!-- Курьер-->
                <div class="input-group cleared" >
                    <label for="manager">Курьер</label>
                    <v-select :options="curiers" v-model="formData.curier" label="label" placeholder="- Укажите курьера -"></v-select>
                </div>

        <!-- Регион -->
        <div :class="['input-group', { updated: updatedFields.deliveryregion }]">
          <label class="label-common" for="deliveryAddressRegion">Регион</label>
          <v-select
            v-if="regions.length"
            v-model="formData.deliveryregion"
            id="deliveryAddressRegion"
            @input="onRegionSelect"
            :options="regions"
            placeholder="- Укажите регион -"
            taggable
             @tag="addNewRegion"
          ></v-select>
        </div>


    <!-- Город -->
    <div :class="['input-group', 'street-field-group', { updated: updatedFields.deliverycity && !citySuggestions.length, 'street-not-in-directory': citySuggestions.length > 0 }]">
      <label class="label-common" for="deliveryAddressCity">Город</label>
      <div class="street-field-control">
        <v-select
          id="deliveryAddressCity"
          v-model="formData.deliverycity"
          :options="cities"
          @input="onCitySelect"
          @search="fetchCities"
          placeholder="- Укажите город -"
          taggable
          @tag="addNewCity"
        ></v-select>
        <div v-if="citySuggestions.length" class="street-directory-hint">
          Несколько населённых пунктов в Беларуси — выберите нужный.
        </div>
        <div v-if="citySuggestions.length" class="street-suggestions city-suggestions">
          <button
            v-for="c in citySuggestions"
            :key="'city-sug-' + c.value"
            type="button"
            class="street-suggestion-btn"
            @click="selectCitySuggestion(c)"
          >{{ c.label }}</button>
        </div>
        <div v-if="addressCandidates.length" class="street-suggestions city-suggestions">
          <button
            v-for="(c, idx) in addressCandidates"
            :key="'addr-cand-' + idx"
            type="button"
            class="street-suggestion-btn"
            @click="selectAddressCandidate(c)"
          >{{ c.buttonLabel || c.text }}</button>
        </div>
      </div>
    </div>

    <!-- Улица -->
    <div :class="['input-group', 'street-field-group', { updated: updatedFields.deliverystreet && !isStreetNotInDirectory, 'street-not-in-directory': isStreetNotInDirectory }]">
      <label class="label-common" for="deliveryAddressStreet">Улица</label>
      <div class="street-field-control">
        <v-select
          id="deliveryAddressStreet"
          v-model="formData.deliverystreet"
          :options="streets"
          @search="fetchStreets"
          @input="onStreetSelect"
          placeholder="- Укажите улицу -"
          taggable
          @tag="addNewStreet"
        ></v-select>
        <div v-if="isStreetNotInDirectory" class="street-directory-hint">
          Не из справочника — выберите из списка, если есть (сохранить можно и так).
        </div>
        <div v-if="streetSuggestions.length" class="street-suggestions">
          <button
            v-for="s in streetSuggestions"
            :key="s.value"
            type="button"
            class="street-suggestion-btn"
            @click="selectStreetSuggestion(s)"
          >{{ s.label }}</button>
        </div>
      </div>
    </div>

    <div class="address-details-compact">
      <div :class="['input-group', { updated: updatedFields.deliverybuilding }]">
        <label class="label-common" for="deliveryAddress_building">Дом</label>
        <input type="text" id="deliveryAddress_building" v-model="formData.deliverybuilding" autocomplete="disabled" class="input-field" >
      </div>

      <div class="input-group cleared">
        <label class="label-common" for="deliveryAddress_housing">Корпус</label>
        <input type="text" id="deliveryAddress_housing" v-model="formData.housing" autocomplete="disabled" class="input-field" >
      </div>

      <div class="input-group cleared">
        <label class="label-common" for="deliveryAddress_block">Подъезд</label>
        <input type="text" id="deliveryAddress_block" v-model="formData.block" autocomplete="disabled" class="input-field" >
      </div>
     
      <div class="input-group cleared">
        <label class="label-common" for="deliveryAddress_floor">Этаж</label>
        <input type="text" id="deliveryAddress_floor" v-model="formData.floor" autocomplete="disabled" class="input-field" >
      </div>
    </div>

  <div class="input-group cleared ">
      <label class="label-common" for="deliveryAddress_flat">Квартира</label>
      <input type="text" id="deliveryAddress_flat" v-model="formData.flat" autocomplete="disabled" class="input-field" >
    </div>
  


        <div class="input-group cleared">
          <label class="label-common" for="deliveryCost">Стоимость доставки</label>
          <input type="text" id="deliveryCost" v-model="deliveryCost" class="input-field">
        </div>
        <div class="input-group cleared street-field-group">
          <label class="label-common" for="deliveryAddress">Адрес</label>
          <div class="street-field-control">
            <textarea
              id="deliveryAddress"
              v-model="deliveryAddress"
              class="input-field"
              @blur="onDeliveryAddressBlur"
            ></textarea>
            <button
              type="button"
              @click="splitAddress()"
              class="split-address-btn"
              :disabled="addressResolving"
            >{{ addressResolving ? 'Распознаём…' : 'Разбить адрес по отдельным полям' }}
</button>
            <div v-if="addressResolveStatus" class="street-directory-hint">{{ addressResolveStatus }}</div>
          </div>
        </div>
      <!-- кнопка скопировать-->
       <div class="block-address-btn">
        <button 
  @click="copyAdress" 
  class="address-btn-copy" 
  :style="{ color: isAddressCopied ? '#28a745' : '', transition: 'color 0.3s' }"
>
  <span v-if="!isAddressCopied">Скопировать адрес</span>
  <span v-else>Скопировано</span>

  <i data-v-5d05c032="" class="fa" style="margin-left: 5px;">
    <svg v-if="!isAddressCopied" data-v-5d05c032="" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 2048 2048" fill="currentColor">
      <path data-v-5d05c032="" d="M416 0h979v1l31 4 22 6 21 9 16 9 16 12 10 9 13 13 12 16 11 19 9 21 5 18 3 17 1 12v133h129l22 2 15 3 17 5 18 8 18 10 17 13 13 12 10 11 10 14 9 15 7 15 6 17 5 22 2 21v1406l-2 19-4 20-6 18-7 16-13 21-13 16-16 16-19 14-20 11-20 8-15 4-17 3-12 1H711l-21-2-20-5-19-7-16-8-16-10-13-11-11-10-7-8-9-11-12-19-9-19-6-18-4-20-2-20v-129H420l-23-2-20-4-20-7-19-9-11-7-16-12-15-14-7-8-10-13-9-15-8-16-6-16-5-21-2-15-1-26V177l1-18 3-19 6-21 6-15 10-19 12-17 11-12 14-14 15-11 15-9 14-7 24-8 15-3 22-3zm10 94-16 1-13 3-16 8-9 6-8 7-10 13-7 14-4 13-1 6-1 1399 1 16 4 16 8 16 8 11 8 8 13 9 10 5 14 4 8 1 117 1h717l151-1 11-2 12-4 15-8 11-9 8-9 8-13 5-13 2-9 1-10V169l-3-16-5-13-7-12-11-12-8-7-14-8-15-5-5-1-21-1zm1139 298-1 1187-2 19-5 21-7 19-11 21-8 12-11 13-7 8-11 10-17 12-14 8-15 7-18 6-18 4-15 2-44 1H640l-1 1v132l2 11 4 12 7 13 7 9 10 10 12 8 11 5 17 4 13 1h936l42-1 16-4 16-8 10-7 11-11 7-11 6-13 3-11 1-7V465l-3-16-7-16-7-11-13-13-11-7-10-5-13-4-6-1z"></path>
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
    </svg>
  </i>
</button>
      </div>
      <!--конец кнопки скопировать-->

        <div class="input-group cleared">
          <label class="label-common" for="marssh">Маршрутный лист курьера</label>
          <input type="text" id="marssh" v-model="formData.marssh" class="input-field" placeholder="Введите маршрутный лист курьера">
        </div>
        <div class="input-group cleared">






          <label class="label-common" for="deliveryDate">Дата доставки</label>
          <date-picker 
                v-model="formData.deliveryDate" 
                lang="ru" 
                :format="'DD.MM.YYYY'" 
                placeholder="Выберите дату" 
                :input-class="'input-field' + (errors.deliveryDate ? ' is-invalid' : '')"
                :disabled-date="disabledVozimDeliveryDate"
                @input="onDeliveryDateInput"
            ></date-picker>
          <span v-if="errors.deliveryDate" class="error-message">{{ errors.deliveryDate }}</span>
        </div>
        
         <div class="input-group cleared" id="time-group">
            <label class="label-common" for="delivery-time-from">Время доставки</label>

            <div class="gray-bg fs13 time-interval-widget">
              <span class="inputs">
                <span class="exact" v-if="isExactMode">
                  в
                </span>
                <span class="range" v-if="isRangeMode">
                  с
                </span>
                <span class="exact range" v-if="isRangeMode">
                  <input
                    type="text"
                    v-model="timeFrom"
                    v-mask="'##:##'"
                    id="delivery-time-from"
                    placeholder="чч:мм"
                    class="range short center"
                    
                  />
                </span>
                <span class="range" v-if="isRangeMode">
                  по
                  <input
                    type="text"
                    v-model="timeTo"
                    v-mask="'##:##'"
                    id="delivery-time-to"
                    placeholder="чч:мм"
                    class="range short center"
                   
                  />
                </span>
                <span class="custom" v-if="isCustomMode">
                  <input
                    type="text"
                    v-model="customTime"
                    id="delivery-time-custom"
                    placeholder="Введите своё время"
                    class="big left"
                    @input="updateTime"
                  />
                </span>
              </span>

              <span class="select-time-btn dropdown no-set down" @click="toggleDropdown">
                <a href="#">...</a>
                <ul v-if="dropdownVisible">
                  <li v-for="(range, index) in timeRanges" :key="index">
                    <a class="range" href="#" @click.prevent="selectRange(range)">
                      {{ range.label }}
                    </a>
                  </li>
                  <li>
                    <a class="custom-range" href="#" @click.prevent="activateCustomRange">
                      другой диапазон
                    </a>
                  </li>
                  <li>
                    <a class="custom-value" href="#" @click.prevent="activateCustomValue">
                      другое
                    </a>
                  </li>
                  <li>
                    <a class="clear" href="#" @click.prevent="clearTime">
                      очистить
                    </a>
                  </li>
                </ul>
              </span>
            </div>
          </div>

          

          <div class="input-group cleared">
                        <label  for="dostavka_bez_oplaty">Доставка на наш магазин товара (без оплаты + приемка)</label> 
                        <v-select :options="dostavka_bez_oplaty" v-model="formData.dostavka_bez_oplaty" label="label" placeholder="- Укажите значение -"></v-select>
                        
                    </div>

          <div class="input-group cleared">
            <label class="label-common" for="vgvgvgv">№ ВГ:</label>
            <input type="text" id="vgvgvgv" v-model="vgvgvgv" class="input-field">
          </div>

          <!-- WB FBS: сборка / наклейки -->
          <div v-if="isWbOrder" class="wb-fulfill-panel">
            <div class="input-group cleared">
              <label class="label-common" for="wbAssembled">Собран (WB)</label>
              <input
                type="checkbox"
                id="wbAssembled"
                v-model="wbAssembled"
                class="input-field"
              >
              <span class="wb-fulfill-hint">Отметить → статус «Доставка ТК» + отгрузка на WB</span>
            </div>
            <div class="wb-fulfill-docs">
              <div class="wb-fulfill-docs__title">
                Наклейки WB
                <button type="button" class="btn btn-sm" :disabled="wbDocsLoading" @click="loadWbDocs(true)">
                  {{ wbDocsLoading ? 'Загрузка…' : 'Обновить' }}
                </button>
              </div>
              <div v-if="vgvgvgv" class="wb-fulfill-vg">Поставка (ВГ): <strong>{{ vgvgvgv }}</strong></div>
              <div v-if="wbDocs && wbDocs.stickers && wbDocs.stickers.length" class="wb-fulfill-block">
                <div class="wb-fulfill-block__head">
                  1. Стикер на товар
                  <button type="button" class="btn btn-sm btn-primary" @click="printWbDocs('stickers')">Печать</button>
                </div>
                <div class="wb-fulfill-grid">
                  <div v-for="(s, i) in wbDocs.stickers" :key="'st'+i" class="wb-fulfill-item">
                    <img :src="'data:image/png;base64,' + s.file" alt="sticker">
                    <div class="wb-fulfill-cap">#{{ s.orderId }} {{ s.partA }} {{ s.partB }}</div>
                  </div>
                </div>
              </div>
              <div v-if="wbDocs && wbDocs.trbxStickers && wbDocs.trbxStickers.length" class="wb-fulfill-block">
                <div class="wb-fulfill-block__head">
                  2. Короб / QR короба
                  <button type="button" class="btn btn-sm btn-primary" @click="printWbDocs('boxes')">Печать</button>
                </div>
                <div class="wb-fulfill-grid">
                  <div v-for="(s, i) in wbDocs.trbxStickers" :key="'bx'+i" class="wb-fulfill-item">
                    <img :src="'data:image/png;base64,' + s.file" alt="box">
                    <div class="wb-fulfill-cap">{{ s.trbxId }}</div>
                  </div>
                </div>
              </div>
              <div v-if="!wbDocsLoading && (!wbDocs || !(wbDocs.stickers && wbDocs.stickers.length))" class="wb-fulfill-empty">
                Наклеек пока нет. Переведите заказ в «Комплектуется склад Карвата» — стикеры появятся сами.
              </div>
            </div>
          </div>

      </div>
    </div>
  </div>



 <div id="order-payment" class="collapse-section template-block" data-template-block-code="payment">
    <!-- Заголовок секции -->
    <div class="collapse-section__head">
      <div class="collapse-section__title">Оплата</div>
      <div class="collapse-section__head-col">
        <div class="collapse-section__head-content"></div>
        <div class="section-error">
          <div class="section-error__icon">
            <svg class="svg-icon">
              <use xlink:href="/build/icons.f8cd2060.svg#error_outlined"></use>
            </svg>
          </div>
          <div class="section-error__text section-error__text_usual">Ошибка в блоке</div>
          <div class="section-error__text section-error__text_require">Не заполнено обязательное поле</div>
        </div>
        <div class="collapse-section__btn" @click="togglePaymentSection">
          <svg class="svg-icon">
            <use :xlink:href="paymentSectionExpanded ? '/build/icons.f8cd2060.svg#chevron_up' : '/build/icons.f8cd2060.svg#chevron_down'"></use>
          </svg>
        </div>
      </div>
    </div>

    <!-- Содержимое секции -->
    <div v-if="paymentSectionExpanded" class="collapse-section__body">
      <div class="bk" data-order-section="payments">
        <div class="cleared info_pay_block">
          <!-- Поле "Номер реестра" -->


          <div class="input-group cleared">
                        <label  for="link_oplata">Отправить ссылку на оплату</label>
                        <input type="checkbox" id="link_oplata" v-model="formData.link_oplata" class="input-field" value="1">
                    </div>



          <div class="input-group cleared">
            <label class="label-common" for="registryNumber">Номер реестра</label>
            <input type="text" id="registryNumber" v-model="formData.registryNumber" class="input-field">
          </div>

            <div class="input-group cleared">
                        <label  for="predoplata">Предоплата безналичными (справочник)</label> 
                        <v-select :options="predoplata" v-model="formData.predoplata" @input="validateField('predoplata')" label="label" placeholder="- Укажите значение -" :class="{ 'is-invalid': errors.predoplata, 'is-valid': formData.predoplata && !errors.predoplata }"></v-select>
                        <span v-if="errors.predoplata" class="error-message">✖ {{ errors.predoplata }}</span>
                    </div>

          <div class="input-group cleared">
            <label class="label-common" for="vznos">Сумма первого взноса</label>
            <input type="text" id="vznos" v-model="formData.vznos" class="input-field" placeholder="0.00">
          </div>

          <!-- Чекбокс "Отгрузка без оплаты" -->
          <div class="input-group cleared">
            <label class="label-common" for="shipmentWithoutPayment">Отгрузка без оплаты</label>
            <input type="checkbox" id="shipmentWithoutPayment" v-model="formData.shipmentWithoutPayment" class="input-field" value="1">
          </div>

          
          <!-- Итоговая сумма -->
          <div class="input-group cleared">
            <label class="label-common">К оплате</label>
            <div id="order-to-pay-summ" class="gray-bg fs13 static">
              {{ grandTotal.toLocaleString() }}&nbsp;<span class="currency-symbol byn">руб.</span>
            </div>
          </div>
        </div>

        <!-- Список платежей -->
        <div id="payments" class="cleared">
          <div v-for="(payment, index) in payments" :key="index" class="payment">
            <div class="divider-title">
              <span class="controls">{{ payment.name }}</span>
            </div>
            <div class="field-for-group cleared">
              <div class="payment__content-wrapper">
                <!-- Удаление платежа -->
                <a href="#" title="Удалить оплату" @click.prevent="removePayment(index,payment.id)" class="tr-delete"></a>

                <!-- Статус платежа -->
                  <div class="input-group cleared">
                    <label class="label-common">Статус</label>
                    <select v-model="payment.status" @change="updatePayments" class="input-field">
                      <option v-for="status in getPaymentStatuses(payment.type)" :key="status" :value="status">
                        {{ formatStatusLabel(status) }}
                      </option>
                    </select>
                  </div>

                <!-- Дата платежа -->
                  <div class="input-group cleared">
                    <label class="label-common">Дата оплаты</label>
                    <date-picker v-model="payment.date" @change="updatePayments" lang="ru" :format="'DD.MM.YYYY'" input-class="input-field"></date-picker>
                  </div>

                <!-- Сумма платежа -->
                <div class="input-group cleared">
                  <label class="label-common">Сумма</label>
                  <input
                    type="number"
                    v-model.number="payment.amount"
                    @input="updatePaymentAmounts(index, payment.amount)"
                    @blur="updatePayments"
                    class="input-field"
                    min="0"
                    :readonly="isPaymentAmountLocked(payment)"
                    :title="isPaymentAmountLocked(payment) ? 'Оплаченную сумму нельзя менять' : ''"
                  />
                </div>

                <!-- Чекбокс "Не менять" -->
                <div class="input-group cleared">
                  <label class="label-common payment-fixed-checkbox">
                    <input 
                      type="checkbox" 
                      v-model="payment.fixedAmount"
                      :disabled="isPaymentPaid(payment)"
                    />
                    <span>Не менять</span>
                  </label>
                </div>

                <!-- Кнопка "Списать бонусы" для типа bonusami -->
                <div v-if="payment.type === 'bonusami'" class="input-group cleared" style="text-align: right;display: flex;justify-content: flex-end;padding: 2px 18px;">
                  <button type="button" class="btn-default" @click="spisatBonusy(payment, index)" style="background: transparent;border: 0px;font-size: 12px;border-bottom: 1px dotted;color: #005eeb;">
                    Списать бонусы
                  </button>
                </div>

                <!-- Комментарий -->
                <div class="input-group cleared">
                  <a href="javascript:void(0);" class="show-next-block-link link-inline controls" @click="toggleComment(payment)">Добавить комментарий</a>
                </div>
                <div v-if="payment.showComment" class="input-group cleared">
                  <label class="label-common">Комментарий</label>
                  <textarea v-model="payment.comment" @blur="updatePayments" class="input-field"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Кнопка "Добавить оплату" -->
        <div class="bk__footer bk__footer_dark">
          <div class="controls dropdown no-set add-payment-type">
            <a href="#" @click.prevent="toggleDropdownPay">
              <span>Добавить оплату</span>
            </a>
            <div class="ul-scroll-dropdown-wrapper" :style="{ display: dropdownOpen ? 'block' : 'none' }">
              <ul class="dropdown-with-hints">
                <li v-for="(paymentType, index) in paymentTypes" :key="index" :data-type-id="paymentType.id">
                  <a href="#" @click.prevent="addPayment(paymentType)">
                    {{ paymentType.label }}
                  </a>
                  <div v-if="paymentType.tooltip" class="dropdown-with-hints__hint">
                    <svg class="dropdown-with-hints__hint-icon">
                      <use xlink:href="/build/icons.f8cd2060.svg#error_outlined"></use>
                    </svg>
                    <span class="dropdown-with-hints__tooltip">
                      <p v-for="(text, idx) in paymentType.tooltip" :key="idx" class="dropdown-with-hints__tooltip-text">{{ text }}</p>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>







</div>



<div class="m-box__right-side order-compos">
    <!-- Комментарии клиента -->
    <div class="template-block" data-template-block-code="customer-comment">
      <div id="order-customer-comment" class="collapse-section collapse-section_min">
        <div class="collapse-section__head">
          <div class="collapse-section__title">Комментарии клиента</div>
          
        </div>
        <div class="collapse-section__body" >
            <div class="bk">
          <div class="m-box-content" data-order-section="customer-comment">
            <textarea v-model="formData.customerComment" class="input-field wide"></textarea>
          </div>
      </div>
        </div>
      </div>
    </div>

    <!-- Комментарии оператора -->
    <div class="template-block" data-template-block-code="manager-comment">
      <div id="order-manager-comment" class="collapse-section collapse-section_min">
        <div class="collapse-section__head">
          <div class="collapse-section__title">Комментарии оператора</div>
          
        </div>
        <div class="collapse-section__body" >
            <div class="bk">
          <div class="m-box-content" data-order-section="manager-comment">
            <textarea v-model="managerComment" class="input-field wide"></textarea>
          </div>
          <div class="m-box-content personal-offer-meta">
            <div class="input-group personal-offer-meta__item">
              <label for="visitor_code">Код посетителя</label>
              <input id="visitor_code" type="text" class="input-field" v-model="formData.visitor_code" readonly>
            </div>
            <div class="input-group personal-offer-meta__item">
              <label for="visitor_city">Город посетителя</label>
              <input id="visitor_city" type="text" class="input-field" v-model="formData.visitor_city" readonly>
            </div>
            <div class="input-group personal-offer-meta__item">
              <label for="personal_offer_discount">Товар дня %</label>
              <input id="personal_offer_discount" type="text" class="input-field" v-model="formData.personal_offer_discount" readonly>
            </div>
          </div>
      </div>
        </div>
      </div>
    </div>
  </div>
 </div>

<div class="save-box save-box_with-btns" data-js-save-box="">
    <div class="wrapper" :class="{ 'saved-success': successSaved }">
      <!-- Блок кнопок -->
       <div class="btn__block btn-split">
        <button
          class="white small btn-save-back btn_split-hov btn"
          @click="createOrderExit"
        >
          Сохранить и выйти
        </button>
        <button
          type="submit"
          name="save"
          class="btn_success small btn-save btn"
          @click="createOrder"
        >
          <div class="btn-content btn-content_icon btn-content_done">
            Сохранить
          </div>
        </button>
        <button
          v-if="!formData.moyskladUuid && formData.id && formData.number"
          type="button"
          class="white small btn btn_split-hov btn-sync-ms"
          :disabled="syncMoyskladLoading"
          @click="syncMoyskladUuid"
        >
          <span v-if="syncMoyskladLoading" class="btn-sync-spinner"></span>
          <span v-else>Синхронизировать с МС</span>
        </button>
        <span
        v-if="successSaved"
        class="success-messages"
        style="margin-left: 10px; color: #28a745; font-weight: 400"
      >
        ✔ Успешно сохранено
      </span>
      </div>

      <input type="hidden" name="saveAndBack" v-model="saveAndBack" />

      
      

      <div class="save-box__nav"></div>
    </div>
  </div>


    </div>



<!-- Модальное окно -->
<div v-if="isModalOpenPhone" id="omnica-modal-window-14" aria-hidden="false" aria-modal="true" aria-labelledby="omnica-modal-window-14-title" class="window_TUhCe call-history omnica-modal" style="">
    <div class="ps omnica-modal-window-container">
    <div class="omnica-modal-window omnica-modal-window_popup omnica-modal-window_wide omnica-popper-container">
      <div class="omnica-modal-window__header">
        <div class="omnica-modal-window__title">История звонков</div>
        <div aria-label="Esc" role="button" class="omnica-modal-window__close" @click="closeModalVochi">
          <svg data-v-bf71e310="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="omnica-popper-target" style="width: 100%;"><path data-v-bf71e310="" d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg>
        </div>
      </div>
      <div v-if="isLoadingCall" class="loader-container-call">
        <div class="spinner-call"></div>
      </div>
      <div class="omnica-modal-window__content" v-else>
        <div v-if="!callLogs.length" class="calls-empty-message">Звонки не найдены в Vochi CRM</div>
        <!-- Таблица с историей звонков -->
        <table v-else class="table_AJsNp calls-table">
          <colgroup>
            <col style="width: 120px; min-width: 120px;" />
            <col style="width: 90px; min-width: 90px;" />
            <col style="width: 130px; min-width: 130px;" />
            <col style="width: 140px; min-width: 140px;" />
            <col style="width: 90px; min-width: 90px;" />
            <col style="width: 80px; min-width: 80px;" />
            <col style="width: 320px; min-width: 320px;" />
            <col style="width: 150px; min-width: 150px;" />
          </colgroup>
         <thead>
  <tr>
    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Дата</th>
    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Тип</th>
    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Телефон</th>
    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Менеджер</th>
    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Результат</th>
    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Теги</th>
    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Запись звонка</th>
    <th class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_tiny-1_wc cell_eOMiF cell_left_yyJOq">Расшифровка</th>
  </tr>
</thead>
<tbody>
  <tr v-for="call in callLogs" :key="call._id">
    <!-- Дата -->
    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
      {{ formatDateCall(call.DateReceived) }}
    </td>

    <!-- Тип -->
    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
      {{ getCallType(call.CallType) }}
    </td>

    <!-- Телефон -->
    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
      {{ call.Phone }}
    </td>

    <!-- Менеджер -->
    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY" >
      <div v-if="call.extraData && call.extraData.ExtensionInfo">
        {{ (call.extraData.ExtensionInfo.firstName + ' ' + (call.extraData.ExtensionInfo.lastName || '')).trim() || '—' }}
      </div>
    </td>


    <!-- Результат -->
    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
      {{ getCallStatus(call.CallStatus) }}
    </td>

    <!-- Теги -->
    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY call-tags-cell">
      <span
        v-for="tag in parseTagsString(call.tags)"
        :key="`${call.UniqueId}-${tag}`"
        class="tag-item tag-item_inline"
      >{{ tag }}</span>
    </td>

    <td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY call-record-cell">
  <div class="audio-player-container" v-if="call.filePath">
    <!-- Скрытый audio элемент -->
    <audio 
      :id="'audio-' + call.UniqueId" 
      :src="call.filePath"
      @loadedmetadata="onAudioLoaded(call.UniqueId)"
      @timeupdate="onTimeUpdate(call.UniqueId)"
      @ended="onAudioEnded(call.UniqueId)"
      preload="metadata"
      style="display: none;"
    ></audio>
    
    <!-- Кастомный плеер -->
    <div class="custom-audio-player">
      <!-- Кнопка Play/Pause -->
      <button 
        class="player-btn player-btn-play" 
        @click="togglePlay(call.UniqueId)"
        :title="audioStates[call.UniqueId] && audioStates[call.UniqueId].playing ? 'Пауза' : 'Воспроизвести'"
      >
        <svg v-if="!(audioStates[call.UniqueId] && audioStates[call.UniqueId].playing)" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M8 5v14l11-7z"/>
        </svg>
        <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
        </svg>
      </button>
      
      <!-- Время текущее -->
      <span class="player-time">{{ formatTime(audioStates[call.UniqueId] ? audioStates[call.UniqueId].currentTime : 0) }}</span>
      
      <!-- Прогресс-бар с перемоткой -->
      <div class="player-progress-wrap">
        <input 
          type="range" 
          class="player-progress" 
          min="0" 
          :max="audioStates[call.UniqueId] ? audioStates[call.UniqueId].duration : 100"
          :value="audioStates[call.UniqueId] ? audioStates[call.UniqueId].currentTime : 0"
          @input="seekAudio(call.UniqueId, $event)"
          step="0.1"
        />
        <div 
          class="player-progress-fill" 
          :style="{ width: getProgressPercent(call.UniqueId) + '%' }"
        ></div>
      </div>
      
      <!-- Время общее -->
      <span class="player-time player-duration">{{ formatTime(audioStates[call.UniqueId] ? audioStates[call.UniqueId].duration : 0) }}</span>
      
      <!-- Скорость воспроизведения (кастомный) -->
      <div class="player-speed-wrap">
        <button 
          class="player-speed-btn"
          @click="toggleSpeedMenu(call.UniqueId)"
          :title="'Скорость: ' + (audioStates[call.UniqueId] ? audioStates[call.UniqueId].speed : 1) + 'x'"
        >
          {{ audioStates[call.UniqueId] ? audioStates[call.UniqueId].speed : 1 }}x
        </button>
        <div 
          v-if="speedMenuOpen === call.UniqueId" 
          class="player-speed-menu"
        >
          <button 
            v-for="spd in [0.5, 0.75, 1, 1.25, 1.5, 2]" 
            :key="spd"
            :class="['speed-option', { active: (audioStates[call.UniqueId] ? audioStates[call.UniqueId].speed : 1) === spd }]"
            @click="selectSpeed(call.UniqueId, spd)"
          >
            {{ spd }}x
          </button>
        </div>
      </div>
      
      <!-- Кнопка скачать -->
      <button 
        class="player-btn player-btn-download" 
        @click="downloadCallRecord(call)" 
        title="Скачать MP3"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
        </svg>
      </button>
    </div>
  </div>
  <div v-else class="no-record">Нет записи</div>
</td>

<!-- Новый столбец с кнопкой для расшифровки -->
<td class="UiText-text-2_z8 UiText-text_black-1BwQ UiText-text_small-QTWp cell_OWup9 cell_middle_su8IT cell_left_eorMY">
  <button
    v-if="call.hasTranscription"
    @click="fetchTranscription(call)"
    class="omnica-button omnica-button_transcription"
  >
    Расшифровка разговора
  </button>
  <button
    v-if="hintMode && call.hasTranscription"
    type="button"
    class="omnica-button omnica-button_hint"
    @click="openCallHintForCall(call)"
  >
    подсказка
  </button>
</td>

  </tr>
</tbody>

        </table>
        

      </div>
      
      
      <div class="pystoHistoy" v-if="isLoadingCallHistory">История изменений пуста</div>

      <div class="omnica-modal-window__footer">
        <button type="button" @click="closeModalVochi" class="omnica-button omnica-button_secondary omnica-button_sm">
          Закрыть
        </button>

      </div>
    </div>
  </div>
</div>












<!-- Модалка подсказки ответа клиенту (отдел брак, внутр. номер 192) -->
<div v-if="isHintModalOpen" class="transcription-modal client-hint-modal">
  <div class="transcription-modal-content">
    <div class="transcription-modal-header">
      <h3 class="client-hint-title">{{ hintModalTitle }}</h3>
      <button type="button" @click="closeHintModal" class="close-button tagbutclose">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="width: 100%;"><path d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg>
      </button>
    </div>
    <div class="transcription-modal-body client-hint-body">
      <div v-if="hintLoading" class="client-hint-status">Формируем подсказку по расшифровке…</div>
      <div v-else-if="clientResponseHintError" class="client-hint-status client-hint-error">{{ clientResponseHintError }}</div>
      <template v-else>
        <div v-if="clientResponseHintTopics.length" class="client-hint-claims">
          <strong>{{ hintTopicsLabel }}:</strong>
          <span v-for="(c, i) in clientResponseHintTopics" :key="i" class="tag-item">{{ c }}</span>
        </div>
        <div v-if="hintCatalogPreview.length && hintMode === 'sales'" class="client-hint-catalog">
          <strong>Подходящие АКБ из каталога (по разговору):</strong>
          <ul>
            <li v-for="(item, idx) in hintCatalogPreview" :key="idx">
              {{ item.name }}<template v-if="item.price"> — {{ item.price }} руб.</template>
              <template v-if="item.korpus"> ({{ item.korpus }})</template>
            </li>
          </ul>
        </div>
        <div class="client-hint-text">{{ clientResponseHint }}</div>
      </template>
    </div>
  </div>
</div>

<!-- Новое модальное окно для вывода расшифровки (выезжает справа) -->
<div v-if="isTranscriptionModalOpen" class="transcription-modal">
  <div class="transcription-modal-content">
    <div class="transcription-modal-header">
      <div class="transcription-tags">
        <!-- Вывод тегов (например, если они хранятся как массив) -->
        <span v-for="tag in currentCallTags" :key="tag" class="tag-item">{{ tag }}</span>
      </div>
      <button @click="closeTranscriptionModal" class="close-button tagbutclose"><svg data-v-bf71e310="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="omnica-popper-target" style="width: 100%;"><path data-v-bf71e310="" d="M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z" fill="currentColor"></path></svg></button>
    </div>
    <div class="transcription-modal-body">
      <h3>Расшифровка разговора</h3>
      <div v-html="formatTranscription(transcriptionData)"></div>
    </div>
  </div>
</div>
 






<ProductModal
  :isVisible="isModalVisible"
  :products="products"
  :initialCorpusTypes="vehicleCorpusForCatalog"
  :initialSearchQuery="productModalSearchQuery"
  :isProductInOrder="isProductInOrder"
  @add-product="addOrUpdateProduct"
  @increase-product="increaseProductQuantity"
  @decrease-product="decreaseProductQuantity"
  @close="closeModal"
  @remove-product="removeProduct"
/>

<ProductModalMS
  :isVisible="isModalMSVisible"
  :products="products"
  :isProductInOrder="isProductInOrder"
  @add-product="addOrUpdateProduct"
  @increase-product="increaseProductQuantity"
  @decrease-product="decreaseProductQuantity"
  @close="closeModalMS"
  @remove-product="removeProduct"
/>

<LoaderTable v-if="loading"/>
    <OrderHistoryModal
      :isVisible="showModal"
      :orderId="parseInt(selectedOrderId)"
      :managers="managers"
      :curiers="curiers"
      @close="showModal = false"
    />




<AnalogModal
  :isVisible="isAnalogModalVisible"
  :products="products"
  :isProductInOrder="isProductInOrder"
  :korpusType="selectedKorpusType" 
  @add-product="addOrUpdateProduct"
  @increase-product="increaseProductQuantity"
  @decrease-product="decreaseProductQuantity"
  @close="closeModal"
  @remove-product="removeProduct"
/>

<div
  v-if="isCarSelectorVisible"
  class="car-selector-overlay"
  role="dialog"
  aria-modal="true"
  aria-labelledby="car-selector-title"
  @keydown.esc="closeCarSelector"
>
  <div class="car-selector-modal-shell">
    <header class="car-selector-modal-head">
      <h2 id="car-selector-title" class="car-selector-modal-title">Подбор марки и модели автомобиля</h2>
      <button type="button" class="car-selector-modal-close" aria-label="Закрыть" @click="closeCarSelector">×</button>
    </header>
    <div class="car-selector-modal-body">
      <car-selector ref="carSelector" @select="applyCarSelection" @close="closeCarSelector" />
    </div>
  </div>
</div>


<!-- Тултип остатков по складам при наведении на плашку -->
<div
  v-if="stockHoverVisible && stockHoverProduct"
  class="stock-hover-tooltip"
  :style="{
    position: 'fixed',
    left: stockHoverPosition.x + 'px',
    top: stockHoverPosition.y + 'px',
    zIndex: 5002
  }"
  @mouseenter="keepStockHover"
  @mouseleave="scheduleCloseStockHover"
>
  <div class="stock-hover-tooltip__title">Остатки на складах</div>
  <div v-if="!isProductStockLoaded(stockHoverProduct)" class="stock-hover-tooltip__empty">Загрузка…</div>
  <div v-else-if="!getStockOverviewRows(stockHoverProduct).length" class="stock-hover-tooltip__empty">
    Нет данных по складам
  </div>
  <div v-else class="stock-hover-tooltip__list">
    <div
      v-for="row in getStockOverviewRows(stockHoverProduct)"
      :key="'stock-hov-' + row.id"
      class="stock-hover-tooltip__row"
      :class="{
        'stock-hover-tooltip__row--primary': row.primary,
        'stock-hover-tooltip__row--zero': row.available <= 0
      }"
    >
      <span class="stock-hover-tooltip__label">{{ row.label }}</span>
      <span class="stock-hover-tooltip__qty">{{ row.qtyText }}</span>
    </div>
  </div>
</div>

<!-- Выпадающий список источника товара -->
<div
  v-if="sourceDropdownVisible && sourceDropdownProduct"
  ref="sourceDropdown"
  :style="{
    position: 'fixed',
    left: sourceDropdownPosition.x + 'px',
    top: sourceDropdownPosition.y + 'px',
    width: sourceDropdownWidth + 'px',
    zIndex: 5001
  }"
  class="zakaz-source-dropdown"
  @click.stop
>
  <div class="zakaz-source-dropdown__header">Откуда забрать товар</div>
  <div class="zakaz-source-dropdown__body">
    <div v-if="getProductSources(sourceDropdownProduct).length === 0" class="zakaz-source-empty">
      Нет остатков в магазинах и у поставщиков
    </div>
    <template v-else>
      <div v-if="getSourceGroup(sourceDropdownProduct, 'minsk').length" class="zakaz-source-group">
        <div class="zakaz-source-group__title">Минск</div>
        <button
          v-for="opt in getSourceGroup(sourceDropdownProduct, 'minsk')"
          :key="'m-' + opt.id"
          type="button"
          class="zakaz-source-option"
          :class="{ 'zakaz-source-option--active': isSourceSelected(sourceDropdownProduct, opt) }"
          @click="pickProductSource(sourceDropdownProduct, opt)"
        >
          <span class="zakaz-source-option__label">{{ opt.label }}</span>
          <span class="zakaz-source-option__qty">{{ opt.available }} шт</span>
        </button>
      </div>
      <div v-if="getSourceGroup(sourceDropdownProduct, 'regions').length" class="zakaz-source-group">
        <div class="zakaz-source-group__title">Регионы</div>
        <button
          v-for="opt in getSourceGroup(sourceDropdownProduct, 'regions')"
          :key="'r-' + opt.id"
          type="button"
          class="zakaz-source-option"
          :class="{ 'zakaz-source-option--active': isSourceSelected(sourceDropdownProduct, opt) }"
          @click="pickProductSource(sourceDropdownProduct, opt)"
        >
          <span class="zakaz-source-option__label">{{ opt.label }}</span>
          <span class="zakaz-source-option__qty">{{ opt.available }} шт</span>
        </button>
      </div>
      <div v-if="getSourceGroup(sourceDropdownProduct, 'suppliers').length" class="zakaz-source-group">
        <div class="zakaz-source-group__title">Поставщики</div>
        <button
          v-for="opt in getSourceGroup(sourceDropdownProduct, 'suppliers')"
          :key="'s-' + opt.id"
          type="button"
          class="zakaz-source-option zakaz-source-option--supplier"
          :class="{ 'zakaz-source-option--active': isSourceSelected(sourceDropdownProduct, opt) }"
          @click="pickProductSource(sourceDropdownProduct, opt)"
        >
          <span class="zakaz-source-option__label">{{ opt.label }}</span>
          <span class="zakaz-source-option__qty">{{ opt.available }} шт</span>
        </button>
      </div>
    </template>
  </div>
</div>

<!-- Выпадающий список (ВНЕ таблицы, в самом низу компонента, чтобы был поверх всего) -->
<div v-if="productStatusDropdownVisible"
     ref="productStatusDropdown"
     :style="{ position: 'fixed', left: productStatusDropdownPosition.x + 'px', top: productStatusDropdownPosition.y + 'px', zIndex: 5000 }"
     class="product-status-dropdown">
  <ul class="product-status-dropdown-list">
    <li v-for="status in productStatuses" 
        :key="status.value"
        :class="{ active: currentStatusProduct.status === status.value }"
        @click="setProductStatus(currentStatusProduct, status.value)">
      {{ status.label }}
    </li>
  </ul>
</div>








<PopularBatteriesModal
  :visible="showModalPodborProduct"
  :batteries="popularBatteries"
  :isProductInOrder="isProductInOrder"
  @close="showModalPodborProduct = false"
  @add-product="addOrUpdateProduct"
  @remove-product="removeProduct"
  :managersDict="managers"  
/>

<VisitorLookupModal
  :visible="visitorLookupVisible"
  :code="visitorLookupCode"
  :saved-code="formData.visitor_code"
  @close="visitorLookupVisible = false"
  @save-code="saveVisitorCodeFromLookup"
/>


<!--<Wait />-->

<!-- Модальное окно неактивности (не показывается для отдела контроля) -->
<InactivityModal 
  v-if="!isControlDepartment()"
  :isVisible="showInactivityModal"
  @continue-work="handleContinueWork"
  @close-order="handleCloseOrder"
  @close="closeInactivityModal"
/>




</div>


</template>

<script>
import { ORDERS_API_BASE, MANAGER_API_BASE } from '@/config/api';
import axios from 'axios';
import vSelect from 'vue-select';
import OmnicaSidebar from "./OmnicaSidebar.vue";
import DoubleModal from "./DoubleModal.vue";
import OmnicaTask from "./OmnicaTask.vue";
import OmnicaEditTask from "./OmnicaEditTask.vue";
import 'vue-select/dist/vue-select.css';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Vue from 'vue';
import { VueMaskDirective } from 'v-mask';

Vue.directive('mask', VueMaskDirective);
import LoaderTable from '@/components/LoaderTable.vue';
import ProductModal from '@/components/ProductModal.vue';
import ProductModalMS from '@/components/ProductModalMS.vue';
import QuickProductSearch from '@/components/QuickProductSearch.vue';
import OrderHistoryModal from '@/components/OrderHistoryModal.vue';
import CarSelector from '@/components/CarSelector.vue';
import BatteryAiAssistant from '@/components/BatteryAiAssistant.vue';
import AnalogModal from '@/components/AnalogModal.vue';
import Helper from '@/components/Helper.vue';
import Wait from '@/components/Wait.vue';
import PopularBatteriesModal from '@/components/PopularBatteriesModal.vue';
import VisitorLookupModal from '@/components/VisitorLookupModal.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import { filterFieldsByRole } from '@/assets/filterFieldsByRole';
import { inactivityMixin } from '@/mixins/inactivityMixin.js';
import { sortManagersByLabel } from '@/constants/sortManagers';
export default {

  name: 'OrderEdit',
  mixins: [inactivityMixin],
  inject: ['ws'],
  components: {
  CarSelector,
  BatteryAiAssistant,
  LoaderTable,
  ProductModalMS,
  QuickProductSearch,
  OmnicaSidebar, 
  DoubleModal,
  OmnicaTask,
  OmnicaEditTask,
  ProductModal,
  AnalogModal,
  Helper,
  Wait,
  PopularBatteriesModal,
  OrderHistoryModal,
  VisitorLookupModal,
    'v-select': vSelect,
    'date-picker': DatePicker // Зарегистрируйте DatePicker
  },
  data() {
  return {
    visitorLookupCode: '',
    visitorLookupVisible: false,
    navigationSections: [
      { id: 'order-common', title: 'Основное' },
      { id: 'order-customer', title: 'Клиент' },
      { id: 'order-list', title: 'Товары' },
      { id: 'order-control', title: 'Контроль' },
      { id: 'order-delivery', title: 'Доставка' },
      { id: 'order-payment', title: 'Оплата' },
      { id: 'order-customer-comment', title: 'Комментарий клиента' },
      { id: 'order-manager-comment', title: 'Комментарий менеджера' }
    ],
    activeSection: 'order-common',
    isSticky: false,
    isAddressCopied: false,
  orderViewers: [],
  wsMessageHandler: null, // Обработчик WebSocket сообщений
  formattedPhone: '',
  invalidPhone: false,
  installationPriceError: null,
  installationPrice: null,
  isOpen: false,
  brand: '',
  sidebarVisible: false,
  showDoubleModal: false,
  taskVisible: false,
  successSaved: false,
  syncMoyskladLoading: false,
  productStockData: {},
  productSourcePick: {},
  podZakazStatusValue: 'pod-zakaz',
  podZakazTriggerStatuses: ['send-to-delivery', 'dskjdslksd'],
  sourceDropdownVisible: false,
  sourceDropdownProduct: null,
  sourceDropdownProductId: '',
  sourceDropdownPosition: { x: 0, y: 0 },
  sourceDropdownWidth: 260,
  stockHoverVisible: false,
  stockHoverProduct: null,
  stockHoverPosition: { x: 0, y: 0 },
  stockHoverHideTimer: null,
  stockSourcesFetchTimer: null,
  isInitialized: false,
  isFirstGrandTotalCall: true,
  taskEditVisible: false,
  isVisibleWhere: false,
  pageHistoryCustomField: '',
  visitedProducts: [],
  visitedPages: [],
  visitedProductsLoading: false,
  productModalSearchQuery: '',
  clientBonusMessage: '',
  oplacheno_bonusami:'',
    transcriptionData: {
        dialogue: [],
        tags: ''
      },
       isTranscriptionModalOpen: false,
      isHintModalOpen: false,
      hintLoading: false,
      clientResponseHint: '',
      clientResponseHintClaims: [],
      clientResponseHintTopics: [],
      hintCatalogPreview: [],
      clientResponseHintError: '',
      hintCallId: null,
  isPlaying: {}, // Хранит состояния для каждого UniqueId
      audioStates: {}, // Состояния кастомных аудиоплееров
      speedMenuOpen: null, // ID аудио с открытым меню скорости
      selectedStatusOrder: {},
      isModalOpenPhone: false,
      callLogs: [],
      isLoadingCall:false, // Флаг загрузки
      isLoadingCallHistory: false, // История изменений пуста
                  isLoadingOrder: false, // Флаг загрузки заказа (для предотвращения зацикливания)
      isAdjustingPayments: false, // не зацикливать create/update платежей
      grandTotalPaymentsTimer: null, // debounce автопересчёта платежей от grandTotal
      usersByExtension: {}, // Сопоставление внутреннего номера -> пользователь из users-settings
      statusesOrder: [
        { value: "new", label: "Новый", color: "rgba(254,165,48,1)", class: "new" },
        { value: "propushchennyi-zvonok", label: "Пропущенный", color: "rgba(254,165,48,0.85)", class: "new" },
        { value: "approval", label: "Согласование", color: "rgba(254,165,48,0.2)", class: "approval" },
        { value: "assembling", label: "Сборка", color: "rgba(101,40,215,0.1)", class: "assembling" },
        { value: "delivery", label: "Доставка", color: "rgba(0,94,235,0.13)", class: "delivery" },
        { value: "custom-17", label: "Специальный", color: "rgba(175,185,195,1)", class: "custom-status-color-17" },
        { value: "complete", label: "Завершено", color: "rgba(34,201,147,0.15)", class: "complete" },
        { value: "cancel", label: "Отмена", color: "rgba(255,83,83,0.15)", class: "cancel" },
        { value: "custom-3", label: "Дополнительно", color: "rgba(101,40,215,0.1)", class: "custom-status-color-3" },
        { value: "custom-23", label: "Темный", color: "rgba(30,34,72,1)", class: "custom-status-color-23" },
      ],
      statusGroupsOrder: [
      {
    group: "new",
    color: "rgba(254,165,48,1)",
    options: [
      { value: "2", label: "Новый", disabled: true, class: "new" },
      { value: "new", label: "Новый", dataData: "new", class: "new" },
      { value: "propushchennyi-zvonok", label: "Пропущенный", dataData: "propushchennyi-zvonok", class: "new" }
    ],
      },
        {
    group: "approval",
    color: "rgba(254,165,48,0.2)",
    options: [

      { value: "2", label: "Согласование", disabled: true, class: "approval" },
      { value: "vzial-v-rabotu", label: "Взял в работу", class: "approval" },
      { value: "availability-confirmed", label: "Консультация", dataData: "availability-confirmed", class: "approval" },
      { value: "sdilsddkls", label: "Счет отправлен", class: "approval" },
      { value: "lskdjslkklsk", label: "Ожидание оплаты", class: "approval hide" },
      { value: "dffddsdfsdd", label: "Отложено", class: "approval" },
      { value: "offer-analog", label: "СРЕЗАТЬ", class: "approval" },
      { value: "maslosto", label: "Масло, СТО, запчасти, шины (для Леши)", class: "approval hide" },
      { value: "sdlkfsdjfsdfsdf-sdfgsdf-sdf", label: "с магазина (обзвонить менеджеру)", class: "approval hide" },
      { value: "pod-zakaz", label: "---- товар под З А К А З ----", class: "approval" },
      { value: "novyi-beznalnyi-klient", label: "Новый безнальный клиент", class: "approval" }
    ],
  },
  {
    group: "delivery",
    color: "rgba(0,94,235,0.13)",
    options: [
      { value: "4", label: "Доставка", disabled: true, class: "delivery" },
      { value: "send-to-delivery", label: "Передан в доставку", dataData: "send-to-delivery", class: "delivery" },
      { value: "redirect", label: "Доставка курьером", class: "delivery  hide" },
      { value: "fdjkdfkljd", label: "Доставка транспортной компанией", class: "delivery  hide" },
      { value: "dskjdslksd", label: "Самовывоз", class: "delivery" },
      { value: "zakaz-dostavlen-kur", label: "Заказ доставлен курьером", class: "delivery  hide" },
      { value: "zakaz-magaz", label: "заказ из магазина", class: "delivery" },
      
    ],
  },
  {
    group: "cancel",
    color: "rgba(255,83,83,0.15)", // Примерный цвет для отмененных заказов
    options: [
      { value: "cancel-other", label: "Отмена", disabled: true, class: "cancel" },
      { value: "cancel-other", label: "Отменен", class: "cancel" },
      { value: "otmena-dubl", label: "Отмена дубль", class: "cancel" },
      { value: "otmenaskomentom", label: "Масло, СТО, запчасти, шины (ОТМЕНА с комментом)", class: "cancel" },
      { value: "khkhhjgsdlgtij6", label: "Отмена сдача акб, диагностика", class: "cancel" },
      { value: "otmena-s-necelevoi", label: "Нецелевой (гарантия, неверный номер...) Обязю указывю причину", class: "cancel" },
      { value: "otmena-magas-mesto-man", label: "Отмена с магазина (обзвонить менеджеру)", class: "cancel"},
      { value: "otmena-kupil-u-dr-mened", label: "Отмена купил у другого менеджера", class: "cancel"},
      { value: "otmena-s-otgruzkoi-kureru", label: "3. Отмена с отгрузкой курьеру", class: "cancel"},
      { value: "otmena-vozim-by", label: "4. Отмена с отгрузкой транспортной компании", class: "cancel"},
      { value: "povregden-tovar-piidostavke", label: "10. Поврежден товар при доставке", class: "cancel"},
      { value: "delyvery-did-not-suit", label: "2. Отмена с доставкой Минск", class: "cancel"},
      { value: "otmenasdostavk", label: "2а. Отмена с доставкой ТС", class: "cancel"},
      { value: "prodaza-chastichnaya-sostoyalas", label: "11. Частичная продажа с возвратом на СКЛАД", class: "cancel"},
      { value: "obmen-s-doplatiu", label: "13. Обмен товара с доплатой", class: "cancel"},
      { value: "kiuhhjsdsdkkkkkkk12", label: "15. Отмена с доставкой Минск, неверный подбор, итого купил", class: "cancel"},
      { value: "klkhdshjlsd88sdfsdf898", label: "15b. Отмена с доставкой Минск, неверный подбор, итого НЕ купил", class: "cancel"},
      { value: "kdjfffffff8hjf", label: "15a. Отмена с доставкой Минск, дело не в акб, итого НЕ купил", class: "cancel"},
      { value: "khkhhjgsdlgtij6", label: "16. Отмена сдача акб, диагностика", class: "cancel"},
      { value: "send-to-assembling", label: "5. Отмена отгрузка с КАРВАТА - возврат на магазин розничный", class: "cancel"},
      { value: "otmenasdoskdfjdkfj", label: "2b. Отмена с доставкой ТК товар на складе", class: "cancel"},
      { value: "otmena-sotgruz-kupil", label: "3а. Отмена с отгрузкой курьеру (Итого КУПИЛ)", class: "cancel"},
      { value: "otmena-nashel-konkurentov", label: "7. Отмена нашёл намного дешевле у конкурентов", class: "cancel"},
      { value: "otmenasvozvratomvmagazin", label: "12. Отмена с возвратом в этот же магазин (собственная продажа магазина)", class: "cancel"},
      { value: "5blsdfhoisdhflkdshf", label: "5b. Отмена заказ из магазина", class: "cancel"},
      { value: "otmena-s-necelevoi", label: "17. Нецелевой (гарантия, неверный номер...) Обязю указывю причину", class: "cancel"},
      { value: "kldjfdfdfsdfsdfdfffffffffffffff", label: "Контроль Нецелевой (гарантия, неверный номер...)", class: "cancel"},
    ],
  },
  {
    group: "complete",
    color: "rgba(34,201,147,0.15)", // Примерный цвет для комплектации заказов
    options: [
      
      { value: "5asjkdhgfilu333", label: "5а. Собственная продажа магазина", class: "complete hide" },
      {value: "dsfssffsds", label: "5. Заказ забран", class: "complete hide"},
      {value: "kfhdlfhgkfldfofuglfdlidfhgfdgjlfklghldfk", label: "Контроль Отмена с доставкой Минск", class: "complete hide"},
      {value: "kontrolhgcfxhg", label: "1. Контроль", class: "complete hide"},
      {value: "15k-usljsd-sl", label: "15.КОНТРОЛЬ Отмена с дост Минск, дело не в акб,НЕ купил", class: "complete hide"},
      {value: "vyopilnen-svozvratomvmagaztovara", label: "3. Выполнен отмена отгрузка с КАРВАТА - возврат на САЛЮТЫ", class: "complete hide"},
      {value: "12kontrol-obmen", label: "12. Контроль обмен товара с доплатой", class: "complete hide"},
      {value: "kontrol-vozvrat-na-sklad", label: "11. Контроль частичная продажа с возвратом на СКЛАД", class: "complete hide"},
      {value: "jkjsdlflsdhfgdld", label: "Контроль Конверт", class: "complete hide"},
      {value: "876h-hk-kjhkj", label: "15. КОНТРОЛЬ Отмена с дост Минск, нев под,купил", class: "complete hide"},
      {value: "5asjkdhgfilu333", label: "5а. Собственная продажа магазина", class: "complete hide"},
      {value: "kontrol-vozvratr-magazin", label: "1. Контроль отмена отгрузка с КАРВАТА - возврат на САЛЮТЫ (на любой наш магазин)", class: "complete hide"},
      {value: "6kontrol-otmena-ddubl", label: "6a.Контроль отмена дубль", class: "complete hide"},
      {value: "otmena-sdacha-akb", label: "6b. Контроль отмена диагностика, сдача акб", class: "complete hide"},
      {value: "7kontrol-otmena", label: "7а Контроль ОТМЕНА", class: "complete hide"},
      {value: "kontrol-maslo-sto", label: "КОНТРОЛЬ Масло, СТО, запчасти, шины", class: "complete hide"},
      {value: "kontrol-kupil-u-ddrugogo", label: "Контроль купил у другого менеджера", class: "complete hide"},
      {value: "sobstvenn55proda", label: "Собственная продажа ВЫПОЛНЕНО", class: "complete hide"},
      {value: "samovyvos-zabra-vypol", label: "Самовывоз забран ВЫПОЛНЕНО", class: "complete hide"},
    ],
  },
  {
    group: "dflkdslskl",
    color: "#afb9c3", // Примерный цвет для комплектации заказов
    options: [
      
      {value: "dsfssffsds", label: "5. Заказ забран", class: "complete hide"},
      {value: "1-zakaz-kurerom-dostavlen-dengi-i-bu-sdany", label: "2. заказ курьером доставлен (деньги и бу сданы)!!!!!!" , class: "complete hide"},
      {value: "zamena0po0braku", label: "6. Замена по браку", class:"complete hide"},
      { value: "fdkjsdkjdsklkl1", label: "3. Доставлен ТС", class: "complete hide"},
      { value: "kushddflsidudhy", label: "Доставлен ТС + БУ забрали", class: "complete hide"},
      { value: "nelvvhs47ujgt", label: "Доставлен ТС + БУ НЕ забрали !", class: "complete hide"},
      { value: "povtornaya098", label: "Повторная доставка состоялась", class: "complete hide"},
      { value: "zaradka-akb-uspeshno4", label: "Зарядка АКБ (неудачная)", class: "complete hide"},
      { value: "zaradka-akb-uspeshno", label: "Зарядка АКБ (успешно)", class: "complete hide"},
      { value: "ofis-prinyal-dengi", label: "1. Офис принял деньги", class: "complete hide"},
      { value: "korrektirovka-zakaza", label: "4. корректировка заказа", class: "complete hide"},
    ],
  },
  {
    group: "assembling",
    color: "rgba(101, 40, 215, .1)", // Примерный цвет для комплектации заказов
    options: [
      
      { value: "assembling", label: "1. Комплектуется склад Карвата (Курьер 1)", class: "complete hide" },
      { value: "assembling-complete", label: "2. Комплектуется склад Карвата (Курьер 2)", class: "complete hide"},
      { value: "3-komplektuetsya-sklad-sharangovicha-kurer-1", 'label': '3. Комплектуется склад Карвата (Курьер 3)', class: 'complete hide'},
      { value: "4-komplektuetsya-sklad-sharangovicha-kurer-2", 'label': '4. Комплектуется склад Карвата (Курьер 4)', class: 'complete hide'},
      { value: "ktuetsya-sklad-sharangovicha-kur234234ggg", 'label': '5. Комплектуется склад Карвата (Курьер 5)', class: 'complete hide'},
      { value: "jdhfjfhjdhfjdhfdfhhhhhhhhhhhhh", 'label': '6. Комплектуется склад Карвата (Курьер 6)', class: 'complete hide'},
      { value: "7-komplektuetsia-sklad-karvata-kurer-7", 'label': '7. Комплектуется склад Карвата (Курьер 7)', class: 'complete hide'},
      { value: "8-komplektuetsia-sklad-karvata-kurer-8", 'label': '8-komplektuetsia-sklad-karvata-kurer-8', class: 'complete hide'},
      { value: "9-komplektuetsia-sklad-karvata-kurer-9", 'label': '9-komplektuetsia-sklad-karvata-kurer-9', class: 'complete hide'},
      { value: "10-komplektuetsia-sklad-karvata-kurer-10", 'label': '10. Комплектуется склад Карвата (Курьер 10)', class: 'complete hide'},
    ],
  },
  {
    group: "brak12",
    color: "rgba(101,40,215,0.1)",
    options: [
      
      { value : "1-priniat-na-proverku-sostavleny-vse-bumagi-postavil-na-zariadku", label: "1. Принят на проверку (составлены все бумаги, находится на диагностике у меня)", class:"complete"},
      { value : "2a-akb-zariadilsia-klienta-uvedomil-zhdu-ego-vizita", label: "2а. АКБ зарядился, клиента уведомил, жду его визита (Брака нет)", class:"complete"},
      { value : "2b-ne-zariadilsia-klienta-uvedomil-zhdu-ego-vizita-sniat-s-garantii", label: "2б. НЕ зарядился, клиента уведомил, жду его визита - (СНЯТ с гарантии)", class:"complete"},
      { value : "3-1-s-karvata-peredali-na-mashinostroitelei-servis", label: "3/1 с Карвата передали на Машиностроителей сервис", class:"complete"},
      { value : "3-1-s-karvata-peredali-postavshchiku-importioru-ne-nasha-akb", label: "3/1 с Карвата передали поставщику (импортёру), не наша АКБ", class:"complete"},
      { value : "3-2-s-mashinostroitelei-servis-peredali-na-karvata", label: "3/2 с Машиностроителей сервис  передали на Карвата", class:"complete"},
      { value : "4-otkaz-net-braka-budet-vozvrat-klientu", label: "4. АКБ остаётся на складе у нас, клиенту или деньги или новый", class:"complete"},
      { value : "0-vopros-uregulirovan-klient-bolshe-ne-bespokoit", label: "0. Вопрос урегулирован, клиент больше не беспокоит", class:"complete"},
      { value : "0-neobkhodim-otvet-na-pretenziiu", label: "0. Необходим ответ на претензию", class:"complete"},
      { value : "0-otvet-otpravlen-potrebiteliu", label: "0. Ответ отправлен потребителю", class:"complete"},
      { value : "6-postavshchik-vernul-nam-novyi-akb-vmesto-braka", label: "6. Поставщик вернул нам новый АКБ вместо брака (БРАК остался у поставщика)", class:"complete"},
      { value : "3-2-ot-postavshchika-peredali-na-karvata", label: "3/2 от поставщика передали на Карвата", class:"complete"},
      { value : "4-brak-podtverzhdion-soglasovyvaetsia-zamena-klienta-opovestil", label: "4. Необходимо вернуть клиенту при довозе - или согласовывается замена, клиента оповестил.", class:"complete"},
      { value : "2g-ne-zariadilsia-klienta-uvedomil-chto-peredaiu-na-minsk-vozmozhno-brak", label: "2г. НЕ зарядился, клиента уведомил что возможно БРАК ( передаю на Минск или жду подтверждения что БРАК)", class:"complete"},
      { value : "5-vydan-pokupateliu-novyi-akb-dokumenty-podpisany-vopros-zakryt", label: "5г. Выдан покупателю НОВЫЙ АКБ вместо его БРАКА ( Вопрос закрыт)", class:"complete"},
      { value : "5-vydan-obratno-ego-zhe-akb-ne-zariadilsia-sniat-s-garantii", label: "5б. Выдан обратно его же АКБ, НЕ зарядился - (СНЯТ с гарантии)", class:"complete"},
      { value : "ili-dengi-dokumenty-podpisany", label: "5д. Выданы покупателю ДЕНЬГИ вместо его бракованного АКБ ( Вопрос закрыт)", class:"complete"},
      { value : "2-vopros-uregulirovan-v-magazine-vozvrashchion-klientu-zariazhennym", label: "5а. Отдан клиенту его же, АКБ ИСПРАВЕН  (возвращён клиенту после подзарядки)", class:"complete"},
    
    ]
  },
  {
    group: "sto12f",
    color: "rgba(30,34,72,1)",
    options: [
      { value: "sto-prodazaza", label: "1) Необходим подбор и продажа запчастей", class: ""},
      { value: "stoffnksajn12212", label: "2) Авто ожидает ремонта (ждет зч/очередь)", class:""},
      { value: "avto-v-remonte-v-tsekhu", label: "3) Авто в ремонте, в цеху", class: ""},
      { value: "gotov-k-vydache", label: "4) Готово к выдаче авто", class: ""},
      { value: "5-avto-vydan-klientu", label: "5) Авто выдан клиенту", class: ""},
      { value: "stowfifdk2j", label:"6) Ничего не нужно, не поможем (указываем причину)", class:""},
      { value: "prokonsultirovan-perezvonit-pozzhe", label:"1) Проконсультирован, пнуть клиента позже", class:""},
      { value: "neobkhodimo-perezvonit-klientu-zapchasti-tseny-perechen-rabot-sto", label:"1) Необходимо перезвонить клиенту: запчасти, цены, перечень работ (СТО)", class:""},
    ]
  },
  
      ],

    isModalCustomerVisible: false,
    isLoadingCustomerOrders: false,
    showModalPodborProduct:false,
    loadingPopularBatteries: false,
    corpusMatchStatusData: null,
    corpusMatchUpdateSeq: 0,
    aiFitStatusData: null,
    aiFitUpdateSeq: 0,
    aiFitDebounceTimer: null,
    aiFitLastKey: '',
    isModalStatusVisible: false, // Видимость модального окна
    pendingStatus: null, // Статус, который ожидает подтверждения
    tasks: [], // Список задач
    activeOrders: [],
    oneNewTradeInAmount:0,
    previousOrders: [],
    bonusReserves: [],
    orderStatusFetch:null,
    countDouble:'',
    doubleArray: {},
    productStatuses: [],
    currentStatusProduct: null,
    productStatusDropdownVisible: false,
    productStatusDropdownPosition: { x: 0, y: 0 },
    activeCount: 0,
    previousCount: 0,
    statusGroupMap: {},
    retailStatuses: [],
    popularBatteries: {
      exact: [],
      similar: [],
      model: []
    },
    errors: {
                orderType: null,
                site: null,
                contragentTypes: null,
                firstName: null,
                selectionLink: null,
                predoplata: null,
                deliveryDate: null,
                dataSoglasovaniia: null
            },
    showModal: false,
    selectedOrderId: String(this.$route.params.orderId),
    printTemplates: [
      { id: 116, name: 'Лист курьера 2025', disabled: false },
      { id: 115, name: 'Гарантийный талон 2025', disabled: false },
      { id: 110, name: 'Список заказов для курьера (с подписью)', disabled: false },
      { id: 109, name: 'Договор c печатью Галицкий (новый)', disabled: false },
      { id: 70, name: 'Счет-фактура с печатью Галицкий', disabled: false },
      { id: 112, name: 'Нормальный Товарный чек НДС(печатать)', disabled: false },
      { id: 66, name: 'Договор без печати Гамзюк', disabled: false },
      { id: 107, name: 'Счет-фактура Гамзюк (3 дня)', disabled: false },
      { id: 67, name: 'Счет-фактура Гамзюк (5 дней)', disabled: false },
      { id: 119, name: 'Заказы vozim', disabled: false },
      { id: 118, name: 'Копия Лист курьера 2025', disabled: false },
      { id: 122, name: 'Акт выполненных работ', disabled: false },
      { id: 123, name: 'Расчёт зарплаты курьера', disabled: false },
    ],
    printDropdownOpen: false,
    copyDropdownOpen: false,
    copyOrderModes: [
      {
        id: 'light',
        title: 'Light',
        description: 'Основной блок, клиент, юр. реквизиты и состав заказа',
      },
      {
        id: 'normal',
        title: 'Обычный',
        description: 'Рабочие поля менеджера без доставки, отгрузки и контроля',
      },
      {
        id: 'full',
        title: 'Полный (для руководителя)',
        description: 'Копируется всё содержимое заказа',
      },
      {
        id: 'legal',
        title: 'Юр. лица',
        description: 'Клиент, реквизиты (УНП, адрес, счёт) и адрес доставки',
      },
    ],
    timeFrom: '',
    timeTo: '',
    customTime: '',
    isCarSelectorVisible: false, 
    maskTime: '##:##', // Маска для времени
    isRangeMode: true,
    isExactMode: false,
    isCustomMode: false,
    dropdownVisible: false,
    timeRanges: [
        { from: "09:00", to: "11:30", label: "с 09:00 до 11:30" },
        { from: "11:30", to: "14:00", label: "с 11:30 до 14:00" },
        { from: "14:00", to: "16:30", label: "с 14:00 до 16:30" },
        { from: "16:30", to: "19:00", label: "с 16:30 до 19:00" },
        { from: "19:00", to: "21:30", label: "с 19:00 до 21:30" },
        { from: "21:30", to: "00:00", label: "с 21:30 до 00:00" },
      ],

   
    selectedKorpusType: null, // будет хранить тип корпуса для аналогичных товаров
    // Массив соответствия ёмкости аккумулятора к весу в тоннах
    capacityToWeight: {
      45: 0.011,   // 45 Ah -> 0.011 тонн (11 кг)
      50: 0.012,   // 50 Ah -> 0.012 тонн (12 кг)
      55: 0.013,   // 55 Ah -> 0.013 тонн (13 кг)
      60: 0.014,   // 60 Ah -> 0.014 тонн (14 кг)
      65: 0.015,   // 65 Ah -> 0.015 тонн (15 кг)
      70: 0.017,   // 70 Ah -> 0.017 тонн (17 кг)
      75: 0.018,   // 75 Ah -> 0.018 тонн (18 кг)
      80: 0.019,   // 80 Ah -> 0.019 тонн (19 кг)
      85: 0.020,   // 85 Ah -> 0.020 тонн (20 кг)
      90: 0.021,   // 90 Ah -> 0.021 тонн (21 кг)
      95: 0.022,   // 95 Ah -> 0.022 тонн (22 кг)
      100: 0.024,  // 100 Ah -> 0.024 тонн (24 кг)
      105: 0.025,  // 105 Ah -> 0.025 тонн (25 кг)
      110: 0.026,  // 110 Ah -> 0.026 тонн (26 кг)
      120: 0.029,  // 120 Ah -> 0.029 тонн (29 кг)
      140: 0.041,  // 140 Ah -> 0.041 тонн (41 кг)
      190: 0.061,  // 190 Ah -> 0.061 тонн (61 кг)
      220: 0.053,  // 220 Ah -> 0.053 тонн (53 кг)
      225: 0.054,  // 225 Ah -> 0.054 тонн (54 кг)
      230: 0.056,  // 230 Ah -> 0.056 тонн (56 кг)
      240: 0.058,  // 240 Ah -> 0.058 тонн (58 кг)
    },
    pricePerKg: 1.34, // Стоимость за 1 кг (за старый АКБ)
    previousCapacityDiscount: 0, // Предыдущая скидка за ёмкость для корректного пересчёта
    previousTradeInAmount: 0, // Предыдущая сумма trade-in для корректного пересчёта скидки товара
    capacityWeightDifference: 0, // Разница между стоимостью по весу и по ёмкости (для сохранения в rs)
    capacityWeightKg: 0, // Вес в килограммах (для сохранения в rsmass)
    oneTimeDiscountAmount: 0,
        oneTimeDiscountPercent: 0,
loading: false, // Управляет видимостью лоадера
     manualTotalInput: null,

    manualTotal: null, // для ручного ввода
    manualOverride: false, // следит, вводил ли пользователь вручную
     paymentSectionExpanded: true,
      dropdownOpen: false,
     isAnalogModalVisible:false,
     sectionExpanded: false,
      customerSectionExpanded: false,
      isModalVisible: false,
      isModalMSVisible: false,
      priceDropdownVisible: false,
        dropdownPosition: { top: '0px', left: '0px' },
        selectedProduct: null,
        priceInput: 0,
        originalPriceBeforeEdit: null, // Сохраняем цену до редактирования для пересчета скидки
        discountAmount: 0,
        discountPercent: 0,
      availableProducts: [], // доступные товары в модальном окне
       apiKey: 'BAdmMau5GdJ1g9xiHFHVm2KL9WM0NhlX',  // Ваш API-ключ
      regions: [],
      cities: [],
      streets: [],
      streetSuggestions: [],
      citySuggestions: [],
      addressCandidates: [],
      pendingAddressParts: null,
      addressResolving: false,
      addressResolveStatus: '',
      _addressBlurTimer: null,
    error: false,
    isFieldFilled: true,
    customerInfo: {
       firstName:'',
       id:'',
       phone:''
    },
    showPopupStatus: false,
    statusComment:null,
    statusModalAgreementDate: null,
    editTaskid:'',
    bonusClient:0,
    formData: {

        redaktor:null,
        ocenka_manageru: [],
        ocenkaprodavcu: [],
        ocenochka_kureru: [],
        dgh66hhhhhhh: [],
        proverkazakazamenedgero: [],
        obzvon_klienta: [],
        zvonok_text_bot: '',
      magazin:null,
      id: null,
      country: null,
      ncorrectBonus:null,
      statusUpdatedAt:null,
      data_izmeneniia:null,
      auto:null,
      store:null,
      lsdhgs888sl4k:null,
      statusComment:null,
      orderType: null,
      manager: null,
      manager_new: [],
      curier:null,
      number:'',
      site: null,
      bonus:null,
      orderMethod: [],
      sayt_zvonka: '',
      carBrand: null,
      carModel:null,
      carName: '',
      carYear: '',
      fuelType: '',
      carBodyType: '',
      lastName: '',
      firstName: '',
      phone: '',
      patronymic: '',
      email: '',
      additionalPhone: '',
      email2: '',
      selectionLink: '',
      wrongSelection: false,
      seller: null,
      contragentTypes: null,
      contragentINN: '',
      contragentLegalName: '',
      contragentOKPO: '',
      contragentKPP: '',
      contragentOGRNIP: '',
      contragentLegalAddress: '',
      contragentOGRN: '',
      contragentCertificateNumber: '',
      contragentCertificateDate: null,
      iuridicheskoe_naimenovanie: '',
      tradeInAmount: '',
      tradeInAmountNew: '',
      invoiceDate: null,
      batteryCapacity: '',
      batteryCapacityNew: '',
      summ:'',
      discountCard: false,
      link_oplata:false,
      managerComments: '',
      visitor_code: '',
      visitor_city: '',
      personal_offer_discount: '',
      forma_na_saite: '',
      pomoshchIi: '',
      tegi_dialoga: '',
      shipmentStore: '',
      deliverybuilding: '',
      predoplata: '',
      vznos: '',
      housing:'',
      flat:'',
      floor:'',
      registryNumber:'',
      block:'',
      marssh:'',
      sf_num:null,
      dostavka_bez_oplaty:null,
      house:'',
      shipmentDate: '', // Дата отгрузки
      datazakazaobrabotki:'',
      dataSoglasovaniia: null, // Дата согласования (data_soglasovaniia1)
      deliveryTypes: null,
      deliveryCost: '', // Стоимость доставки
      deliveryAddress: '', // Адрес доставки
      deliveryDate: '', // Дата доставки
      deliveryPaidBy: null, // Оплата доставки: 'discount' - за счет скидки, 'client' - за счет клиента, null - не выбрано
      installationComplex: null, // Выбранный комплекс установки (изначально ничего не выбрано)
      installationPaidBy: null, // Оплата установки: 'discount' - за счет скидки, 'client' - за счет клиента, null - не выбрано
      isChangingComplex: false, // Флаг для программной смены комплекса
      weight: '',  // Вес
      length: '',  // Длина
      width: '',   // Ширина
      height: '',  // Высота
      customerComment: '', // Комментарии клиента
      createdAt:'',
      deliveryregion: null,
     deliverycity: null,
     deliverystreet: null,
     moyskladUuid: '',
     location_zabor: ''
    },
    updatedFields: {
      deliveryregion: false,
      deliverycity: false,
      deliverystreet: false,
      deliverybuilding: false
    },
    vgvgvgv: '',
    wbAssembled: false,
    wbDocs: null,
    wbDocsLoading: false,
    wbOrderId: '',
    payments: [],
      paymentTypes: [],
      dostavka_bez_oplaty:[], 
      saveAndBack: "",
      
     
      deliveryType: '',
      deliveryCost: '',
      takeFromClient: null,
      
      managerComment: '',
      weight: '',
      length: '',
      width: '',
      height: '',
      deliveryAddress: '',
      predoplata: [],
      seller: [],
      stores: [
        { value: '8', text: 'Склад "Карвата"' },
        { value: '7', text: 'ул. Ваупшасова 10' },
      ],
     
      productSectionExpanded: true,

      contragentTypes: [
        {
          label: 'Физическое лицо',
          value: 'individual'
        },
        {
          label: 'Юридическое лицо',
          value: 'legal-entity'
        },
        {
          label: 'Индивидуальный предприниматель',
          value: 'enterpreneur'
        }
      ],
     
      
      countries: [
        { label: 'Беларусь', value: 'BY' },
        { label: 'Россия', value: 'RU' },
        { label: 'Украина', value: 'UA' }
      ],
      shipmentStores:[],
      orderTypes: [],
      managers: [],
      managers_update: [],
      manager_new: [],
      curiers:[],
       sites: [
        { label: "Центральный офис 1akb.by", value: "1akb-by" },
        { label: "Володько 9", value: "volodko-magazin" },
        { label: "Ваупшасова", value: "salyt-magazin" },
        { label: "Бельского", value: "belskodihfjpsd" },
        { label: "Машиностроителей 9а", value: "masshinostroiteley-magazin" },
        { label: "Витебск", value: "vitebsk-magazin" },
        { label: "Полоцк №1 Северный рынок", value: "pol1" },
        { label: "Барановичи", value: "baramkimagaz" },
        { label: "Бобруйск, ул. Минская, 123-3", value: "bobruiskmagaz" },
        { label: "Гомель, Бакунинский рынок", value: "gomel-bakunin" },
        { label: "Гомель, Ефремовский рынок", value: "Gomel" },
        { label: "Гродно", value: "grodnomagaz" },
        { label: "Могилев", value: "mogilev-magaz" },
        { label: "Новополоцк ТЦ \"Стрелецкий капитал\"", value: "strelec-magaz" },
        { label: "Брест", value: "brestmagaz" },
        { label: "СТО", value: "sto-prodaza" }
      ],
      // Список складов
      allShipmentStores: [
        { label: "ул. Ваупшасова 10", value: "ishdjsdkj34" },
        { label: "Склад \"Карвата\"", value: "rfhdfnfcrkfl" },
        { label: "Склад - 2 этаж (зарядки)", value: "pfhzlrb2'nf" },
        { label: "Полоцк \"рынок Северный\"", value: "hsyjrctdthysq" },
        { label: "Новополоцк ( ТЦ Стрелецкий капитал )", value: "cnhtktwrbqrfgbnfk" },
        { label: "Склад БУ на продажу (отобранные)", value: "bushka-sklad-prodaza" },
        { label: "Володько 9", value: "sklad-volodko" },
        { label: "Машиностроителей 9А", value: "sklad-mashinostroiteley" },
        { label: "Витебск, пр-т. Строителей 12", value: "sklad-vitebsk" },
        { label: "Склад КАРВАТА УЦЕНКА", value: "sklad-ucenka" },
        { label: "СТО", value: "sto" },
        { label: "Брест склад", value: "brestbrest" },
        { label: "Гомель, Ефремовский склад", value: "Gomelsklad" },
        { label: "Виртуальные остатки", value: "sdfsddfgdfg333ggsd" },
        { label: "Могилёв склад", value: "mogilevsklad" },
        { label: "Барановичи склад", value: "barankiskldd" },
        { label: "Гродно склад", value: "grodnoooskalad" },
        { label: "Бобруйск, ул. Минская, склад", value: "bobruiskskald" },
        { label: "Гомель, склад Бакунинский", value: "gomel-bakun" },
        { label: "Бобруйск Советская", value: "bobr22sklad" },
        { label: "Бельского склад", value: "belskoasfs" },
        { label: "1. БРАК - Сервисный центр", value: "1-brak-servisnyi-tsentr" }
      ],
      // Маппинг магазинов и складов
      storeMap: {
        "1akb-by": ["rfhdfnfcrkfl"],
        "volodko-magazin": ["sklad-volodko"],
        "salyt-magazin": ["ishdjsdkj34"],
        "belskodihfjpsd": ["belskoasfs"],
        "masshinostroiteley-magazin": ["sklad-mashinostroiteley"],
        "vitebsk-magazin": ["sklad-vitebsk"],
        "pol1": ["hsyjrctdthysq"],
        "baramkimagaz": ["barankiskldd"],
        "bobruiskmagaz": ["bobruiskskald", "bobr22sklad"],
        "gomel-bakunin": ["gomel-bakun"],
        "Gomel": ["Gomelsklad"],
        "grodnomagaz": ["grodnoooskalad"],
        "mogilev-magaz": ["mogilevsklad"],
        "strelec-magaz": ["cnhtktwrbqrfgbnfk"],
        "brestmagaz": ["brestbrest"],
        "sto-prodaza": ["sto"],
        "servisnyi-tsentr": ["1-brak-servisnyi-tsentr"]
      },
      magazinToMsStore: {
        '1akb-by': 'Карвата',
        'volodko-magazin': 'Володько',
        'salyt-magazin': 'Салюты',
        'masshinostroiteley-magazin': 'Машинка',
        'belskodihfjpsd': 'Бельского',
        'vitebsk-magazin': 'Витебск',
        'pol1': 'Полоцк',
        'strelec-magaz': 'Новополоцк',
        'baramkimagaz': 'Барановичи',
        'bobruiskmagaz': 'Бобруйск',
        'gomel-bakunin': 'Гомель-Бакун',
        Gomel: 'Гомель-Ефрем',
        grodnomagaz: 'Гродно',
        'mogilev-magaz': 'Могилев',
        brestmagaz: 'Брест',
        'servisnyi-tsentr': 'Машинка',
      },
      shipmentStoreToMsStore: {
        rfhdfnfcrkfl: 'Карвата',
        'sklad-volodko': 'Володько',
        ishdjsdkj34: 'Салюты',
        'sklad-mashinostroiteley': 'Машинка',
        belskoasfs: 'Бельского',
        'sklad-vitebsk': 'Витебск',
        hsyjrctdthysq: 'Полоцк',
        cnhtktwrbqrfgbnfk: 'Новополоцк',
        barankiskldd: 'Барановичи',
        bobruiskskald: 'Бобруйск',
        bobr22sklad: 'Бобруйск',
        'gomel-bakun': 'Гомель-Бакун',
        Gomelsklad: 'Гомель-Ефрем',
        grodnoooskalad: 'Гродно',
        mogilevsklad: 'Могилев',
        brestbrest: 'Брест',
        '1-brak-servisnyi-tsentr': '1. БРАК - Сервисный центр',
      },
      orderMethods: [],
      errorss:{},
      ocenka_manageruList:[],
      proverkazakazamenedgeroList:[],
      obzvon_klientaList:[],
      ocenochka_kureruList:[],
      dgh66hhhhhhhList:[],
      ocenkaprodavcuList: [],
    
    

    
    
    deliveryTypes: [], // Типы доставки
    isEditingComplexDiscount: false, // Флаг редактирования комплекса для "За счет скидки"
    isEditingComplexClient: false, // Флаг редактирования комплекса для "За счет клиента"
    installationComplexOptions: [
      { 
        label: 'Комплекс 1', 
        value: 'complex1',
        price: '10 руб.',
        description: 'Установка + диагностика без нагрузки и под нагрузкой'
      },
      { 
        label: 'Комплекс 2', 
        value: 'complex2',
        price: '15 руб.',
        description: 'Комплекс 1 + диагностика генератора и стартера'
      },
      { 
        label: 'Комплекс 3', 
        value: 'complex3',
        price: '25 руб.',
        description: 'Комплекс 2 + измерение токов утечки'
      }
    ],
    isComplexDropdownOpen: false,
    activeComplexDropdown: null,
    isComplexSelectDropdownOpen: false,

    
  };
}
,
computed: {
    /** Заказ Wildberries FBS */
    isWbOrder() {
      const method = this.formData && this.formData.orderMethod
        ? (this.formData.orderMethod.value || this.formData.orderMethod)
        : '';
      const delivery = this.formData && this.formData.deliveryTypes
        ? (this.formData.deliveryTypes.value || this.formData.deliveryTypes)
        : '';
      const manager = this.formData && this.formData.manager_new
        ? (this.formData.manager_new.value || this.formData.manager_new)
        : (this.formData && this.formData.manager
          ? (this.formData.manager.value || this.formData.manager)
          : '');
      if (String(method) === 'wildberries') return true;
      if (String(delivery) === 'wb') return true;
      if (String(manager) === 'wildberries') return true;
      if (this.wbOrderId) return true;
      const num = String((this.formData && this.formData.number) || this.orderNumber || '');
      return num.indexOf('WB_') === 0;
    },
    /** Сайт звонка — только customFields.sayt_zvonka, без fallback */
    callSiteLabel() {
      const raw = this.formData && this.formData.sayt_zvonka
        ? String(this.formData.sayt_zvonka).trim()
        : '';
      if (!raw || raw === 'phone' || raw === 'unknown') return '';
      const fromMethods = (this.orderMethods || []).find(
        (m) => m && String(m.value) === String(raw)
      );
      if (fromMethods && fromMethods.label) {
        return this.cleanCallSiteLabel(fromMethods.label);
      }
      return this.cleanCallSiteLabel(raw);
    },
    hasCustomerPurchaseHistory() {
      return Number(this.previousCount) > 0 || Number(this.activeCount) > 0;
    },
    clientSideCity() {
      const visitorCity = (this.formData.visitor_city || '').trim();
      if (visitorCity) return visitorCity;
      const c = this.formData.deliverycity;
      if (c && typeof c === 'object') return (c.label || '').trim();
      if (typeof c === 'string') return c.trim();
      return '';
    },
    /** Улица введена вручную / без id GeoHelper */
    isStreetNotInDirectory() {
      const street = this.formData && this.formData.deliverystreet;
      if (!street) return false;
      if (typeof street === 'string') return street.trim().length > 0;
      const label = (street.label || '').trim();
      if (!label) return false;
      const value = street.value;
      return value === null || value === undefined || value === '';
    },
    hasPageVisitHistory() {
      const comment = String(this.formData.customerComment || '');
      const custom = String(this.pageHistoryCustomField || '');
      if (this.visitedProducts.length || this.visitedPages.length) return true;
      if (/Какие страницы посещал|Страницы, которые посетил|История посещений|URL:/i.test(comment)) {
        return true;
      }
      if (/\/catalog\/akkumulyator[_-]/i.test(comment) || /\/catalog\/akkumulyator[_-]/i.test(custom)) {
        return true;
      }
      return Boolean(custom && custom.trim() && custom.trim() !== 'Нет страниц');
    },

  userRole() {
      return this.$store.state.user.role; // или откуда у вас роль
    },
  isBrakHintUser() {
      const u = this.$store.state.user || {};
      const ext = String(u.phone_extension != null ? u.phone_extension : '');
      const role = String(u.role || '').toLowerCase();
      return u.id === 162 || ext === '192' || role.includes('брак');
    },
  /** Подсказки по продажам: менеджеры и руководство */
  isSalesHintsRole() {
      const role = String(this.userRole || '').toLowerCase();
      return role.includes('менедж') || role.includes('руковод');
    },
  hintMode() {
      if (this.isBrakHintUser) return 'brak';
      if (this.isSalesHintsRole) return 'sales';
      return null;
    },
  hintLabelTitle() {
      if (this.hintMode === 'sales') {
        return 'Подсказка: что сказать клиенту при продаже АКБ (по расшифровке и каталогу)';
      }
      return 'Подсказка: что ответить клиенту по расшифровке разговора';
    },
  hintModalTitle() {
      return this.hintMode === 'sales' ? 'Что сказать клиенту (продажа)' : 'Что ответить клиенту';
    },
  hintTopicsLabel() {
      return this.hintMode === 'sales' ? 'Подбор' : 'Претензии';
    },
  vehicleContextForAi() {
      return {
        carBrand: this.formData.carBrand || '',
        carModel: this.formData.carModel || '',
        carName: this.formData.carName || '',
        carYear: this.formData.carYear || '',
        fuelType: this.formData.fuelType || '',
        carBodyType: this.formData.carBodyType || '',
        auto: this.formData.auto || '',
        selectionLink: this.formData.selectionLink || '',
      };
    },
  orderContextForAi() {
      return {
        batteryCapacityNew: this.formData.batteryCapacityNew || '',
        tradeInAmountNew: this.formData.tradeInAmountNew || '',
        deliveryTypes: this.formData.deliveryTypes || null,
        fuelType: this.formData.fuelType || '',
      };
    },
  vehicleCorpusForCatalog() {
      return this.normalizeCorpusTokens(this.formData.carBodyType);
    },
  deliveryCityLabel() {
      const c = this.formData.deliverycity;
      if (!c) return '';
      if (typeof c === 'string') return c;
      return c.label || c.name || c.value || '';
    },
  hasCallWithTranscription() {
      return (this.callLogs || []).some((c) => c.hasTranscription);
    },
  latestCallWithTranscription() {
      const withTr = (this.callLogs || []).filter((c) => c.hasTranscription);
      if (!withTr.length) return null;
      return withTr.sort((a, b) => new Date(b.DateReceived) - new Date(a.DateReceived))[0];
    },
  isManagersRole() {
      const role = String(this.userRole || '').toLowerCase();
      return role.includes('менедж');
    },
  canViewControlFields() {
      const role = String(this.userRole || '').toLowerCase();
      const allowedMarkers = ['руковод', 'контрол', 'логист'];
      return role && allowedMarkers.some(marker => role.includes(marker));
    },
  isLogistOrControl() {
      const role = String(this.userRole || '').toLowerCase();
      return role && (role.includes('логист') || role.includes('контрол') || role.includes('контроль'));
    },
    isLogist() {
      const role = String(this.userRole || '').toLowerCase();
      return role.includes('логист');
    },
  filteredStatusGroupsOrder() {
      // Используем прямой доступ к statusGroupsOrder из data
      const originalStatusGroups = this.statusGroupsOrder || [];
      const CENTRAL_SITE = '1akb-by';
      const deliveryStatusesCentralOnly = ['send-to-delivery', 'redirect', 'fdjkdfkljd'];
      const siteVal =
        (this.formData.site && this.formData.site.value) ||
        (this.formData.magazin && this.formData.magazin.value) ||
        '';
      const blockDeliveryCentralStatuses =
        siteVal && siteVal !== CENTRAL_SITE;

      let result;
      // Если пользователь логист или контроль, показываем все статусы
      if (this.isLogistOrControl) {
        result = originalStatusGroups.map(group => ({
          ...group,
          options: group.options.map(option => {
            const newOption = { ...option };
            // Убираем disabled для всех статусов
            delete newOption.disabled;
            // Убираем класс hide из строки класса
            if (newOption.class) {
              // Разбиваем класс на массив, убираем 'hide', собираем обратно
              const classArray = newOption.class.split(/\s+/).filter(cls => cls && cls !== 'hide');
              newOption.class = classArray.join(' ');
            }
            return newOption;
          })
        }));
      } else {
        result = originalStatusGroups;
      }

      if (!blockDeliveryCentralStatuses) {
        return result;
      }
      return result.map(group => ({
        ...group,
        options: group.options.map(opt =>
          deliveryStatusesCentralOnly.includes(opt.value)
            ? { ...opt, disabled: true }
            : { ...opt }
        ),
      }));
    },

  /** vozim.by и экспресс vozim.by — при выборе даты нельзя раньше сегодня; уже выставленную не трогаем */
  isVozimDeliveryType() {
      const code = this.formData && this.formData.deliveryTypes && this.formData.deliveryTypes.value;
      return code === 'vozimby' || code === 'rb';
    },

  showDeliveryBlock() {
      // Показываем блок "Доставка" для: курьером, vozim.by, Европочта, Маршрутка и Автолайтэкспресс
      if (!this.formData.deliveryTypes || !this.formData.deliveryTypes.value) {
        return false;
      }
      const deliveryType = this.formData.deliveryTypes.value;
      return deliveryType === 'courier' || deliveryType === 'vozimby' || deliveryType === 'euro987fh' || deliveryType === 'marshrutkapolock' || deliveryType === 'rb';
    },
    showInstallationBlock() {
      // Показываем блок "Комплекс" для: курьер, самовывоз, магазин (типы доставки из API delivery.php)
      // Магазин в CRM: code = kjivjv9u39oijskj (label "4. Магазин")
      if (!this.formData.deliveryTypes || !this.formData.deliveryTypes.value) {
        return false;
      }
      const deliveryType = this.formData.deliveryTypes.value;
      const excludedTypes = ['vozimby', 'euro987fh', 'marshrutkapolock'];
      const typesWithComplex = ['redirect', 'courier', 'self-delivery', 'kjivjv9u39oijskj'];
      return typesWithComplex.includes(deliveryType) && !excludedTypes.includes(deliveryType);
    },
    hasTradeInCapacityValue() {
      return String(this.formData.batteryCapacityNew || '').trim().length > 0;
    },
    hasLastNameValue() {
      return String(this.formData.lastName || '').trim().length > 0;
    },
    hasPatronymicValue() {
      return String(this.formData.patronymic || '').trim().length > 0;
    },
    showLomSenderWarning() {
      return this.hasTradeInCapacityValue && (!this.hasLastNameValue || !this.getFirstNameValue() || !this.hasPatronymicValue);
    },
    showLomSenderPreview() {
      return this.hasTradeInCapacityValue;
    },
    lomSenderDisplayNamePreview() {
      const lastName = String(this.formData.lastName || '').trim() || 'Иванов';
      const firstName = this.getFirstNameValue();
      const patronymic = String(this.formData.patronymic || '').trim();
      const firstInitial = firstName ? `${firstName.charAt(0).toUpperCase()}.` : 'И.';
      const patronymicInitial = patronymic ? `${patronymic.charAt(0).toUpperCase()}.` : 'О.';
      return `${lastName} ${firstInitial}${patronymicInitial}`;
    },

    deliveryPrice() {
      const price = this.getDefaultDeliveryPrice();
      return `${price} руб.`;
    },

    // Дополнительная скидка на основной товар (без учета скидок на доставку и комплекс)
    additionalMainProductDiscount() {
      const DELIVERY_PRODUCT_ID = '989773504';
      const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
      
      const products = this.$route.params.orderId 
        ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
        : this.products;
      
      // Находим товар с наибольшей ценой
      const productsFiltered = products.filter(p => p.id !== DELIVERY_PRODUCT_ID && !COMPLEX_PRODUCT_IDS.includes(p.id) && !this.isExcludedFromTotalsStatus(p.status));
      const maxPriceProduct = productsFiltered.length > 0 ? productsFiltered.reduce((max, p) => 
        (parseFloat(p.originalPrice || p.price || 0) > parseFloat(max.originalPrice || max.price || 0) ? p : max)
      ) : null;
      
      if (!maxPriceProduct) {
        return 0;
      }
      
      // Текущая скидка на товар с максимальной ценой
      const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
      
      // Вычисляем скидки на доставку и комплекс (если они за счет скидки)
      let discountOnDeliveryAndComplex = 0;
      
      // Скидка на доставку (если она за счет скидки)
      if (this.formData.deliveryPaidBy === 'discount') {
        const deliveryProduct = products.find(p => p.id === DELIVERY_PRODUCT_ID);
        if (deliveryProduct) {
          const deliveryPrice = (deliveryProduct.originalPrice || deliveryProduct.price || 0) * (deliveryProduct.quantity || 1);
          discountOnDeliveryAndComplex += deliveryPrice;
        }
      }
      
      // Скидка на комплекс (если он за счет скидки)
      if (this.formData.installationPaidBy === 'discount' && this.formData.installationComplex) {
        const complexProductId = {
          complex1: '989773501',
          complex2: '989773505',
          complex3: '989773503'
        }[this.formData.installationComplex];
        
        if (complexProductId) {
          const complexProduct = products.find(p => p.id === complexProductId);
          if (complexProduct) {
            const complexPrice = (complexProduct.originalPrice || complexProduct.price || 0) * (complexProduct.quantity || 1);
            discountOnDeliveryAndComplex += complexPrice;
          }
        }
      }
      
      // Дополнительная скидка = текущая скидка - скидки на доставку и комплекс
      const additionalDiscount = currentDiscount - discountOnDeliveryAndComplex;
      
      return Math.max(0, additionalDiscount);
    },

 displayGrandTotal() {
    return this.manualOverride ? this.manualTotalInput : this.grandTotal;
  },

 hasPopularBatteries() {
  const b = this.popularBatteries;
  return (
    b.exact && b.exact.products && b.exact.products.length > 0 ||
    b.similar && b.similar.products && b.similar.products.length > 0 ||
    b.model && b.model.products && b.model.products.length > 0
  );
},

 aiFitHoverTitle() {
  const data = this.aiFitStatusData;
  if (!data) return '';
  const parts = [];
  if (data.text) parts.push(data.text);
  if (data.reason && !data.loading) parts.push(data.reason);
  if (data.recommended_case && !data.loading) {
    parts.push(`Рекоменд. корпус: ${data.recommended_case}`);
  }
  if (data.drive2_found && !data.loading) parts.push('есть данные drive2.ru');
  return parts.join(' — ');
},
  // Фильтрация активных задач
    activeTasks() {
      return this.tasks.filter(task => task.viewed === "false");
    },

    // Фильтрация неактивных задач
    inactiveTasks() {
      return this.tasks.filter(task => task.viewed === '1');
    },

isStatusChangeAllowed() {
    // Логисты и контроль могут менять статус в любом случае
    if (this.isLogistOrControl) {
      return true;
    }
    
    const forbiddenStatuses = [
      //"otmena-dubl",
      "otmenaskomentom",
      "khkhhjgsdlgtij6",
      "otmena-s-necelevoi"
    ];
    
    // Проверяем, есть ли текущий статус в списке запрещенных
    if (forbiddenStatuses.includes(this.orderStatusFetch)) {
      return false;
    }
    
    // Проверяем, есть ли текущий статус в списке разрешенных для перевода
    const allowedStatuses = this.getAllowedStatusesForTransfer();
    return allowedStatuses.includes(this.orderStatusFetch);
  },



 products() {
    return this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
 },
  // Общая стоимость товаров без скидок
totalPrice() {
  return this.products
    .filter(product => !this.isExcludedFromTotalsStatus(product.status))
    .reduce((sum, product) => sum + (product.originalPrice * product.quantity), 0);
},

totalDiscount() {
  const tradeInAmount = parseFloat(this.formData.tradeInAmountNew) || 0;

  const oneTimeDiscountAmount = Number(this.oneTimeDiscountAmount) || 0;
  const oneTimeDiscountPercent = Number(this.oneTimeDiscountPercent) || 0;

  const productsForTotals = this.products.filter(
    p => !this.isExcludedFromTotalsStatus(p.status)
  );

  const productDiscounts = productsForTotals.reduce((sum, product) => {
    const discountInRubles = Number(product.discountAmount || 0);
    const discountInPercent = product.originalPrice * (Number(product.discountPercent || 0) / 100);
    return sum + (discountInRubles + discountInPercent) * product.quantity;
  }, 0);

  const adjustedTotalPrice = productsForTotals.reduce((sum, product) => {
    return sum + product.displayPrice * product.quantity;
  }, 0);

  let oneTimeDiscount = 0;

  if (oneTimeDiscountPercent) {
    oneTimeDiscount += (adjustedTotalPrice * oneTimeDiscountPercent) / 100;
  }

  oneTimeDiscount += oneTimeDiscountAmount;

  return productDiscounts + oneTimeDiscount;
},


 grandTotal() {
      const tradeInDiscount = 0; // parseFloat(this.formData.tradeInAmountNew) || 0;
      const calculated = Math.max(
        0,
        this.totalPrice - this.totalDiscount - tradeInDiscount + Number(this.deliveryCost)
      );

      return this.manualTotal !== null ? this.manualTotal : calculated;
    },

  tegiDialogaTags() {
    return this.parseTagsString(this.formData.tegi_dialoga);
  },

},
  methods: {
    parseTagsString(str) {
      if (!str) return [];
      return String(str)
        .split(/[,;]+/)
        .map((t) => t.trim())
        .filter(Boolean);
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerElement = document.querySelector('.order-head-wrap');
        const headerHeight = headerElement ? headerElement.offsetHeight : 0;
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerHeight - 20;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        
        this.activeSection = sectionId;
      }
    },
    
    formatManagerLabel(option) {
      if (!option) return '';
      
      // Если мы уже сгенерировали displayName в getManagers, используем его
      if (option.displayName) {
        return option.displayName;
      }
      
      // Если displayName нет (объект пришел из fetchOrder), переворачиваем label на лету
      if (option.label) {
        const parts = option.label.trim().split(' ');
        if (parts.length >= 2) {
          return `${parts[1]} ${parts[0]}`; // Фамилия Имя
        }
        return option.label; // Если там одно слово, возвращаем как есть
      }
      
      return '';
    },
    
    handleScroll() {
      const scrollPosition = window.pageYOffset + 200; // Отступ для определения активной секции
      
      // Проверяем, является ли блок sticky
      const headerWrap = document.querySelector('.order-head-wrap');
      if (headerWrap) {
        const rect = headerWrap.getBoundingClientRect();
        this.isSticky = rect.top <= 0;
      }
      
      // Разделы, которые не учитываются при автоматическом определении активной секции
      const excludedSections = ['order-customer-comment', 'order-manager-comment'];
      
      // Проверяем каждую секцию
      for (let i = this.navigationSections.length - 1; i >= 0; i--) {
        const section = this.navigationSections[i];
        
        // Пропускаем исключенные разделы
        if (excludedSections.includes(section.id)) {
          continue;
        }
        
        const element = document.getElementById(section.id);
        
        if (element) {
          const elementTop = element.offsetTop;
          const elementBottom = elementTop + element.offsetHeight;
          
          if (scrollPosition >= elementTop && scrollPosition < elementBottom) {
            this.activeSection = section.id;
            break;
          }
        }
      }
    },
    
    getComplexName() {
      // Возвращает название выбранного комплекса
      const complexNames = {
        complex1: 'Комплекс 1',
        complex2: 'Комплекс 2',
        complex3: 'Комплекс 3'
      };
      return complexNames[this.formData.installationComplex] || 'Комплекс';
    },
    
    getComplexPrice() {
      // Возвращает цену выбранного комплекса
      const option = this.installationComplexOptions.find(item => item.value === this.formData.installationComplex);
      return option ? option.price : '0 руб.';
    },
    
    toggleComplexSelectDropdown() {
      // Переключаем дропдаун выбора комплекса
      this.isComplexSelectDropdownOpen = !this.isComplexSelectDropdownOpen;
      // Закрываем старый дропдаун, если был открыт
      if (this.isComplexDropdownOpen) {
        this.closeComplexDropdown();
      }
    },
    
    selectComplexFromDropdown(complexValue) {
      // Если тот же комплекс - просто закрываем дропдаун
      if (this.formData.installationComplex === complexValue) {
        this.isComplexSelectDropdownOpen = false;
        return;
      }
      
      // Закрываем дропдаун
      this.isComplexSelectDropdownOpen = false;
      
      // Устанавливаем флаг для watcher
      this.isChangingComplex = true;
      
      // Сохраняем предыдущий способ оплаты
      const previousPaidBy = this.formData.installationPaidBy;
      
      // Используем toggleComplex для переключения комплекса (он сам обработает удаление старого и добавление нового)
      // toggleComplex устанавливает formData.installationComplex = value в конце
      this.toggleComplex(complexValue);
      
      // Устанавливаем способ оплаты "за счет клиента" по умолчанию при выборе комплекса
      this.$nextTick(() => {
        // Всегда устанавливаем "за счет клиента" при выборе комплекса (как требует пользователь)
        this.setInstallationPaidBy('client');
        this.isChangingComplex = false;
      });
    },
    
    // Установка способа оплаты доставки
    toggleComplex(value) {
      // ID товаров комплексов
      const complexProducts = {
        complex1: { id: '989773501', name: 'Комплекс 1', price: 10.00 },
        complex2: { id: '989773505', name: 'Комплекс 2', price: 15.00 },
        complex3: { id: '989773503', name: 'Комплекс 3', price: 25.00 }
      };

      // Если кликнули на уже выбранный комплекс, снимаем выбор и удаляем товар
      if (this.formData.installationComplex === value) {
        const complexProduct = complexProducts[value];
        if (complexProduct) {
          // Сначала убираем скидку, если была выбрана "За счет скидки" (ДО удаления товара)
          if (this.formData.installationPaidBy === 'discount') {
            // Получаем список товаров
            let products = this.$route.params.orderId 
              ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
              : this.products;
            
            // Находим товар установки (комплекса) в заказе, чтобы получить его реальную цену
            const installationProduct = products.find(p => p.id === complexProduct.id);
            
            if (installationProduct) {
              // Получаем реальную стоимость товара установки (цена, которую могли изменить менеджеры)
              const installationPrice = Number(installationProduct.displayPrice || installationProduct.originalPrice || installationProduct.price || 0);
              
              // ID товаров, которые не нужно учитывать (доставка и комплексы)
              const DELIVERY_PRODUCT_ID = '989773504';
              const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
              
              // Находим товар с наибольшей ценой (исключая доставку и комплексы)
              const productsWithoutDelivery = products.filter(p => 
                p.id !== DELIVERY_PRODUCT_ID && 
                !COMPLEX_PRODUCT_IDS.includes(p.id) &&
                !this.isExcludedFromTotalsStatus(p.status)
              );
              
              let maxPriceProduct = null;
              if (productsWithoutDelivery.length > 0) {
                maxPriceProduct = productsWithoutDelivery[0];
                let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
                
                for (let i = 1; i < productsWithoutDelivery.length; i++) {
                  const product = productsWithoutDelivery[i];
                  const productPrice = parseFloat(product.originalPrice || product.price || 0);
                  if (productPrice > maxPrice) {
                    maxPrice = productPrice;
                    maxPriceProduct = product;
                  }
                }
              }
              
              if (maxPriceProduct && installationPrice > 0) {
                const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
                // Вычитаем реальную стоимость установки из скидки
                maxPriceProduct.discountAmount = Math.max(0, currentDiscount - installationPrice);
                
                // Пересчитываем отображаемую цену товара
                maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
                
                // Пересчитываем итоговую стоимость товара
                this.updateProductTotal(maxPriceProduct);
                
                // Обновляем массив товаров
                if (!this.$route.params.orderId) {
                  const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                  if (index !== -1) {
                    this.$set(this.products, index, maxPriceProduct);
                  }
                } else {
                  // Если используется store, обновляем через store
                  products = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
                  const productInStore = products.find(p => p.id === maxPriceProduct.id);
                  if (productInStore) {
                    productInStore.discountAmount = maxPriceProduct.discountAmount;
                    productInStore.displayPrice = maxPriceProduct.displayPrice;
                    this.updateProductTotal(productInStore);
                  }
                }
              }
            }
          }
          
          // Теперь удаляем товар комплекса из заказа
          const productIndex = this.products.findIndex(p => p.id === complexProduct.id);
          if (productIndex !== -1) {
            if (this.$route.params.orderId) {
              this.$store.commit('removeProduct', {
                orderId: this.$route.params.orderId,
                productId: complexProduct.id
              });
            } else {
              this.products.splice(productIndex, 1);
            }
          }
        }
        
        // Сбрасываем выбор комплекса и способа оплаты
        this.formData.installationComplex = null;
        this.formData.installationPaidBy = null;
      } else {
        // Удаляем предыдущий товар комплекса, если был выбран другой комплекс
        if (this.formData.installationComplex) {
          const prevComplexProduct = complexProducts[this.formData.installationComplex];
          if (prevComplexProduct) {
            // Если был выбран способ оплаты "За счет скидки", нужно убрать старую скидку
            const prevPaidBy = this.formData.installationPaidBy;
            const prevComplexPrice = prevComplexProduct.price;
            
            const productIndex = this.products.findIndex(p => p.id === prevComplexProduct.id);
            if (productIndex !== -1) {
              if (this.$route.params.orderId) {
                this.$store.commit('removeProduct', {
                  orderId: this.$route.params.orderId,
                  productId: prevComplexProduct.id
                });
              } else {
                this.products.splice(productIndex, 1);
              }
            }
            
            // Если был выбран "За счет скидки", убираем скидку со старого комплекса
            if (prevPaidBy === 'discount') {
              const products = this.$route.params.orderId 
                ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
                : this.products;
              
              const DELIVERY_PRODUCT_ID = '989773504';
              const complexProductIds = ['989773501', '989773505', '989773503'];
              
              // Находим товар с наибольшей ценой (исключая доставку и комплексы)
              const productsWithoutDelivery = products.filter(p => 
                p.id !== DELIVERY_PRODUCT_ID && 
                !complexProductIds.includes(p.id) &&
                !this.isExcludedFromTotalsStatus(p.status)
              );
              
              let maxPriceProduct = null;
              if (productsWithoutDelivery.length > 0) {
                maxPriceProduct = productsWithoutDelivery[0];
                let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
                
                for (let i = 1; i < productsWithoutDelivery.length; i++) {
                  const product = productsWithoutDelivery[i];
                  const productPrice = parseFloat(product.originalPrice || product.price || 0);
                  if (productPrice > maxPrice) {
                    maxPrice = productPrice;
                    maxPriceProduct = product;
                  }
                }
              }
              
              if (maxPriceProduct) {
                const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
                if (currentDiscount >= prevComplexPrice) {
                  maxPriceProduct.discountAmount = Math.max(0, currentDiscount - prevComplexPrice);
                  maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
                  this.updateProductTotal(maxPriceProduct);
                  
                  if (!this.$route.params.orderId) {
                    const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                    if (index !== -1) {
                      this.$set(this.products, index, maxPriceProduct);
                    }
                  }
                }
              }
            }
          }
        }

        // Добавляем новый товар комплекса
        const complexProduct = complexProducts[value];
        if (complexProduct) {
          // Проверяем, не добавлен ли уже этот товар
          const productIndex = this.products.findIndex(p => p.id === complexProduct.id);
          if (productIndex === -1) {
            const newProduct = {
              id: complexProduct.id,
              name: complexProduct.name,
              price: complexProduct.price,
              originalPrice: complexProduct.price,
              quantity: 1,
              total: complexProduct.price,
              displayPrice: complexProduct.price,
              discountAmount: 0,
              discountPercent: 0,
              status: 'new'
            };

            if (this.$route.params.orderId) {
              this.$store.commit('addProduct', {
                orderId: this.$route.params.orderId,
                product: newProduct
              });
            } else {
              this.products.push(newProduct);
            }
          }
        }
        this.formData.installationComplex = value;
      }
    },
    toggleInstallationPaidBy(value, event) {
      // Предотвращаем стандартное поведение
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        
        // Проверяем, не кликнули ли на элемент внутри дропдауна
        const target = event.target;
        if (target.closest('.footer-complex-dropdown')) {
          return; // Клик был на дропдаун - игнорируем
        }
      }
      
      // Закрываем дропдаун только если он открыт
      if (this.isComplexDropdownOpen) {
        this.closeComplexDropdown();
        return; // Если дропдаун был открыт - закрываем его, но не меняем способ оплаты
      }
      
      // Если комплекс не выбран, не делаем ничего (комплекс должен быть выбран через дропдаун в левой части)
      if (!this.formData.installationComplex) {
        return;
      }

      // Выбор «За счет скидки» для комплексов отключён (снятие уже выбранного ещё допускается)
      if (value === 'discount' && this.formData.installationPaidBy !== 'discount') {
        return;
      }
      
      // Если кликнули на уже выбранный вариант, снимаем выбор полностью
      if (this.formData.installationPaidBy === value) {
        // Устанавливаем флаг для watcher
        this.isChangingComplex = true;
        
        // Сохраняем данные комплекса перед удалением
        const complexValue = this.formData.installationComplex;
        const paidBy = this.formData.installationPaidBy;
        
        // ID товаров комплексов
        const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
        const DELIVERY_PRODUCT_ID = '989773504';
        
        // Получаем список товаров
        let products = this.$route.params.orderId 
          ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
          : this.products;
        
        // Находим товар комплекса
        const complexProducts = {
          complex1: { id: '989773501', name: 'Комплекс 1', price: 10.00 },
          complex2: { id: '989773505', name: 'Комплекс 2', price: 15.00 },
          complex3: { id: '989773503', name: 'Комплекс 3', price: 25.00 }
        };
        
        const complexProduct = complexProducts[complexValue];
        if (complexProduct) {
          const installationProduct = products.find(p => p.id === complexProduct.id);
          
          // Если было выбрано "за счет скидки", убираем скидку
          if (paidBy === 'discount' && installationProduct) {
            const installationPrice = Number(installationProduct.displayPrice || installationProduct.originalPrice || installationProduct.price || 0);
            
            // Находим товар с наибольшей ценой (исключая доставку и комплексы)
const productsWithoutDelivery = products.filter(p => 
            p.id !== DELIVERY_PRODUCT_ID && 
            !COMPLEX_PRODUCT_IDS.includes(p.id) &&
            !this.isExcludedFromTotalsStatus(p.status)
            );
            
            let maxPriceProduct = null;
            if (productsWithoutDelivery.length > 0) {
              maxPriceProduct = productsWithoutDelivery[0];
              let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
              
              for (let i = 1; i < productsWithoutDelivery.length; i++) {
                const product = productsWithoutDelivery[i];
                const productPrice = parseFloat(product.originalPrice || product.price || 0);
                if (productPrice > maxPrice) {
                  maxPrice = productPrice;
                  maxPriceProduct = product;
                }
              }
            }
            
            if (maxPriceProduct && installationPrice > 0) {
              const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
              // Вычитаем реальную стоимость установки из скидки
              maxPriceProduct.discountAmount = Math.max(0, currentDiscount - installationPrice);
              
              // Пересчитываем отображаемую цену товара
              maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
              
              // Пересчитываем итоговую стоимость товара
              this.updateProductTotal(maxPriceProduct);
              
              // Обновляем массив товаров
              if (!this.$route.params.orderId) {
                const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                if (index !== -1) {
                  this.$set(this.products, index, maxPriceProduct);
                }
              } else {
                // Если используется store, обновляем через store
                products = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
                const productInStore = products.find(p => p.id === maxPriceProduct.id);
                if (productInStore) {
                  productInStore.discountAmount = maxPriceProduct.discountAmount;
                  productInStore.displayPrice = maxPriceProduct.displayPrice;
                  this.updateProductTotal(productInStore);
                }
              }
            }
          }
          
          // Удаляем товар комплекса
          const productIndex = products.findIndex(p => p.id === complexProduct.id);
          if (productIndex !== -1) {
            if (this.$route.params.orderId) {
              this.$store.commit('removeProduct', {
                orderId: this.$route.params.orderId,
                productId: complexProduct.id
              });
            } else {
              this.products.splice(productIndex, 1);
            }
          }
        }
        
        // Очищаем комплекс и способ оплаты
        Vue.set(this.formData, 'installationComplex', null);
        Vue.set(this.formData, 'installationPaidBy', null);
        this.isComplexSelectDropdownOpen = false;
        this.closeComplexDropdown();
        
        // Снимаем флаг
        this.$nextTick(() => {
          this.isChangingComplex = false;
        });
        
        return;
      }
      
      // Комплекс уже выбран, устанавливаем способ оплаты
      this.setInstallationPaidBy(value);
    },
    
    toggleComplexDropdown(context) {
      if (this.formData.installationPaidBy !== context || !this.formData.installationComplex) {
        this.closeComplexDropdown();
        return;
      }
      
      if (this.isComplexDropdownOpen && this.activeComplexDropdown === context) {
        this.closeComplexDropdown();
      } else {
        this.activeComplexDropdown = context;
        this.isComplexDropdownOpen = true;
      }
    },
    
    closeComplexDropdown() {
      this.isComplexDropdownOpen = false;
      this.activeComplexDropdown = null;
    },
    
    selectInstallationComplex(newComplexValue) {
      // Сохраняем способ оплаты и старый комплекс ДО всех изменений
      const savedPaidBy = this.formData.installationPaidBy;
      const oldComplexValue = this.formData.installationComplex;
      
      // Если тот же комплекс - просто закрываем дропдаун
      if (oldComplexValue === newComplexValue) {
        this.closeComplexDropdown();
        return;
      }
      
      // Устанавливаем флаг для watcher
      this.isChangingComplex = true;
      
      // КРИТИЧНО: УСТАНАВЛИВАЕМ ЗНАЧЕНИЯ СРАЗУ - чтобы блок НЕ ОЧИЩАЛСЯ
      Vue.set(this.formData, 'installationComplex', newComplexValue);
      if (savedPaidBy) {
        Vue.set(this.formData, 'installationPaidBy', savedPaidBy);
      }
      
      // Принудительно обновляем DOM
      this.$forceUpdate();
      
      // Константы
      const DELIVERY_PRODUCT_ID = '989773504';
      const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
      const complexProducts = {
        complex1: { id: '989773501', name: 'Комплекс 1', price: 10.00 },
        complex2: { id: '989773505', name: 'Комплекс 2', price: 15.00 },
        complex3: { id: '989773503', name: 'Комплекс 3', price: 25.00 }
      };
      
      // Получаем список товаров
      let products = this.$route.params.orderId 
        ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
        : this.products;
      
      // Находим товар с наибольшей ценой (исключая доставку и комплексы)
const productsWithoutDelivery = products.filter(p => 
            p.id !== DELIVERY_PRODUCT_ID && 
            !COMPLEX_PRODUCT_IDS.includes(p.id) &&
            !this.isExcludedFromTotalsStatus(p.status)
            );
      
      let maxPriceProduct = null;
      if (productsWithoutDelivery.length > 0) {
        maxPriceProduct = productsWithoutDelivery[0];
        let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
        
        for (let i = 1; i < productsWithoutDelivery.length; i++) {
          const product = productsWithoutDelivery[i];
          const productPrice = parseFloat(product.originalPrice || product.price || 0);
          if (productPrice > maxPrice) {
            maxPrice = productPrice;
            maxPriceProduct = product;
          }
        }
      }
      
      // Старый и новый комплексы
      const oldProductMeta = oldComplexValue ? complexProducts[oldComplexValue] : null;
      const newProductMeta = complexProducts[newComplexValue];
      
      if (!newProductMeta) {
        this.isChangingComplex = false;
        this.closeComplexDropdown();
        return;
      }
      
      // 1. УДАЛЯЕМ СТАРЫЙ ТОВАР
      if (oldProductMeta && oldProductMeta.id !== newProductMeta.id) {
        const oldProductInList = products.find(p => p.id === oldProductMeta.id);
        
        // Убираем скидку, если была "За счет скидки"
        if (savedPaidBy === 'discount' && oldProductInList && maxPriceProduct) {
          const oldPrice = Number(oldProductInList.displayPrice || oldProductInList.originalPrice || oldProductInList.price || oldProductMeta.price);
          const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
          maxPriceProduct.discountAmount = Math.max(0, currentDiscount - oldPrice);
          maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
          this.updateProductTotal(maxPriceProduct);
          
          if (!this.$route.params.orderId) {
            const idx = this.products.findIndex(p => p.id === maxPriceProduct.id);
            if (idx !== -1) {
              this.$set(this.products, idx, maxPriceProduct);
            }
          } else {
            const productsInStore = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
            const productInStore = productsInStore.find(p => p.id === maxPriceProduct.id);
            if (productInStore) {
              productInStore.discountAmount = maxPriceProduct.discountAmount;
              productInStore.displayPrice = maxPriceProduct.displayPrice;
              this.updateProductTotal(productInStore);
            }
          }
        }
        
        // Удаляем старый товар
        const productIndex = products.findIndex(p => p.id === oldProductMeta.id);
        if (productIndex !== -1) {
          if (this.$route.params.orderId) {
            this.$store.commit('removeProduct', {
              orderId: this.$route.params.orderId,
              productId: oldProductMeta.id
            });
          } else {
            this.products.splice(productIndex, 1);
          }
        }
      }
      
      // 2. ДОБАВЛЯЕМ НОВЫЙ ТОВАР (если еще нет)
      const newPrice = Number(newProductMeta.price || 0);
      products = this.$route.params.orderId 
        ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
        : this.products;
      
      const existingNewProduct = products.find(p => p.id === newProductMeta.id);
      if (!existingNewProduct) {
        const installationProduct = {
          id: newProductMeta.id,
          name: newProductMeta.name,
          price: newPrice,
          originalPrice: newPrice,
          quantity: 1,
          total: newPrice,
          displayPrice: newPrice,
          discountAmount: 0,
          discountPercent: 0,
          status: 'new'
        };
        
        if (this.$route.params.orderId) {
          this.$store.commit('addProduct', {
            orderId: this.$route.params.orderId,
            product: installationProduct
          });
        } else {
          this.products.push(installationProduct);
        }
      }
      
      // 3. ДОБАВЛЯЕМ СКИДКУ, если "За счет скидки"
      if (savedPaidBy === 'discount') {
        products = this.$route.params.orderId 
          ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
          : this.products;
        
        // Находим товар с наибольшей ценой (исключая доставку и комплексы)
const productsWithoutDelivery = products.filter(p => 
            p.id !== DELIVERY_PRODUCT_ID && 
            !COMPLEX_PRODUCT_IDS.includes(p.id) &&
            !this.isExcludedFromTotalsStatus(p.status)
            );
        
        let updatedMaxPriceProduct = null;
        if (productsWithoutDelivery.length > 0) {
          updatedMaxPriceProduct = productsWithoutDelivery[0];
          let maxPrice = parseFloat(updatedMaxPriceProduct.originalPrice || updatedMaxPriceProduct.price || 0);
          
          for (let i = 1; i < productsWithoutDelivery.length; i++) {
            const product = productsWithoutDelivery[i];
            const productPrice = parseFloat(product.originalPrice || product.price || 0);
            if (productPrice > maxPrice) {
              maxPrice = productPrice;
              updatedMaxPriceProduct = product;
            }
          }
        }
        
        const newProductInList = products.find(p => p.id === newProductMeta.id);
        
        if (updatedMaxPriceProduct && newProductInList) {
          const productPrice = Number(newProductInList.displayPrice || newProductInList.originalPrice || newProductInList.price || newPrice);
          const currentDiscount = Number(updatedMaxPriceProduct.discountAmount) || 0;
          
          // Добавляем скидку только если ее еще нет
          if (!oldProductMeta || oldProductMeta.id !== newProductMeta.id) {
            updatedMaxPriceProduct.discountAmount = currentDiscount + productPrice;
            updatedMaxPriceProduct.displayPrice = this.calculateDiscountedPrice(updatedMaxPriceProduct);
            this.updateProductTotal(updatedMaxPriceProduct);
            
            if (!this.$route.params.orderId) {
              const idx = this.products.findIndex(p => p.id === updatedMaxPriceProduct.id);
              if (idx !== -1) {
                this.$set(this.products, idx, updatedMaxPriceProduct);
              }
            } else {
              const productsInStore = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
              const productInStore = productsInStore.find(p => p.id === updatedMaxPriceProduct.id);
              if (productInStore) {
                productInStore.discountAmount = updatedMaxPriceProduct.discountAmount;
                productInStore.displayPrice = updatedMaxPriceProduct.displayPrice;
                this.updateProductTotal(productInStore);
              }
            }
          }
        }
      }
      
      // Закрываем дропдаун
      this.closeComplexDropdown();
      
      // Снимаем флаг
      this.$nextTick(() => {
        this.isChangingComplex = false;
        // Гарантируем, что значения остались
        Vue.set(this.formData, 'installationComplex', newComplexValue);
        if (savedPaidBy) {
          Vue.set(this.formData, 'installationPaidBy', savedPaidBy);
        }
      });
    },
    
    getComplexDescription(value) {
      const option = this.installationComplexOptions.find(item => item.value === value);
      return option ? option.description : 'Выберите комплекс';
    },

    setInstallationPaidBy(value) {
      // Выбор «За счет скидки» для комплексов отключён
      if (value === 'discount') {
        return;
      }

      // Сохраняем ПРЕДЫДУЩИЙ способ оплаты ДО изменения (очень важно!)
      const previousPaidBy = this.formData.installationPaidBy || null;
      
      // Устанавливаем способ оплаты напрямую (даже если комплекс не выбран, для визуального заполнения блока)
      this.formData.installationPaidBy = value;
      
      // ID товаров комплексов
      const complexProducts = {
        complex1: { id: '989773501' },
        complex2: { id: '989773505' },
        complex3: { id: '989773503' }
      };
      
      // Если комплекс не выбран или способ оплаты снят, только устанавливаем значение и выходим
      if (!this.formData.installationComplex || value === null) {
        return;
      }
      
      const selectedComplex = complexProducts[this.formData.installationComplex];
      if (!selectedComplex) {
        return;
      }
      
      // Получаем актуальный список товаров
      let products = this.$route.params.orderId 
        ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
        : this.products;

      // Находим товар установки (комплекса) в заказе
      const installationProduct = products.find(p => p.id === selectedComplex.id);
      
      // Если товар установки не найден - выходим
      if (!installationProduct) {
        // Если пытаемся установить способ оплаты, но товара нет - сбрасываем выбор
        if (value !== null) {
          this.formData.installationPaidBy = previousPaidBy; // Возвращаем старое значение
        }
        return;
      }

      // Получаем реальную стоимость товара установки (цена, которую могут изменить менеджеры)
      const installationPrice = Number(installationProduct.displayPrice || installationProduct.originalPrice || installationProduct.price || 0);

      // ID товаров, которые не нужно учитывать (доставка и комплексы)
      const DELIVERY_PRODUCT_ID = '989773504';
      const complexProductIds = ['989773501', '989773505', '989773503'];
      
      // Находим товар с наибольшей ценой (исключая доставку и комплексы)
      const productsWithoutDelivery = products.filter(p => 
        p.id !== DELIVERY_PRODUCT_ID && 
        !complexProductIds.includes(p.id) &&
        !this.isExcludedFromTotalsStatus(p.status)
      );
      
      let maxPriceProduct = null;
      if (productsWithoutDelivery.length > 0) {
        maxPriceProduct = productsWithoutDelivery[0];
        let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
        
        for (let i = 1; i < productsWithoutDelivery.length; i++) {
          const product = productsWithoutDelivery[i];
          const productPrice = parseFloat(product.originalPrice || product.price || 0);
          if (productPrice > maxPrice) {
            maxPrice = productPrice;
            maxPriceProduct = product;
          }
        }
      }

      // Если выбор снят (value === null), убираем скидку, если она была
      if (value === null) {
        // Убираем скидку с товара с максимальной ценой, если она была добавлена из-за "За счет скидки"
        if (previousPaidBy === 'discount' && maxPriceProduct && installationPrice > 0) {
          const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
          // Вычитаем реальную стоимость установки
          maxPriceProduct.discountAmount = Math.max(0, currentDiscount - installationPrice);
          
          // Пересчитываем отображаемую цену товара
          maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
          
          // Пересчитываем итоговую стоимость товара
          this.updateProductTotal(maxPriceProduct);
          
          // Обновляем массив товаров, чтобы Vue отследил изменения
          if (!this.$route.params.orderId) {
            const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
            if (index !== -1) {
              this.$set(this.products, index, maxPriceProduct);
            }
          }
        }
        
        // Устанавливаем способ оплаты в null
        this.formData.installationPaidBy = null;
        return;
      }

      // Устанавливаем способ оплаты
      this.formData.installationPaidBy = value;

      // Применяем или убираем скидку с товара с максимальной ценой (не доставка и не комплексы)
      if (maxPriceProduct && installationProduct) {
        // Получаем текущую скидку товара с максимальной ценой
        const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
        
        // Определяем изменение скидки
        let discountChange = 0;
        if (previousPaidBy === 'discount' && value === 'client') {
          // Было "за счет скидки", стало "за счет клиента" - вычитаем реальную стоимость установки
          discountChange = -installationPrice;
        } else if (previousPaidBy === 'client' && value === 'discount') {
          // Было "за счет клиента", стало "за счет скидки" - добавляем реальную стоимость установки
          discountChange = installationPrice;
        } else if (previousPaidBy !== 'discount' && value === 'discount') {
          // Было не "за счет скидки" (null или client), стало "за счет скидки" - добавляем реальную стоимость установки
          discountChange = installationPrice;
        } else if (previousPaidBy === 'discount' && value === 'discount') {
          // Уже было "за счет скидки", осталось "за счет скидки" - ничего не меняем (был выбран другой комплекс)
          discountChange = 0;
        }
        
        // Применяем изменение скидки к товару с максимальной ценой
        if (discountChange !== 0) {
          maxPriceProduct.discountAmount = Math.max(0, currentDiscount + discountChange);
          
          // Пересчитываем отображаемую цену товара
          maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
          
          // Пересчитываем итоговую стоимость товара
          this.updateProductTotal(maxPriceProduct);
          
          // Обновляем массив товаров, чтобы Vue отследил изменения
          if (!this.$route.params.orderId) {
            const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
            if (index !== -1) {
              this.$set(this.products, index, maxPriceProduct);
            }
          } else {
            // Если используется store, обновляем через store
            const updatedProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
            const productInStore = updatedProducts.find(p => p.id === maxPriceProduct.id);
            if (productInStore) {
              productInStore.discountAmount = maxPriceProduct.discountAmount;
              productInStore.displayPrice = maxPriceProduct.displayPrice;
              this.updateProductTotal(productInStore);
            }
          }
        }
      }
    },
    toggleDeliveryPaidBy(value, event) {
      // Предотвращаем стандартное поведение
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      
      // Если кликнули на уже выбранный вариант, снимаем выбор
      if (this.formData.deliveryPaidBy === value) {
        this.setDeliveryPaidBy(null);
        return;
      }
      
      // Иначе устанавливаем новый выбор
      this.setDeliveryPaidBy(value);
    },
    
    // Цена доставки: vozim.by — 15р; курьер и остальные — 10р
    getDefaultDeliveryPrice(deliveryType) {
      const type = deliveryType != null
        ? deliveryType
        : (this.formData.deliveryTypes && this.formData.deliveryTypes.value) || null;
      if (type === 'vozimby') {
        return 15.00;
      }
      return 10.00;
    },

    setDeliveryPaidBy(value) {
      const DELIVERY_PRODUCT_ID = '989773504';
      const DELIVERY_PRODUCT_NAME = 'Доставка';
      
      // Проверяем тип доставки
      const deliveryType = this.formData.deliveryTypes ? this.formData.deliveryTypes.value : null;
      
      const DEFAULT_DELIVERY_PRICE = this.getDefaultDeliveryPrice(deliveryType);

      // Получаем актуальный список товаров
      let products = this.$route.params.orderId 
        ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
        : this.products;

      // Находим товар доставки в заказе
      let deliveryProduct = products.find(p => p.id === DELIVERY_PRODUCT_ID);

      // Добавляем товар доставки при выборе способа оплаты (для всех типов доставки, включая vozim.by)
      if (value && !deliveryProduct) {
        // Добавляем товар доставки с дефолтной ценой (15 руб для vozim.by, 10 руб для остальных)
        deliveryProduct = {
          id: DELIVERY_PRODUCT_ID,
          name: DELIVERY_PRODUCT_NAME,
          price: DEFAULT_DELIVERY_PRICE,
          originalPrice: DEFAULT_DELIVERY_PRICE,
          quantity: 1,
          total: DEFAULT_DELIVERY_PRICE,
          displayPrice: DEFAULT_DELIVERY_PRICE,
          discountAmount: 0,
          discountPercent: 0,
          status: 'new'
        };

        if (this.$route.params.orderId) {
          this.$store.commit('addProduct', {
            orderId: this.$route.params.orderId,
            product: deliveryProduct
          });
          // Получаем обновленный список товаров
          products = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
          deliveryProduct = products.find(p => p.id === DELIVERY_PRODUCT_ID);
        } else {
          this.products.push(deliveryProduct);
          products = this.products;
        }
      }

      // Получаем предыдущий способ оплаты доставки
      const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
      
      // Находим товар с наибольшей ценой (исключая доставку и комплексы)
const productsWithoutDelivery = products.filter(p => 
            p.id !== DELIVERY_PRODUCT_ID && 
            !COMPLEX_PRODUCT_IDS.includes(p.id) &&
            !this.isExcludedFromTotalsStatus(p.status)
            );
      
      let maxPriceProduct = null;
      if (productsWithoutDelivery.length > 0) {
        maxPriceProduct = productsWithoutDelivery[0];
        let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
        
        for (let i = 1; i < productsWithoutDelivery.length; i++) {
          const product = productsWithoutDelivery[i];
          const productPrice = parseFloat(product.originalPrice || product.price || 0);
          if (productPrice > maxPrice) {
            maxPrice = productPrice;
            maxPriceProduct = product;
          }
        }
      }
      
      const previousPaidBy = this.formData.deliveryPaidBy || null;
      
      // Если товар доставки не найден и мы пытаемся установить способ оплаты - выходим
      if (value && !deliveryProduct) {
        return;
      }

      // Полная сумма строки доставки (цена × кол-во); скидку на основной товар кладём пропорционально количеству штук
      const deliveryLineTotal = this.getDeliveryLineTotal(deliveryProduct, DEFAULT_DELIVERY_PRICE);

      // Если выбор снят (value === null), удаляем товар доставки и убираем скидку, если она была
      if (value === null) {
        // Удаляем товар доставки, если он есть
        if (deliveryProduct) {
          if (this.$route.params.orderId) {
            this.$store.commit('removeProduct', {
              orderId: this.$route.params.orderId,
              productId: DELIVERY_PRODUCT_ID
            });
          } else {
            const index = this.products.findIndex(p => p.id === DELIVERY_PRODUCT_ID);
            if (index !== -1) {
              this.products.splice(index, 1);
            }
          }
        }
        
        // Убираем скидку с товара с максимальной ценой, если она была добавлена из-за "За счет скидки"
        if (previousPaidBy === 'discount' && maxPriceProduct && deliveryLineTotal > 0) {
          const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
          const perMain = this.deliveryDiscountPerMainProductUnit(deliveryProduct, maxPriceProduct, DEFAULT_DELIVERY_PRICE);
          // Вычитаем долю доставки с одной штуки (ранее добавляли deliveryLineTotal / qty)
          maxPriceProduct.discountAmount = Math.max(0, currentDiscount - perMain);
          
          // Пересчитываем отображаемую цену товара
          maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
          
          // Пересчитываем итоговую стоимость товара
          this.updateProductTotal(maxPriceProduct);
          
          // Обновляем массив товаров, чтобы Vue отследил изменения
          if (!this.$route.params.orderId) {
            const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
            if (index !== -1) {
              this.$set(this.products, index, maxPriceProduct);
            }
          }
        }
        
        // Устанавливаем способ оплаты в null
        this.formData.deliveryPaidBy = null;
        return;
      }

      // Устанавливаем способ оплаты
      this.formData.deliveryPaidBy = value;

      // Применяем или убираем скидку с товара с максимальной ценой (не доставки)
      // Для vozim.by скидка применяется только когда есть товар (т.е. при "за счет скидки")
      if (maxPriceProduct && deliveryProduct) {
        // Получаем текущую скидку товара с максимальной ценой
        const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
        const perMain = this.deliveryDiscountPerMainProductUnit(deliveryProduct, maxPriceProduct, DEFAULT_DELIVERY_PRICE);
        
        // Изменение скидки на одну штуку основного товара (сумма доставки распределяется на все штуки позиции)
        let discountChange = 0;
        
        if (previousPaidBy === 'discount' && value === 'client') {
          // Было "за счет скидки", стало "за счет клиента" - вычитаем долю доставки с одной штуки
          discountChange = -perMain;
        } else if (previousPaidBy === 'client' && value === 'discount') {
          // Было "за счет клиента", стало "за счет скидки" - добавляем долю доставки на одну штуку
          discountChange = perMain;
        } else if (previousPaidBy !== 'discount' && value === 'discount') {
          // Было не "за счет скидки" (null или client), стало "за счет скидки"
          discountChange = perMain;
        }
        
        // Применяем изменение скидки к товару с максимальной ценой
        if (discountChange !== 0) {
          maxPriceProduct.discountAmount = Math.max(0, currentDiscount + discountChange);
          
          // Пересчитываем отображаемую цену товара
          maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
          
          // Пересчитываем итоговую стоимость товара
          this.updateProductTotal(maxPriceProduct);
          
          // Обновляем массив товаров, чтобы Vue отследил изменения
          if (!this.$route.params.orderId) {
            const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
            if (index !== -1) {
              this.$set(this.products, index, maxPriceProduct);
            }
          }
        }
      }
    },
                      // Метод для получения всех доступных статусов из statusGroupsOrder
                  getAllAvailableStatuses() {
                    const availableStatuses = [];
                    this.filteredStatusGroupsOrder.forEach(group => {
                      group.options.forEach(option => {
                        // Проверяем, что статус не отключен и не скрыт
                        if (!option.disabled && !(option.class && option.class.includes('hide'))) {
                          availableStatuses.push(option.value);
                        }
                      });
                    });
                    return availableStatuses;
                  },

    // Метод для получения статусов, в которые менеджер может переводить заказы
    getAllowedStatusesForTransfer() {
      const allowedStatuses = [
        // Группа "new"
        "new",
        "propushchennyi-zvonok",

        // Группа "approval"
        "vzial-v-rabotu",
        "availability-confirmed", 
        "sdilsddkls",
        "dffddsdfsdd",
        "offer-analog",
        "pod-zakaz",
        "novyi-beznalnyi-klient",
        "sdlkfsdjfsdfsdf-sdfgsdf-sdf",
        // Группа "delivery"
        "send-to-delivery",
        "dskjdslksd",
        "zakaz-magaz",

        
        // Группа "cancel" (кроме запрещенных)
        "cancel-other",
        "otmena-magas-mesto-man",
        "otmena-kupil-u-dr-mened",
        "otmena-s-otgruzkoi-kureru",
        "otmena-vozim-by",
        "povregden-tovar-piidostavke",
        "delyvery-did-not-suit",
        "otmenasdostavk",
        "prodaza-chastichnaya-sostoyalas",
        "obmen-s-doplatiu",
        "kiuhhjsdsdkkkkkkk12",
        "klkhdshjlsd88sdfsdf898",
        "kdjfffffff8hjf",
        "send-to-assembling",
        "otmenasdoskdfjdkfj",
        "otmena-sotgruz-kupil",
        "otmena-nashel-konkurentov",
        "otmenasvozvratomvmagazin",
        "5blsdfhoisdhflkdshf",
        "kldjfdfdfsdfsdfdfffffffffffffff",
        "otmena-dubl",
        
        // Группа "brak12"
        "1-priniat-na-proverku-sostavleny-vse-bumagi-postavil-na-zariadku",
        "2a-akb-zariadilsia-klienta-uvedomil-zhdu-ego-vizita",
        "2b-ne-zariadilsia-klienta-uvedomil-zhdu-ego-vizita-sniat-s-garantii",
        "3-1-s-karvata-peredali-na-mashinostroitelei-servis",
        "3-1-s-karvata-peredali-postavshchiku-importioru-ne-nasha-akb",
        "3-2-s-mashinostroitelei-servis-peredali-na-karvata",
        "4-otkaz-net-braka-budet-vozvrat-klientu",
        "0-vopros-uregulirovan-klient-bolshe-ne-bespokoit",
        "0-neobkhodim-otvet-na-pretenziiu",
        "0-otvet-otpravlen-potrebiteliu",
        "6-postavshchik-vernul-nam-novyi-akb-vmesto-braka",
        "3-2-ot-postavshchika-peredali-na-karvata",
        "4-brak-podtverzhdion-soglasovyvaetsia-zamena-klienta-opovestil",
        "2g-ne-zariadilsia-klienta-uvedomil-chto-peredaiu-na-minsk-vozmozhno-brak",
        "5-vydan-pokupateliu-novyi-akb-dokumenty-podpisany-vopros-zakryt",
        "5-vydan-obratno-ego-zhe-akb-ne-zariadilsia-sniat-s-garantii",
        "ili-dengi-dokumenty-podpisany",
        "2-vopros-uregulirovan-v-magazine-vozvrashchion-klientu-zariazhennym",
        
        // Группа "sto12f"
        "sto-prodazaza",
        "stoffnksajn12212",
        "avto-v-remonte-v-tsekhu",
        "gotov-k-vydache",
        "5-avto-vydan-klientu",
        "stowfifdk2j",
        "prokonsultirovan-perezvonit-pozzhe",
        "neobkhodimo-perezvonit-klientu-zapchasti-tseny-perechen-rabot-sto"
      ];
      
      return allowedStatuses;
    },

    toggleCopyDropdown(event) {
      if (event) event.stopPropagation();
      this.copyDropdownOpen = !this.copyDropdownOpen;
      if (this.copyDropdownOpen) {
        setTimeout(() => {
          document.addEventListener('click', this.closeCopyDropdownOnOutsideClick);
        }, 0);
      } else {
        document.removeEventListener('click', this.closeCopyDropdownOnOutsideClick);
      }
    },
    closeCopyDropdownOnOutsideClick(event) {
      const el = this.$el && this.$el.querySelector('.copy_order');
      if (el && !el.contains(event.target)) {
        this.copyDropdownOpen = false;
        document.removeEventListener('click', this.closeCopyDropdownOnOutsideClick);
      }
    },
    mapCopyItems(items) {
      return (items || []).map(item => ({
        offer: { id: item.offer && item.offer.id },
        status: item.status,
        discountAmount: item.discountAmount,
        percentAmount: item.percentAmount,
        productName: item.productName,
        initialPrice: item.initialPrice,
        quantity: item.quantity,
      }));
    },
    pickCopyCustomer(src) {
      const c = src.customer || {};
      return {
        firstName: c.firstName,
        lastName: c.lastName,
        patronymic: c.patronymic,
        phone: c.phone,
        additionalPhone: c.additionalPhone,
        email: c.email,
      };
    },
    pickCopyContragent(src) {
      return src.contragent ? { ...src.contragent } : null;
    },
    pickCopyDeliveryAddress(src) {
      const d = src.delivery || {};
      const a = d.address || {};
      return {
        address: {
          text: a.text,
          building: a.building,
          flat: a.flat,
          floor: a.floor,
          block: a.block,
          housing: a.housing,
          house: a.house,
          region: a.region,
          city: a.city,
          street: a.street,
        },
      };
    },
    pickCopyCustomFields(src, keys) {
      const cf = src.customFields || {};
      const out = {};
      keys.forEach((key) => {
        if (cf[key] !== undefined && cf[key] !== null && cf[key] !== '') {
          out[key] = cf[key];
        }
      });
      return out;
    },
    buildCopyOrderPayload(mode) {
      const src = this.getOrderData().order;
      const site = src.site;
      const customer = this.pickCopyCustomer(src);
      const contragent = this.pickCopyContragent(src);
      const items = this.mapCopyItems(src.items);

      // Light — основной блок + клиент + юр. реквизиты + состав
      if (mode === 'light') {
        return {
          order: {
            copyMode: mode,
            orderType: src.orderType,
            orderMethod: src.orderMethod,
            site,
            magazin: src.magazin,
            managerId: src.managerId,
            customer,
            contragent,
            items,
            customFields: this.pickCopyCustomFields(src, [
              'email2',
              'iuridicheskoe_naimenovanie',
              'manager_new',
            ]),
          },
        };
      }

      // Юр. лица — клиент, реквизиты, счёт, адрес доставки
      if (mode === 'legal') {
        return {
          order: {
            copyMode: mode,
            site,
            customer,
            contragent,
            delivery: this.pickCopyDeliveryAddress(src),
            customFields: this.pickCopyCustomFields(src, [
              'email2',
              'iuridicheskoe_naimenovanie',
              'sf_date',
              'sf_num',
              'contragentINN',
              'contragentLegalName',
              'contragentOKPO',
              'contragentKPP',
              'contragentOGRNIP',
              'contragentLegalAddress',
              'contragentOGRN',
              'contragentCertificateNumber',
              'contragentCertificateDate',
            ]),
          },
        };
      }

      // Обычный — рабочие поля менеджера без доставки/отгрузки/контроля/системных
      if (mode === 'normal') {
        return {
          order: {
            copyMode: mode,
            orderType: src.orderType,
            orderMethod: src.orderMethod,
            magazin: src.magazin,
            store: src.store,
            site,
            discount: src.discount,
            discountPercent: src.discountPercent,
            managerId: src.managerId,
            customer,
            contragent,
            items,
            customFields: this.pickCopyCustomFields(src, [
              'email2',
              'sssylkaaaaasssyyylka',
              'selectionLink',
              'wrongSelection',
              'carBrand',
              'carModel',
              'carName',
              'carYear',
              'fuelType',
              'carBodyType',
              'registryNumber',
              'iuridicheskoe_naimenovanie',
              'manager_new',
              'prodavec',
              'dfgfdddf',
              'dfgfdddfnew',
              'slksdkk2j3iu3n',
              'slksdkk2j3iu3nnew',
              'dsksajklsal',
              'contragentINN',
              'contragentLegalName',
              'contragentOKPO',
              'contragentKPP',
              'contragentOGRNIP',
              'contragentLegalAddress',
              'contragentOGRN',
              'contragentCertificateNumber',
              'contragentCertificateDate',
            ]),
          },
        };
      }

      // Полный — почти всё, кроме системных id/редактора/даты изменения
      const fullCustom = { ...(src.customFields || {}) };
      delete fullCustom.redaktor;
      delete fullCustom.data_izmeneniia;
      return {
        order: {
          copyMode: mode,
          orderType: src.orderType,
          orderMethod: src.orderMethod,
          magazin: src.magazin,
          store: src.store,
          site,
          discount: src.discount,
          discountPercent: src.discountPercent,
          managerId: src.managerId,
          shipmentStore: src.shipmentStore,
          shipmentDate: src.shipmentDate,
          customer,
          contragent,
          items,
          delivery: src.delivery,
          managerComment: src.managerComment,
          customerComment: src.customerComment,
          payments: src.payments,
          customFields: fullCustom,
        },
      };
    },
    async copyOrder(mode = 'normal') {
      this.copyDropdownOpen = false;
      document.removeEventListener('click', this.closeCopyDropdownOnOutsideClick);

      const orderData = this.buildCopyOrderPayload(mode);
      const modeTitle = (this.copyOrderModes.find(m => m.id === mode) || {}).title || mode;

      try {
        const response = await axios.post(ORDERS_API_BASE + '/copyOrder.php', orderData);
        if (response.data.success && response.data.orderId) {
          this.$router.push(`/edit/${response.data.orderId}`);
          this.$toast && this.$toast.success(`Заказ скопирован (${modeTitle})`);
        } else {
          this.$toast && this.$toast.error('Ошибка при копировании: ' + (response.data.message || 'Неизвестно'));
        }
      } catch (error) {
        this.$toast && this.$toast.error('Ошибка при копировании заказа');
        console.error(error);
      }
    },
    isFieldVisible(field) {
  const role = this.userRole ? String(this.userRole).trim().toLowerCase() : '';
  

  let matchedRoleKey = Object.keys(filterFieldsByRole).find(key => {
    const normalizedKey = String(key).trim().toLowerCase();
    return (
      role === normalizedKey ||
      role.includes(normalizedKey) ||
      normalizedKey.includes(role)
    );
  });

  if (!matchedRoleKey && this.canViewControlFields && filterFieldsByRole.control) {
    matchedRoleKey = 'control';
  }

  if (matchedRoleKey) {
    return filterFieldsByRole[matchedRoleKey].includes(field);
  }

  return false;
},
selectManager(){
  
    console.log(this.selectedStatusOrder);
  const role = String(this.userRole || '').toLowerCase();
  const isManagementRole = role.includes('руковод');
  if(this.selectedStatusOrder.label === 'Новый' && !isManagementRole){
    
    // Подставляем менеджера по символьному коду в поле "Менеджер тест"
    const userSymbolicCode = this.$store.state.user.symbolicCode;
    if (userSymbolicCode) {
      this.formData.manager_new = this.manager_new.find(m => m.value === userSymbolicCode) || null;
    }

    const targetStatus = this.filteredStatusGroupsOrder
      .flatMap(g => g.options)
      .find(opt => opt.value === 'vzial-v-rabotu');

    this.selectedStatusOrder = targetStatus || null;


    this.createOrder();

  }
},

visibleWhere(){
  this.isVisibleWhere = !this.isVisibleWhere;
},
curWhereText(customerCommnet) {
  const startText = "Какие страницы посещал";
  const endText = "Данные по переходам";

  const startIndex = customerCommnet.indexOf(startText);
  const endIndex = customerCommnet.indexOf(endText);

  if (startIndex !== -1 && endIndex !== -1 && endIndex > startIndex) {
    let extracted = customerCommnet.substring(startIndex, endIndex);

    // Удаляем лишние фразы и символы
    extracted = extracted
      .replace(startText, "")
      .replace(/Ссылка/g, "")
      .replace(/-/g, "")
      .trim();

    // Удаляем параметры ссылки (всё после ?)
    extracted = extracted.replace(/\?(.*)/, "").trim();

    return extracted;
  }

  // Корзина: "Страницы, которые посетил пользователь:"
  const cartMarker = 'Страницы, которые посетил пользователь:';
  const cartIdx = customerCommnet.indexOf(cartMarker);
  if (cartIdx !== -1) {
    const after = customerCommnet.substring(cartIdx + cartMarker.length);
    const stopMatch = after.search(/\nТекущий тип трафика:|\nДанные по переходам/);
    const chunk = (stopMatch === -1 ? after : after.substring(0, stopMatch)).trim();
    return chunk.replace(/\?[^\s]*/g, '').trim();
  }

  return "";
},

isProductCatalogPath(path) {
  const sectionSlugs = new Set([
    'akkumulyatory', 'legkovye', 'gruzovye', 'agm', 'mototsikly', 'scooter', 'lodki',
    'tyagovye', 'aksessuary', 'akb', 'bu_akkumulyatory', 'premium', 'elektromobili',
    'motornye_masla', 'cart', 'basket', 'compare', 'wishlist', 'search',
    'zaryadnye_ustroystva_dlya_akkumulyatorov',
  ]);
  const p = decodeURIComponent(String(path || '')).replace(/\/+$/, '') + '/';
  if (/\/catalog\/akkumulyator[_-][^/]+\/$/i.test(p)) return true;
  const m = p.match(/^\/catalog\/([^/]+)\/$/i);
  if (!m) return false;
  const code = String(m[1] || '').toLowerCase();
  if (!code || sectionSlugs.has(code)) return false;
  // Карточки обычно с цифрами в CODE (ёмкость/ток)
  return /\d/.test(code);
},

normalizeVisitedUrl(raw) {
  if (!raw) return null;
  let u = String(raw).trim().replace(/[),\];.'"»]+$/g, '');
  if (!u) return null;
  if (u.startsWith('/')) {
    u = 'https://1akb.by' + u;
  }
  if (!/^https?:\/\//i.test(u)) return null;
  try {
    const parsed = new URL(u);
    if (/^(www\.)?test\.1akb\.by$/i.test(parsed.hostname)) {
      parsed.hostname = '1akb.by';
    }
    if (!/1akb\.by$/i.test(parsed.hostname)) return null;
    const path = decodeURIComponent(parsed.pathname || '');
    const key = path.replace(/\/+$/, '').toLowerCase() || '/';
    const href = parsed.origin + (path === '/' ? '/' : path.replace(/\/?$/, '/'));
    return { href, path, key };
  } catch (e) {
    return null;
  }
},

extractH1MapFromHistory(comment = '', customField = '') {
  const map = {};
  const texts = [customField, comment].filter((t) => String(t || '').trim());

  texts.forEach((text) => {
    String(text).split(/\r?\n/).forEach((line) => {
      const trimmed = line.trim();
      // Новый формат vision_site: "H1 :: URL"
      const withH1 = trimmed.match(/^(.+?)\s+::\s+(https?:\/\/\S+|\/\S+)/i);
      if (withH1) {
        const h1 = String(withH1[1] || '').replace(/\s+/g, ' ').trim();
        const normalized = this.normalizeVisitedUrl(withH1[2]);
        if (h1 && normalized) map[normalized.key] = h1;
        return;
      }
    });

    // Из комментария сайта: "1. H1" + следующая строка "URL: ..."
    const blocks = String(text).match(/(?:^|\n)\s*\d+\.\s+([^\n]+)\n\s*URL:\s*(\S+)/gi) || [];
    blocks.forEach((block) => {
      const m = block.match(/\d+\.\s+([^\n]+)\n\s*URL:\s*(\S+)/i);
      if (!m) return;
      const h1 = String(m[1] || '').replace(/\s+/g, ' ').trim();
      const normalized = this.normalizeVisitedUrl(m[2]);
      if (h1 && normalized && h1.toLowerCase() !== 'не указан') {
        map[normalized.key] = h1;
      }
    });

    // "Текущая страница" блок: "- H1: ..." + "- URL: ..."
    const currentH1 = String(text).match(/-\s*H1:\s*([^\n]+)/i);
    const currentUrl = String(text).match(/-\s*URL:\s*(\S+)/i);
    if (currentH1 && currentUrl) {
      const h1 = String(currentH1[1] || '').replace(/\s+/g, ' ').trim();
      const normalized = this.normalizeVisitedUrl(currentUrl[1]);
      if (h1 && normalized && h1.toLowerCase() !== 'не указан') {
        map[normalized.key] = h1;
      }
    }
  });

  return map;
},

extractAllVisitedUrls(comment = '', customField = '') {
  const texts = [comment, customField].filter((t) => String(t || '').trim());
  const urls = [];
  const seen = new Set();
  const h1Map = this.extractH1MapFromHistory(comment, customField);

  const pushUrl = (raw, h1Hint = '') => {
    const normalized = this.normalizeVisitedUrl(raw);
    if (!normalized) return;
    if (seen.has(normalized.key)) {
      const existing = urls.find((u) => u.key === normalized.key);
      if (existing && !existing.h1 && h1Hint) existing.h1 = h1Hint;
      return;
    }
    seen.add(normalized.key);
    urls.push({
      ...normalized,
      h1: h1Hint || h1Map[normalized.key] || '',
    });
  };

  texts.forEach((text) => {
    String(text).split(/\r?\n/).forEach((line) => {
      const trimmed = line.trim();
      const withH1 = trimmed.match(/^(.+?)\s+::\s+(https?:\/\/\S+|\/\S+)/i);
      if (withH1) {
        pushUrl(withH1[2], String(withH1[1] || '').replace(/\s+/g, ' ').trim());
        return;
      }
      if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('/')) {
        pushUrl(trimmed);
      }
    });
    const full = String(text).match(/https?:\/\/[^\s<>"']+/gi) || [];
    full.forEach((u) => pushUrl(u));
    const rel = String(text).match(/\/(?:catalog|podbor|basket|cart|search|blog|info|services?|dostavka|oplata|contacts?|cto|garantiya)[^\s<>"']*/gi) || [];
    rel.forEach((u) => pushUrl(u));
  });

  // Дополнить H1 из карты, если нашли позже
  urls.forEach((item) => {
    if (!item.h1 && h1Map[item.key]) item.h1 = h1Map[item.key];
  });

  return urls;
},

extractVisitedPageUrls(comment = '', customField = '') {
  return this.extractAllVisitedUrls(comment, customField)
    .filter((item) => this.isProductCatalogPath(item.path))
    .map((item) => item.href);
},

formatVisitedPagePathLabel(path = '') {
  const p = decodeURIComponent(String(path || '')).replace(/\/+$/, '') || '/';
  if (p === '/') return '/';
  return p;
},

isLikelyBrowserTitle(text = '') {
  const s = String(text || '').replace(/\s+/g, ' ').trim();
  if (!s) return false;
  // document.title на сайте обычно с разделителем и брендом
  if (/\s[\|\—\-–]\s*1akb/i.test(s) || /1akb\.by/i.test(s)) return true;
  if (/\|\s*купить/i.test(s) || /купить\s.+\sв\sминске/i.test(s)) return true;
  return false;
},

formatVisitedPageLabel(url, path = '', h1 = '') {
  const cleanH1 = String(h1 || '').replace(/\s+/g, ' ').trim();
  if (cleanH1 && cleanH1.toLowerCase() !== 'не указан' && !this.isLikelyBrowserTitle(cleanH1)) {
    return cleanH1;
  }
  // Без настоящего H1 не выдумываем title из slug — путь покажем отдельно
  return this.formatVisitedPagePathLabel(path || url) || path || url;
},

async enrichVisitedPagesWithH1(pages = []) {
  const list = Array.isArray(pages) ? pages : [];
  if (!list.length) return list;

  try {
    const response = await axios.post(ORDERS_API_BASE + '/page-h1.php', {
      urls: list.map((p) => p.url),
    });
    const items = (response.data && response.data.items) || [];
    const byKey = {};
    items.forEach((item) => {
      if (!item || !item.h1) return;
      const h1 = String(item.h1).replace(/\s+/g, ' ').trim();
      if (!h1) return;
      ;[item.url, item.resolvedUrl].filter(Boolean).forEach((u) => {
        const normalized = this.normalizeVisitedUrl(u);
        if (normalized) byKey[normalized.key] = h1;
      });
    });

    list.forEach((page) => {
      const normalized = this.normalizeVisitedUrl(page.url);
      const resolved = normalized ? byKey[normalized.key] : '';
      if (!resolved) return;
      page.h1 = resolved;
      page.label = resolved;
    });
  } catch (e) {
    console.warn('Не удалось подтянуть H1 страниц:', e);
  }
  return list;
},

extractVisitedNonProductPages(comment = '', customField = '') {
  return this.extractAllVisitedUrls(comment, customField)
    .filter((item) => !this.isProductCatalogPath(item.path))
    .map((item) => ({
      url: item.href,
      path: item.path,
      pathLabel: this.formatVisitedPagePathLabel(item.path),
      label: this.formatVisitedPageLabel(item.href, item.path, item.h1),
      h1: item.h1 || '',
    }));
},

scrollVisitedCarousel(direction = 1) {
  const el = this.$refs.visitedCarousel;
  if (!el) return;
  // Листаем примерно на 5 карточек (ширину вьюпорта карусели)
  const step = Math.max(240, el.clientWidth);
  el.scrollBy({ left: direction * step, behavior: 'smooth' });
},

async loadVisitedProductsFromHistory(comment = '', customField = '') {
  this.visitedPages = this.extractVisitedNonProductPages(comment, customField);
  // Подтянуть настоящий h1.breadcrumbs__title с сайта (если в CRM лежит title/slug)
  this.enrichVisitedPagesWithH1(this.visitedPages).then((pages) => {
    this.visitedPages = pages.slice();
  });
  const urls = this.extractVisitedPageUrls(comment, customField);
  if (!urls.length) {
    this.visitedProducts = [];
    this.visitedProductsLoading = false;
    return;
  }

  this.visitedProductsLoading = true;
  try {
    const response = await axios.post(ORDERS_API_BASE + '/products-by-urls.php', { urls });
    const products = (response.data && response.data.products) || [];
    this.visitedProducts = products;
  } catch (error) {
    console.error('Ошибка загрузки просмотренных АКБ:', error);
    this.visitedProducts = [];
  } finally {
    this.visitedProductsLoading = false;
  }
},

async fetchClientBonus(phone, currentOrderId = null) {
  try {
    let bonus = 0;
    let reserves = [];
    if (phone) {
      const response = await axios.get('https://manager.1akb.by/get-bonus', {
        params: { phone }
      });
      bonus = Number(response.data.bonus) || 0;
      reserves = response.data.reserves || [];
      this.bonusClient = bonus;
      this.bonusReserves = reserves;   // <---- ВАЖНО! Сохраняем массив резервов для других методов
      // Формируем красивое сообщение:
      let msg = `У клиента ${bonus} бонусных баллов`;
      if (reserves.length > 0) {
        msg += ' (в резерве: ';
        msg += reserves.map(r => {
          if (r.order_id == currentOrderId) {
            // Выделить текущий заказ, например, через <span> с классом
            return `<span style="color: blue; font-weight: bold">${r.amount} — ${r.order_id}</span>`;
          }
          return `${r.amount} — ${r.order_id}`;
        }).join('; ');
        msg += ')';
      }
      this.clientBonusMessage = msg;
    } else {
      this.clientBonusMessage = 'Телефон не указан. Данные о бонусах недоступны';
      this.bonusReserves = [];    // <---- Очищаем если нет телефона
    }
  } catch (error) {
    console.error('Ошибка при получении бонусов:', error);
    this.clientBonusMessage = 'Ошибка при получении бонусов клиента';
    this.bonusReserves = [];    // <---- Очищаем если ошибка
  }
},

getOrderBonusReserve(orderId) {
  if (!this.bonusReserves || !orderId) return 0;
  const found = this.bonusReserves.find(r => r.order_id == orderId);
  return found ? Number(found.amount) : 0;
},

spisatBonusy(payment, index) {
  const maxSumm = this.grandTotal * 0.3;

  // 1. Бонусы, доступные на счету (без резерва!)
  let bonusOnBalance = this.bonusClient || 0;
  // 2. Сумма в резерве по этому заказу (order_id)
  const orderId = this.$route.params.orderId;

  const reserveForThisOrder = this.getOrderBonusReserve(orderId);

  

  // 3. Итоговая максимальная сумма: бонусы на счету + резерв по этому заказу
  let maxBonus = Math.min(maxSumm, bonusOnBalance + reserveForThisOrder);

  console.log(maxBonus);

  // 4. Установить лимит и сумму
  this.payments[index].bonusLimit = maxBonus;
  this.payments[index].amount = maxBonus;

  // 5. Перерасчет, если нужно
  this.updatePaymentAmounts(index, maxBonus);
  this.updatePayments();
},






    correctDiscountInput() {
      // Разовая скидка не должна зависеть от суммы trade-in.
      // Оставляем только защиту от отрицательных значений.
      if (this.oneTimeDiscountAmount < 0) {
        this.oneTimeDiscountAmount = 0;
      }
      this.updateTotalDiscount();
    },

onManualGrandTotalChange(val) {
      const parsedVal = parseFloat(val);
      if (isNaN(parsedVal)) return;

      const totalProductPrice = this.totalPrice;
      // Разница между полной ценой и тем, что ввёл пользователь
      const targetDiscount = totalProductPrice - parsedVal;
      // Вся эта разница — это oneTimeDiscountAmount
      this.oneTimeDiscountAmount += targetDiscount > 0 ? targetDiscount : 0;
      // Сохраняем ввод и активируем ручной режим
      this.manualTotal = parsedVal;
      this.manualOverride = true;
},
applyManualGrandTotal() {
      const parsedVal = parseFloat(this.manualTotalInput);
      if (isNaN(parsedVal)) return;

      const tradeIn = parseFloat(this.formData.tradeInAmountNew) || 0;
      const totalProductPrice = this.totalPrice;

      const maxPossible = totalProductPrice - tradeIn;

      // Ограничим максимально допустимую сумму
      if (parsedVal > maxPossible) {
        this.manualTotalInput = maxPossible.toFixed(2);
        this.manualTotal = maxPossible;
        this.manualOverride = true;
        return;
      }

      const requiredTotalDiscount = totalProductPrice - parsedVal;
      const existingDiscounts = this.totalDiscount - this.oneTimeDiscountAmount;

      const additionalOneTimeDiscount = requiredTotalDiscount - existingDiscounts;

      this.oneTimeDiscountAmount = additionalOneTimeDiscount > 0
        ? additionalOneTimeDiscount + tradeIn
        : tradeIn;

      this.manualTotal = parsedVal;
      this.manualOverride = true;
},

  resetManualTotal() {
    this.manualTotal = null;
    this.manualOverride = false;
  },

 updateFormattedPhone() {
    const raw = this.formData.phone;
    const digits = raw.replace(/\D/g, '');
    let normalized = '';

    if (digits.length === 11 && digits.startsWith('80')) {
      normalized = '+375' + digits.slice(2);
    } else if (digits.length === 12 && digits.startsWith('375')) {
      normalized = '+' + digits;
    } else if (digits.length === 13 && digits.startsWith('375')) {
      normalized = '+' + digits;
    }

    if (normalized && /^\+375(25|29|33|44)\d{7}$/.test(normalized)) {
      this.formattedPhone = normalized;
      this.invalidPhone = this.formData.phone !== normalized;
    } else {
      this.formattedPhone = '';
      this.invalidPhone = true;
    }
  },
  applyFormattedPhone() {
    if (this.formattedPhone) {
      this.formData.phone = this.formattedPhone;
      this.invalidPhone = false;
    }
  },

    getCurentDates(dat){

      const date = new Date(dat.replace(' ', 'T'));

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${day}.${month}.${year} ${hours}:${minutes}`;
    },

    cleanCallSiteLabel(label) {
      if (!label) return '';
      return String(label).replace(/^[-–—\s]+|[-–—\s]+$/g, '').replace(/\s+/g, ' ').trim();
    },

    curStatus(status) {
      const code = this.normalizeStatusCode(status);
      if (code && this.statusGroupMap[code]) {
        return this.statusGroupMap[code].name;
      }
      for (const group of this.filteredStatusGroupsOrder) {
        const foundStatus = group.options.find((option) => String(option.value) === code);
        if (foundStatus) {
          return foundStatus.label;
        }
      }
      return null;
    },

    normalizeStatusCode(status) {
      if (status == null || status === '') return '';
      if (typeof status === 'object') {
        return String(status.code || status.value || status.id || '');
      }
      return String(status);
    },

    createStatusGroupMap() {
      const statuses = Array.isArray(this.retailStatuses) ? this.retailStatuses : [];
      this.statusGroupMap = statuses.reduce((map, status) => {
        if (!status || !status.code) return map;
        map[status.code] = {
          name: status.name,
          group: status.group,
          color: status.color,
        };
        return map;
      }, {});
    },

    async fetchRetailStatuses() {
      try {
        const response = await axios.get(ORDERS_API_BASE + '/statuses.php');
        this.retailStatuses = Array.isArray(response.data && response.data.statuses)
          ? response.data.statuses
          : [];
        this.createStatusGroupMap();
      } catch (error) {
        console.error('Ошибка при получении статусов:', error);
      }
    },

    getStatusGroupColor(colorName) {
      const colors = {
        new: 'rgba(254,165,48,1)',
        approval: 'rgba(254,165,48,0.2)',
        delivery: 'rgba(0,94,235,0.13)',
        complete: 'rgba(34,201,147,0.15)',
        cancel: 'rgba(255,83,83,0.15)',
        assembling: 'rgba(101,40,215,0.1)',
        dflkdslskl: 'rgba(175,185,195,1)',
        brak12: 'rgba(101,40,215,0.1)',
        sto12f: 'rgba(30,34,72,1)',
      };
      return colors[colorName] || colorName || 'rgba(0,0,0,0.1)';
    },

    getStatusGroupClass(status) {
      const code = this.normalizeStatusCode(status);
      if (code && this.statusGroupMap[code]) {
        return this.statusGroupMap[code].group || '';
      }
      for (const group of this.filteredStatusGroupsOrder) {
        const foundStatus = group.options.find((option) => String(option.value) === code);
        if (foundStatus && foundStatus.class) {
          const className = String(foundStatus.class).split(' ')[0];
          return className || group.group || '';
        }
      }
      return '';
    },

    getStatusColor(status) {
      const code = this.normalizeStatusCode(status);
      if (code && this.statusGroupMap[code]) {
        const entry = this.statusGroupMap[code];
        return this.getStatusGroupColor(entry.group || entry.color);
      }
      for (const group of this.filteredStatusGroupsOrder) {
        const foundStatus = group.options.find((option) => String(option.value) === code);
        if (foundStatus) {
          return group.color;
        }
      }
      return '#ccc';
    },

    openSidebar() {
      this.sidebarVisible = true;
    },
    closeSidebar() {
      this.sidebarVisible = false;
    },
    openTask(){
      this.taskVisible = true;
    },
    closeTask(){
      this.taskVisible = false;
    },
    openEditTask(taskid){
      this.editTaskid = taskid;
      this.taskEditVisible = true;
    },
    closeEditTask(){
      this.taskEditVisible = false;
    },
    handleSubmit(data) {
      console.log("Submitted data:", data);
      // Здесь можно отправить данные на сервер или обработать
    },

    // Очистка номера телефона
    cleanPhoneNumber(phone) {
      return phone.replace(/\D/g, '');
    },
    formatDateCall(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  },
  getCallType(callType) {
    if (callType === 0) {
      return 'Входящий';
    } else {
      return 'Исходящий';
    }
  },
  getCallStatus(callStatus) {
    if (callStatus === 2) {
      return 'Завершен';
    } else {
      return 'Ожидает';
    }
  },

getCallRecordUrl(uniqueId) {
    this.$set(this.isPlaying, uniqueId, true);
    return `https://bot.vochi.by/api/v1/recording?unique_id=${encodeURIComponent(uniqueId)}&key=vchi_9f42b55f8ad44b9ea1b910d452f43e9a22907f8e`;
  },
  playCallRecord(uniqueId) {
    const audioElement = document.getElementById(`audio-${uniqueId}`);
    console.log(uniqueId);
    if (audioElement) {
      this.$set(this.isPlaying, uniqueId, true); // Устанавливаем состояние в true
      audioElement.play(); // Проигрываем аудиозапись
    }
  },

  /** Скачать запись разговора с правильным расширением .mp3 (иначе браузер сохраняет без расширения и файл не открывается) */
  async downloadCallRecord(call) {
    let url = call.filePath;
    if (!url) {
      const metaUrl = `https://bot.vochi.by/api/v1/recording?unique_id=${encodeURIComponent(call.UniqueId)}&key=vchi_9f42b55f8ad44b9ea1b910d452f43e9a22907f8e`;
      const metaRes = await fetch(metaUrl);
      if (!metaRes.ok) throw new Error('Ошибка получения записи');
      const meta = await metaRes.json();
      url = meta.download_url || meta.recording_url;
      if (!url) throw new Error('Нет ссылки на запись');
    }
    const filename = `zapis_${call.UniqueId}.mp3`;
    try {
      const response = await fetch(url, { method: 'GET' });
      if (!response.ok) throw new Error('Ошибка загрузки');
      const blob = await response.blob();
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(a.href);
    } catch (e) {
      console.error('Не удалось скачать запись:', e);
      this.$toast && this.$toast.error('Не удалось скачать запись разговора.');
    }
  },

  // Методы для кастомного аудиоплеера
  onAudioLoaded(uniqueId) {
    const audio = document.getElementById(`audio-${uniqueId}`);
    if (audio) {
      this.$set(this.audioStates, uniqueId, {
        playing: false,
        currentTime: 0,
        duration: audio.duration || 0,
        speed: 1
      });
    }
  },
  
  onTimeUpdate(uniqueId) {
    const audio = document.getElementById(`audio-${uniqueId}`);
    if (audio && this.audioStates[uniqueId]) {
      this.$set(this.audioStates[uniqueId], 'currentTime', audio.currentTime);
    }
  },
  
  onAudioEnded(uniqueId) {
    if (this.audioStates[uniqueId]) {
      this.$set(this.audioStates[uniqueId], 'playing', false);
      this.$set(this.audioStates[uniqueId], 'currentTime', 0);
    }
  },
  
  togglePlay(uniqueId) {
    const audio = document.getElementById(`audio-${uniqueId}`);
    if (!audio) return;
    
    // Инициализируем состояние если не существует
    if (!this.audioStates[uniqueId]) {
      this.$set(this.audioStates, uniqueId, {
        playing: false,
        currentTime: 0,
        duration: audio.duration || 0,
        speed: 1
      });
    }
    
    if (audio.paused) {
      // Останавливаем все другие аудио
      Object.keys(this.audioStates).forEach(id => {
        if (id !== uniqueId && this.audioStates[id] && this.audioStates[id].playing) {
          const otherAudio = document.getElementById(`audio-${id}`);
          if (otherAudio) {
            otherAudio.pause();
            this.$set(this.audioStates[id], 'playing', false);
          }
        }
      });
      audio.play();
      this.$set(this.audioStates[uniqueId], 'playing', true);
    } else {
      audio.pause();
      this.$set(this.audioStates[uniqueId], 'playing', false);
    }
  },
  
  seekAudio(uniqueId, event) {
    const audio = document.getElementById(`audio-${uniqueId}`);
    if (audio) {
      audio.currentTime = parseFloat(event.target.value);
    }
  },
  
  changeSpeed(uniqueId, event) {
    const audio = document.getElementById(`audio-${uniqueId}`);
    const speed = parseFloat(event.target.value);
    if (audio) {
      audio.playbackRate = speed;
      if (this.audioStates[uniqueId]) {
        this.$set(this.audioStates[uniqueId], 'speed', speed);
      }
    }
  },
  
  toggleSpeedMenu(uniqueId) {
    if (this.speedMenuOpen === uniqueId) {
      this.speedMenuOpen = null;
    } else {
      this.speedMenuOpen = uniqueId;
    }
  },
  
  selectSpeed(uniqueId, speed) {
    const audio = document.getElementById(`audio-${uniqueId}`);
    if (audio) {
      audio.playbackRate = speed;
      if (!this.audioStates[uniqueId]) {
        this.$set(this.audioStates, uniqueId, {
          playing: false,
          currentTime: 0,
          duration: audio.duration || 0,
          speed: speed
        });
      } else {
        this.$set(this.audioStates[uniqueId], 'speed', speed);
      }
    }
    this.speedMenuOpen = null;
  },
  
  formatTime(seconds) {
    if (!seconds || isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  },
  
  getProgressPercent(uniqueId) {
    const state = this.audioStates[uniqueId];
    if (!state || !state.duration) return 0;
    return (state.currentTime / state.duration) * 100;
  },

  // Формат номера для API Vochi: +375...
  formatPhoneForVochiApi(cleaned) {
    if (!cleaned) return '';
    if (cleaned.startsWith('80')) return '+375' + cleaned.slice(2);
    if (cleaned.startsWith('375')) return '+' + cleaned;
    return '+375' + cleaned;
  },

  // Собирает ExtensionInfo (менеджер/оператор) из разных форматов ответа API
  buildExtensionInfo(item) {
    const ext = item.extraData && item.extraData.ExtensionInfo;
    if (ext && (ext.firstName || ext.lastName || ext.first_name || ext.last_name)) {
      return {
        firstName: ext.firstName || ext.first_name || '',
        lastName: ext.lastName || ext.last_name || '',
      };
    }
    const info = item.extension_info || item.operator || item.user || {};
    const firstName = info.firstName || info.first_name || '';
    const lastName = info.lastName || info.last_name || '';
    if (firstName || lastName) {
      return { firstName, lastName };
    }
    const nameStr = item.extension_name || item.operator_name || item.user_name || item.agent_name || info.name || '';
    if (nameStr) {
      const parts = String(nameStr).trim().split(/\s+/);
      return {
        firstName: parts[0] || '',
        lastName: parts.slice(1).join(' ') || '',
      };
    }
    // Новый формат: participants: [{ extension: "205", status: "answered" }, ...]
    if (Array.isArray(item.participants) && item.participants.length) {
      const answered = item.participants.find(p => p && p.status === 'answered');
      const p = answered || item.participants[0];
      if (p && p.extension) {
        const extStr = String(p.extension);
        const user = this.usersByExtension && this.usersByExtension[extStr];
        if (user && (user.firstName || user.lastName)) {
          return {
            firstName: user.firstName || '',
            lastName: user.lastName || ''
          };
        }
        return { firstName: extStr, lastName: '' };
      }
    }
    const extNumber = item.extension_number || item.extension || item.extension_id || info.extension_number || info.number;
    if (extNumber != null && extNumber !== '') {
      return { firstName: String(extNumber), lastName: '' };
    }
    return null;
  },

  async loadUsersByExtension() {
    try {
      // Если уже загружено сопоставление, повторно не тянем
      if (this.usersByExtension && Object.keys(this.usersByExtension).length) {
        return;
      }
      const res = await fetch('https://manager.1akb.by/users-settings');
      if (!res.ok) {
        throw new Error('Ошибка загрузки users-settings');
      }
      const data = await res.json();
      const list = Array.isArray(data) ? data : [];
      const map = {};
      list.forEach(u => {
        if (u && u.internalPhone) {
          const ext = String(u.internalPhone);
          map[ext] = {
            firstName: (u.firstName || '').trim() || (u.label || '').trim() || ext,
            lastName: (u.lastName || '').trim() || ''
          };
        }
      });
      this.usersByExtension = map;
    } catch (e) {
      console.error('Не удалось загрузить users-settings для сопоставления внутренних номеров:', e);
      this.usersByExtension = {};
    }
  },

  // Преобразует объект звонка из API bot.vochi.by/api/v1/calls в формат для шаблона
  mapVochiCallToCallLog(item) {
    const uniqueId = item.unique_id || item.UniqueId || item.id;
    const date = item.start_time || item.date || item.DateReceived;

    // Тип звонка: 0/1 из call_type, иначе пытаемся понять по direction
    const rawCallType = item.call_type != null ? String(item.call_type) : (item.CallType != null ? String(item.CallType) : null);
    let callType;
    if (rawCallType === '0') {
      callType = 0; // входящий
    } else if (rawCallType === '1') {
      callType = 1; // исходящий
    } else {
      const direction = (item.direction || '').toString().toLowerCase();
      callType = direction === 'inbound' || direction === 'входящий' ? 0 : 1;
    }

    // Статус: сначала числовой call_status, потом текстовый status
    const rawCallStatus = item.call_status != null ? String(item.call_status) : (item.CallStatus != null ? String(item.CallStatus) : null);
    let callStatus;
    if (rawCallStatus === '0') {
      callStatus = 0;
    } else if (rawCallStatus === '2') {
      callStatus = 2;
    } else if (rawCallStatus !== null) {
      callStatus = Number(rawCallStatus);
    } else {
      const status = item.status;
      callStatus =
        status === 'completed' || status === 'завершен'
          ? 2
          : status === 'no-answer' || status === 'no_answer'
          ? 0
          : 1;
    }
    const extensionInfo = this.buildExtensionInfo(item);
    const extraData = item.extraData ? { ...item.extraData } : {};
    if (extensionInfo) {
      extraData.ExtensionInfo = extensionInfo;
    }
    return {
      _id: uniqueId,
      UniqueId: uniqueId,
      DateReceived: date,
      CallType: callType,
      Phone: item.phone_number || item.Phone || '',
      CallStatus: typeof item.CallStatus !== 'undefined' ? item.CallStatus : callStatus,
      extraData,
      filePath: item.recording_url || item.download_url || null,
      duration_seconds: item.duration_seconds || item.duration,
    };
  },

  async fetchCallHistory(phoneCustomer) {
    const phoneInput = phoneCustomer;
    const phone = this.cleanPhoneNumber(phoneInput);
    const additionalPhoneInput = this.formData.additionalPhone;
    const additionalPhone = this.cleanPhoneNumber(additionalPhoneInput);

    this.isModalOpenPhone = true;
    this.isLoadingCall = true;
    const VOCHI_KEY = 'vchi_9f42b55f8ad44b9ea1b910d452f43e9a22907f8e';

    try {
      // Загружаем пользователей для сопоставления internalPhone -> ФИО
      await this.loadUsersByExtension();

      const fetchCallsByPhone = async (cleanedPhone, limit = 50, offset = 0) => {
        const apiPhone = this.formatPhoneForVochiApi(cleanedPhone);
        if (!apiPhone) return [];
        const url = `https://bot.vochi.by/api/v1/calls?phone=${encodeURIComponent(apiPhone)}&key=${VOCHI_KEY}&limit=${limit}&offset=${offset}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('Ошибка загрузки звонков');
        const data = await res.json();
        const list = data.calls || data.data || (Array.isArray(data) ? data : []);
        return list.map((item) => this.mapVochiCallToCallLog(item));
      };

      let callLogs = await fetchCallsByPhone(phone);
      if (additionalPhone) {
        const calls2 = await fetchCallsByPhone(additionalPhone);
        callLogs = [...callLogs, ...calls2];
      }
      callLogs = callLogs.filter((elem) => elem.CallStatus !== 0);

      this.callLogs = callLogs;

      for (const call of this.callLogs) {
        const response = await fetch(`https://manager.1akb.by/getTranscription?id=${call.UniqueId}`);
        if (response.ok) {
          const data = await response.json();
          call.hasTranscription = !!data.transcription;
          call.transcription = data.transcription;
          call.tags = data.tags;
          if (!call.filePath && data.audio_url) call.filePath = data.audio_url;
        } else {
          call.hasTranscription = false;
        }
        if (this.hintMode && !call.hasTranscription && call.CallStatus === 2) {
          try {
            await fetch('https://manager.1akb.by/calls/request-transcription', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                callId: call.UniqueId,
                phone: call.Phone,
                startDate: call.DateReceived,
                endDate: call.DateReceived,
                immediate: true,
              }),
            });
          } catch (e) {
            console.warn('Не удалось поставить звонок в очередь расшифровки:', e);
          }
        }
      }
    } catch (error) {
      console.error('Ошибка загрузки истории звонков:', error);
      this.callLogs = [];
    } finally {
      this.isLoadingCall = false;
    }
  },


closeModalVochi() {
  this.isModalOpenPhone = false;
},

onSiteChange(site) {
  if (site && this.storeMap[site.value]) {
    // Находим первое значение из связанных складов
    const relatedStores = this.storeMap[site.value];
    const storeList = (this.shipmentStores && this.shipmentStores.length)
      ? this.shipmentStores
      : this.allShipmentStores;
    const defaultStore = storeList.find(store =>
      relatedStores.includes(store.value)
    );
    // Устанавливаем значение "Склад отгрузки"
    this.formData.shipmentStore = defaultStore || null;
  } else {
    // Сбрасываем значение, если магазин не выбран
    this.formData.shipmentStore = null;
  }
},

onShipmentStoreChange(store) {
  if (store) {
    // Найти магазин, связанный с этим складом
    const matchingSite = Object.keys(this.storeMap).find(siteKey =>
      this.storeMap[siteKey].includes(store.value)
    );
    if (matchingSite) {
      // Проверяем, не выбран ли уже этот магазин
      if (!this.formData.site || this.formData.site.value !== matchingSite) {
        const foundSite = this.sites.find(s => s.value === matchingSite);
        this.formData.site = foundSite || null;
      }
    }
  }
}
,
   

   // Инициализация платежей
  initializeDefaultPayments() {
    if (this.payments.length === 1 && !this.isPaymentAmountLocked(this.payments[0])) {
      this.payments[0].amount = this.grandTotal;
    }
  },

  paymentStatusCode(payment) {
    if (!payment) return '';
    const s = payment.status;
    if (s && typeof s === 'object') {
      return String(s.code || s.value || '');
    }
    return String(s || '');
  },

  isPaymentPaid(payment) {
    return this.paymentStatusCode(payment) === 'paid';
  },

  /** Оплачено / MTBank / «Не менять» — сумму не переписываем при смене товара */
  isPaymentAmountLocked(payment) {
    if (!payment || payment.type === 'bonusami') return false;
    if (payment.fixedAmount) return true;
    if (this.isPaymentPaid(payment)) return true;
    const comment = String(payment.comment || '');
    return comment.indexOf('MTBank ') !== -1;
  },

  roundMoney(v) {
    return Math.round((Number(v) || 0) * 100) / 100;
  },

  /**
   * Смена товара/итога: paid не трогаем.
   * Если заказ стал дороже — докидываем в unpaid или создаём ещё одну оплату (недостача).
   */
  adjustPaymentsAfterTotalChange(nextTotal) {
    const EPS = 0.02;
    const next = this.roundMoney(nextTotal);
    this.payments.forEach(payment => {
      if (payment.type === 'bonusami' && payment.bonusLimit != null) {
        payment.amount = Math.min(Number(payment.amount) || 0, payment.bonusLimit);
      }
    });

    const bonusSum = this.roundMoney(this.payments
      .filter(p => p.type === 'bonusami')
      .reduce((s, p) => s + (Number(p.amount) || 0), 0));

    const locked = this.payments.filter(p => p.type !== 'bonusami' && this.isPaymentAmountLocked(p));
    const unlocked = this.payments.filter(p => p.type !== 'bonusami' && !this.isPaymentAmountLocked(p));
    const lockedSum = this.roundMoney(locked.reduce((s, p) => s + (Number(p.amount) || 0), 0));
    let need = this.roundMoney(next - bonusSum - lockedSum);

    if (need > EPS) {
      if (unlocked.length) {
        unlocked.forEach((p, idx) => {
          p.amount = idx === 0 ? need : 0;
        });
        need = 0;
      } else if (locked.length) {
        // Недостачу создаём ТОЛЬКО если уже есть paid/зафиксированная оплата.
        // На новом заказе без платежей ничего не добавляем — иначе автоматом лезет безнал.
        const type = this.pickShortfallPaymentType(locked);
        const existing = this.payments.find(p =>
          !p.id &&
          p.type === type &&
          p.status === 'not-paid' &&
          String(p.comment || '').indexOf('Недостача после изменения суммы заказа') !== -1
        );
        if (existing) {
          existing.amount = need;
        } else {
          const paymentType = (this.paymentTypes || []).find(t => t.value === type);
          this.payments.push({
            type: type,
            name: paymentType ? paymentType.label : 'Предоплата безналичными',
            status: 'not-paid',
            date: null,
            amount: need,
            showComment: false,
            comment: 'Недостача после изменения суммы заказа',
            fixedAmount: false,
          });
        }
        need = 0;
      }
      // else: платежей ещё нет — не создаём ничего сами
    } else if (need < -EPS) {
      let excess = this.roundMoney(Math.abs(need));
      for (let i = unlocked.length - 1; i >= 0 && excess > EPS; i--) {
        const p = unlocked[i];
        const deduction = Math.min(Number(p.amount) || 0, excess);
        p.amount = this.roundMoney((Number(p.amount) || 0) - deduction);
        excess = this.roundMoney(excess - deduction);
      }
      this.payments = this.payments.filter(p => {
        if (
          !p.id &&
          (Number(p.amount) || 0) <= EPS &&
          String(p.comment || '').indexOf('Недостача после изменения суммы заказа') !== -1
        ) {
          return false;
        }
        return true;
      });
    } else if (unlocked.length) {
      const unlockedSum = this.roundMoney(unlocked.reduce((s, p) => s + (Number(p.amount) || 0), 0));
      if (unlockedSum > EPS && need <= EPS) {
        // итог совпал с paid — unpaid обнулять не обязательно, оставляем как есть
      }
    }
  },

  pickShortfallPaymentType(lockedPayments) {
    const list = lockedPayments || [];
    const beznal = list.find(p => p.type === '3-predoplata-kartoi');
    if (beznal) return '3-predoplata-kartoi';
    if (list.length && list[0].type) return list[0].type;
    const any = (this.payments || []).find(p => p.type && p.type !== 'bonusami');
    return (any && any.type) ? any.type : '3-predoplata-kartoi';
  },

  async persistPaymentsAfterTotalChange() {
    if (this.isLoadingOrder || !this.isInitialized || this.isAdjustingPayments) return;
    const orderId = this.$route && this.$route.params && this.$route.params.orderId;
    if (!orderId) return;
    this.isAdjustingPayments = true;
    try {
      // Создаём в CRM только явные «недостачи» после paid — не любой локальный платёж без id
      const pending = this.payments.filter(p =>
        !p.id &&
        (Number(p.amount) || 0) > 0.02 &&
        String(p.comment || '').indexOf('Недостача после изменения суммы заказа') !== -1
      );
      for (const p of pending) {
        await this.createPayment({
          amount: p.amount,
          site: this.$route.params.site,
          type: p.type,
          status: p.status || 'not-paid',
          order: { id: orderId },
          paidAt: null,
          comment: p.comment || '',
        }, { skipReload: true, skipUpdate: true });
      }
      // updatePayments только если есть платежи с id (иначе API нечего править)
      if (this.payments.some(p => p.id)) {
        await this.updatePayments({ silent: true });
      }
    } finally {
      this.isAdjustingPayments = false;
    }
  },

  updateBonusAmount() {
  this.oplacheno_bonusami = this.payments
    .filter(p => p.type === 'bonusami')
    .reduce((sum, p) => sum + Number(p.amount || 0), 0);
    this.fetchClientBonus(this.formData.phone);
},

// Обновление сумм в платежах
updatePaymentAmounts(index, newAmount) {
  const payment = this.payments[index];

  // 1. Если это бонусы — учитываем резерв по текущему заказу!
  if (payment.type === 'bonusami') {
    // Сколько уже оплачено бонусами (например, если правим)
    const minBonus = 0;

    // Получаем резерв по этому заказу (функция должна быть объявлена в methods)
    const orderId = this.$route.params.orderId;
    const reserveForThisOrder = this.getOrderBonusReserve(orderId);
    const bonusOnBalance = this.bonusClient || 0;

    // Общий лимит по 30% суммы заказа
    const bonusLimit = payment.bonusLimit != null ? payment.bonusLimit : Math.floor(this.grandTotal * 0.3);

    // Итоговая максимальная сумма (бонусы на счету + резерв, но не больше лимита)
    const maxBonus = Math.max(0, Math.min(bonusLimit, bonusOnBalance + reserveForThisOrder));

    // Итоговая сумма — не меньше minBonus и не больше maxBonus
    newAmount = Math.max(minBonus, Math.min(newAmount, maxBonus));
  }

  // 2. Лимитируем по общей сумме заказа (если платеж не зафиксирован / не paid)
  if (this.isPaymentAmountLocked(payment)) {
    return;
  }
  if (!payment.fixedAmount) {
    payment.amount = Math.min(newAmount, this.grandTotal);
  }

  // 3. Суммируем, чтобы узнать остаток для других платежей
  // Включаем все зафиксированные платежи и текущий платеж с новой суммой
  const totalAllocated = this.payments.reduce((sum, p, i) => {
    if (i === index) {
      // Текущий платеж - используем новую сумму
      return sum + payment.amount;
    } else if (this.isPaymentAmountLocked(p)) {
      // Зафиксированные платежи - включаем полностью
      return sum + (p.amount || 0);
    } else {
      // Не зафиксированные платежи - включаем текущую сумму
      return sum + (p.amount || 0);
    }
  }, 0);
  let remainingAmount = this.grandTotal - totalAllocated;

  // 4. Распределяем остаток по другим платежам (исключаем платежи с fixedAmount)
  if (remainingAmount > 0) {
    for (let i = 0; i < this.payments.length; i++) {
      if (i === index || this.payments[i].type === 'bonusami' || this.isPaymentAmountLocked(this.payments[i])) continue; // не бонусы, не текущий, не зафиксированные
      const maxPossibleAddition = Math.min(remainingAmount, this.grandTotal - this.payments[i].amount);
      this.payments[i].amount += maxPossibleAddition;
      remainingAmount -= maxPossibleAddition;
      if (remainingAmount <= 0) break;
    }
  } else if (remainingAmount < 0) {
    remainingAmount = Math.abs(remainingAmount);
    for (let i = this.payments.length - 1; i >= 0; i--) {
      if (i === index || this.payments[i].type === 'bonusami' || this.isPaymentAmountLocked(this.payments[i])) continue; // не бонусы, не текущий, не зафиксированные
      const deduction = Math.min(this.payments[i].amount, remainingAmount);
      this.payments[i].amount -= deduction;
      remainingAmount -= deduction;
      if (remainingAmount <= 0) break;
    }
  }
  
  // После перераспределения — еще раз clamp на всякий случай
  this.clampBonuses(this.payments, this.grandTotal, this.bonusClient, this.oplacheno_bonusami);
  this.updateBonusAmount();

},


async updatePayments(options = {}) {
  const silent = !!(options && options.silent);
  // Функция для преобразования даты в формат Y-m-d H:i:s
  const formatDateForAPI = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const paymentsData = this.payments.map(payment => ({
    id: payment.id,
    amount: payment.amount,
    paidAt: payment.date ? formatDateForAPI(payment.date) : null,
    comment: payment.comment,
    status: payment.status,
    type: payment.type,
  }));

  try {
    const response = await axios.post(ORDERS_API_BASE + "/paymentOrder.php", {
      order_id: this.$route.params.orderId,
      action: "edit",
      payments: paymentsData,
      userRole: this.userRole
    });

    if (response.data.success) {
      if (!silent) {
        this.$toast.success("Платежи успешно обновлены", { timeout: 2000, position: "bottom-right", style: { padding: '10px', minHeight: '40px',display: 'flex', alignItems: 'center' } });
      }
    } else if (!silent) {
      this.$toast.error(`Ошибка: ${response.data.message}`, { timeout: 2000, position: "bottom-right", style: { padding: '10px', minWidth: '300px', width:'300px', minHeight: '40px',display: 'flex', alignItems: 'center' } });
    }
  } catch (error) {
    console.error("Ошибка при обновлении платежей:", error);
    if (!silent) {
      this.$toast.error("Ошибка при связи с сервером", { timeout: 5000 });
    }
  }
},




rebalancePaymentsProportionally() {
  // 1. Принудительно ограничить все бонусы по лимиту!
  this.payments.forEach(payment => {
    if (payment.type === 'bonusami' && payment.bonusLimit != null) {
      payment.amount = Math.min(payment.amount, payment.bonusLimit);
    }
  });

  // 2. Только теперь считаем сумму бонусов
  const totalBonus = this.payments
    .filter(p => p.type === 'bonusami')
    .reduce((sum, p) => sum + (p.amount || 0), 0);

  // 3. Считаем сумму зафиксированных платежей (не бонусов)
  const fixedPaymentsTotal = this.payments
    .filter(p => p.type !== 'bonusami' && this.isPaymentAmountLocked(p))
    .reduce((sum, p) => sum + (p.amount || 0), 0);

  // 4. Остаток на другие платежи (исключая зафиксированные и paid)
  const nonBonusPayments = this.payments.filter(p => p.type !== 'bonusami');
  const nonBonusTotal = Math.max(0, this.grandTotal - totalBonus);
  const availableForRedistribution = Math.max(0, nonBonusTotal - fixedPaymentsTotal);
  
  // 5. Платежи, которые можно пересчитывать (не зафиксированные / не paid)
  const redistributablePayments = nonBonusPayments.filter(p => !this.isPaymentAmountLocked(p));
  const totalAssigned = redistributablePayments.reduce((sum, p) => sum + (p.amount || 0), 0);

  // 6. Если у остальных ничего не стояло - всё в первый пересчитываемый
  if (totalAssigned === 0 && redistributablePayments.length > 0) {
    redistributablePayments.forEach((payment, idx) => {
      payment.amount = idx === 0 ? availableForRedistribution : 0;
    });
    return;
  }

  // 7. Пропорционально остаток между не-бонусными и не-зафиксированными
  // Округляем до копеек (Math.round до целых рублей давал 165,5→166 и остаток -0,5 на последнем платеже)
  if (redistributablePayments.length > 0 && totalAssigned > 0) {
    const roundMoney = (v) => Math.round(Number(v) * 100) / 100;
    let sumAssigned = 0;
    const lastIdx = redistributablePayments.length - 1;
    redistributablePayments.forEach((payment, idx) => {
      if (idx === lastIdx) {
        payment.amount = Math.max(0, roundMoney(availableForRedistribution - sumAssigned));
      } else {
        const raw =
          ((Number(payment.amount) || 0) / totalAssigned) * availableForRedistribution;
        payment.amount = roundMoney(raw);
        sumAssigned = roundMoney(sumAssigned + payment.amount);
      }
    });
  }

  // 8. (опционально) ещё раз обрезать бонусы по лимиту, если вдруг что-то поменяли
  this.payments.forEach(payment => {
    if (payment.type === 'bonusami' && payment.bonusLimit != null) {
      payment.amount = Math.min(payment.amount, payment.bonusLimit);
    }
  });
},

 

  addPayment(paymentType) {
  // Создаём новый платёж в локальном массиве
  const newPayment = {
    type: paymentType.value,
    name: paymentType.label,
    status: "not-paid", // Статус по умолчанию
    date: null,
    amount: 0,
    showComment: false,
    comment: "",
    fixedAmount: false, // Чекбокс "Не менять" по умолчанию выключен
  };


   

  // Добавляем платёж в локальный массив
  this.payments.push(newPayment);
  this.dropdownOpen = false;
  this.clampBonuses(this.payments, this.grandTotal, this.bonusClient, this.oplacheno_bonusami);
  this.rebalancePaymentsProportionally();

  // Отправляем платёж на сервер
  const paymentData = {
    amount: newPayment.amount,
    site:this.$route.params.site,
    type: newPayment.type,
    status: newPayment.status,
    order: { id: this.$route.params.orderId }, // Используем ID текущего заказа
    paidAt: newPayment.date ? new Date(newPayment.date).toISOString() : null,
    comment: newPayment.comment,
  };

  this.createPayment(paymentData);
},

 
  // Удаление способа оплаты
  removePayment(index,paymentId) {
    this.payments.splice(index, 1);
    this.deletePayment(paymentId);
    this.clampBonuses(this.payments, this.grandTotal, this.bonusClient, this.oplacheno_bonusami);
    this.rebalancePaymentsProportionally();
    this.updateBonusAmount();
  },

async createPayment(paymentData, options = {}) {
  const skipReload = !!(options && options.skipReload);
  const skipUpdate = !!(options && options.skipUpdate);
  const requestData = {
    action: "create",
    payment: paymentData, // Платёжные данные
  };

  try {
    const response = await axios.post(
      ORDERS_API_BASE + "/paymentOrder.php",
      requestData
    );

    if (response.data.success) {
      if (!skipReload) {
        this.$toast.success("Платёж успешно добавлен", { timeout: 500 });
      }

      // Обновляем платеж в локальном массиве
      const createdPayment = this.payments.find(
        (payment) => payment.amount === paymentData.amount && !payment.id
      );

      if (createdPayment) {
        createdPayment.id = response.data.id; // Добавляем ID
      }

      if (!skipReload) {
        this.fetchPayment();
      }
    } else if (!skipReload) {
      this.$toast.error(`Ошибка: ${response.data.message}`, { timeout: 500 });
    }
  } catch (error) {
    console.error("Ошибка при добавлении платежа:", error);
    if (!skipReload) {
      this.$toast.error("Ошибка связи с сервером", { timeout: 500 });
    }
  }
  if (!skipUpdate) {
    this.updatePayments();
  }
},

async editPayments(payments) {
  const requestData = {
    action: "edit",
    payments, // Массив платежей для изменения
  };

  try {
    const response = await axios.post(ORDERS_API_BASE + "/paymentOrder.php", requestData);

    if (response.data.success) {
      this.$toast.success("Платежи успешно обновлены", { timeout: 500 });
      this.fetchPayment(); // Обновление платежей из системы
    } else {
      this.$toast.error(`Ошибка: ${response.data.message}`, { timeout: 500 });
    }
  } catch (error) {
    console.error("Ошибка при обновлении платежей:", error);
    this.$toast.error("Ошибка при связи с сервером", { timeout: 500 });
  }
}
,

async deletePayment(paymentId) {
  const requestData = {
    action: "delete",
    paymentId: paymentId, // ID платежа, который нужно удалить
  };

  try {
    const response = await axios.post(
      ORDERS_API_BASE + "/paymentOrder.php",
      requestData
    );
    if (response.data.success) {
      this.$toast.success("Платёж успешно удалён");
      // Обновление данных, если требуется
      this.fetchPayment();
    } else {
      this.$toast.error(`Ошибка: ${response.data.message}`);
    }
  } catch (error) {
    console.error("Ошибка при удалении платежа:", error);
    
  }
  this.updatePayments(); 
},

  // Расчет скидки для получения нужной суммы "Взять с клиента"
  calculateClientAmount() {
    // Проверяем, что введено значение
    if (!this.takeFromClient || this.takeFromClient <= 0) {
      alert('Введите сумму, которую нужно взять с клиента');
      return;
    }
    
    const targetAmount = Number(this.takeFromClient);
    
    // Находим основной товар (не доставка, не комплексы)
    const DELIVERY_PRODUCT_ID = '989773504';
    const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
    
    const products = this.$route.params.orderId 
      ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
      : this.products;
    
    // Находим товар с наибольшей ценой
    const productsFiltered = products.filter(p => p.id !== DELIVERY_PRODUCT_ID && !COMPLEX_PRODUCT_IDS.includes(p.id) && !this.isExcludedFromTotalsStatus(p.status));
    const maxPriceProduct = productsFiltered.length > 0 ? productsFiltered.reduce((max, p) => 
      (parseFloat(p.originalPrice || p.price || 0) > parseFloat(max.originalPrice || max.price || 0) ? p : max)
    ) : null;
    
    if (!maxPriceProduct) {
      alert('Не найден основной товар для применения скидки');
      return;
    }
    
    // Вычисляем максимальную сумму, которую можно взять с клиента
    // = стоимость аккумулятора + доставка (если за счет клиента) + комплекс (если за счет клиента)
    let maxAmount = (maxPriceProduct.originalPrice || maxPriceProduct.price || 0) * (maxPriceProduct.quantity || 1);
    
    // Добавляем стоимость доставки, если она за счет клиента
    if (this.formData.deliveryPaidBy === 'client') {
      const deliveryProduct = products.find(p => p.id === DELIVERY_PRODUCT_ID);
      if (deliveryProduct) {
        maxAmount += (deliveryProduct.originalPrice || deliveryProduct.price || 0) * (deliveryProduct.quantity || 1);
      }
    }
    
    // Добавляем стоимость комплекса, если он за счет клиента
    if (this.formData.installationPaidBy === 'client' && this.formData.installationComplex) {
      const complexProductId = {
        complex1: '989773501',
        complex2: '989773505',
        complex3: '989773503'
      }[this.formData.installationComplex];
      
      if (complexProductId) {
        const complexProduct = products.find(p => p.id === complexProductId);
        if (complexProduct) {
          maxAmount += (complexProduct.originalPrice || complexProduct.price || 0) * (complexProduct.quantity || 1);
        }
      }
    }
    
    // Проверяем, что сумма не превышает максимальную
    if (targetAmount > maxAmount) {
      alert(`Сумма "Взять с клиента" не может быть больше ${maxAmount.toFixed(2)} руб. (стоимость аккумулятора${this.formData.deliveryPaidBy === 'client' ? ' + доставка' : ''}${this.formData.installationPaidBy === 'client' ? ' + комплекс' : ''})`);
      return;
    }
    
    // ЛОГИКА: Итого = то, что пользователь ввел (targetAmount)
    // Скидка на основной товар = стоимость основного товара - (targetAmount - сумма товаров за счет скидки)
    // Разницу вычитаем из товара с наибольшей ценой (maxPriceProduct)
    
    // Вычисляем стоимость основного товара (товар с макс. ценой)
    const mainProductPrice = (maxPriceProduct.originalPrice || maxPriceProduct.price || 0) * (maxPriceProduct.quantity || 1);
    
    // Вычисляем сумму товаров за счет скидки (доставка + комплекс, если они за счет скидки)
    let discountProductsAmount = 0;
    
    // Доставка за счет скидки
    if (this.formData.deliveryPaidBy === 'discount') {
      const deliveryProduct = products.find(p => p.id === DELIVERY_PRODUCT_ID);
      if (deliveryProduct) {
        const deliveryPrice = (deliveryProduct.originalPrice || deliveryProduct.price || 0) * (deliveryProduct.quantity || 1);
        discountProductsAmount += deliveryPrice;
      }
    }
    
    // Комплекс за счет скидки
    if (this.formData.installationPaidBy === 'discount' && this.formData.installationComplex) {
      const complexProductId = {
        complex1: '989773501',
        complex2: '989773505',
        complex3: '989773503'
      }[this.formData.installationComplex];
      
      if (complexProductId) {
        const complexProduct = products.find(p => p.id === complexProductId);
        if (complexProduct) {
          const complexPrice = (complexProduct.originalPrice || complexProduct.price || 0) * (complexProduct.quantity || 1);
          discountProductsAmount += complexPrice;
        }
      }
    }
    
    // Вычисляем, сколько должен стоить основной товар с учетом скидки
    // targetAmount - это итого, которое мы хотим получить
    // Из него вычитаем стоимость товаров за счет скидки
    // Остаток - это то, сколько должен стоить основной товар (включая стоимость доставки/комплекса за счет клиента)
    
    // Стоимость доставки/комплекса за счет клиента
    let clientPaidProductsAmount = 0;
    
    if (this.formData.deliveryPaidBy === 'client') {
      const deliveryProduct = products.find(p => p.id === DELIVERY_PRODUCT_ID);
      if (deliveryProduct) {
        const deliveryPrice = (deliveryProduct.originalPrice || deliveryProduct.price || 0) * (deliveryProduct.quantity || 1);
        clientPaidProductsAmount += deliveryPrice;
      }
    }
    
    if (this.formData.installationPaidBy === 'client' && this.formData.installationComplex) {
      const complexProductId = {
        complex1: '989773501',
        complex2: '989773505',
        complex3: '989773503'
      }[this.formData.installationComplex];
      
      if (complexProductId) {
        const complexProduct = products.find(p => p.id === complexProductId);
        if (complexProduct) {
          const complexPrice = (complexProduct.originalPrice || complexProduct.price || 0) * (complexProduct.quantity || 1);
          clientPaidProductsAmount += complexPrice;
        }
      }
    }
    
    // Простая логика: разница между текущим итого и желаемой суммой = скидка на товар
    // Текущий grandTotal
    const round2 = (v) => Math.round(Number(v) * 100) / 100;
    const currentGrandTotal = round2(this.grandTotal);
    const wantAmount = round2(targetAmount);

    // Разница, которую нужно вычесть скидкой (общая сумма скидки)
    const difference = round2(currentGrandTotal - wantAmount);

    const quantity = Math.max(1, Number(maxPriceProduct.quantity) || 1);
    // Текущая скидка на товар хранится за ОДНУ штуку — считаем общую текущую скидку по позиции
    const currentDiscountPerUnit = Number(maxPriceProduct.discountAmount) || 0;
    const currentTotalDiscountOnProduct = round2(currentDiscountPerUnit * quantity);

    // Новая общая скидка на позицию = текущая общая скидка + разница
    let discountOnMainProduct = round2(currentTotalDiscountOnProduct + difference);

    // Проверяем, что скидка не превышает стоимость основного товара и не отрицательная
    discountOnMainProduct = round2(Math.max(0, Math.min(discountOnMainProduct, mainProductPrice)));

    // Скидка в модели хранится на ОДНУ единицу.
    // НЕ округляем до 2 знаков за штуку: при qty=3 (и любом qty>1)
    // 192.50/3 → 64.17 даёт 192.51 и «Итого» 527.49 вместо 527.50.
    const discountPerUnit = discountOnMainProduct / quantity;

    // Устанавливаем новую скидку на товар с максимальной ценой (на одну штуку)
    maxPriceProduct.discountAmount = discountPerUnit;

    // Пересчитываем отображаемую цену товара
    maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);

    // Пересчитываем итоговую стоимость товара
    this.updateProductTotal(maxPriceProduct);

    // Обновляем массив товаров
    if (!this.$route.params.orderId) {
      const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
      if (index !== -1) {
        this.$set(this.products, index, maxPriceProduct);
      }
    } else {
      const updatedProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
      const productInStore = updatedProducts.find(p => p.id === maxPriceProduct.id);
      if (productInStore) {
        productInStore.discountAmount = maxPriceProduct.discountAmount;
        productInStore.displayPrice = maxPriceProduct.displayPrice;
        this.updateProductTotal(productInStore);
      }
    }

    // Сохраняем текущую сумму для следующего пересчета
    this.previousClientAmount = wantAmount;
    this.takeFromClient = wantAmount;

    // Гарантируем Итого = введённая сумма.
    // 1) подправляем скидку за штуку без округления копеек;
    // 2) если после watchers всё ещё расхождение — фиксируем manualTotal.
    this.$nextTick(() => {
      const got = round2(this.grandTotal);
      if (got !== wantAmount) {
        const adjPerUnit = (got - wantAmount) / quantity;
        maxPriceProduct.discountAmount = Number(maxPriceProduct.discountAmount || 0) + adjPerUnit;
        maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
        this.updateProductTotal(maxPriceProduct);
        if (this.$route.params.orderId) {
          const updatedProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
          const productInStore = updatedProducts.find(p => p.id === maxPriceProduct.id);
          if (productInStore) {
            productInStore.discountAmount = maxPriceProduct.discountAmount;
            productInStore.displayPrice = maxPriceProduct.displayPrice;
            this.updateProductTotal(productInStore);
          }
        }
      }
      this.$nextTick(() => {
        if (round2(this.grandTotal) !== wantAmount) {
          this.manualTotal = wantAmount;
          this.manualOverride = true;
          this.manualTotalInput = wantAmount.toFixed(2);
        }
        this.$forceUpdate();
      });
    });

    this.$forceUpdate();
},

  // Обновление `grandTotal`
  onGrandTotalChange() {
    this.clampBonuses(this.payments, this.grandTotal, this.bonusClient, this.oplacheno_bonusami);
    this.rebalancePaymentsProportionally();
    this.updateBonusAmount();
  },


clampBonuses(payments, grandTotal, bonusClient, oplacheno_bonusami) {
  const bonusLimit = Math.floor(grandTotal * 0.3);

  // Получаем резерв по текущему заказу (без optional chaining!)
  const orderId = this.$route && this.$route.params && this.$route.params.orderId ? this.$route.params.orderId : null;
  const reserveForThisOrder = typeof this.getOrderBonusReserve === 'function' && orderId ? this.getOrderBonusReserve(orderId) : 0;

  const maxBonus = Math.min(bonusLimit, (bonusClient || 0) + reserveForThisOrder);
  const minBonus = 0;

  payments.forEach(payment => {
    if (payment.type === 'bonusami') {
      payment.bonusLimit = maxBonus;
      payment.amount = Math.max(minBonus, Math.min(payment.amount || 0, payment.bonusLimit));
    }
  });
},



 togglePaymentSection() {
      this.paymentSectionExpanded = !this.paymentSectionExpanded;
    },
    calculateTotalToPay() {
      return 1000; // Пример итоговой суммы (замените на нужное значение)
    },
    toggleDropdownPay() {
      this.dropdownOpen = !this.dropdownOpen;
    },
   
    toggleComment(payment) {
      payment.showComment = !payment.showComment;
    },



  applyCarSelection(payload) {
    if (!payload) return;
    if (payload.url) this.formData.selectionLink = payload.url;
    if (payload.carBrand) this.formData.carBrand = payload.carBrand;
    if (payload.carModel) this.formData.carModel = payload.carModel;
    if (payload.carName) this.formData.carName = payload.carName;
    if (payload.carYear) this.formData.carYear = payload.carYear;
    if (payload.fuelType) this.formData.fuelType = payload.fuelType;
    if (payload.carBodyType) this.formData.carBodyType = payload.carBodyType;
    if (payload.auto) this.formData.auto = payload.auto;
    this.closeCarSelector();
  },
  onBatteryAiRecommendation(payload) {
    if (!payload) return;
    const block = payload.fullText || payload.text || '';
    if (!block) return;
    const prev = (this.formData.pomoshchIi || '').trim();
    this.formData.pomoshchIi = prev ? `${prev}\n\n${block}` : block;
    if (payload.questionnaire && payload.questionnaire.trade_in_similar_capacity === 'yes') {
      if (!this.formData.batteryCapacityNew || !String(this.formData.batteryCapacityNew).trim()) {
        this.formData.batteryCapacityNew = 'зачёт';
      }
    }
    if (this.$toast) {
      this.$toast.success('Рекомендация записана в поле «Помощь ИИ»', { timeout: 3000, position: 'bottom-right' });
    }
  },
  updateCorpus(url) {
    this.formData.selectionLink = url;
    this.closeCarSelector();
  },
  closeCarSelector() {
    this.isCarSelectorVisible = false;
  },
  openCarSelector() {
    this.isCarSelectorVisible = true;
  },
   toggleDropdownStatus() {
    if (this.isStatusChangeAllowed) {
      this.isOpen = !this.isOpen;
    } else {
      // Проверяем причину блокировки для более точного сообщения
      const forbiddenStatuses = [
        "otmena-dubl",
        "otmenaskomentom", 
        "khkhhjgsdlgtij6",
        "otmena-s-necelevoi"
      ];
      
      if (forbiddenStatuses.includes(this.orderStatusFetch)) {
        this.$toast.error('Редактирование статуса запрещено: заказ находится в статусе отмены', { 
          timeout: 4000, 
          position: "bottom-right", 
          style: { 
            padding: '10px', 
            minWidth: '350px', 
            minHeight: '40px',
            display: 'flex', 
            alignItems: 'center' 
          } 
        });
      } else {
        const allowedStatuses = this.getAllowedStatusesForTransfer();
        if (!allowedStatuses.includes(this.orderStatusFetch)) {
          this.$toast.error('Редактирование статуса запрещено: текущий статус не входит в список разрешенных для перевода', { 
            timeout: 4000, 
            position: "bottom-right", 
            style: { 
              padding: '10px', 
              minWidth: '450px', 
              minHeight: '40px',
              display: 'flex', 
              alignItems: 'center' 
            } 
          });
        } else {
          this.$toast.error('Редактирование статуса запрещено', { 
            timeout: 3000, 
            position: "bottom-right", 
            style: { 
              padding: '10px', 
              minWidth: '300px', 
              minHeight: '40px',
              display: 'flex', 
              alignItems: 'center' 
            } 
          });
        }
      }
      console.warn("Статус запрещен для изменения.");
    }
  },

async makeCall() {
  if (!this.formData.phone || !this.$store.state.user.phone_extension) {
    console.error("Не указан номер телефона или внутренний номер пользователя.");
    return;
  }

  const internalNumber = this.$store.state.user.phone_extension;

  // Удаляем все символы, кроме цифр
  let phoneNumber = String(this.formData.phone || '').replace(/\D/g, '');

  // Преобразование номера, если он начинается с 8029 или других кодов
  if (phoneNumber.startsWith('80')) {
    phoneNumber = '375' + phoneNumber.slice(2);
  }

  if (!phoneNumber) {
    console.error("Некорректный номер телефона:", this.formData.phone);
    return;
  }

  // clientId (secret) — только для инициации звонков через makecallexternal
  const clientId = "e16bc4fc51d243ae80ab476c51b1e7c2";
  const url = `https://bot.vochi.by/api/makecallexternal?code=${encodeURIComponent(internalNumber)}&phone=${encodeURIComponent('+' + phoneNumber)}&clientId=${clientId}`;

  try {
    const response = await axios.get(url);

    if (response.data && response.data.success === false) {
      console.error("Ошибка при инициации звонка:", response.data.message || response.data);
    } else {
      console.log("Звонок успешно инициирован:", (response.data && response.data.message) || response.data);
    }
  } catch (error) {
    console.error("Ошибка при обращении к API Vochi:", error);
  }
},

async makeCallDop() {
  if (!this.formData.additionalPhone || !this.$store.state.user.phone_extension) {
    console.error("Не указан номер телефона или внутренний номер пользователя.");
    return;
  }

  const internalNumber = this.$store.state.user.phone_extension;

  // Удаляем все символы, кроме цифр
  let phoneNumber = this.formData.additionalPhone.replace(/\D/g, '');

  // Преобразование номера, если он начинается с 8029 или других кодов
  if (phoneNumber.startsWith('80')) {
    phoneNumber = '375' + phoneNumber.slice(2);
  }

  if (!phoneNumber) {
    console.error("Некорректный номер телефона:", this.formData.phone);
    return;
  }

  // clientId (secret) — только для инициации звонков через makecallexternal
  const clientId = "e16bc4fc51d243ae80ab476c51b1e7c2";
  const url = `https://bot.vochi.by/api/makecallexternal?code=${encodeURIComponent(internalNumber)}&phone=${encodeURIComponent('+' + phoneNumber)}&clientId=${clientId}`;

  try {
    const response = await axios.get(url);

    if (response.data && response.data.success === false) {
      console.error("Ошибка при инициации звонка:", response.data.message || response.data);
    } else {
      console.log("Звонок успешно инициирован:", (response.data && response.data.message) || response.data);
    }
  } catch (error) {
    console.error("Ошибка при обращении к API Vochi:", error);
  }
},


 selectStatusOrder(option) {
console.log('selectStatusOrder вызван', option);
if (!option) {
  console.error('option is null or undefined');
  return;
}

if (this.$route.params.orderId && option.value === 'new') {
console.warn('Нельзя перевести в статус "Новый" при редактировании заказа');
this.$toast.error('Нельзя перевести в статус "Новый" при редактировании заказа', { 
  timeout: 3000, 
  position: "bottom-right", 
  style: { 
    padding: '10px', 
    minWidth: '350px', 
    minHeight: '40px',
    display: 'flex', 
    alignItems: 'center' 
  } 
});
return;
}

// Дополнительная проверка на доступность статуса
if (option.disabled) {
  console.log('Статус disabled, пропускаем', option);
  this.$toast.error('Этот статус недоступен для выбора', { 
    timeout: 3000, 
    position: "bottom-right", 
    style: { 
      padding: '10px', 
      minWidth: '300px', 
      minHeight: '40px',
      display: 'flex', 
      alignItems: 'center' 
    } 
  });
  return;
}

if (this.isSoglasovanieStatusByLabel(option.label) && !this.hasDeliveryDateFilled()) {
  this.errors.deliveryDate = 'Обязательна при переводе в статус «Согласование»';
  this.$toast.error('Укажите дату доставки: без неё нельзя перевести заказ в статус «Согласование».', {
    timeout: 5000,
    position: 'bottom-right',
    style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' }
  });
  return;
}

let statusOption = option;
if (this.shouldRedirectToPodZakaz(option.value)) {
  const podZakazOption = this.getPodZakazStatusOption();
  if (podZakazOption) {
    statusOption = podZakazOption;
    const names = this.getOutOfStockProducts().map((p) => p.name).join(', ');
    const targetStore = this.getPodZakazTargetMsStoreName();
    const stockHint = targetStore
      ? `нет в магазине «${targetStore}»`
      : 'нет на складе и в магазинах';
    this.$toast.warning(
      `Товар отсутствует (${stockHint}): ${names}. Статус заказа изменён на «---- товар под З А К А З ----».`,
      {
        timeout: 7000,
        position: 'bottom-right',
        style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' },
      }
    );
  }
}

const group = this.filteredStatusGroupsOrder.find(g => g.options.some(o => o.value === statusOption.value));
this.pendingStatus = {
value: statusOption.value,
label: statusOption.label,
color: group ? group.color : statusOption.color,
class: group ? group.group : statusOption.class,
};
this.prepareAgreementDateForStatusModal(statusOption.value);
console.log('Устанавливаем pendingStatus и открываем модальное окно', this.pendingStatus);
this.isModalStatusVisible = true;
this.isOpen = false;
},
  async confirmStatus(exitAfterSave) {
    const saveAndLeave = exitAfterSave === true;
    if (!this.pendingStatus) {
      this.isModalStatusVisible = false;
      this.statusComment = '';
      this.statusModalAgreementDate = null;
      return;
    }
    if (this.isAgreementDateRequiredStatus(this.pendingStatus.value)) {
      this.formData.dataSoglasovaniia = this.statusModalAgreementDate;
    }
    if (!this.validateAgreementDateForStatus(this.pendingStatus.value)) {
      return;
    }
    const canEdit = await this.checkCanEditCurrentStatus();
    if (!canEdit) return;
    const toCode = this.pendingStatus.value;
    const fromCode = this.orderStatusFetch || '';
    if (fromCode !== toCode) {
      const checkOk = await this.checkStatusTransitionBeforeSave(fromCode, toCode, this.pendingStatus.label);
      if (!checkOk) {
        return;
      }
    }
    this.selectedStatusOrder = { ...this.pendingStatus };
    this.formData.statusComment = this.statusComment;
    this.isModalStatusVisible = false;
    this.statusComment = '';
    this.statusModalAgreementDate = null;

    if (saveAndLeave) {
      await this.createOrderExit();
    } else {
      await this.createOrder();
    }

    if (!saveAndLeave) {
      setTimeout(() => {
        this.fetchOrderStatuses(
          [parseInt(this.$route.params.orderId)],
          [String(this.$route.params.orderId)]
        );
      }, 2000);
    }

  },
  openModalhistory() {
      this.showModal = true;
    },
  togglePrintDropdown(event) {
    if (event) {
      event.stopPropagation();
    }
    this.printDropdownOpen = !this.printDropdownOpen;
    
    // Закрываем меню при клике вне его
    if (this.printDropdownOpen) {
      setTimeout(() => {
        document.addEventListener('click', this.closePrintDropdownOnOutsideClick);
      }, 0);
    } else {
      document.removeEventListener('click', this.closePrintDropdownOnOutsideClick);
    }
  },
  closePrintDropdownOnOutsideClick(event) {
    const dropdown = this.$el.querySelector('.order-actions__list .print');
    if (dropdown && !dropdown.contains(event.target)) {
      this.printDropdownOpen = false;
      document.removeEventListener('click', this.closePrintDropdownOnOutsideClick);
    }
  },
  async printDocument(templateId) {
    try {
      // Проверяем, это шаблон "Лист курьера" (ID 116 или 110) или "Гарантийный талон" (ID 115) или "Печать vozim.by" (ID 119) или "Договор Галицкий" (ID 109) или "Договор без печати Гамзюк" (ID 66) или "Счет-фактура Галицкий" (ID 70) или "Счет-фактура Гамзюк" (ID 107, 67)
      const isRouteSheet = templateId === 116 || templateId === 110 || templateId === 118;
      const isVozimSheet = templateId === 119;
      const isWarrantyTicket = templateId === 115;
      const isGalitskyContract = templateId === 109;
      const isGamzContract = templateId === 66;
      const isGalitskyInvoice = templateId === 70;
      const isGamz3Invoice = templateId === 107;
      const isGamz5Invoice = templateId === 67;
      const isActDelivery = templateId === 122;
      const isCourierSalary = templateId === 123;
      
      if (isCourierSalary) {
        const orderData = this.getOrderData();
        const order = orderData.order;
        if (!order || !order.id) {
          alert('Не найдены данные заказа');
          return;
        }
        const items = (this.products || []).map(product => ({
          offer: {
            id: product.id ? String(product.id) : '',
            name: product.name || '',
          },
          productName: product.name || '',
          initialPrice: product.price || product.initialPrice || 0,
          quantity: product.quantity || 0,
          summ: (product.price || 0) * (product.quantity || 0),
        }));
        const deliveryAddress = {};
        if (this.formData.floor) deliveryAddress.floor = this.formData.floor;
        const orderPayload = {
          id: order.id,
          number: order.number,
          delivery: {
            date: this.formData.deliveryDate || (order.delivery && order.delivery.date),
            data: { firstName: (order.delivery && order.delivery.data && order.delivery.data.firstName) || '' },
            address: deliveryAddress,
          },
          items,
          customFields: order.customFields || {},
        };
        const date = this.formData.deliveryDate
          ? new Date(this.formData.deliveryDate).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' })
          : new Date().toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
        try {
          const response = await axios.post(ORDERS_API_BASE + '/generate_courier_salary.php', {
            orders: [orderPayload],
            date: date,
          }, { timeout: 60000, headers: { 'Content-Type': 'application/json' } });
          if (response.data && response.data.success && response.data.url) {
            window.open(response.data.url, '_blank');
          } else {
            throw new Error((response.data && response.data.error) || 'Ошибка генерации');
          }
        } catch (e) {
          alert((e.response && e.response.data && e.response.data.error) || e.message || 'Ошибка генерации PDF');
        }
        return;
      }
      
      if (isRouteSheet || isVozimSheet || isWarrantyTicket || isGalitskyContract || isGamzContract || isGalitskyInvoice || isGamz3Invoice || isGamz5Invoice || isActDelivery) {
        // Для специальных шаблонов используем новый способ - генерируем из данных заказа
        const orderData = this.getOrderData();
        const order = orderData.order;
        
        if (!order || !order.id) {
          alert('Не найдены данные заказа');
          return;
        }
        
        // Подготавливаем payments из this.payments
        let payments = [];
        if (this.payments && Array.isArray(this.payments)) {
          payments = this.payments.map(payment => ({
            amount: payment.amount || 0,
            type: payment.type ? {
              code: payment.type.value || payment.type.code || '',
              name: payment.type.label || payment.type.name || ''
            } : null
          })).filter(p => p.type !== null);
        }
        
        // Преобразуем items из products (цена со скидкой — displayPrice)
        const items = (this.products || []).map(product => {
          const quantity = product.quantity || 1;
          const originalPrice = product.originalPrice || product.price || product.initialPrice || 0;
          const displayPrice = product.displayPrice != null
            ? product.displayPrice
            : this.calculateDiscountedPrice({
              originalPrice,
              discountAmount: product.discountAmount || 0,
              discountPercent: product.discountPercent || 0
            });
          return {
            offer: {
              id: product.id ? String(product.id) : '',
              name: product.name || ''
            },
            productName: product.name || '',
            initialPrice: originalPrice,
            quantity,
            prices: [{ price: displayPrice, quantity }],
            discountTotal: Math.max(0, (originalPrice - displayPrice) * quantity),
            summ: displayPrice * quantity
          };
        });
        
        // Формируем delivery address
        const deliveryAddress = {};
        if (this.deliveryAddress) {
          deliveryAddress.text = this.deliveryAddress;
        }
        if (this.formData.deliverybuilding) deliveryAddress.building = this.formData.deliverybuilding;
        if (this.formData.flat) deliveryAddress.flat = this.formData.flat;
        if (this.formData.floor) deliveryAddress.floor = this.formData.floor;
        if (this.formData.block) deliveryAddress.block = this.formData.block;
        if (this.formData.housing) deliveryAddress.house = this.formData.housing;
        if (this.formData.house) deliveryAddress.house = this.formData.house;
        if (this.formData.deliveryregion) {
          if (typeof this.formData.deliveryregion === 'object') {
            deliveryAddress.city = this.formData.deliveryregion.label || '';
          } else {
            deliveryAddress.city = this.formData.deliveryregion;
          }
        }
        if (this.formData.deliverystreet) {
          deliveryAddress.street = this.formData.deliverystreet;
        }
        
        // Формируем delivery time
        const deliveryTime = {};
        if (this.formData.deliveryDate) {
          deliveryTime.from = this.formData.deliveryDate;
          deliveryTime.to = this.formData.deliveryDate;
        }
        
        // Получаем customFields
        const customFields = {};
        if (this.formData.customFields) {
          Object.assign(customFields, this.formData.customFields);
        }
        // Добавляем часто используемые кастомные поля
        if (this.formData.marssh) customFields.marssh = this.formData.marssh;
        if (this.formData.vgvgvgv) customFields.vgvgvgv = this.formData.vgvgvgv;
        if (this.formData.visitor_code) customFields.visitor_code = this.formData.visitor_code;
        if (this.formData.visitor_city) customFields.visitor_city = this.formData.visitor_city;
        if (this.formData.personal_offer_discount !== '' && this.formData.personal_offer_discount != null) {
          customFields.personal_offer_discount = this.formData.personal_offer_discount;
        }
        if (this.formData.dfgfdddf) customFields.dfgfdddf = this.formData.dfgfdddf;
        if (this.formData.dfgfdddfnew) customFields.dfgfdddfnew = this.formData.dfgfdddfnew;
        if (this.formData.slksdkk2j3iu3n) customFields.slksdkk2j3iu3n = this.formData.slksdkk2j3iu3n;
        if (this.formData.slksdkk2j3iu3nnew) customFields.slksdkk2j3iu3nnew = this.formData.slksdkk2j3iu3nnew;
        if (this.formData.predoplata_beznalichnymi_spravochnik) {
          customFields.predoplata_beznalichnymi_spravochnik = this.formData.predoplata_beznalichnymi_spravochnik;
        }
        if (this.formData.iuridicheskoe_naimenovanie) {
          customFields.iuridicheskoe_naimenovanie = this.formData.iuridicheskoe_naimenovanie;
        }
        if (this.formData.pomoshchIi != null && this.formData.pomoshchIi !== undefined) {
          customFields.pomoshch_ii = this.formData.pomoshchIi;
        }
        if (this.formData.vznos != null && this.formData.vznos !== '') {
          customFields.vznos = this.formData.vznos;
        }
        
        // Добавляем разницу по весу (rs) и вес в кг (rsmass)
        // Передаем разницу, даже если она 0 (для очистки поля)
        if (this.capacityWeightDifference !== null && this.capacityWeightDifference !== undefined) {
          customFields.rs = parseFloat(this.capacityWeightDifference.toFixed(2));
        }
        // Передаем вес, даже если он 0 (для очистки поля)
        if (this.capacityWeightKg !== null && this.capacityWeightKg !== undefined) {
          customFields.rsmass = parseFloat(this.capacityWeightKg.toFixed(2));
        }
        
        const printLastName = (order.customer && order.customer.lastName) || this.formData.lastName || '';
        const printFirstName = (order.customer && order.customer.firstName)
          || this.getFirstNameValue()
          || this.formData.firstName
          || '';
        const printPatronymic = (order.customer && order.customer.patronymic)
          || this.formData.patronymic
          || '';
        const printFullName = [printLastName, printFirstName, printPatronymic].filter(Boolean).join(' ').trim();

        const orderToSend = {
          id: order.id,
          number: this.formData.number || order.number || '',
          site: order.site ? order.site.value || order.site : '',
          phone: order.customer ? order.customer.phone || '' : '',
          additionalPhone: order.customer ? order.customer.additionalPhone || '' : '',
          lastName: printLastName,
          firstName: printFirstName,
          patronymic: printPatronymic,
          customer: {
            firstName: printFirstName,
            lastName: printLastName,
            patronymic: printPatronymic,
            middleName: printPatronymic,
            fullName: printFullName || undefined,
            phone: order.customer ? order.customer.phone || '' : '',
            additionalPhone: order.customer ? order.customer.additionalPhone || '' : ''
          },
          delivery: {
            address: deliveryAddress,
            date: order.delivery ? order.delivery.date : null,
            time: deliveryTime,
            cost: order.delivery ? order.delivery.cost : null
          },
          items: items,
          payments: payments,
          paymentType: order.paymentType || null,
          customFields: customFields,
          totalSumm: this.grandTotal || this.formData.totalSumm || 0,
          prepaySum: this.prepaySum || 0,
          managerComment: this.formData.managerComment || '',
          createdAt: this.formData.createdAt || null,
          contragent: {
            contragentType: this.formData.contragentTypes ? {
              label: this.formData.contragentTypes.label || '',
              value: this.formData.contragentTypes.value || ''
            } : null,
            INN: this.formData.contragentINN || '',
            legalName: this.formData.contragentLegalName || '',
            OKPO: this.formData.contragentOKPO || '',
            KPP: this.formData.contragentKPP || '',
            OGRNIP: this.formData.contragentOGRNIP || '',
            legalAddress: this.formData.contragentLegalAddress || '',
            OGRN: this.formData.contragentOGRN || '',
            certificateNumber: this.formData.contragentCertificateNumber || '',
            certificateDate: this.formData.contragentCertificateDate || null
          }
        };
        
        let endpoint = '';
        if (isVozimSheet) {
          endpoint = ORDERS_API_BASE + '/generate_vozim_sheet.php';
        } else if (isRouteSheet) {
          endpoint = ORDERS_API_BASE + '/generate_route_sheet.php';
        } else if (isWarrantyTicket) {
          endpoint = ORDERS_API_BASE + '/generate_warranty_ticket.php';
        } else if (isGalitskyContract) {
          endpoint = ORDERS_API_BASE + '/generate_galitsky_contract.php';
        } else if (isGamzContract) {
          endpoint = ORDERS_API_BASE + '/generate_gamz_contract.php';
        } else if (isGalitskyInvoice) {
          endpoint = ORDERS_API_BASE + '/generate_galitsky_invoice.php';
        } else if (isGamz3Invoice) {
          endpoint = ORDERS_API_BASE + '/generate_gamz3_invoice.php';
        } else if (isGamz5Invoice) {
          endpoint = ORDERS_API_BASE + '/generate_gamz5_invoice.php';
        } else if (isActDelivery) {
          endpoint = ORDERS_API_BASE + '/generate_act_delivery.php';
        }
        
        if (!endpoint) {
          alert('Не указан endpoint для данного типа шаблона');
          return;
        }
        
        try {
          const response = await axios.post(endpoint, {
            orders: [orderToSend]
          }, {
            timeout: 60000,
            headers: {
              'Content-Type': 'application/json'
            }
          });
          
          console.log('Ответ получен:', response.data);
          
          if (response.data && response.data.success && response.data.url) {
            const newWindow = window.open(response.data.url, '_blank');
            if (!newWindow) {
              alert('Пожалуйста, разрешите всплывающие окна для открытия документа');
            }
          } else {
            throw new Error((response.data && response.data.error) || 'Ошибка генерации документа');
          }
        } catch (axiosError) {
          console.error('Ошибка axios:', axiosError);
          if (axiosError.response && axiosError.response.data) {
            const errorMsg = axiosError.response.data.error || axiosError.response.data.message || 'Ошибка сервера';
            alert('Ошибка: ' + errorMsg);
          } else if (axiosError.request) {
            alert('Нет ответа от сервера. Проверьте доступность API.');
          } else {
            alert('Ошибка: ' + axiosError.message);
          }
        }
      } else {
        // Для других шаблонов используем обычный способ через URL
        const orderId = this.formData.id || this.selectedOrderId;
        const downloadUrl = `/orders/${orderId}/print/${templateId}`;
        window.open(downloadUrl, '_blank');
      }
    } catch (error) {
      console.error('Ошибка при печати:', error);
      alert('Ошибка при генерации печатной формы: ' + (error.message || 'Неизвестная ошибка'));
    }
  },
  toggleDropdown(event) {
        event.preventDefault(); // Предотвращает скролл страницы
        this.dropdownVisible = !this.dropdownVisible;

        // Если открываем выпадающий список, добавляем обработчик клика вне компонента
        if (this.dropdownVisible) {
            document.addEventListener("click", this.handleOutsideClick);
        } else {
            document.removeEventListener("click", this.handleOutsideClick);
        }
    },
    selectRange(range) {
        this.timeFrom = range.from;
        this.timeTo = range.to;
        this.isRangeMode = true;
        this.isCustomMode = false;
        this.dropdownVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
    },
    activateCustomRange() {
        this.isRangeMode = true;
        this.isExactMode = false;
        this.isCustomMode = false;
        this.timeFrom = "";
        this.timeTo = "";
        this.dropdownVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
    },
    activateCustomValue() {
        this.isRangeMode = false;
        this.isExactMode = false;
        this.isCustomMode = true;
        this.customTime = "";
        this.dropdownVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
    },
    updateTime() {
        if (this.isCustomMode) {
            console.log(`Custom time set to: ${this.customTime}`);
        } else {
            console.log(`Time from ${this.timeFrom} to ${this.timeTo}`);
        }
    },
    clearTime() {
        this.timeFrom = "";
        this.timeTo = "";
        this.customTime = "";
        this.isRangeMode = true;
        this.isCustomMode = false;
        this.dropdownVisible = false;
        document.removeEventListener("click", this.handleOutsideClick);
    },
    handleOutsideClick(event) {
        // Проверяем, находится ли клик вне области выпадающего списка
        const dropdown = this.$el.querySelector(".select-time-btn");
        if (dropdown && !dropdown.contains(event.target)) {
            this.dropdownVisible = false;
            document.removeEventListener("click", this.handleOutsideClick);
        }
    },




            updateTotalDiscount() {
    
  },

      // Запрос на получение регионов с фильтрацией по Беларуси
    fetchRegions() {
      axios.get(`https://geohelper.info/api/v1/regions`, {
        params: {
          apiKey: this.apiKey,
          'locale[lang]': 'ru',
          'filter[countryIso]': 'BY'  // Фильтрация по стране Беларусь
        }
      })
      .then(response => {
        if (response.data.success) {
          // Сохраняем регионы Беларуси, используем имя из "localizedNames" или "name"
          this.regions = response.data.result.map(region => ({
            label: region.name,  // Используем локализованное имя, если оно доступно
            value: region.id
          }));
        } else {
          console.error('Ошибка API:', response.data.error.message);
        }
      })
      .catch(error => {
        console.error("Ошибка загрузки регионов:", error);
      });
    },


   addNewRegion(newRegion) {
  // Проверяем, есть ли уже такой регион по label
  if (!this.regions.some(region => region.label === newRegion)) {
    this.regions.push({ label: newRegion }); // Добавляем новый объект с label
  }
  // Присваиваем в formData объект с label
  this.formData.deliveryregion = { label: newRegion };
},

addNewCity(newCity) {
  if (!this.cities.some(city => city.label === newCity)) {
    this.cities.push({ label: newCity }); // Добавляем новый объект с label
  }
  this.formData.deliverycity = { label: newCity, value:'' }; // Присваиваем объект с label
},

addNewStreet(newStreet) {
  if (!this.streets.some(street => street.label === newStreet)) {
    this.streets.push({ label: newStreet, value: '' });
  }
  this.formData.deliverystreet = { label: newStreet, value: '' };
  this.loadStreetSuggestionsForCurrentCity(newStreet);
},

openVisitorLookup() {
  const code = String(this.visitorLookupCode || '').trim().toUpperCase();
  this.visitorLookupCode = code;
  if (!/^\d{3}[ABCDKLMFE]\d$/.test(code)) {
    alert('Код вида 747A1 (3 цифры + буква + цифра)');
    return;
  }
  this.visitorLookupVisible = true;
},

async saveVisitorCodeFromLookup(payload) {
  const code = String((payload && payload.code) || this.visitorLookupCode || '')
    .trim()
    .toUpperCase();
  if (!/^\d{3}[ABCDKLMFE]\d$/.test(code)) {
    this.$toast.error('Некорректный код клиента');
    return;
  }
  this.visitorLookupCode = code;
  this.formData.visitor_code = code;
  if (payload && payload.city) {
    this.formData.visitor_city = String(payload.city).trim();
  }
  if (payload && payload.discount != null && payload.discount !== '') {
    this.formData.personal_offer_discount = payload.discount;
  }

  // Сразу гасим оффер 20% у клиента на сайте (не ждём полного save заказа)
  try {
    await fetch('https://1akb.by/local/api/visitor/mark-goal.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ code, reason: 'manager_order' }),
    });
  } catch (e) {
    console.warn('mark-goal visitor offer', e);
  }

  if (!this.$route.params.orderId) {
    this.$toast.success('Код привязан к форме — сохраните заказ');
    this.visitorLookupVisible = false;
    return;
  }

  try {
    const orderData = this.getOrderData();
    if (!orderData.order.customFields) orderData.order.customFields = {};
    orderData.order.customFields.visitor_code = code;
    if (this.formData.visitor_city) {
      orderData.order.customFields.visitor_city = this.formData.visitor_city;
    }
    if (this.formData.personal_offer_discount !== '' && this.formData.personal_offer_discount != null) {
      orderData.order.customFields.personal_offer_discount = this.formData.personal_offer_discount;
    }
    const response = await axios.post(ORDERS_API_BASE + '/updateOrder.php', orderData, { timeout: 8000 });
    if (response.data && response.data.success) {
      this.$toast.success('Код клиента сохранён в заказе');
      this.visitorLookupVisible = false;
      this.registerVisitorReturnWatch(code);
    } else if (response.data && response.data.conflict) {
      this.handleOrderConflictReload();
    } else {
      this.$toast.error((response.data && response.data.message) || 'Не удалось сохранить код');
    }
  } catch (e) {
    console.error('saveVisitorCodeFromLookup', e);
    this.$toast.error('Ошибка сохранения кода');
  }
},

async registerVisitorReturnWatch(code) {
  try {
    const user = this.$store.state.user || {};
    const managerUserId = user.id;
    if (!managerUserId || !code) return;
    const orderId = this.$route.params.orderId;
    const site =
      (this.formData.site && (this.formData.site.value || this.formData.site)) ||
      this.$route.params.site ||
      '';
    await axios.post(
      MANAGER_API_BASE + '/visitor-return/watch',
      {
        code,
        orderId,
        orderNumber: this.formData.number || orderId,
        site,
        phone: this.formData.phone || '',
        managerUserId,
        managerLabel: user.label || '',
      },
      { timeout: 5000 }
    );
  } catch (e) {
    console.warn('registerVisitorReturnWatch', e && e.message ? e.message : e);
  }
},

onStreetSelect(selected) {
  if (selected && typeof selected === 'object' && selected.value) {
    this.streetSuggestions = [];
    this.addressResolveStatus = '';
  }
},

selectStreetSuggestion(street) {
  if (!street) return;
  this.formData.deliverystreet = { label: street.label, value: street.value };
  if (!this.streets.some(s => s.value === street.value)) {
    this.streets = [street, ...this.streets];
  }
  this.streetSuggestions = [];
  this.addressResolveStatus = '';
  this.updatedFields.deliverystreet = true;
},

async selectCitySuggestion(city) {
  if (!city || this.addressResolving) return;
  this.addressResolving = true;
  try {
    await this.applyResolvedCity(city);
    this.citySuggestions = [];
    this.addressCandidates = [];
    const pending = this.pendingAddressParts || {};
    await this.applyStreetAndHouseFromParts(pending.streetLabel || '', pending.houseLabel || '');
    this.pendingAddressParts = null;
  } catch (e) {
    console.error(e);
    this.addressResolveStatus = 'Не удалось выбрать населённый пункт';
  } finally {
    this.addressResolving = false;
  }
},

async selectAddressCandidate(candidate) {
  if (!candidate || this.addressResolving) return;
  this.addressResolving = true;
  this.addressResolveStatus = 'Уточняем выбранный вариант…';
  this.addressCandidates = [];
  this.citySuggestions = [];
  try {
    await this.applyParsedCandidate(candidate, { forceSingle: true });
  } catch (e) {
    console.error(e);
    this.addressResolveStatus = 'Не удалось применить выбранный адрес';
  } finally {
    this.addressResolving = false;
  }
},

onDeliveryAddressBlur() {
  if (this._addressBlurTimer) clearTimeout(this._addressBlurTimer);
  this._addressBlurTimer = setTimeout(() => {
    const text = (this.deliveryAddress || '').trim();
    if (!text || text.length < 8) return;
    if (this.addressResolving) return;
    // Не перезаписываем, если улица уже выбрана из справочника
    const street = this.formData.deliverystreet;
    if (street && typeof street === 'object' && street.value) return;
    // И если ждём выбор населённого пункта
    if (this.citySuggestions.length || this.addressCandidates.length) return;
    this.splitAddress({ silent: true });
  }, 400);
},


    // Запрос на получение городов при выборе региона
    onRegionSelect(selectedRegion) {
     

      axios.get(`https://geohelper.info/api/v1/cities`, {
        params: {
          apiKey: this.apiKey,
          'locale[lang]': 'ru',
          'filter[countryIso]': 'BY',  // Фильтрация по стране Беларусь
          'filter[regionId]': selectedRegion.value  // Фильтрация по стране Беларусь
          
        }
      })
      .then(response => {
        if (response.data.success) {
          this.cities = response.data.result.map(city => ({
             label: `${city.localityType.localizedNamesShort.ru} ${city.name}`,
            value: city.id
          }));
        } else {
          console.error('Ошибка API:', response.data.error.message);
        }
      })
      .catch(error => {
        console.error("Ошибка загрузки городов:", error);
      });
    },

    // Запрос на получение улиц при выборе города
    onCitySelect(selectedCity) {
      this.streetSuggestions = [];
      if (selectedCity && selectedCity.value) {
        this.citySuggestions = [];
        this.addressCandidates = [];
      }
      if (!selectedCity || !selectedCity.value) {
        this.streets = [];
        return;
      }

      axios.get(`https://geohelper.info/api/v1/streets`, {
        params: {
          apiKey: this.apiKey,
          'locale[lang]': 'ru',
          'filter[cityId]': selectedCity.value,
          'pagination[limit]': 50
        }
      })
      .then(response => {
        if (response.data.success) {
          this.streets = response.data.result.map(this.mapGeoStreet);
        } else {
          console.error('Ошибка API:', response.data.error.message);
        }
      })
      .catch(error => {
        console.error("Ошибка загрузки улиц:", error);
      });
    },
    // Запрос на получение городов при вводе части названия
fetchCities(query) {
  if (!this.formData.deliveryregion) return;

  axios.get(`https://geohelper.info/api/v1/cities`, {
    params: {
      apiKey: this.apiKey,
      'locale[lang]': 'ru',
      'filter[countryIso]': 'BY',
      'filter[regionId]': this.formData.deliveryregion.value,
      'filter[name]': query || '',  // Поиск по части имени города
      'pagination[limit]': 20
    }
  })
  .then(response => {
    if (response.data.success) {
      this.cities = response.data.result.map(city => ({
        label: `${city.localityType.localizedNamesShort.ru} ${city.name}`,
        value: city.id
      }));
    } else {
      console.error('Ошибка API:', response.data.error.message);
    }
  })
  .catch(error => {
    console.error("Ошибка загрузки городов:", error);
  });
},
// Запрос на получение улиц при вводе части названия
fetchStreets(query) {
  if (!this.formData.deliverycity || !this.formData.deliverycity.value) return;

  axios.get(`https://geohelper.info/api/v1/streets`, {
    params: {
      apiKey: this.apiKey,
      'locale[lang]': 'ru',
      'filter[cityId]': this.formData.deliverycity.value,
      'filter[name]': query || '',
      'pagination[limit]': 20
    }
  })
  .then(response => {
    if (response.data.success) {
      this.streets = response.data.result.map(street => this.mapGeoStreet(street));
    } else {
      console.error('Ошибка API:', response.data.error.message);
    }
  })
  .catch(error => {
    console.error("Ошибка загрузки улиц:", error);
  });
},
copyAdress() {
  const extractText = (val) => {
    if (!val) return '';
    if (typeof val === 'object') {
      return val.label || val.value || val.name || ''; 
    }
    return String(val).trim();
  };

  const parts = [];
  
  const region = extractText(this.formData.deliveryregion);
  const city = extractText(this.formData.deliverycity);
  const street = extractText(this.formData.deliverystreet);
  const building = extractText(this.formData.deliverybuilding);
  const housing = extractText(this.formData.housing);

  if (region) parts.push(region);
  if (city) parts.push(city);
  if (street) parts.push(street);
  if (building) parts.push(building);
  if (housing) parts.push(housing);

  const addressString = parts.join(', ');

  // Функция для анимации: включаем галочку и зелёный текст на 2 секунды
  const triggerSuccessAnimation = () => {
    this.isAddressCopied = true;
    setTimeout(() => {
      this.isAddressCopied = false;
    }, 2000); 
  };

  if (addressString) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(addressString)
        .then(() => triggerSuccessAnimation()) // Вызываем при успехе
        .catch(err => console.error('Ошибка при копировании', err));
    } else {
      const input = document.createElement('textarea');
      input.value = addressString;
      input.style.position = 'fixed';
      document.body.appendChild(input);
      input.focus();
      input.select();
      try {
        document.execCommand('copy');
        triggerSuccessAnimation(); // Вызываем при успехе
      } catch (err) {
        console.error('Ошибка fallback копирования', err);
      }
      document.body.removeChild(input);
    }
  }
},

async splitAddress(options = {}) {
  const silent = options === true || (options && options.silent);
  if (!this.deliveryAddress || !String(this.deliveryAddress).trim()) {
    if (!silent) alert('Пожалуйста, введите адрес');
    return;
  }
  if (this._addressBlurTimer) {
    clearTimeout(this._addressBlurTimer);
    this._addressBlurTimer = null;
  }
  if (this.addressResolving) return;

  this.addressResolving = true;
  this.addressResolveStatus = silent ? 'Распознаём адрес в Беларуси…' : '';
  this.streetSuggestions = [];
  this.citySuggestions = [];
  this.addressCandidates = [];
  this.pendingAddressParts = null;

  try {
    const response = await fetch(
      `${ORDERS_API_BASE}/addres-parse.php?address=${encodeURIComponent(this.deliveryAddress)}`
    );
    const data = await response.json();

    if (!data || data.success === false || data.error) {
      const err = (data && data.error) || 'Адрес не найден на территории Беларуси';
      this.addressResolveStatus = err;
      if (!silent) alert(err);
      return;
    }

    this.formData.deliveryregion = null;
    this.formData.deliverycity = null;
    this.formData.deliverystreet = null;
    this.formData.deliverybuilding = '';
    this.cities = [];
    this.streets = [];

    const candidates = Array.isArray(data.candidates) && data.candidates.length
      ? data.candidates
      : [{
          text: '',
          province: data.province || { label: '' },
          area: data.area || { label: '' },
          locality: data.locality || { label: '' },
          street: data.street || { label: '' },
          house: data.house || { label: '' },
        }];

    // Несколько разных населённых пунктов → даём выбрать явно
    const uniqueLocalities = this.uniqueLocalityKeys(candidates);
    if (uniqueLocalities.length > 1) {
      this.addressCandidates = candidates.map(c => ({
        ...c,
        buttonLabel: this.formatAddressCandidateLabel(c),
      }));
      this.pendingAddressParts = null;
      this.addressResolveStatus =
        `Найдено ${uniqueLocalities.length} вариантов в Беларуси — выберите населённый пункт.`;
      return;
    }

    await this.applyParsedCandidate(candidates[0], { forceSingle: true, allCandidates: candidates });
  } catch (error) {
    console.error('Ошибка при отправке запроса:', error);
    this.addressResolveStatus = 'Ошибка при обработке адреса';
    if (!silent) alert('Произошла ошибка при обработке адреса');
  } finally {
    this.addressResolving = false;
  }
},

uniqueLocalityKeys(candidates) {
  const keys = [];
  const seen = {};
  (candidates || []).forEach(c => {
    const key = [
      this.normalizeAddressName(c && c.province && c.province.label),
      this.normalizeAddressName(c && c.area && c.area.label),
      this.normalizeAddressName(this.stripLocalityType(c && c.locality && c.locality.label)),
    ].join('|');
    if (!key.replace(/\|/g, '') || seen[key]) return;
    seen[key] = true;
    keys.push(key);
  });
  return keys;
},

formatAddressCandidateLabel(c) {
  if (!c) return '';
  const locality = (c.locality && c.locality.label) || '';
  const district = (c.district && c.district.label) || '';
  const area = (c.area && c.area.label) || '';
  const province = (c.province && c.province.label) || '';
  const street = (c.street && c.street.label) || '';
  const house = (c.house && c.house.label) || '';
  const parts = [];
  if (locality) parts.push(locality);
  if (district) parts.push(district);
  else if (area) parts.push(area);
  if (province) parts.push(province.replace(/\s*область$/i, ' обл.'));
  if (street) parts.push(street + (house ? ` ${house}` : ''));
  if (parts.length) return parts.join(', ');
  return c.text || '';
},

stripLocalityType(name) {
  return String(name || '')
    .replace(/^(г\.|город|аг\.|агрогородок|д\.|дер\.|деревня|п\.|пос\.|поселок|посёлок|с\.|село|гп\.|городской\s+посёлок|городской\s+поселок)\s+/iu, '')
    .trim();
},

async applyParsedCandidate(candidate, options = {}) {
  const forceSingle = !!(options && options.forceSingle);
  const provinceLabel = candidate && candidate.province && candidate.province.label
    ? candidate.province.label
    : '';
  const areaLabel = candidate && candidate.area && candidate.area.label
    ? candidate.area.label
    : '';
  const districtLabel = candidate && candidate.district && candidate.district.label
    ? candidate.district.label
    : '';
  let localityLabel = candidate && candidate.locality && candidate.locality.label
    ? candidate.locality.label
    : '';
  let streetLabel = candidate && candidate.street && candidate.street.label
    ? candidate.street.label
    : '';
  let houseLabel = candidate && candidate.house && candidate.house.label
    ? candidate.house.label
    : '';

  if (!streetLabel) {
    const guessed = this.guessStreetAndHouseFromText(
      this.deliveryAddress,
      localityLabel || this.stripLocalityType(localityLabel)
    );
    if (guessed.street) streetLabel = guessed.street;
    if (!houseLabel && guessed.house) houseLabel = guessed.house;
  }

  // Регион → GeoHelper (BY)
  let region = null;
  if (provinceLabel) {
    region = await this.findRegionByName(provinceLabel);
    this.formData.deliveryregion = region || { label: provinceLabel, value: null };
    this.updatedFields.deliveryregion = !!region;
  }

  const localitySearch = this.stripLocalityType(localityLabel) || localityLabel;
  const geoAreaHint = districtLabel || areaLabel;
  let city = null;

  if (localitySearch) {
    const regionId = region && region.value ? region.value : null;
    let cities = await this.findCitiesByName(localitySearch, regionId, { areaLabel: geoAreaHint });
    if ((!cities || !cities.length) && regionId) {
      cities = await this.findCitiesByName(localitySearch, null, { areaLabel: geoAreaHint });
    }

    if (cities && cities.length > 1 && !forceSingle) {
      this.citySuggestions = cities.slice(0, 20);
      this.cities = cities.slice(0, 20);
      this.pendingAddressParts = { streetLabel, houseLabel, provinceLabel, areaLabel, localityLabel };
      this.formData.deliverycity = { label: localityLabel || localitySearch, value: '' };
      this.updatedFields.deliverycity = false;
      this.addressResolveStatus =
        `Найдено ${cities.length} населённых пунктов «${localitySearch}» в Беларуси — выберите.`;
      return;
    }

    if (cities && cities.length > 1 && forceSingle) {
      // Пытаемся сузить по району (area); иначе — выбор вручную
      const areaNorm = this.normalizeAddressName(areaLabel);
      let narrowed = cities;
      if (areaNorm) {
        const byArea = cities.filter(c => this.normalizeAddressName(c.area || '').includes(areaNorm)
          || areaNorm.includes(this.normalizeAddressName(c.area || '')));
        if (byArea.length === 1) narrowed = byArea;
        else if (byArea.length > 1) narrowed = byArea;
      }
      if (narrowed.length === 1) {
        city = narrowed[0];
      } else {
        this.citySuggestions = narrowed.slice(0, 20);
        this.cities = narrowed.slice(0, 20);
        this.pendingAddressParts = { streetLabel, houseLabel, provinceLabel, areaLabel, localityLabel };
        this.formData.deliverycity = { label: localityLabel || localitySearch, value: '' };
        this.updatedFields.deliverycity = false;
        this.addressResolveStatus =
          `Уточните населённый пункт «${localitySearch}» (${narrowed.length} в справочнике BY).`;
        if (houseLabel) {
          this.formData.deliverybuilding = houseLabel;
          this.updatedFields.deliverybuilding = true;
        }
        return;
      }
    } else if (cities && cities.length === 1) {
      city = cities[0];
    }

    if (city) {
      await this.applyResolvedCity(city);
    } else if (localityLabel) {
      this.formData.deliverycity = { label: localityLabel, value: '' };
      this.updatedFields.deliverycity = false;
      this.addressResolveStatus = 'Населённый пункт не найден в справочнике Беларуси — укажите вручную.';
    }
  }

  await this.applyStreetAndHouseFromParts(streetLabel, houseLabel);
},

async applyResolvedCity(city) {
  if (!city) return;
  const cityOption = { label: city.label, value: city.value };
  this.formData.deliverycity = cityOption;
  this.updatedFields.deliverycity = !!city.value;
  this.cities = [cityOption];
  this.citySuggestions = [];

  if (city.regionId) {
    let region = (this.regions || []).find(r => String(r.value) === String(city.regionId));
    if (!region) {
      region = await this.findRegionById(city.regionId);
    }
    if (region) {
      this.formData.deliveryregion = region;
      this.updatedFields.deliveryregion = true;
    }
  }

  if (city.value) {
    await this.loadStreetsForCity(city.value);
  }
},

async applyStreetAndHouseFromParts(streetLabel, houseLabel) {
  if (houseLabel) {
    this.formData.deliverybuilding = houseLabel;
    this.updatedFields.deliverybuilding = true;
  }

  if (!streetLabel) {
    if (!this.addressResolveStatus) {
      this.addressResolveStatus = this.formData.deliverycity && this.formData.deliverycity.value
        ? 'Населённый пункт определён. Улицу укажите вручную, если нужна.'
        : this.addressResolveStatus;
    }
    return;
  }

  const cityId = this.formData.deliverycity && this.formData.deliverycity.value
    ? this.formData.deliverycity.value
    : null;
  let street = null;
  let suggestions = [];
  if (cityId) {
    const result = await this.searchStreetsByName(streetLabel, cityId);
    street = result.match;
    suggestions = result.suggestions || [];
  }

  if (street) {
    this.formData.deliverystreet = street;
    this.streetSuggestions = [];
    if (!this.streets.some(s => String(s.value) === String(street.value))) {
      this.streets = [street, ...this.streets];
    }
    this.updatedFields.deliverystreet = true;
    this.addressResolveStatus = 'Адрес распознан в Беларуси, улица из справочника.';
  } else {
    const freeStreet = { label: streetLabel, value: '' };
    this.streets = [freeStreet, ...suggestions];
    this.formData.deliverystreet = freeStreet;
    this.streetSuggestions = suggestions.slice(0, 8);
    this.updatedFields.deliverystreet = false;
    if (suggestions.length) {
      this.addressResolveStatus = 'Улица не найдена точно — выберите из похожих ниже.';
    } else {
      this.addressResolveStatus = cityId
        ? 'Улица не найдена в справочнике. Можно оставить как есть или выбрать вручную.'
        : 'Сначала выберите населённый пункт в Беларуси — тогда подберём улицу.';
    }
  }
},


formatDateToYYYYMMDD(date) {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
},

// Функция для формирования объекта orderData
  getOrderData() {
    this.formData.location_zabor = this.buildLocationZaborValue();
    // Функция для преобразования даты в формат Y-m-d H:i:s
    const formatDateForAPI = (date) => {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const payments = this.payments.map(payment => ({
        externalId: payment && payment.id ? payment.id : null,
        amount: payment && payment.amount ? payment.amount : 0,
        paidAt: payment && payment.date ? formatDateForAPI(payment.date) : null,
        comment: payment && payment.comment ? payment.comment : "",
        type: payment && payment.type ? payment.type : null,
        status: payment && payment.status ? payment.status : null,
    }));

    const getField = (field, defaultValue = "") => (field ? field : defaultValue);
    const getNestedField = (obj, key, defaultValue = "") => (obj && obj[key] ? obj[key] : defaultValue);
    const getNestedFieldAdress = (obj, key, defaultValue = "") => {
          if (obj && typeof obj === "object" && key in obj) {
            return obj[key];
          }
          return defaultValue;
        };

    return {
        order: {
            id: this.$route.params.orderId || null,
            status: {
                label: getNestedField(this.selectedStatusOrder, 'label'),
                value: getNestedField(this.selectedStatusOrder, 'value'),
            },
            orderType: {
                label: getNestedField(this.formData.orderType, 'label'),
                value: getNestedField(this.formData.orderType, 'value'),
            },
            orderMethod: {
                label: getNestedField(this.formData.orderMethod, 'label'),
                value: getNestedField(this.formData.orderMethod, 'value'),
            },
            magazin:{
                label: getNestedField(this.formData.magazin, 'label'),
                value: getNestedField(this.formData.magazin, 'value'),
            },
            store:{
                label: getNestedField(this.formData.store, 'label'),
                value: getNestedField(this.formData.store, 'value'),
            },
            site: {
                label: getNestedField(this.formData.site, 'label'),
                value: getNestedField(this.formData.site, 'value'),
            },
            discount: getField(this.oneTimeDiscountAmount, null),
            discountPercent: getField(this.oneTimeDiscountPercent, null),
            managerId: {
                label: getNestedField(this.formData.manager, 'label'),
                value: getNestedField(this.formData.manager, 'value'),
            },
            shipmentStore: {
                label: getNestedField(this.formData.shipmentStore, 'label'),
                value: getNestedField(this.formData.shipmentStore, 'value'),
            },
            customer: {
                firstName: this.getFirstNameValue() || getField(this.formData.firstName),
                lastName: getField(this.formData.lastName),
                patronymic: getField(this.formData.patronymic),
                phone: getField(this.formData.phone),
                additionalPhone: getField(this.formData.additionalPhone),
                email: getField(this.formData.email),
            },
            items: this.products.map(product => ({
                offer: { id: String(getField(product && product.id, "")) },
                status: getField(product && product.status, 'new'),
                discountAmount: getField(product && product.discountAmount, null),
                percentAmount: getField(product && product.discountPercent, null),
                productName: getField(product && product.name, ""),
                initialPrice: getField(product && product.price, null),
                quantity: getField(product && product.quantity, 0),
            })),
            shipmentDate: this.formData.shipmentDate instanceof Date
                ? this.formatDateToYYYYMMDD(this.formData.shipmentDate)
                : null,

            delivery: {
                code: {
                    label: getNestedField(this.formData.deliveryTypes, 'label'),
                    value: getNestedField(this.formData.deliveryTypes, 'value'),
                },
                cost: getField(this.deliveryCost, null),
                date: this.formData.deliveryDate
            ? this.formData.deliveryDate.toLocaleDateString('ru-RU', { year: 'numeric', month: '2-digit', day: '2-digit' })
            : null,
                data: (this.formData.curier && getNestedField(this.formData.curier, 'value')) ? {
                    id: parseInt(getNestedField(this.formData.curier, 'value')),
                    courierId: parseInt(getNestedField(this.formData.curier, 'value'))
                } : { id: '', courierId: '' }, // Пустые строки для удаления курьера в CRM
                address: {
                    text: getField(this.deliveryAddress),
                    building: getField(this.formData.deliverybuilding),
                    flat: getField(this.formData.flat),
                    floor: getField(this.formData.floor),
                    block: getField(this.formData.block),
                    housing: getField(this.formData.housing),
                    house: getField(this.formData.house),
                    region: {
                    label: this.formData.deliveryregion && typeof this.formData.deliveryregion === "object" && "label" in this.formData.deliveryregion
                           ? getNestedFieldAdress(this.formData.deliveryregion, "label") 
                           : (typeof this.formData.deliveryregion === "string" ? this.formData.deliveryregion : ""),
                    value: this.formData.deliveryregion && typeof this.formData.deliveryregion === "object"
                           ? getNestedFieldAdress(this.formData.deliveryregion, "value", "") 
                           : "", // Пустая строка, если value нет
                  },
                  city: {
                    label: this.formData.deliverycity && typeof this.formData.deliverycity === "object" && "label" in this.formData.deliverycity
                           ? getNestedFieldAdress(this.formData.deliverycity, "label") 
                           : (typeof this.formData.deliverycity === "string" ? this.formData.deliverycity : ""),
                    value: this.formData.deliverycity && typeof this.formData.deliverycity === "object"
                           ? getNestedFieldAdress(this.formData.deliverycity, "value", "") 
                           : "", // Пустая строка, если value нет
                  },
                  street: {
                    label: this.formData.deliverystreet && typeof this.formData.deliverystreet === "object" && "label" in this.formData.deliverystreet
                           ? getNestedFieldAdress(this.formData.deliverystreet, "label") 
                           : (typeof this.formData.deliverystreet === "string" ? this.formData.deliverystreet : ""),
                    value: this.formData.deliverystreet && typeof this.formData.deliverystreet === "object"
                           ? getNestedFieldAdress(this.formData.deliverystreet, "value", "") 
                           : "", // Пустая строка, если value нет
                  },

                },
                time: {
                    from: getField(this.timeFrom),
                    to: getField(this.timeTo),
                    custom: getField(this.customTime),
                },
                weight: getField(this.weight, null),
                dimensions: {
                    length: getField(this.length, null),
                    width: getField(this.width, null),
                    height: getField(this.height, null),
                },
            },
            statusComment:getField(this.formData.statusComment),
            payments,
            contragent: {
                contragentType: {
                    label: getNestedField(this.formData.contragentTypes, 'label'),
                    value: getNestedField(this.formData.contragentTypes, 'value'),
                },
                INN: getField(this.formData.contragentINN),
                legalName: getField(this.formData.contragentLegalName),
                OKPO: getField(this.formData.contragentOKPO),
                KPP: getField(this.formData.contragentKPP),
                OGRNIP: getField(this.formData.contragentOGRNIP),
                legalAddress: getField(this.formData.contragentLegalAddress),
                OGRN: getField(this.formData.contragentOGRN),
                certificateNumber: getField(this.formData.contragentCertificateNumber),
                certificateDate: this.formData.contragentCertificateDate instanceof Date
                    ? this.formatDateToYYYYMMDD(this.formData.contragentCertificateDate)
                    : (this.formData.contragentCertificateDate || null),
            },
            managerComment: getField(this.managerComment),
            customerComment: getField(this.customerComment),
            customFields: {
                data_izmeneniia: this.formData.data_izmeneniia || null,
                vgvgvgv:getField(this.vgvgvgv, null),
                sf_date: this.formData.invoiceDate instanceof Date
                ? this.formatDateToYYYYMMDD(this.formData.invoiceDate)
                : null,
                email2: getField(this.formData.email2),
                nekorrektnyi_bonus: getField(this.formData.ncorrectBonus),
                dfgfdddf: getField(this.formData.tradeInAmount),
                dfgfdddfnew: getField(this.formData.tradeInAmountNew),
                dsksajklsal: getField(this.formData.discountCard),
                otpravit_ssylku_na_oplatu: this.formData.link_oplata,
                komentariimenedgera: getField(this.formData.managerComments),
                pomoshch_ii: getField(this.formData.pomoshchIi),
                sssylkaaaaasssyyylka: getField(this.formData.selectionLink),
                shipmentWithoutPayment: getField(this.formData.shipmentWithoutPayment),
                carBrand:this.formData.carBrand,
                carModel:this.formData.carModel,
                fuelType:this.formData.fuelType,
                carName:this.formData.carName,
                carYear:this.formData.carYear,
                registryNumber:this.formData.registryNumber,
                iuridicheskoe_naimenovanie: getField(this.formData.iuridicheskoe_naimenovanie),
                // Поля контрагента для сохранения
                contragentINN: getField(this.formData.contragentINN),
                contragentLegalName: getField(this.formData.contragentLegalName),
                contragentOKPO: getField(this.formData.contragentOKPO),
                contragentKPP: getField(this.formData.contragentKPP),
                contragentOGRNIP: getField(this.formData.contragentOGRNIP),
                contragentLegalAddress: getField(this.formData.contragentLegalAddress),
                contragentOGRN: getField(this.formData.contragentOGRN),
                contragentCertificateNumber: getField(this.formData.contragentCertificateNumber),
                contragentCertificateDate: this.formData.contragentCertificateDate instanceof Date
                    ? this.formatDateToYYYYMMDD(this.formData.contragentCertificateDate)
                    : null,
                ocenka_manageru: {
                    label: getNestedField(this.formData.ocenka_manageru, 'label'),
                    value: getNestedField(this.formData.ocenka_manageru, 'value'),
                },
                ocenkaprodavcu: {
                    label: getNestedField(this.formData.ocenkaprodavcu, 'label'),
                    value: getNestedField(this.formData.ocenkaprodavcu, 'value'),
                },
                ocenochka_kureru: {
                    label: getNestedField(this.formData.ocenochka_kureru, 'label'),
                    value: getNestedField(this.formData.ocenochka_kureru, 'value'),
                },
                manager_new: {
                   label: getNestedField(this.formData.manager_new, 'label'),
                    value: getNestedField(this.formData.manager_new, 'value'),
                },
                dgh66hhhhhhh: {
                    label: getNestedField(this.formData.dgh66hhhhhhh, 'label'),
                    value: getNestedField(this.formData.dgh66hhhhhhh, 'value'),
                },  
                proverkazakazamenedgero: {
                    label: getNestedField(this.formData.proverkazakazamenedgero, 'label'),
                    value: getNestedField(this.formData.proverkazakazamenedgero, 'value'),
                },  
                obzvon_klienta:{
                    label: getNestedField(this.formData.obzvon_klienta, 'label'),
                    value: getNestedField(this.formData.obzvon_klienta, 'value'),
                },
                zvonok_text_bot: getField(this.formData.zvonok_text_bot),
                datazakazaobrabotki: this.formData.datazakazaobrabotki instanceof Date
                ? this.formatDateToYYYYMMDD(this.formData.datazakazaobrabotki)
                : null,
                data_soglasovaniia1: this.formData.dataSoglasovaniia
                  ? (this.formData.dataSoglasovaniia instanceof Date
                    ? (() => {
                        const d = this.formData.dataSoglasovaniia;
                        const yyyy = d.getFullYear();
                        const mm = String(d.getMonth() + 1).padStart(2, '0');
                        const dd = String(d.getDate()).padStart(2, '0');
                        const hh = String(d.getHours()).padStart(2, '0');
                        const mi = String(d.getMinutes()).padStart(2, '0');
                        const ss = String(d.getSeconds()).padStart(2, '0');
                        return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
                      })()
                    : this.formData.dataSoglasovaniia)
                  : null,
                         
                carBodyType:this.formData.carBodyType,
                sf_num:this.formData.sf_num,
                vznos: getField(this.formData.vznos),
                oplacheno_bonusami:this.oplacheno_bonusami,
                predoplata_beznalichnymi_spravochnik: {
                    label: getNestedField(this.formData.predoplata, 'label'),
                    value: getNestedField(this.formData.predoplata, 'value'),
                },
                dostavka_na_nash_magazin_tovara_bez_oplaty_priemka1: {
                    label: getNestedField(this.formData.dostavka_bez_oplaty, 'label'),
                    value: getNestedField(this.formData.dostavka_bez_oplaty, 'value'),
                }, 
                slksdkk2j3iu3n: getField(this.formData.batteryCapacity),
                slksdkk2j3iu3nnew: getField(this.formData.batteryCapacityNew),
                marssh: getField(this.formData.marssh),
                wrongSelection: this.formData.wrongSelection,
                visitor_code: getField(this.formData.visitor_code),
                visitor_city: getField(this.formData.visitor_city),
                personal_offer_discount: getField(this.formData.personal_offer_discount),
                prodavec: {
                    label: getNestedField(this.formData.seller, 'label'),
                    value: getNestedField(this.formData.seller, 'value'),
                },
                redaktor: this.$store.state.user.label,
                oplata_deliveri: this.formData.deliveryPaidBy || 'no_discount',
                oplata_building: this.formData.installationPaidBy || null,
                location_zabor: getField(this.formData.location_zabor),
            },
        },
        userRole: this.userRole,
        wbAssembled: !!this.wbAssembled,
    };
},

togglePopupStatus() {
      this.showPopupStatus = !this.showPopupStatus;
    },

    async loadWbDocs(refresh = false) {
      if (!this.isWbOrder) return;
      this.wbDocsLoading = true;
      try {
        const payload = {
          order_id: this.$route.params.orderId || null,
          wb_order_id: this.wbOrderId || null,
          refresh: !!refresh,
        };
        const response = await axios.post(ORDERS_API_BASE + '/wb_order_docs.php', payload, { timeout: 60000 });
        if (response.data && response.data.success) {
          this.wbDocs = response.data.docs || null;
          if (response.data.supplyId) {
            this.vgvgvgv = response.data.supplyId;
          }
          if (response.data.wbOrderId) {
            this.wbOrderId = String(response.data.wbOrderId);
          }
        } else {
          this.wbDocs = null;
        }
      } catch (e) {
        console.error('WB docs load error', e);
      } finally {
        this.wbDocsLoading = false;
      }
    },

    printWbDocs(kind) {
      const docs = this.wbDocs || {};
      const sheets = [];
      if (kind === 'stickers' || kind === 'all') {
        (docs.stickers || []).forEach((s) => {
          if (s && s.file) sheets.push(s.file);
        });
      }
      if (kind === 'boxes' || kind === 'all') {
        (docs.trbxStickers || []).forEach((s) => {
          if (s && s.file) sheets.push(s.file);
        });
      }
      if (!sheets.length) return;
      const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Печать WB</title>
<style>
@page{size:58mm 40mm;margin:0}
html,body{margin:0;padding:0;background:#fff}
.label{width:58mm;height:40mm;page-break-after:always;display:flex;align-items:center;justify-content:center}
.label:last-child{page-break-after:auto}
.label img{width:58mm;height:40mm;object-fit:fill;display:block}
</style></head><body>
${sheets.map((f) => `<div class="label"><img src="data:image/png;base64,${f}"></div>`).join('')}
</body></html>`;
      let frame = document.getElementById('wbPrintFrameMgr');
      if (frame) frame.remove();
      frame = document.createElement('iframe');
      frame.id = 'wbPrintFrameMgr';
      frame.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;opacity:0';
      document.body.appendChild(frame);
      const doc = frame.contentDocument || frame.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
      const imgs = Array.from(doc.images || []);
      const doPrint = () => {
        try { frame.contentWindow.focus(); frame.contentWindow.print(); } catch (e) { /* noop */ }
      };
      if (!imgs.length) { setTimeout(doPrint, 100); return; }
      let left = imgs.length;
      imgs.forEach((img) => {
        const done = () => { left -= 1; if (left <= 0) setTimeout(doPrint, 50); };
        if (img.complete) done();
        else { img.onload = done; img.onerror = done; }
      });
    },


validateField(fieldName) {
            // Если поле заполнено, удаляем ошибку
            if (fieldName === 'firstName') {
                this.errors.firstName = this.getFirstNameValue() ? null : 'Обязательное поле';
            } else if (this.formData[fieldName]) {
                this.errors[fieldName] = null;
            }
        },
    // Единое значение «Имя»: строка или объект { value/label }; резервно — из DOM
    getFirstNameValue() {
        const v = this.formData.firstName;
        if (v != null) {
            if (typeof v === 'object' && !Array.isArray(v)) {
                const val = v.value != null ? v.value : (v.label != null ? v.label : '');
                if (String(val).trim()) return String(val).trim();
            } else if (String(v).trim()) {
                return String(v).trim();
            }
        }
        var el = document.getElementById('firstName');
        if (el && el.value && String(el.value).trim()) return String(el.value).trim();
        return '';
    },

    async createOrderExit() {
         this.clearErrors(); // Сбрасываем ошибки перед началом проверки
         await this.$nextTick();

                // Синхронизируем «Имя» из DOM (как при показе галочки)
                var firstNameElExit = document.getElementById('firstName');
                if (firstNameElExit && firstNameElExit.value && String(firstNameElExit.value).trim()) {
                  this.formData.firstName = String(firstNameElExit.value).trim();
                  this.errors.firstName = null;
                }

                // Проверка полей
                if (!this.formData.orderType) {
                    this.errors.orderType = 'Обязательное поле';
                }
                if (!this.formData.site) {
                    this.errors.site = 'Обязательное поле';
                }
                if (!this.formData.contragentTypes) {
                    this.errors.contragentTypes = 'Обязательное поле';
                }
                if (!this.getFirstNameValue()) {
                    this.errors.firstName = 'Обязательное поле';
                }

                // Не сохраняем, если есть ошибки обязательных полей (Ссылка на подбор — необязательна)
                const hasRequiredErrorsExit = this.errors.orderType || this.errors.site || this.errors.contragentTypes || this.errors.firstName;
                if (hasRequiredErrorsExit) {
                    const missing = [];
                    if (this.errors.orderType) missing.push('Тип заказа');
                    if (this.errors.site) missing.push('Магазин');
                    if (this.errors.contragentTypes) missing.push('Тип контрагента');
                    if (this.errors.firstName) missing.push('Имя');
                    this.$toast.error('Заполните обязательные поля: ' + missing.join(', '));
                    return;
                }

                const fromStExit = String(this.orderStatusFetch || '');
                const toStExit = String((this.selectedStatusOrder && this.selectedStatusOrder.value) || '');
                const toLblExit = String((this.selectedStatusOrder && this.selectedStatusOrder.label) || '');
                if (fromStExit !== toStExit && this.isSoglasovanieStatusByLabel(toLblExit) && !this.hasDeliveryDateFilled()) {
                  this.errors.deliveryDate = 'Обязательна при переводе в статус «Согласование»';
                  this.$toast.error('Укажите дату доставки: без неё нельзя сохранить перевод в статус «Согласование».', {
                    timeout: 5000,
                    position: 'bottom-right',
                    style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' }
                  });
                  return;
                }
                if (!this.validateAgreementDateForStatus(toStExit || fromStExit)) {
                  return;
                }
                if (!this.validateVozimDeliveryDate()) {
                  return;
                }

                // Если в платежах выбран «3. Предоплата безналичными» — справочник «Предоплата безналичными» обязателен
                const hasPredoplataBeznalichnymiPaymentExit = this.payments.some(p => {
                  const name = (p.name || '').toString();
                  const typeLabel = (p.type && typeof p.type === 'object' ? (p.type.label || p.type.name || '') : '').toString();
                  return name.indexOf('Предоплата безналичными') !== -1 || typeLabel.indexOf('Предоплата безналичными') !== -1;
                });
                if (hasPredoplataBeznalichnymiPaymentExit) {
                  const predoplataSelectedExit = this.formData.predoplata && (this.formData.predoplata.value != null && this.formData.predoplata.value !== '');
                  if (!predoplataSelectedExit) {
                    this.errors.predoplata = 'Укажите значение в справочнике «Предоплата безналичными»';
                    this.$toast.error('При выборе «Предоплата безналичными» в платежах необходимо указать значение в справочнике');
                    return;
                  }
                }

                // Сумма платежей должна соответствовать сумме к оплате
                if (this.payments.length > 0) {
                  const totalPaymentsExit = this.payments.reduce((sum, p) => sum + (Number(p.amount) || 0), 0);
                  const amountToPayExit = parseFloat(Number(this.grandTotal).toFixed(2));
                  if (parseFloat(totalPaymentsExit.toFixed(2)) < amountToPayExit) {
                    this.$toast.error('Сумма платежей не соответствует сумме к оплате. Укажите корректные суммы в платежах.');
                    return;
                  }
                }

                if (this.isManagersRole && this.showLomSenderWarning) {
                    this.$toast.error('Нельзя сохранить заказ: при зачёте лома укажите фамилию, имя и отчество ломосдатчика полностью (имя и отчество — полными словами).');
                    return;
                }

                if (!this.validatePodZakazOrderStatusBeforeSave()) {
                    return;
                }

        this.loading = true;

        try {
            const orderData = this.getOrderData();
            const response = await axios.post(ORDERS_API_BASE + '/updateOrder.php', orderData, { timeout: 5000 });
            if (response.data.success) {
                await this.ensureAgreementReminderTask();
                this.clearEmptyRetailFieldDraft();
                this.$store.dispatch('savedFormsModule/clearSavedForms');
                this.$store.commit('clearProducts', this.$route.params.orderId); // Очистка продуктов через Vuex мутацию
                this.$router.push('/orders');
            } else {
                this.loading = false;
                // Проверяем, является ли это конфликтом обновления
                if (response.data.conflict) {
                    this.handleOrderConflictReload();
                } else {
                    alert('Ошибка при обновлении заказа: ' + response.data.message);
                }
            }
        } catch (error) {
            console.error('Ошибка при обновлении заказа:', error);
            this.loading = false;
            alert(error.code === 'ECONNABORTED' ? 'Сервер не ответил за 5 секунд. Попробуйте сохранить ещё раз.' : 'Произошла ошибка при обновлении заказа.');
        }
    },

   async checkCanEditCurrentStatus() {
      const userGroup = this.userRole || (this.$store.state.user && this.$store.state.user.group_name) || '';
      if (!userGroup) return true;
      const currentStatus = this.orderStatusFetch || '';
      if (!currentStatus) return true;
      try {
        const matrixRes = await fetch(`https://manager.1akb.by/status-transitions-matrix?group=${encodeURIComponent(userGroup)}`);
        const matrixData = await matrixRes.json();
        const matrix = matrixData.matrix || {};
        if (Object.keys(matrix).length === 0) return true;
        const canEditFrom = matrix[currentStatus] != null;
        if (!canEditFrom) {
          const statusOption = (this.statusGroupsOrder || []).flatMap(g => g.options || []).find(o => String(o.value) === String(currentStatus));
          const statusName = statusOption ? statusOption.label : currentStatus;
          this.$toast.error(`Вы не можете редактировать заказ в текущем статусе «${statusName}»`, { timeout: 4000, position: 'bottom-right', style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' } });
          return false;
        }
      } catch (e) {
        console.warn('Ошибка проверки матрицы переходов:', e);
      }
      return true;
    },

    /** Только пункт с подписью «Согласование» (не вся группа согласования) */
    isSoglasovanieStatusByLabel(label) {
      return String(label || '').trim() === 'Согласование';
    },
    hasDeliveryDateFilled() {
      const d = this.formData && this.formData.deliveryDate;
      if (d == null || d === '') return false;
      if (d instanceof Date) return !isNaN(d.getTime());
      if (typeof d === 'number') return !isNaN(d);
      return String(d).trim() !== '';
    },

    isAgreementDateRequiredStatus(statusCode) {
      const code = String(statusCode || '');
      return code === 'availability-confirmed' || code === 'dffddsdfsdd';
    },

    prepareAgreementDateForStatusModal(statusCode) {
      if (!this.isAgreementDateRequiredStatus(statusCode)) {
        this.statusModalAgreementDate = null;
        return;
      }
      // В formData/CRM ничего не пишем заранее — только значение для модалки.
      // Если в CRM уже есть дата — показываем её; иначе пустое поле (ставит менеджер).
      if (this.hasAgreementDateFilled()) {
        const current = this.formData.dataSoglasovaniia;
        this.statusModalAgreementDate = current instanceof Date
          ? new Date(current.getTime())
          : new Date(current);
      } else {
        this.statusModalAgreementDate = null;
      }
      if (this.errors) this.errors.dataSoglasovaniia = null;
    },

    hasAgreementDateFilled() {
      const d = this.formData && this.formData.dataSoglasovaniia;
      if (d == null || d === '') return false;
      if (d instanceof Date) return !isNaN(d.getTime());
      if (typeof d === 'number') return !isNaN(d);
      const parsed = new Date(d);
      return !isNaN(parsed.getTime());
    },

    validateAgreementDateForStatus(statusCode) {
      if (!this.isAgreementDateRequiredStatus(statusCode)) {
        if (this.errors) this.errors.dataSoglasovaniia = null;
        return true;
      }
      if (this.hasAgreementDateFilled()) {
        if (this.errors) this.errors.dataSoglasovaniia = null;
        return true;
      }
      this.errors.dataSoglasovaniia = 'Обязательна для статусов «Консультация» и «Отложено»';
      this.$toast.error('Укажите дату и время согласования: поле обязательно для «Консультация» и «Отложено».', {
        timeout: 5000,
        position: 'bottom-right',
        style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' }
      });
      return false;
    },

    formatAgreementDueDate(dateValue) {
      const d = dateValue instanceof Date ? dateValue : new Date(dateValue);
      if (isNaN(d.getTime())) return '';
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, '0');
      const mi = String(d.getMinutes()).padStart(2, '0');
      return `${dd}.${mm}.${yyyy} ${hh}:${mi}`;
    },

    resolveOrderManagerPerformer() {
      const users = Array.isArray(this.managers_update) ? this.managers_update : [];
      const bySymbolic = this.formData.manager_new && this.formData.manager_new.value;
      if (bySymbolic) {
        const u = users.find((m) => String(m.symbolicCode) === String(bySymbolic));
        if (u && u.retailCrmId != null) {
          return { label: u.label, value: u.retailCrmId };
        }
      }
      const newLabel = this.formData.manager_new && this.formData.manager_new.label;
      if (newLabel) {
        const u = users.find((m) => m.label === newLabel);
        if (u && u.retailCrmId != null) {
          return { label: u.label, value: u.retailCrmId };
        }
      }
      const oldLabel = this.formData.manager && this.formData.manager.label;
      if (oldLabel) {
        const u = users.find((m) => m.label === oldLabel);
        if (u && u.retailCrmId != null) {
          return { label: u.label, value: u.retailCrmId };
        }
      }
      const user = this.$store.state.user || {};
      if (user.retailCrmId != null) {
        return { label: user.label || 'Менеджер', value: user.retailCrmId };
      }
      return null;
    },

    async ensureAgreementReminderTask() {
      const statusCode = (this.selectedStatusOrder && this.selectedStatusOrder.value) || this.orderStatusFetch || '';
      if (!this.isAgreementDateRequiredStatus(statusCode) || !this.hasAgreementDateFilled()) {
        return;
      }
      const performer = this.resolveOrderManagerPerformer();
      if (!performer) {
        console.warn('Дата согласования: не найден менеджер для напоминания');
        return;
      }
      const orderId = this.$route.params.orderId;
      const orderNumber = this.formData.number || orderId;
      const dueDate = this.formatAgreementDueDate(this.formData.dataSoglasovaniia);
      if (!dueDate || !orderId) return;

      const taskText = `Дата согласования — заказ №${orderNumber}`;
      const description = `Напоминание по статусу «${(this.selectedStatusOrder && this.selectedStatusOrder.label) || statusCode}». Перезвонить / согласовать с клиентом.`;
      const tag = 'data_soglasovaniia1';

      try {
        let existing = null;
        try {
          const listRes = await axios.get('https://manager.1akb.by/getTasksByOrderId', {
            params: { taskOrderId: orderId },
            timeout: 8000,
          });
          const rows = Array.isArray(listRes.data) ? listRes.data : [];
          existing = rows.find((t) => String(t.tags || '') === tag || String(t.taskText || '').startsWith('Дата согласования'));
        } catch (e) {
          // если список не загрузился — создадим новую
        }

        if (existing && existing.id) {
          if (String(existing.dueDate || '') === dueDate) return;
          await axios.post('https://manager.1akb.by/updateTaskFields', {
            id: existing.id,
            dueDate,
            taskText,
            description,
            performer: JSON.stringify(performer),
            tags: tag,
            taskOrder: orderNumber,
            taskOrderId: String(orderId),
          }, { timeout: 8000 });
        } else {
          await axios.post('https://manager.1akb.by/addTask', {
            taskText,
            description,
            dueDate,
            tags: tag,
            taskOrder: orderNumber,
            taskOrderId: String(orderId),
            performer,
          }, { timeout: 8000 });
        }

        if (typeof this.fetchTasks === 'function') {
          this.fetchTasks();
        }
      } catch (error) {
        console.error('Не удалось создать напоминание по дате согласования:', error);
      }
    },

    /** Начало сегодняшнего дня — мин. дата для vozim (дата заказа / прошедшие дни недоступны) */
    getVozimMinDeliveryDate() {
      const min = new Date();
      min.setHours(0, 0, 0, 0);
      return min;
    },

    normalizeDeliveryDateValue(value) {
      if (value == null || value === '') return null;
      const d = value instanceof Date ? new Date(value.getTime()) : new Date(value);
      if (isNaN(d.getTime())) return null;
      d.setHours(0, 0, 0, 0);
      return d;
    },

    /** vue2-datepicker: true = день недоступен */
    disabledVozimDeliveryDate(date) {
      if (!this.isVozimDeliveryType) return false;
      const d = this.normalizeDeliveryDateValue(date);
      if (!d) return false;
      return d < this.getVozimMinDeliveryDate();
    },

    onDeliveryDateInput(value) {
      this.errors.deliveryDate = null;
      if (!this.isVozimDeliveryType) return;
      const d = this.normalizeDeliveryDateValue(value);
      const min = this.getVozimMinDeliveryDate();
      if (d && d < min) {
        this.formData.deliveryDate = min;
        this.errors.deliveryDate = 'Для vozim.by дата — не раньше сегодняшнего дня';
      }
    },

    /**
     * Для vozim: если даты ещё нет — подставить сегодня.
     * Уже выставленную дату НЕ переписываем (даже если она в прошлом).
     */
    ensureVozimDeliveryDate(opts = {}) {
      if (!this.isVozimDeliveryType) return true;
      const { silent = false } = opts;
      const d = this.normalizeDeliveryDateValue(this.formData.deliveryDate);
      if (!d) {
        this.formData.deliveryDate = this.getVozimMinDeliveryDate();
        if (!silent) {
          this.errors.deliveryDate = 'Для vozim.by укажите дату доставки (не раньше сегодня)';
        }
        return false;
      }
      return true;
    },

    /**
     * При сохранении: требуем дату, но уже проставленную не меняем и не блокируем,
     * даже если день уже прошёл. Ограничение «не раньше сегодня» — только при выборе даты.
     */
    validateVozimDeliveryDate() {
      if (!this.isVozimDeliveryType) return true;
      const st = String(
        (this.selectedStatusOrder && this.selectedStatusOrder.value) ||
        this.orderStatusFetch ||
        ''
      );
      const terminalStatuses = [
        'complete',
        'cancel',
        'otmena-vozim-by',
        'no-call',
        'already-buy',
        'dalshe-ne-nado',
      ];
      if (terminalStatuses.includes(st)) return true;

      const d = this.normalizeDeliveryDateValue(this.formData.deliveryDate);
      if (!d) {
        this.errors.deliveryDate = 'Для vozim.by укажите дату доставки (не раньше сегодня)';
        this.$toast.error('Для vozim.by / экспресс vozim.by укажите дату доставки не раньше сегодняшнего дня.', {
          timeout: 5000,
          position: 'bottom-right',
          style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' }
        });
        return false;
      }
      return true;
    },

   async checkStatusTransitionBeforeSave(fromCodeParam, toCodeParam, toLabelParam) {
      const CENTRAL_SITE = '1akb-by';
      const deliveryStatusesCentralOnly = ['send-to-delivery', 'redirect', 'fdjkdfkljd'];
      const fromCode = fromCodeParam != null ? fromCodeParam : (this.orderStatusFetch || '');
      const toCode = toCodeParam != null ? toCodeParam : (this.selectedStatusOrder && this.selectedStatusOrder.value ? this.selectedStatusOrder.value : '');
      if (fromCode === toCode) return true;

      const toLabel = toLabelParam != null ? toLabelParam : ((this.selectedStatusOrder && this.selectedStatusOrder.label) || '');
      if (this.isSoglasovanieStatusByLabel(toLabel) && !this.hasDeliveryDateFilled()) {
        this.errors.deliveryDate = 'Обязательна при переводе в статус «Согласование»';
        this.$toast.error('Укажите дату доставки: без неё нельзя перевести заказ в статус «Согласование».', {
          timeout: 5000,
          position: 'bottom-right',
          style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' }
        });
        return false;
      }
      if (!this.validateAgreementDateForStatus(toCode)) {
        return false;
      }

      const siteVal =
        (this.formData.site && this.formData.site.value) ||
        (this.formData.magazin && this.formData.magazin.value) ||
        '';
      if (
        siteVal &&
        siteVal !== CENTRAL_SITE &&
        deliveryStatusesCentralOnly.includes(toCode)
      ) {
        this.$toast.error(
          'Для магазинов, кроме «Центральный офис 1akb.by», недоступны статусы «Передан в доставку», «Доставка курьером» и «Доставка транспортной компанией». Укажите центральный офис или другой статус.',
          { timeout: 5000, position: 'bottom-right', style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' } }
        );
        return false;
      }

      const userGroup = this.userRole || (this.$store.state.user && this.$store.state.user.group_name) || '';
      if (!userGroup) return true;
      try {
        const matrixRes = await fetch(`https://manager.1akb.by/status-transitions-matrix?group=${encodeURIComponent(userGroup)}`);
        const matrixData = await matrixRes.json();
        const matrix = matrixData.matrix || {};
        if (Object.keys(matrix).length === 0) return true;
        const row = matrix[fromCode];
        const allowed = row && typeof row === 'object' && row[toCode];
        if (!allowed) {
          const fromOption = (this.statusGroupsOrder || []).flatMap(g => g.options || []).find(o => String(o.value) === String(fromCode));
          const fromName = fromOption ? fromOption.label : fromCode;
          const toName = toLabelParam != null ? toLabelParam : (this.selectedStatusOrder && this.selectedStatusOrder.label) || toCode;
          this.$toast.error(`Ваши права не позволяют перевести из «${fromName}» в «${toName}»`, { timeout: 4000, position: 'bottom-right', style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' } });
          return false;
        }
      } catch (e) {
        console.warn('Ошибка проверки матрицы переходов:', e);
      }
      return true;
    },

   async createOrder() {
        this.clearErrors();
        await this.$nextTick();

        // Синхронизируем «Имя» из DOM: если в инпуте есть значение (как при показе галочки), подставляем в formData
        var firstNameEl = document.getElementById('firstName');
        if (firstNameEl && firstNameEl.value && String(firstNameEl.value).trim()) {
          this.formData.firstName = String(firstNameEl.value).trim();
          this.errors.firstName = null;
        }

        if (!this.formData.orderType) {
          this.errors.orderType = 'Обязательное поле';
        }
        if (!this.formData.site) {
          this.errors.site = 'Обязательное поле';
        }
        if (!this.formData.contragentTypes) {
          this.errors.contragentTypes = 'Обязательное поле';
        }
        if (!this.getFirstNameValue()) {
          this.errors.firstName = 'Обязательное поле';
        }

        // Не сохраняем, если есть ошибки обязательных полей (Ссылка на подбор — необязательна)
        const hasRequiredErrors = this.errors.orderType || this.errors.site || this.errors.contragentTypes || this.errors.firstName;
        if (hasRequiredErrors) {
          const missing = [];
          if (this.errors.orderType) missing.push('Тип заказа');
          if (this.errors.site) missing.push('Магазин');
          if (this.errors.contragentTypes) missing.push('Тип контрагента');
          if (this.errors.firstName) missing.push('Имя');
          this.$toast.error('Заполните обязательные поля: ' + missing.join(', '));
          return;
        }

        const fromSt = String(this.orderStatusFetch || '');
        const toSt = String((this.selectedStatusOrder && this.selectedStatusOrder.value) || '');
        const toLbl = String((this.selectedStatusOrder && this.selectedStatusOrder.label) || '');
        if (fromSt !== toSt && this.isSoglasovanieStatusByLabel(toLbl) && !this.hasDeliveryDateFilled()) {
          this.errors.deliveryDate = 'Обязательна при переводе в статус «Согласование»';
          this.$toast.error('Укажите дату доставки: без неё нельзя сохранить перевод в статус «Согласование».', {
            timeout: 5000,
            position: 'bottom-right',
            style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' }
          });
          return;
        }
        if (!this.validateAgreementDateForStatus(toSt || fromSt)) {
          return;
        }
        if (!this.validateVozimDeliveryDate()) {
          return;
        }

        // Если в платежах выбран «3. Предоплата безналичными» — справочник «Предоплата безналичными» обязателен
        const hasPredoplataBeznalichnymiPayment = this.payments.some(p => {
          const name = (p.name || '').toString();
          const typeLabel = (p.type && typeof p.type === 'object' ? (p.type.label || p.type.name || '') : '').toString();
          return name.indexOf('Предоплата безналичными') !== -1 || typeLabel.indexOf('Предоплата безналичными') !== -1;
        });
        if (hasPredoplataBeznalichnymiPayment) {
          const predoplataSelected = this.formData.predoplata && (this.formData.predoplata.value != null && this.formData.predoplata.value !== '');
          if (!predoplataSelected) {
            this.errors.predoplata = 'Укажите значение в справочнике «Предоплата безналичными»';
            this.$toast.error('При выборе «Предоплата безналичными» в платежах необходимо указать значение в справочнике');
            return;
          }
        }

        // Сумма платежей должна соответствовать сумме к оплате
        if (this.payments.length > 0) {
          const totalPayments = this.payments.reduce((sum, p) => sum + (Number(p.amount) || 0), 0);
          const amountToPay = parseFloat(Number(this.grandTotal).toFixed(2));
          if (parseFloat(totalPayments.toFixed(2)) < amountToPay) {
            this.$toast.error('Сумма платежей не соответствует сумме к оплате. Укажите корректные суммы в платежах.');
            return;
          }
        }

        if (this.isManagersRole && this.showLomSenderWarning) {
          this.$toast.error('Нельзя сохранить заказ: при зачёте лома укажите фамилию, имя и отчество ломосдатчика полностью (имя и отчество — полными словами).');
          return;
        }

        if (!this.validatePodZakazOrderStatusBeforeSave()) {
          return;
        }

        this.loading = true;

        const isSelfDelivery = this.formData.deliveryTypes && this.formData.deliveryTypes.value === "self-delivery";
        const isSelfStore = this.formData.deliveryTypes && this.formData.deliveryTypes.value === "kjivjv9u39oijskj";
          const isKarbata = this.formData.shipmentStore && this.formData.shipmentStore.value === "rfhdfnfcrkfl";

          // 1. Склад карвата + самовывоз — нельзя
          if (isKarbata && isSelfDelivery) {
            this.$toast.error('Самовывоз с этого склада запрещён');
            this.loading = false;
            return;
          }

          // 2. Любой другой склад + НЕ самовывоз — нельзя
          /*if (!isKarbata && !isSelfDelivery && !isSelfStore) {
            this.$toast.error('Этот склад доступен только для самовывоза');
            this.loading = false;
            return;
          }*/

        try {
          const orderData = this.getOrderData();
          const response = await axios.post(ORDERS_API_BASE + '/updateOrder.php', orderData, { timeout: 5000 });

          if (response.data.success) {
            this.successSaved = true;
            this.clearEmptyRetailFieldDraft();
            await this.ensureAgreementReminderTask();

            // Авто-скрытие через 4 секунды
            setTimeout(() => {
              this.successSaved = false;
            }, 4000);

            if (this.payments.length === 1 && Number(this.payments[0].amount) === 0) {
              this.$toast.error('Заказ сохранен. Не проставлена сумма оплаты');
              this.loading = false;
              
            }

            // WB: после «Комплектуется» / «Собран» подтянуть наклейки (воркер в фоне)
            if (response.data.wbBridge && this.isWbOrder) {
              const action = response.data.wbBridge.action;
              if (action === 'deliver') {
                this.wbAssembled = false;
                this.$toast.success('WB: отгрузка запущена, статус «Доставка ТК»');
              } else if (action === 'prepare') {
                this.$toast.success('WB: создаём поставку и наклейки…');
              }
              setTimeout(() => this.loadWbDocs(true), action === 'prepare' ? 8000 : 3000);
            }

            this.fetchOrder(this.$route.params.orderId, '');
          } else {
            // Проверяем, является ли это конфликтом обновления
            if (response.data.conflict) {
              this.handleOrderConflictReload();
            } else {
              this.$toast.error('Ошибка: ' + response.data.message, { timeout: 2000, position: 'bottom-right', style: { padding: '10px', minWidth: '300px', width: '300px', minHeight: '40px',display: 'flex', alignItems: 'center' } });
            }
          }
        } catch (error) {
          console.error('Ошибка при обновлении заказа:', error);
          this.$toast.error(error.code === 'ECONNABORTED' ? 'Сервер не ответил за 5 секунд. Попробуйте сохранить ещё раз.' : 'Произошла ошибка при обновлении заказа.', { timeout: 500 });
        } finally {
          this.loading = false;
        }

      },

    async syncMoyskladUuid() {
      const orderId = this.formData.id;
      const orderNumber = this.formData.number;
      const siteVal = (this.formData.site && this.formData.site.value) || (this.formData.magazin && this.formData.magazin.value) || '1akb-by';
      const magazinVal = (this.formData.magazin && this.formData.magazin.value) || (this.formData.site && this.formData.site.value) || '1akb-by';
      if (!orderId || !orderNumber) {
        this.$toast.error('Нет данных заказа для синхронизации');
        return;
      }
      this.syncMoyskladLoading = true;
      try {
        const url = `${ORDERS_API_BASE}/sync_moysklad_uuid.php?orderId=${encodeURIComponent(orderId)}&orderNumber=${encodeURIComponent(orderNumber)}&site=${encodeURIComponent(siteVal)}&magazin=${encodeURIComponent(magazinVal)}`;
        const response = await axios.get(url);
        const data = response.data;
        if (data.success) {
          this.formData.moyskladUuid = data.uuid || '';
          this.$toast.success(data.message || 'UUID успешно записан', { timeout: 3000 });
        } else {
          this.$toast.error(data.message || 'Ошибка синхронизации', { timeout: 3000 });
        }
      } catch (error) {
        const msg = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Ошибка при синхронизации с МС';
        this.$toast.error(msg, { timeout: 3000 });
      } finally {
        this.syncMoyskladLoading = false;
      }
    },

  saveAndExit() {
                  this.saveAndBack = true;
                  // Ваша логика сохранения и выхода
                  console.log("Сохранить и выйти");
                },
                save() {
                  this.saveAndBack = false;
                  // Ваша логика для сохранения
                  console.log("Сохранить");
                },
                deleteOrder() {
                  // Логика удаления заказа
                  const confirmDeletion = confirm(
                    "Восстановить заказ можно в течение 14 дней, после этого срока восстановление невозможно. Удалить заказ?"
                  );
                  if (confirmDeletion) {
                    window.location.href = "/orders/580430/delete";
                  }
                },
 
               
 clearErrors() {
                    this.errors = {
                        orderType: null,
                        site: null,
                        contragentTypes: null,
                        firstName: null,
                        selectionLink: null,
                        predoplata: null,
                        deliveryDate: null,
                        dataSoglasovaniia: null
                    };
                },
               
  calculateProductTotal(product) {
    // Начал стоимость
    let total = product.originalPrice * product.quantity;

    // Применяем процентную скидку
    if (product.discountPercent) {
        total -= (total * product.discountPercent) / 100;
    }

    // Применяем скидку в рублях
    if (product.discountAmount) {
        total -= product.discountAmount * product.quantity;
    }

    // Устанавливаем значение total, гарантируя, что оно не будет отрицательным
    product.total = Math.max(Math.round(total * 100) / 100, 0);
},

addOrUpdateProduct(product) {
  const products = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
  const existingProduct = products.find(p => p.id === product.id);

  // Всегда приводим цену к числу (если вдруг она строка)
  const safePrice = Number(product.price) || 0;

  if (existingProduct) {
    // Увеличиваем количество, все расчёты безопасно
    const oldQty = this.getLineItemQuantity(existingProduct);
    const newQty = oldQty + 1;
    this.redistributeTradeInOnQuantityChange(existingProduct, oldQty, newQty);
    this.$store.commit('updateProductQuantity', {
        orderId: this.$route.params.orderId,
        productId: product.id,
        quantity: newQty
      });
    } else {
      this.$store.commit('addProduct', {
        orderId: this.$route.params.orderId,
        product: {
          ...product,
          price: safePrice,
          originalPrice: safePrice,
          quantity: 1,
          displayPrice: safePrice,
          total: safePrice
        }
      });
    }
  // Vuex мутирует массив in-place — watcher products без deep не срабатывает
  this.scheduleKarvataStockFetch();
  }

,
calculateDiscountedPrice(product) {
  let discountedPrice = parseFloat(product.originalPrice) || 0;

  // Применение скидки в процентах и рублях
  if (product.discountPercent) {
    discountedPrice -= (discountedPrice * parseFloat(product.discountPercent)) / 100;
  }
  if (product.discountAmount) {
    discountedPrice -= parseFloat(product.discountAmount) || 0;
  }

  return parseFloat(Math.max(discountedPrice, 0).toFixed(2)); // чтоб  цена не была отрицательной, заепло бо в отрицаловку идти
},
               

    toggleSection() {
      this.sectionExpanded = !this.sectionExpanded;
    },
    // для обновления задач при сохранении
    fetchTasks() {
      console.log('t');
      this.fetchTasksByOrderId(this.$route.params.orderId);
    },
     
    async fetchTasksByOrderId(taskOrderId) {
      try {
        const response = await fetch(`https://manager.1akb.by/getTasksByOrderId?taskOrderId=${taskOrderId}`);

        if (!response.ok) {
          throw new Error(`Ошибка: ${response.statusText}`);
        }

        const tasks = await response.json();

        // Парсим performer, если он строка
        this.tasks = tasks.map(task => ({
          ...task,
          performer: typeof task.performer === "string" ? JSON.parse(task.performer) : task.performer
        }));

  

      } catch (error) {
        console.error("Ошибка при получении задач:", error);
        this.tasks = []; // В случае ошибки очищаем список задач
      }
    },

    isRetailEmptyValue(val) {
      if (val === null || val === undefined) return true;
      if (typeof val === 'string') return val.trim() === '';
      if (typeof val === 'boolean') return val === false;
      if (typeof val === 'number') return Number.isNaN(val);
      if (val instanceof Date) return isNaN(val.getTime());
      if (Array.isArray(val)) return val.length === 0;
      if (typeof val === 'object') {
        if (Object.prototype.hasOwnProperty.call(val, 'value') || Object.prototype.hasOwnProperty.call(val, 'label')) {
          const v = val.value;
          const l = val.label;
          return (v === null || v === undefined || v === '') && (l === null || l === undefined || String(l).trim() === '');
        }
        return Object.keys(val).length === 0;
      }
      return false;
    },

    serializeRetailDraftValue(val) {
      if (val instanceof Date) {
        return { __orderDraftDate: val.toISOString() };
      }
      return val;
    },

    deserializeRetailDraftValue(val) {
      if (val && typeof val === 'object' && val.__orderDraftDate) {
        const d = new Date(val.__orderDraftDate);
        return isNaN(d.getTime()) ? null : d;
      }
      return val;
    },

    getEmptyRetailDraftStorageKey(orderId) {
      return 'orderEmptyRetailDraft:' + String(orderId || '');
    },

    getRetailEmptyDraftExtraKeys() {
      return ['deliveryAddress', 'deliveryCost', 'timeFrom', 'timeTo', 'customTime', 'managerComment', 'vgvgvgv', 'weight', 'length', 'width', 'height'];
    },

    getRetailEmptyDraftExcludedFormKeys() {
      return {
        id: true,
        number: true,
        createdAt: true,
        data_izmeneniia: true,
        statusUpdatedAt: true,
        summ: true,
        moyskladUuid: true
      };
    },

    snapshotRetailEmptyFields() {
      const excluded = this.getRetailEmptyDraftExcludedFormKeys();
      const formDataSet = {};
      const formData = [];
      Object.keys(this.formData || {}).forEach((key) => {
        if (excluded[key]) return;
        if (this.isRetailEmptyValue(this.formData[key])) {
          formDataSet[key] = true;
          formData.push(key);
        }
      });
      const extraSet = {};
      this.getRetailEmptyDraftExtraKeys().forEach((key) => {
        if (this.isRetailEmptyValue(this[key])) extraSet[key] = true;
      });
      this._retailEmptyFieldKeys = { formData, formDataSet, extraSet };
    },

    collectEmptyRetailFieldDraft() {
      const orderId = String((this.$route.params && this.$route.params.orderId) || this.formData.id || '');
      const snapshot = this._retailEmptyFieldKeys;
      if (!orderId || !snapshot) return null;

      const formData = {};
      (snapshot.formData || []).forEach((key) => {
        if (!snapshot.formDataSet[key]) return;
        const current = this.formData[key];
        if (this.isRetailEmptyValue(current)) return;
        formData[key] = this.serializeRetailDraftValue(current);
      });

      const extra = {};
      this.getRetailEmptyDraftExtraKeys().forEach((key) => {
        if (!snapshot.extraSet[key]) return;
        const current = this[key];
        if (this.isRetailEmptyValue(current)) return;
        extra[key] = this.serializeRetailDraftValue(current);
      });

      if (!Object.keys(formData).length && !Object.keys(extra).length) return null;
      return { orderId, formData, extra, ts: Date.now() };
    },

    stashEmptyRetailFieldDraft() {
      try {
        const orderId = String((this.$route.params && this.$route.params.orderId) || '');
        if (!orderId) return;
        const key = this.getEmptyRetailDraftStorageKey(orderId);
        const draft = this.collectEmptyRetailFieldDraft();
        if (!draft) {
          sessionStorage.removeItem(key);
          const pending = sessionStorage.getItem('orderEmptyRetailDraftPending');
          if (pending === orderId) sessionStorage.removeItem('orderEmptyRetailDraftPending');
          return;
        }
        sessionStorage.setItem(key, JSON.stringify(draft));
        sessionStorage.setItem('orderEmptyRetailDraftPending', orderId);
      } catch (e) {
        console.warn('Не удалось сохранить заполненные пустые поля заказа:', e);
      }
    },

    clearEmptyRetailFieldDraft(orderId) {
      try {
        const id = String(orderId || (this.$route.params && this.$route.params.orderId) || '');
        this._pendingEmptyRetailDraft = null;
        if (!id) return;
        sessionStorage.removeItem(this.getEmptyRetailDraftStorageKey(id));
        const pending = sessionStorage.getItem('orderEmptyRetailDraftPending');
        if (pending === id) sessionStorage.removeItem('orderEmptyRetailDraftPending');
      } catch (e) {
        // ignore
      }
    },

    applyEmptyRetailFieldDraft() {
      try {
        const orderId = String((this.$route.params && this.$route.params.orderId) || '');
        if (!orderId) return;

        let draft = this._pendingEmptyRetailDraft;
        if (draft && String(draft.orderId) !== orderId) {
          this._pendingEmptyRetailDraft = null;
          draft = null;
        }

        const pending = sessionStorage.getItem('orderEmptyRetailDraftPending');
        if (!draft && pending === orderId) {
          const storageKey = this.getEmptyRetailDraftStorageKey(orderId);
          const raw = sessionStorage.getItem(storageKey);
          sessionStorage.removeItem('orderEmptyRetailDraftPending');
          sessionStorage.removeItem(storageKey);
          if (raw) draft = JSON.parse(raw);
        } else if (!draft && pending && pending !== orderId) {
          return;
        }

        if (!draft || String(draft.orderId) !== orderId) return;
        if (draft.ts && (Date.now() - draft.ts > 2 * 60 * 60 * 1000)) {
          this._pendingEmptyRetailDraft = null;
          return;
        }
        this._pendingEmptyRetailDraft = draft;

        Object.keys(draft.formData || {}).forEach((key) => {
          if (!this.isRetailEmptyValue(this.formData[key])) return;
          this.$set(this.formData, key, this.deserializeRetailDraftValue(draft.formData[key]));
        });
        Object.keys(draft.extra || {}).forEach((key) => {
          if (!this.isRetailEmptyValue(this[key])) return;
          this[key] = this.deserializeRetailDraftValue(draft.extra[key]);
        });

        if (this.formData.location_zabor && typeof this.loadLocationZaborFromOrder === 'function') {
          this.loadLocationZaborFromOrder(this.formData.location_zabor);
        }
      } catch (e) {
        console.warn('Не удалось восстановить поля после обновления заказа:', e);
      }
    },

    handleOrderConflictReload() {
      if (confirm('Заказ был изменен другим пользователем. Обновить страницу для загрузки актуальных данных? (Ваши несохраненные изменения будут потеряны)')) {
        this.stashEmptyRetailFieldDraft();
        location.reload();
      }
    },

  async fetchOrder(orderId, site) {
    try {
        // Устанавливаем флаг загрузки заказа, чтобы предотвратить зацикливание
        this.isLoadingOrder = true;
        this._loadOrderToken = (this._loadOrderToken || 0) + 1;
        const loadOrderToken = this._loadOrderToken;
        
        const response = await axios.get(`${ORDERS_API_BASE}/order.php?orderId=${orderId}&site=${site}`);
        const order = response.data.order;
        const shipmentDate = order.shipmentDate ? new Date(order.shipmentDate) : '';
        const deliveryDate = order.delivery && order.delivery.date ? new Date(order.delivery.date) : '';
        const sf_date = order.customFields && order.customFields.sf_date ? new Date(order.customFields.sf_date) : ''; 
        const datazakazaobrabotki = order.customFields && order.customFields.datazakazaobrabotki ? new Date(order.customFields.datazakazaobrabotki) : '';
        const dataSoglasovaniiaRaw = order.customFields && order.customFields.data_soglasovaniia1
          ? new Date(order.customFields.data_soglasovaniia1)
          : null;
        const dataSoglasovaniia = (dataSoglasovaniiaRaw && !isNaN(dataSoglasovaniiaRaw.getTime())) ? dataSoglasovaniiaRaw : null;
        
        console.log(order.customer.phones);

        Object.assign(this.formData, {
            id:order.id || '',
            country: this.getOptionObject(this.countries, order.delivery && order.delivery.address ? order.delivery.address.countryIso : ''),
            orderType: this.getOptionObject(this.orderTypes, order.orderType),
            manager: this.getOptionObject(this.managers, order.managerId),
            curier: this.getOptionObject(
                this.curiers,
                order.delivery && order.delivery.data ? order.delivery.data.courierId : ''
            ),
            site: this.getOptionObject(
              this.sites,
              (order.customFields && order.customFields.magazin_api && this.sites.some(s => String(s.value) === String(order.customFields.magazin_api)))
                ? order.customFields.magazin_api
                : order.site
            ),
            magazin:this.getOptionObject(this.sites, order.site),
            
            orderMethod: this.getOptionObject(this.orderMethods, order.orderMethod),
            sayt_zvonka: (() => {
              const raw = order.customFields && order.customFields.sayt_zvonka;
              if (raw == null || raw === '') return '';
              if (typeof raw === 'object' && raw.value != null) return String(raw.value);
              return String(raw);
            })(),

            // Блок клиента
            lastName: order && order.lastName ? order.lastName : '',
            statusComment: order && order.statusComment ? order.statusComment : '',
            statusUpdatedAt: order && order.statusUpdatedAt ? order.statusUpdatedAt : '',
            data_izmeneniia: order && order.customFields && order.customFields.data_izmeneniia ? order.customFields.data_izmeneniia : '',
            firstName: order && order.firstName ? order.firstName : '',
            phone: order && order.phone ? order.phone : '',
            patronymic: order && order.patronymic ? order.patronymic : '',
            email: order.customer && order.customer.email ? order.customer.email : '',
            additionalPhone: order && order.additionalPhone ? order.additionalPhone : '',
            bonus: order.customer && order.customFields.dfhgodsf8g7 ? order.customFields.dfhgodsf8g7 : '',
            email2: order.customer && order.customer.email2 ? order.customer.email2 : '',
            selectionLink: order.customFields && order.customFields.sssylkaaaaasssyyylka ? order.customFields.sssylkaaaaasssyyylka : '',
            customerComment: order.customerComment || '',
            carBrand:order.customFields && order.customFields.marka_podbor,
            carModel:order.customFields && order.customFields.model_podborts,
            carName:order.customFields && order.customFields.nazvats_podbor,
            carYear:order.customFields && order.customFields.godts_podbor,
            fuelType:order.customFields && order.customFields.toplivo_vid,
            carBodyType:order.customFields && order.customFields.tiprorpusa_ts_podbor,
            auto: [
              order.customFields && order.customFields.marka_podbor,
              order.customFields && order.customFields.model_podborts,
              order.customFields && order.customFields.nazvats_podbor,
              order.customFields && order.customFields.toplivo_vid,
              order.customFields && order.customFields.tiprorpusa_ts_podbor,
            ].filter(Boolean).join(' '),
            shipmentWithoutPayment: order.customFields && order.customFields.otgruzkabezoplata ? order.customFields.otgruzkabezoplata : '',
            ncorrectBonus: order.customFields && order.customFields.nekorrektnyi_bonus ? order.customFields.nekorrektnyi_bonus : '',
            discountCard: order.customFields && order.customFields.dsksajklsal ? order.customFields.dsksajklsal : '',
            // Другие поля
            managerComments: order.customFields && order.customFields.komentariimenedgera ? order.customFields.komentariimenedgera : '',
            visitor_code: order.customFields && order.customFields.visitor_code ? order.customFields.visitor_code : '',
            visitor_city: order.customFields && order.customFields.visitor_city ? order.customFields.visitor_city : '',
            personal_offer_discount: order.customFields && (order.customFields.personal_offer_discount != null && order.customFields.personal_offer_discount !== '')
              ? order.customFields.personal_offer_discount
              : '',
            forma_na_saite: order.customFields && order.customFields.forma_na_saite ? order.customFields.forma_na_saite : '',
            pomoshchIi: order.customFields && order.customFields.pomoshch_ii ? order.customFields.pomoshch_ii : '',
            tegi_dialoga: order.customFields && order.customFields.tegi_dialoga ? order.customFields.tegi_dialoga : '',
            wrongSelection: order.customFields && order.customFields.podbor_plox_sovsem || false,
            seller: this.getOptionObject(this.seller, order.customFields && order.customFields.prodavec),
            predoplata: this.getOptionObject(this.predoplata, order.customFields && order.customFields.predoplata_beznalichnymi_spravochnik),
            dostavka_bez_oplaty: this.getOptionObject(this.dostavka_bez_oplaty, order.customFields && order.customFields.dostavka_na_nash_magazin_tovara_bez_oplaty_priemka1),
            contragentTypes: this.getOptionObject(this.contragentTypes, order.contragent && order.contragent.contragentType),
            // Загружаем поля контрагента из contragent или из customFields (для обратной совместимости)
            contragentINN: (order.contragent && order.contragent.INN) ? order.contragent.INN : (order.customFields && order.customFields.contragentINN ? order.customFields.contragentINN : ''),
            contragentLegalName: (order.contragent && order.contragent.legalName) ? order.contragent.legalName : (order.customFields && order.customFields.contragentLegalName ? order.customFields.contragentLegalName : ''),
            contragentOKPO: (order.contragent && order.contragent.OKPO) ? order.contragent.OKPO : (order.customFields && order.customFields.contragentOKPO ? order.customFields.contragentOKPO : ''),
            contragentKPP: (order.contragent && order.contragent.KPP) ? order.contragent.KPP : (order.customFields && order.customFields.contragentKPP ? order.customFields.contragentKPP : ''),
            contragentOGRNIP: (order.contragent && order.contragent.OGRNIP) ? order.contragent.OGRNIP : (order.customFields && order.customFields.contragentOGRNIP ? order.customFields.contragentOGRNIP : ''),
            contragentLegalAddress: (order.contragent && order.contragent.legalAddress) ? order.contragent.legalAddress : (order.customFields && order.customFields.contragentLegalAddress ? order.customFields.contragentLegalAddress : ''),
            contragentOGRN: (order.contragent && order.contragent.OGRN) ? order.contragent.OGRN : (order.customFields && order.customFields.contragentOGRN ? order.customFields.contragentOGRN : ''),
            contragentCertificateNumber: (order.contragent && order.contragent.certificateNumber) ? order.contragent.certificateNumber : (order.customFields && order.customFields.contragentCertificateNumber ? order.customFields.contragentCertificateNumber : ''),
            contragentCertificateDate: (order.contragent && order.contragent.certificateDate) ? new Date(order.contragent.certificateDate) : (order.customFields && order.customFields.contragentCertificateDate ? new Date(order.customFields.contragentCertificateDate) : null),
            iuridicheskoe_naimenovanie: order.customFields && order.customFields.iuridicheskoe_naimenovanie ? order.customFields.iuridicheskoe_naimenovanie : '',

            ocenka_manageru: this.getOptionObject(this.ocenka_manageruList, order.customFields && order.customFields.ocenka_manageru1),
            ocenkaprodavcu: this.getOptionObject(this.ocenkaprodavcuList, order.customFields && order.customFields.ocenkaprodavcu),
            manager_new: this.getOptionObject(this.manager_new, order.customFields && order.customFields.manager),
            ocenochka_kureru: this.getOptionObject(this.ocenochka_kureruList, order.customFields && order.customFields.ocenochka_kureru),
            dgh66hhhhhhh: this.getOptionObject(this.dgh66hhhhhhhList, order.customFields && order.customFields.dgh66hhhhhhh),
            proverkazakazamenedgero: this.getOptionObject(this.proverkazakazamenedgeroList, order.customFields && order.customFields.proverkazakazamenedgero),
            obzvon_klienta: this.getOptionObject(this.obzvon_klientaList, order.customFields && order.customFields.obzvon_klienta),
            zvonok_text_bot: order.customFields && order.customFields.zvonok_text_bot ? order.customFields.zvonok_text_bot : '',

            datazakazaobrabotki: datazakazaobrabotki,
            dataSoglasovaniia: dataSoglasovaniia,
            sf_num: order.customFields && order.customFields.sf_num || '',

            tradeInAmount: order.customFields && order.customFields.dfgfdddf || '',
            tradeInAmountNew: order.customFields && order.customFields.dfgfdddfnew || '',
            invoiceDate: sf_date,
            createdAt: order.createdAt || '',
            number: order.number || '',
            summ: order.summ || '',
            moyskladUuid: order.customFields && order.customFields.moyskladexternalid ? order.customFields.moyskladexternalid : '',
            location_zabor: order.customFields && order.customFields.location_zabor
              ? order.customFields.location_zabor
              : (order.customFields && order.customFields.zakazattovar ? order.customFields.zakazattovar : ''),

            batteryCapacity: order.customFields && order.customFields.slksdkk2j3iu3n || '',
            registryNumber: order.customFields && order.customFields.lkjdhgdhg768 || '', 
            batteryCapacityNew: order.customFields && order.customFields.slksdkk2j3iu3nnew || '',
            marssh: order.customFields && order.customFields.marssh || '',
            vznos: order.customFields && order.customFields.vznos || '',
           
            link_oplata: order.customFields && order.customFields.otpravit_ssylku_na_oplatu || false,
            
            shipmentDate: shipmentDate,
            deliveryDate: deliveryDate
        });

        // Код клиента в инпут поиска — по умолчанию из сохранённого в заказе
        this.visitorLookupCode = this.formData.visitor_code
          ? String(this.formData.visitor_code).trim().toUpperCase()
          : '';

        Object.values(order.payments).forEach((item, index) => {
            const paymentType = this.paymentTypes.find(type => type.value === item.type);
            const paymentName = paymentType ? paymentType.label : 'Неизвестный способ';

            const paymentStatus = item.status || 'not-paid';
            const isPaid = (typeof paymentStatus === 'object'
              ? (paymentStatus.code || paymentStatus.value)
              : paymentStatus) === 'paid';
            const paymentDate = item.paidAt ? new Date(item.paidAt.replace(' ', 'T')) : null;

            if (this.payments[index]) {
                Vue.set(this.payments, index, {
                    amount: item.amount,
                    id: item.id,
                    type: item.type,
                    name: paymentName,
                    status: paymentStatus,
                    date: paymentDate,
                    comment: item.comment || '',
                    fixedAmount: isPaid
                });
            } else {
                this.payments.push({
                    amount: item.amount,
                    id: item.id,
                    type: item.type,
                    name: paymentName,
                    status: paymentStatus,
                    date: paymentDate,
                    comment: item.comment || '',
                    fixedAmount: isPaid
                });
            }
        });

        this.updateBonusAmount();

        // Инициализируем previousTradeInAmount после загрузки заказа
        this.previousTradeInAmount = Number(this.formData.tradeInAmountNew) || 0;

        // Загружаем разовую скидку из заказа
        // Проверяем разные возможные поля для скидки
        if (order.discount !== undefined && order.discount !== null) {
          this.oneTimeDiscountAmount = Number(order.discount) || 0;
        } else if (order.discountManualAmount !== undefined && order.discountManualAmount !== null) {
          this.oneTimeDiscountAmount = Number(order.discountManualAmount) || 0;
        } else {
          // Если скидка не найдена, оставляем текущее значение (не сбрасываем в 0)
          // this.oneTimeDiscountAmount остается как есть
        }

        // Поля для товаров
        const mappedProducts = await Promise.all(order.items.map(async (item) => {
          const manualProductDiscount = item.discounts.find(d => d.type === "manual_product");
          const discountAmount = manualProductDiscount ? (manualProductDiscount.amount / item.quantity) : 0;

          const productId = item.offer.externalId;
          const { imageUrl, brand, korpus, emkost, length, width, height, gtd } = await this.fetchProductImage(productId);

          return {
            id: productId,
            originalPrice: item.initialPrice || 0,
            discountAmount: discountAmount,
            status: item.status,
            discountPercent: item.discountPercent || 0,
          // В ответе RetailCRM для некоторых позиций одновременно заполнены и `offer.name`, и `offer.displayName`,
          // но они могут различаться. Чтобы в списке и в карточке показывался один и тот же товар —
          // приоритет делаем на `offer.name` (как в таблице OrderForm).
          name: item.offer.name || item.offer.displayName || 'Неизвестный товар',
            price: item.initialPrice || 0,
            quantity: item.quantity || 1,
            total: (item.prices && item.prices[0] ? item.prices[0].price : item.initialPrice || 0) * (item.quantity || 1),
            displayPrice: this.calculateDiscountedPrice({
              originalPrice: item.initialPrice || 0,
              discountAmount: discountAmount,
              discountPercent: item.discountPercent || 0,
            }),
            jpg_url: imageUrl,
            brand: brand,
            korpus: korpus || '',
            emkost: emkost || '',
            length: length || '',
            width: width || '',
            height: height || '',
            gtd: gtd || '',
          };
        }));



        // Очищаем текущие продукты и добавляем новые (с korpus и актуальными полями)
        this.$store.commit('clearProducts', this.$route.params.orderId);
        mappedProducts.forEach(product => {
            this.$store.commit('addProduct', {
              orderId: this.$route.params.orderId,
              product
            });
        });
        this.$nextTick(() => {
          this.updateCorpusMatchStatus();
        });

        const locationZabor = (order.customFields && order.customFields.location_zabor)
          || (order.customFields && order.customFields.zakazattovar)
          || '';
        this.loadLocationZaborFromOrder(locationZabor);
        this.scheduleKarvataStockFetch();

        // Проверяем наличие товаров-комплексов и устанавливаем соответствующий комплекс
        const complexProductIds = {
          '989773501': 'complex1', // Комплекс 1
          '989773505': 'complex2', // Комплекс 2
          '989773503': 'complex3'  // Комплекс 3
        };

        // Проверяем в mappedProducts (товарах заказа), есть ли товары-комплексы
        for (const product of mappedProducts) {
          if (complexProductIds[product.id]) {
            // Найден товар-комплекс - устанавливаем соответствующий комплекс
            this.formData.installationComplex = complexProductIds[product.id];
            break; // Используем первый найденный комплекс
          }
        }


        // Поля для доставки
        // sklad_api / magazin_api могут быть не кодами складов (иногда туда пишут адрес) — берём их только если код есть в справочнике
        const skladApi = order.customFields && order.customFields.sklad_api;
        const shipmentStoreCode = (skladApi && this.shipmentStores.some(s => String(s.value) === String(skladApi)))
          ? skladApi
          : order.shipmentStore;
        this.$set(this.formData, 'shipmentStore', this.getOptionObject(this.shipmentStores, shipmentStoreCode));
        this.$set(this.formData, 'deliveryTypes', this.getOptionObject(this.deliveryTypes, order.delivery && order.delivery.code));
        this.$set(this.formData, 'store', this.getOptionObject(this.shipmentStores, shipmentStoreCode));

        // Загружаем способ оплаты доставки/установки из customFields.
        // Важно: НЕ доначисляем скидки на товары при open/reload — снимок CRM уже содержит суммы.
        // Авто-дозаполнение скидки после load меняло grandTotal → автосейв → fetchOrder → бесконечный цикл.
        if (order.customFields && order.customFields.oplata_deliveri) {
          const oplataDeliveri = order.customFields.oplata_deliveri;
          if (oplataDeliveri === 'discount' || oplataDeliveri === 'client') {
            this.formData.deliveryPaidBy = oplataDeliveri;
          }
        }

        if (order.customFields && order.customFields.oplata_building) {
          const oplataBuilding = order.customFields.oplata_building;
          if (oplataBuilding === 'discount' || oplataBuilding === 'client') {
            this.formData.installationPaidBy = oplataBuilding;
          }
        }

        this.timeFrom = order.delivery && order.delivery.time && order.delivery.time.from || '';
        this.timeTo = order.delivery && order.delivery.time && order.delivery.time.to || '';

        this.managerComment = order.managerComment || '';

        this.customerInfo.firstName = order.customer && order.customer.firstName ? order.customer.firstName : '';
        this.customerInfo.id = order.customer && order.customer.id ? order.customer.id : '';

        this.vgvgvgv = order.customFields && order.customFields.vgvgvgv || '';
        this.wbOrderId = (order.customFields && order.customFields.wb_order_id)
          ? String(order.customFields.wb_order_id)
          : ((order.externalId || order.number || '').toString().indexOf('WB_') === 0
            ? String(order.externalId || order.number).replace(/^WB_/, '')
            : '');
        this.wbAssembled = false;
        this.wbDocs = null;
        if (this.wbOrderId || (order.orderMethod === 'wildberries') || (order.delivery && order.delivery.code === 'wb')) {
          this.$nextTick(() => this.loadWbDocs(false));
        }

        this.oplacheno_bonusami = order.customFields && order.customFields.oplacheno_bonusami || '';

        this.customerInfo.phone = (order && order.phone)
          || (order.customer && order.customer.phones && order.customer.phones[0] && order.customer.phones[0].number)
          || this.formData.phone
          || '';

        // История по телефону: в CRM один номер часто разбит на несколько customerId
        if (this.customerInfo.id || this.customerInfo.phone || this.formData.phone) {
          this.fetchCustomerOrders(this.customerInfo.id, this.customerInfo.phone || this.formData.phone);
        } else {
          this.activeOrders = [];
          this.previousOrders = [];
          this.activeCount = 0;
          this.previousCount = 0;
        }
        
        this.deliveryCost = order.delivery && order.delivery.cost || '';
        //this.deliveryAddress = order.delivery && order.delivery.address ? order.delivery.address.text : '';
        this.formData.deliverybuilding = order.delivery && order.delivery.address.building ? order.delivery.address.building : '';
        this.formData.flat =
  order.delivery &&
  order.delivery.address &&
  typeof order.delivery.address.flat === 'string'
    ? order.delivery.address.flat
    : '';
        this.formData.floor = order.delivery && order.delivery.address.floor ? order.delivery.address.floor : '';
        this.formData.block = order.delivery && order.delivery.address.block ? order.delivery.address.block : '';
        this.formData.house = order.delivery && order.delivery.address.house ? order.delivery.address.house : '';
        this.formData.housing = order.delivery && order.delivery.address.housing ? order.delivery.address.housing : '';

        // Устанавливаем адрес
      const address = order.delivery && order.delivery.address;

this.loadAddressByName(
  address && address.region ? address.region : null,
  address && address.city ? address.city : null,
  address && address.street ? address.street : null,
  address && address.regionId ? address.regionId : null,
  address && address.cityId ? address.cityId : null,
  address && address.streetId ? address.streetId : null
);

        // Загружаем популярные аккумуляторы, если есть ссылка на подбор
        if (this.formData.selectionLink) {
          this.getPopularBatteries();
          // Проверяем стоимость установки после небольшой задержки, чтобы данные точно установились
          setTimeout(() => {
            this.checkInstallationPrice();
          }, 100);
        }

        // История страниц / просмотренные АКБ (vision_site + legacy jsdhjlkshdlk99 + комментарий)
        const visionSite = (order.customFields && order.customFields.vision_site)
          ? String(order.customFields.vision_site)
          : '';
        const legacyPages = (order.customFields && order.customFields.jsdhjlkshdlk99)
          ? String(order.customFields.jsdhjlkshdlk99)
          : '';
        this.pageHistoryCustomField = visionSite || legacyPages;
        this.loadVisitedProductsFromHistory(
          this.formData.customerComment,
          this.pageHistoryCustomField
        );

        this.snapshotRetailEmptyFields();
        this.applyEmptyRetailFieldDraft();
        
        // Пересчитываем разницу по ёмкости аккумулятора после загрузки заказа
        // Сбрасываем previousCapacityDiscount, чтобы при первом изменении ёмкости не вычиталась старая скидка
        this.previousCapacityDiscount = 0;
        // Сбрасываем разницу и вес, чтобы они пересчитались при изменении ёмкости
        this.capacityWeightDifference = 0;
        this.capacityWeightKg = 0;
        
    } catch (error) {
        console.error('Ошибка при получении заказа:', error);
        this.visitedProducts = [];
        this.visitedPages = [];
        this.pageHistoryCustomField = '';
    } finally {
        // Держим isLoadingOrder ещё тик, чтобы watchers grandTotal/products
        // не реагировали на промежуточные значения после clear/add products
        const tokenAtEnd = this._loadOrderToken;
        this.$nextTick(() => {
          setTimeout(() => {
            // Игнор устаревший finally, если стартовал новый fetchOrder
            if (tokenAtEnd !== this._loadOrderToken) return;
            this.isFirstGrandTotalCall = true;
            this.isLoadingOrder = false;
          }, 400);
        });
    }
},

async fetchProductImage(productId) {
  try {
    const response = await axios.get(`${ORDERS_API_BASE}/productimage.php?id=${productId}`);
    return {
      imageUrl: response.data.image || '',
      brand: response.data.brand || '',
      korpus: response.data.korpus || '',
      emkost: response.data.emkost || '',
      length: response.data.length || '',
      width: response.data.width || '',
      height: response.data.height || '',
      gtd: response.data.gtd || '',
    };
  } catch (error) {
    console.error(`Не удалось загрузить картинку для товара ${productId}:`, error);
    return {
      imageUrl: '',
      brand: '',
      korpus: '',
      emkost: '',
      length: '',
      width: '',
      height: '',
      gtd: '',
    };
  }
},

normalizeCorpusTokens(raw) {
  const text = String(raw || '').trim();
  if (!text) return [];
  // 55B24 / 65D23 → B24 / D23 (только префикс ёмкости; D23 и B24 — разные размеры)
  const cleaned = text.replace(/\b\d{2,3}(?=[A-Za-zА-Яа-я])/g, '');
  const tokens = cleaned.split(/[,;/\s|]+/).map((s) => s.trim().toUpperCase()).filter(Boolean);
  const out = [...tokens];
  const addAlias = (a, b) => {
    if (tokens.includes(a) && !out.includes(b)) out.push(b);
    if (tokens.includes(b) && !out.includes(a)) out.push(a);
  };
  // Только DIN/EN синонимы одного размера. НЕ смешивать JIS D23 и B24.
  addAlias('L4', 'LB4');
  addAlias('L3', 'LB3');
  addAlias('L2', 'LB2');
  addAlias('L5', 'LB5');
  addAlias('L1', 'LB1');
  addAlias('L0', 'LB0');
  addAlias('L2', 'LN2');
  addAlias('L3', 'LN3');
  addAlias('L4', 'LN4');
  addAlias('L5', 'LN5');
  addAlias('L1', 'LN1');
  addAlias('L0', 'LN0');
  addAlias('LB2', 'LN2');
  addAlias('LB3', 'LN3');
  addAlias('LB4', 'LN4');
  addAlias('LB5', 'LN5');
  return out;
},

isBatteryProductForCorpusCheck(product) {
  if (!product || !product.id) return false;
  const DELIVERY_PRODUCT_ID = '989773504';
  const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
  if (String(product.id) === DELIVERY_PRODUCT_ID || COMPLEX_PRODUCT_IDS.includes(String(product.id))) {
    return false;
  }
  const name = String(product.name || '').trim();
  if (!name || /^(доставка|комплекс\s)/iu.test(name)) return false;
  return true;
},

async ensureProductsHaveKorpus(products) {
  const list = (products || []).filter((p) => {
    if (!this.isBatteryProductForCorpusCheck(p)) return false;
    const missingKorpus = !String(p.korpus || '').trim();
    const missingEmkost = !String(p.emkost || '').trim();
    return missingKorpus || missingEmkost;
  });
  if (!list.length) return;
  await Promise.all(list.map(async (product) => {
    try {
      const info = await this.fetchProductImage(product.id);
      if (!info) return;
      if (info.korpus) this.$set(product, 'korpus', info.korpus);
      if (info.emkost) this.$set(product, 'emkost', info.emkost);
      if (info.length) this.$set(product, 'length', info.length);
      if (info.width) this.$set(product, 'width', info.width);
      if (info.height) this.$set(product, 'height', info.height);
      if (info.brand && !product.brand) this.$set(product, 'brand', info.brand);
      if (info.gtd && !product.gtd) this.$set(product, 'gtd', info.gtd);
    } catch (e) {
      // ignore
    }
  }));
},

async updateCorpusMatchStatus() {
  const seq = ++this.corpusMatchUpdateSeq;
  const carTokens = this.normalizeCorpusTokens(this.formData && this.formData.carBodyType);
  if (!carTokens.length) {
    if (seq === this.corpusMatchUpdateSeq) this.corpusMatchStatusData = null;
    this.scheduleAiFitCheck();
    return;
  }

  const candidates = (this.products || []).filter((p) => this.isBatteryProductForCorpusCheck(p));
  if (!candidates.length) {
    if (seq === this.corpusMatchUpdateSeq) this.corpusMatchStatusData = null;
    this.scheduleAiFitCheck();
    return;
  }

  await this.ensureProductsHaveKorpus(candidates);
  if (seq !== this.corpusMatchUpdateSeq) return;

  const batteries = candidates.filter((p) => String(p.korpus || '').trim());
  if (!batteries.length) {
    this.corpusMatchStatusData = null;
    this.scheduleAiFitCheck();
    return;
  }

  const allMatch = batteries.every((p) => {
    const productTokens = this.normalizeCorpusTokens(p.korpus);
    return productTokens.some((t) => carTokens.includes(t));
  });

  this.corpusMatchStatusData = allMatch
    ? { ok: true, text: 'АКБ соответствует типу авто' }
    : { ok: false, text: 'АКБ не соответствует авто, уточните' };

  this.scheduleAiFitCheck();
},

aiFitFingerprint() {
  const v = this.vehicleContextForAi || {};
  const vehicleKey = [
    v.carBrand, v.carModel, v.carName, v.carYear, v.fuelType, v.carBodyType, v.auto,
  ].map((x) => String(x || '').trim().toLowerCase()).join('|');
  const batteries = (this.products || [])
    .filter((p) => this.isBatteryProductForCorpusCheck(p))
    .map((p) => [
      p.id,
      p.name,
      p.korpus,
      p.emkost,
      p.length,
      p.width,
      p.height,
    ].map((x) => String(x || '').trim().toLowerCase()).join(':'))
    .sort()
    .join(';');
  return `${vehicleKey}::${batteries}`;
},

scheduleAiFitCheck() {
  // Автопроверка ОТКЛЮЧЕНА: gpt-4o + web_search/drive2 жрёт бюджет на каждом заказе.
  if (this.aiFitDebounceTimer) {
    clearTimeout(this.aiFitDebounceTimer);
    this.aiFitDebounceTimer = null;
  }
  this.aiFitStatusData = null;
  this.aiFitLastKey = '';
},

async updateAiFitStatus() {
  // Автопроверка ОТКЛЮЧЕНА вместе с scheduleAiFitCheck.
  this.aiFitStatusData = null;
},
async fetchOrderStatuses(orderIds = [], externalOrderIds = []) {
  const validOrderIds = orderIds.filter(id => Number.isInteger(id));
  const validExternalOrderIds = externalOrderIds.map(String);

  if (validOrderIds.length === 0 && validExternalOrderIds.length === 0) {
    console.error('Ошибка: Не указаны корректные идентификаторы заказов.');
    return [];
  }

  try {
    const response = await axios.get(ORDERS_API_BASE + '/order_statuses.php', {
      params: {
        'ids[]': validOrderIds,
        'externalIds[]': validExternalOrderIds,
      },
    });

    if (response.data.success) {
      
  const orders = response.data.orders || [];
  const order = orders.length ? orders[orders.length - 1] : null;


  this.orderStatusFetch = order ? order.status : null;
  const orderStatus = order ? order.status : null;
  const orderGroup = order ? order.group : null;

  // Сначала по group из API; если group пустой (own DB) — ищем статус по коду во всех группах
  let group = orderGroup
    ? this.statusGroupsOrder.find(g => g.group === orderGroup)
    : null;
  let option = group
    ? group.options.find(o => o.value === orderStatus)
    : null;
  if (!option && orderStatus) {
    for (const g of this.statusGroupsOrder) {
      const found = (g.options || []).find(o => String(o.value) === String(orderStatus));
      if (found) {
        group = g;
        option = found;
        break;
      }
    }
  }

  if (option && group) {
    this.selectedStatusOrder = {
      value: option.value,
      label: option.label,
      color: group.color,
      class: group.group,
    };
  }
  return response.data.orders;
} else {
      console.error('Error fetching order statuses:', response.data.error);
      return [];
    }
  } catch (error) {
    console.error('Error during request:', error.message);
    return [];
  }
},



/** Нормализация названия адреса для сравнения (ул./г./область и т.п.) */
normalizeAddressName(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/ё/g, 'е')
    .replace(/[«»"'.,]/g, ' ')
    .replace(/\b(ул|улица|пр-т|проспект|пер|переулок|бул|бульвар|пл|площадь|ш|шоссе|тракт|г|город|аг|п|пос|поселок|р-н|район|обл|область)\b/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
},

/** Запасной разбор «Город, Улица 10» если геокодер не вернул улицу */
guessStreetAndHouseFromText(fullAddress, cityLabel) {
  let text = String(fullAddress || '').trim();
  if (!text) return { street: '', house: '' };
  if (cityLabel) {
    const cityRe = new RegExp('^\\s*(г\\.?\\s*)?' + cityLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*[,\\s]+', 'i');
    text = text.replace(cityRe, '');
  }
  text = text.replace(/^\s*(беларусь|рб)\s*[,.]?\s*/i, '').trim();
  const m = text.match(/^(.+?)[\s,]+(\d+[а-яa-z/\-]*)\s*$/i);
  if (m) {
    return {
      street: m[1].replace(/^(ул\.?|улица)\s+/i, '').trim(),
      house: m[2].trim()
    };
  }
  if (text && !/^\d+$/.test(text)) {
    return { street: text.replace(/^(ул\.?|улица)\s+/i, '').trim(), house: '' };
  }
  return { street: '', house: '' };
},

addressNamesMatch(a, b) {
  const na = this.normalizeAddressName(a);
  const nb = this.normalizeAddressName(b);
  if (!na || !nb) return false;
  return na === nb || na.includes(nb) || nb.includes(na);
},

pickBestAddressMatch(items, queryLabel, getLabel) {
  if (!items || !items.length || !queryLabel) return null;
  const normalizedQuery = this.normalizeAddressName(queryLabel);
  let exact = null;
  let partial = null;
  for (const item of items) {
    const label = getLabel(item);
    const normalizedLabel = this.normalizeAddressName(label);
    if (normalizedLabel === normalizedQuery) {
      exact = item;
      break;
    }
    if (!partial && (normalizedLabel.includes(normalizedQuery) || normalizedQuery.includes(normalizedLabel))) {
      partial = item;
    }
  }
  return exact || partial || null;
},

// Поиск региона по названию
async findRegionByName(regionName) {
  try {
    const searchName = this.normalizeAddressName(regionName) || regionName;
    const response = await axios.get(`https://geohelper.info/api/v1/regions`, {
      params: {
        apiKey: this.apiKey,
        'locale[lang]': 'ru',
        'filter[countryIso]': 'BY',
        'filter[name]': searchName,
        'pagination[limit]': 20
      }
    });

    if (response.data.success) {
      const regions = response.data.result.map(region => ({
        label: region.name,
        value: region.id
      }));
      const best = this.pickBestAddressMatch(regions, regionName, r => r.label);
      return best || regions[0] || null;
    }
    console.error('Ошибка при поиске региона:', response.data.error && response.data.error.message);
    return null;
  } catch (error) {
    console.error("Ошибка при поиске региона:", error);
    return null;
  }
},

mapGeoCity(city) {
  const typeShort = city.localityType
    && city.localityType.localizedNamesShort
    && city.localityType.localizedNamesShort.ru
    ? city.localityType.localizedNamesShort.ru
    : '';
  const region = (this.regions || []).find(r => String(r.value) === String(city.regionId));
  const regionName = region ? region.label : '';
  const area = city.area || '';
  const base = `${typeShort ? typeShort + ' ' : ''}${city.name}`.trim();
  const details = [area, regionName].filter(Boolean).join(', ');
  return {
    label: details ? `${base} (${details})` : base,
    value: city.id,
    rawName: city.name,
    area,
    regionId: city.regionId || null,
  };
},

async ensureBelarusRegionsLoaded() {
  if (this.regions && this.regions.length) return;
  try {
    const response = await axios.get(`https://geohelper.info/api/v1/regions`, {
      params: {
        apiKey: this.apiKey,
        'locale[lang]': 'ru',
        'filter[countryIso]': 'BY',
      }
    });
    if (response.data && response.data.success) {
      this.regions = response.data.result.map(region => ({
        label: region.name,
        value: region.id
      }));
    }
  } catch (e) { /* ignore */ }
},

async findRegionById(regionId) {
  if (!regionId) return null;
  await this.ensureBelarusRegionsLoaded();
  return (this.regions || []).find(r => String(r.value) === String(regionId)) || null;
},

// Все города BY по названию (для неоднозначных «Красное»)
async findCitiesByName(cityName, regionId, options = {}) {
  const empty = [];
  if (!cityName) return empty;
  try {
    await this.ensureBelarusRegionsLoaded();
    const searchName = this.stripLocalityType(cityName) || this.normalizeAddressName(cityName) || cityName;
    const params = {
      apiKey: this.apiKey,
      'locale[lang]': 'ru',
      'filter[countryIso]': 'BY',
      'filter[name]': searchName,
      'pagination[limit]': 50
    };
    if (regionId) {
      params['filter[regionId]'] = regionId;
    }
    const response = await axios.get(`https://geohelper.info/api/v1/cities`, { params });
    if (!response.data.success) {
      console.error('Ошибка при поиске города:', response.data.error && response.data.error.message);
      return empty;
    }
    let cities = (response.data.result || []).map(c => this.mapGeoCity(c));
    // Точнее: оставляем совпадение по нормализованному имени
    const queryNorm = this.normalizeAddressName(searchName);
    cities = cities.filter(c => {
      const n = this.normalizeAddressName(c.rawName || c.label);
      return n === queryNorm || n.includes(queryNorm) || queryNorm.includes(n);
    });
    const areaLabel = options && options.areaLabel ? options.areaLabel : '';
    if (areaLabel) {
      const areaNorm = this.normalizeAddressName(areaLabel)
        .replace(/\b(район|сельсовет|сельский совет|р-н)\b/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      const byArea = cities.filter(c => {
        const a = this.normalizeAddressName(c.area || '');
        return a && areaNorm && (a.includes(areaNorm) || areaNorm.includes(a));
      });
      if (byArea.length) return byArea;
    }
    return cities;
  } catch (error) {
    console.error('Ошибка при поиске города:', error);
    return empty;
  }
},

// Поиск города по названию (один лучший)
async findCityByName(cityName, regionId) {
  const cities = await this.findCitiesByName(cityName, regionId);
  if (!cities.length) return null;
  const best = this.pickBestAddressMatch(cities, this.stripLocalityType(cityName) || cityName, c => c.rawName || c.label);
  return best || cities[0] || null;
},

mapGeoStreet(street) {
  const typeShort = street.localityType && street.localityType.localizedNamesShort
    ? street.localityType.localizedNamesShort.ru
    : 'ул.';
  return {
    label: `${typeShort} ${street.name}`,
    value: street.id,
    rawName: street.name
  };
},

async loadStreetsForCity(cityId) {
  if (!cityId) return;
  try {
    const response = await axios.get(`https://geohelper.info/api/v1/streets`, {
      params: {
        apiKey: this.apiKey,
        'locale[lang]': 'ru',
        'filter[cityId]': cityId,
        'pagination[limit]': 50
      }
    });
    if (response.data.success) {
      this.streets = response.data.result.map(this.mapGeoStreet);
    }
  } catch (error) {
    console.error('Ошибка загрузки улиц города:', error);
  }
},

async searchStreetsByName(streetName, cityId) {
  const empty = { match: null, suggestions: [] };
  if (!streetName || !cityId) return empty;
  try {
    const searchName = this.normalizeAddressName(streetName) || streetName;
    const response = await axios.get(`https://geohelper.info/api/v1/streets`, {
      params: {
        apiKey: this.apiKey,
        'locale[lang]': 'ru',
        'filter[cityId]': cityId,
        'filter[name]': searchName,
        'pagination[limit]': 20
      }
    });
    if (!response.data.success) {
      return empty;
    }
    const suggestions = response.data.result.map(this.mapGeoStreet);
    const match = this.pickBestAddressMatch(suggestions, streetName, s => s.rawName || s.label);
    return {
      match: match ? { label: match.label, value: match.value } : null,
      suggestions: suggestions.map(s => ({ label: s.label, value: s.value }))
    };
  } catch (error) {
    console.error('Ошибка поиска улиц:', error);
    return empty;
  }
},

async loadStreetSuggestionsForCurrentCity(streetName) {
  const cityId = this.formData.deliverycity && this.formData.deliverycity.value
    ? this.formData.deliverycity.value
    : null;
  if (!cityId || !streetName) {
    this.streetSuggestions = [];
    return;
  }
  const result = await this.searchStreetsByName(streetName, cityId);
  this.streetSuggestions = (result.suggestions || []).slice(0, 8);
  if (result.match && this.normalizeAddressName(result.match.label) === this.normalizeAddressName(streetName)) {
    this.selectStreetSuggestion(result.match);
  }
},

// Поиск улицы по названию
async findStreetByName(streetName, cityId) {
  const result = await this.searchStreetsByName(streetName, cityId);
  return result.match;
},


async loadAddressByName(regionName, cityName, streetName, regionId, cityId, streetId) {
  try {
    // Установка региона
    if ((regionName && regionName.trim() !== "") || regionId) {

      if (regionId) {
        // Поиск по regionId
        const region = await this.findRegionByName(regionName);
        if (region) {
          this.$set(this.formData, 'deliveryregion', region);
        } else {
          console.warn(`Регион с названием "${regionName}" не найден`);
          this.$set(this.formData, 'deliveryregion', { label: regionName || "", value: null });
        }
      } else {
        this.$set(this.formData, 'deliveryregion', { label: regionName.trim(), value: null });
      }
    }

    // Установка города
    if ((cityName && cityName.trim() !== "") || cityId) {
      if (cityId) {
        // Поиск по cityId
        const city = await this.findCityByName(cityName, regionId);
        if (city) {
          this.$set(this.formData, 'deliverycity', city);
        } else {
          console.warn(`Город с названием "${cityName}" не найден`);
          this.$set(this.formData, 'deliverycity', { label: cityName || "", value: null });
        }
      } else {
        this.$set(this.formData, 'deliverycity', { label: cityName.trim(), value: null });
      }
    }

    // Установка улицы
    if ((streetName && streetName.trim() !== "") || streetId) {
      if (streetId) {
        // Поиск по streetId
        const street = await this.findStreetByName(streetName, cityId);
        if (street) {
          this.$set(this.formData, 'deliverystreet', street);
        } else {
          console.warn(`Улица с названием "${streetName}" не найдена`);
          this.$set(this.formData, 'deliverystreet', { label: streetName || "", value: null });
        }
      } else {
        this.$set(this.formData, 'deliverystreet', { label: streetName.trim(), value: null });
      }
    }
  } catch (error) {
    console.error('Ошибка при загрузке данных адреса:', error);
  }
}
,

updateTradeInAmount() {
    const input = this.formData.batteryCapacityNew || '';
    const trimmedInput = input.trim();
    
    // Если поле пустое или только пробелы, устанавливаем costByCapacity = 0
    if (!trimmedInput) {
      // Синхронизируем previousTradeInAmount перед установкой нового значения
      // Watcher сам уберет скидку из товара
      this.previousTradeInAmount = Number(this.formData.tradeInAmountNew) || 0;
      this.formData.tradeInAmountNew = '0.00';
      this.capacityWeightDifference = 0;
      this.capacityWeightKg = 0;
      this.previousCapacityDiscount = 0;
      this.$forceUpdate();
      return;
    }
    
    const numbers = trimmedInput
      .split('+')
      .map(str => parseFloat(str.trim()))
      .filter(num => !isNaN(num) && num > 0);

    const total = numbers.reduce((sum, n) => sum + n, 0);
    
    // Стоимость по ёмкости
    const costByCapacity = parseFloat((total * 0.30).toFixed(2));
    
    // Синхронизируем previousTradeInAmount ПЕРЕД установкой нового значения
    // чтобы watcher правильно вычислил разницу
    this.previousTradeInAmount = Number(this.formData.tradeInAmountNew) || 0;
    
    this.formData.tradeInAmountNew = costByCapacity.toFixed(2);
    
    // Если total === 0 (введен 0 или пустое), убираем скидку и выходим
    if (total === 0 || costByCapacity === 0) {
      // previousTradeInAmount уже синхронизирован выше
      // Watcher сам уберет скидку из товара
      this.capacityWeightDifference = 0;
      this.capacityWeightKg = 0;
      this.previousCapacityDiscount = 0;
      this.$forceUpdate();
      return;
    }
    
    // Стоимость по весу
    let totalWeightKg = 0;
    numbers.forEach(capacity => {
      if (this.capacityToWeight[capacity]) {
        // Переводим тонны в килограммы
        totalWeightKg += this.capacityToWeight[capacity] * 1000;
      }
    });
    
    const costByWeight = parseFloat((totalWeightKg * this.pricePerKg).toFixed(2));
    
    // Разница: стоимость по весу минус стоимость по ёмкости
    const currentDifference = parseFloat((costByWeight - costByCapacity).toFixed(2));
    
    const DELIVERY_PRODUCT_ID = '989773504';
    
    // Получаем товары правильно (из store или локального массива)
    const products = this.$route.params.orderId 
      ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
      : this.products;
    
    // Сохраняем текущую скидку за емкость для следующего пересчёта
    // Применение скидки к товару теперь происходит через watcher для tradeInAmountNew
    this.previousCapacityDiscount = costByCapacity > 0 ? costByCapacity : 0;
    
    // Принудительно обновляем Vue для пересчета отображения
    this.$forceUpdate();
    
    // Сохраняем разницу и вес для передачи в customFields
    this.capacityWeightDifference = currentDifference > 0 ? parseFloat(currentDifference.toFixed(2)) : 0;
    this.capacityWeightKg = parseFloat(totalWeightKg.toFixed(2));
  },
  addCapacity(value) {
    if (this.formData.batteryCapacityNew.trim() === '') {
      this.formData.batteryCapacityNew = String(value);
    } else {
      this.formData.batteryCapacityNew += '+' + value;
    }
    this.updateTradeInAmount(); // сразу пересчитываем
  },
  clearCapacity() {
    this.formData.batteryCapacityNew = '';
    this.updateTradeInAmount(); // сразу пересчитываем
  },

async fetchCustomerOrders(customerId, customerPhone) {
    const phone = (customerPhone || this.formData.phone || this.customerInfo.phone || '').trim();
    if (!customerId && !phone) return;
    this.isLoadingCustomerOrders = true;
    try {
      const payload = {};
      // Телефон приоритетнее: собирает заказы со всех карточек клиента с этим номером
      if (phone) payload.customerPhone = phone;
      else payload.customerId = customerId;

      const response = await axios.post(ORDERS_API_BASE + '/getustomerOrder.php', payload);

      if (response.data.success) {
        const currentId = String(this.$route.params.orderId || this.formData.id || '');
        const active = this.processOrders(response.data.activeOrders || []);
        const previous = this.processOrders(response.data.previousOrders || []);

        // Текущий заказ не дублируем в истории
        this.activeOrders = active.filter(o => String(o.id) !== currentId);
        this.previousOrders = previous.filter(o => String(o.id) !== currentId);
        this.activeCount = this.activeOrders.length;
        this.previousCount = this.previousOrders.length;
      } else {
        this.activeOrders = [];
        this.previousOrders = [];
        this.activeCount = 0;
        this.previousCount = 0;
        console.error('Ошибка при получении заказов:', response.data.message || response.data.error);
      }
    } catch (error) {
      console.error('Ошибка запроса заказов:', error);
    } finally {
      this.isLoadingCustomerOrders = false;
    }
  },

  async fetchCustomerDouble(customerPhone) {
    try {
      //const defaultStatusGroups = ['new-group', 'delivery-group', 'approval-group'];
      
      // Отправка запроса на сервер
      const response = await axios.post(ORDERS_API_BASE + '/customerPhone.php', { customerPhone});

      if (response.data.success) {
        console.log(response.data);
        this.doubleArray = response.data;
        
        
        this.countDouble = response.data.count;
        
        if(this.countDouble > 0) {
          this.countDouble = response.data.count - 1;
        }

      } else {
        console.error('Ошибка при получении заказов:', response.data.message);
      }
    } catch (error) {
      console.error('Ошибка запроса заказов:', error);
    }
  },

  openDoubleHistory(doubleArray){
    this.showDoubleModal = true;
  },

  processOrders(orders) {
      if (!Array.isArray(orders)) return [];
      return orders.map(order => {
        const address = order.delivery && order.delivery.address ? order.delivery.address : null;
        const deliveryAddress = address
          ? (address.text || [address.city, address.street, address.building || address.house].filter(Boolean).join(', '))
          : '';
        const items = Array.isArray(order.items) ? order.items : [];
        return {
          id: order.id,
          slug: order.slug || order.id,
          number: order.number,
          createdAt: order.createdAt,
          status: order.status,
          deliveryAddress,
          items: items.map(item => {
            let price = 0;
            if (item.prices && item.prices[0] && item.prices[0].price != null) {
              price = item.prices[0].price;
            } else if (item.initialPrice != null) {
              price = item.initialPrice;
            }
            return {
              id: item.id,
              quantity: item.quantity,
              offer: item.offer || {},
              initialPrice: price,
            };
          }),
          totalSumm: order.totalSumm,
        };
      });
    },

  formatCustomerOrderDate(dat) {
    if (!dat) return '—';
    try {
      return this.getCurentDates(String(dat));
    } catch (e) {
      return String(dat);
    }
  },

  formatMoney(value) {
    const num = Number(value);
    if (!Number.isFinite(num)) return value == null ? '0' : String(value);
    return num.toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  },

  orderEditUrl(order) {
    if (!order) return '#';
    if (order.slug) return `https://1akb.retailcrm.ru/orders/${order.slug}/edit`;
    return `https://manager.1akb.by/edit/${order.id}`;
  },

  showCustomerModal() {
    this.isModalCustomerVisible = true;
    if (
      (this.customerInfo.id || this.formData.phone || this.customerInfo.phone)
      && !this.activeOrders.length
      && !this.previousOrders.length
      && !this.isLoadingCustomerOrders
    ) {
      this.fetchCustomerOrders(this.customerInfo.id, this.formData.phone || this.customerInfo.phone);
    }
  },
  closeCustomerModal() {
    this.isModalCustomerVisible = false;
  },

// Функция для поиска объекта по значению и возврата объекта с label и value
getOptionObject(optionsArray, id) {
    const option = optionsArray.find(option => String(option.value) === String(id));
    return option ? { label: option.label, value: option.value } : null;
},

  // Функция для поиска соответствующего label по value
  getLabelFromOptions(optionsArray, value) {
  const foundOption = optionsArray.find(option => String(option.value) === String(value)); // Приводим к строкам для корректного сравнения
  return foundOption ? foundOption.label : '';
},
getLabelFromOption(optionsArray, value) {
  return optionsArray.find(option => String(option.value) === String(value)) || null;
},
    saveOrder() {
      // Логика сохранения заказа
      console.log('Сохранение заказа', this.formData);
    },
    // Открытие модального окна и начало загрузки данных
                openAnalogModal(product) {

                  console.log(product.korpus); 
                  this.selectedKorpusType = product.korpus; 

                  this.isAnalogModalVisible = true; // открываем модальное окно
                  

                },
    // Открытие модального окна и начало загрузки данных
                openModal() {
                  this.productModalSearchQuery = '';
                  this.isModalVisible = true;
                  

                  // Выполняем AJAX запрос на получение товаров
                  axios
                    .get('https://1akb.by.by/manager/api/modalproduct.php')
                    .then(response => {
                      this.availableProducts = response.data;
                      this.loading = false;
                    })
                    .catch(error => {
                      console.error('Ошибка при загрузке товаров:', error);
                      this.loading = false;
                    });
                },
                openModalWithQuery(query) {
                  this.productModalSearchQuery = query || '';
                  this.isModalVisible = true;
                },
                getProductQuantityById(productId) {
                  const list = this.products || [];
                  const found = list.find((p) => String(p.id) === String(productId));
                  return found ? (Number(found.quantity) || 0) : 0;
                },
                // Закрытие модального окна
                closeModal() {
                  this.isModalVisible = false;
                  this.isAnalogModalVisible = false;
                  this.productModalSearchQuery = '';
                },
                closeModalStatus() {
                  this.isModalStatusVisible = false;
                  this.statusComment = ""; // Очищаем комментарий
                  this.statusModalAgreementDate = null; // не трогаем formData / CRM
                  if (this.errors) this.errors.dataSoglasovaniia = null;
                },

                openModalMS() {
                  this.isModalMSVisible = true;
                  

                  // Выполняем AJAX запрос на получение товаров
                  axios
                    .get(ORDERS_API_BASE + '/msproduct.php')
                    .then(response => {
                      this.availableProducts = response.data;
                      this.loading = false;
                    })
                    .catch(error => {
                      console.error('Ошибка при загрузке товаров:', error);
                      this.loading = false;
                    });
                },
                // Закрытие модального окна
                closeModalMS() {
                  this.isModalMSVisible = false;
                  this.isAnalogModalVisible = false;
                },
                
                 // Метод для добавления или обновления количества товара
  
   // Функция для удаления товара из заказа
  removeProduct(productId) {
   this.$store.commit('removeProduct', {
  orderId: this.$route.params.orderId,
  productId: productId // ✅ правильно
});
  this.scheduleKarvataStockFetch();
  
  // Проверяем, остались ли товары (кроме доставки и комплексов) после удаления
  // Используем $nextTick, чтобы дождаться обновления store
  this.$nextTick(() => {
    const DELIVERY_PRODUCT_ID = '989773504';
    const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
    
    const products = this.$route.params.orderId 
      ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
      : this.products;
    
    const regularProducts = products.filter(p => 
      p.id !== DELIVERY_PRODUCT_ID && 
      !COMPLEX_PRODUCT_IDS.includes(p.id)
    );
    
    // Если не осталось обычных товаров, очищаем емкость в зачет
    if (regularProducts.length === 0) {
      this.formData.batteryCapacityNew = '';
      this.formData.tradeInAmountNew = '0.00';
      this.previousTradeInAmount = 0;
      this.previousCapacityDiscount = 0;
      this.capacityWeightDifference = 0;
      this.capacityWeightKg = 0;
    }
  });
  },

  /**
   * Сумма за лом — общая на заказ. discountAmount хранится за штуку,
   * поэтому при смене quantity перераспределяем trade-in на новую единицу,
   * чтобы итог по лому не умножался/не «сжимался».
   */
  redistributeTradeInOnQuantityChange(product, oldQty, newQty) {
    const tradeIn = Number(this.formData.tradeInAmountNew) || 0;
    if (!product || !tradeIn || oldQty === newQty || oldQty <= 0 || newQty <= 0) {
      return;
    }

    const DELIVERY_PRODUCT_ID = '989773504';
    const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
    const products = this.$route.params.orderId
      ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
      : this.products;

    const productsWithoutDelivery = products.filter(p =>
      p.id !== DELIVERY_PRODUCT_ID &&
      !COMPLEX_PRODUCT_IDS.includes(p.id) &&
      !this.isExcludedFromTotalsStatus(p.status)
    );

    if (!productsWithoutDelivery.length) {
      return;
    }

    let maxPriceProduct = productsWithoutDelivery[0];
    let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
    for (let i = 1; i < productsWithoutDelivery.length; i++) {
      const p = productsWithoutDelivery[i];
      const productPrice = parseFloat(p.originalPrice || p.price || 0);
      if (productPrice > maxPrice) {
        maxPrice = productPrice;
        maxPriceProduct = p;
      }
    }

    if (String(maxPriceProduct.id) !== String(product.id)) {
      return;
    }

    const currentPerUnit = Number(product.discountAmount) || 0;
    const adjusted = currentPerUnit - (tradeIn / oldQty) + (tradeIn / newQty);
    product.discountAmount = parseFloat(Math.max(0, adjusted).toFixed(2));
    product.displayPrice = this.calculateDiscountedPrice(product);
    this.updateProductTotal(product);
  },

  // Увеличение количества
increaseProductQuantity(productId) {
  const products = this.$store.getters.getProductsByOrderId(this.$route.params.orderId);
  const existingProduct = products.find(p => p.id === productId);

  if (existingProduct) {
    const oldQty = this.getLineItemQuantity(existingProduct);
    const newQuantity = oldQty + 1;
    this.redistributeTradeInOnQuantityChange(existingProduct, oldQty, newQuantity);
    this.$store.commit('updateProductQuantity', {
      orderId: this.$route.params.orderId,
      productId: productId,
      quantity: newQuantity
    });
  }
},

// Уменьшение количества
decreaseProductQuantity(productId) {
  const products = this.$store.getters.getProductsByOrderId(this.$route.params.orderId);
  const existingProduct = products.find(p => p.id === productId);

  if (existingProduct) {
    if (existingProduct.quantity > 1) {
      const oldQty = this.getLineItemQuantity(existingProduct);
      const newQuantity = oldQty - 1;
      this.redistributeTradeInOnQuantityChange(existingProduct, oldQty, newQuantity);
      this.$store.commit('updateProductQuantity', {
        orderId: this.$route.params.orderId,
        productId: productId,
        quantity: newQuantity
      });
    } else {
      // Если <= 1 — удаляем товар
      this.$store.commit('removeProduct', {
        orderId: this.$route.params.orderId,
        productId: productId // ✅ правильно
      });
    }
  }
}
,

    openProductStatusDropdown(event, product) {
      event.stopPropagation(); // добавьте эту строку!
    this.currentStatusProduct = product;
    this.productStatusDropdownVisible = true;

    const rect = event.currentTarget.getBoundingClientRect();

    // Позиционирование относительно всего окна браузера
    this.productStatusDropdownPosition = {
      x: rect.left,
      y: rect.bottom
    };
  },

  async getPopularBatteries() {
  if (!this.formData.selectionLink) return;

  this.loadingPopularBatteries = true;

  try {
    const response = await fetch(`${ORDERS_API_BASE}/popular-batteries.php?link=${encodeURIComponent(this.formData.selectionLink)}`);
    const result = await response.json();

    if (result.success) {
      this.popularBatteries = result.batteries;
    } else {
      console.error('Ошибка получения популярных товаров:', result.message);
    }
  } catch (error) {
    console.error('Ошибка запроса:', error);
  } finally {
    this.loadingPopularBatteries = false;
  }
},

  async checkInstallationPrice() {
    // Сбрасываем ошибку при очистке поля
    if (!this.formData.selectionLink || this.formData.selectionLink.trim() === '') {
      this.installationPriceError = null;
      this.installationPrice = null;
      return;
    }

    console.log('checkInstallationPrice вызван для ссылки:', this.formData.selectionLink);

    try {
      const url = `${ORDERS_API_BASE}/check_installation_price.php?link=${encodeURIComponent(this.formData.selectionLink)}`;
      console.log('Отправка запроса на:', url);
      
      const response = await fetch(url);
      const data = await response.json();

      console.log('Ответ от API:', data);

      if (data.success && data.hasInstallationPrice) {
        this.installationPrice = data.price;
        this.installationPriceError = data.message || `Сложная установка. Стоимость: ${data.price.toLocaleString('ru-RU')} руб.`;
        console.log('Установлена ошибка стоимости установки:', this.installationPriceError);
      } else {
        this.installationPriceError = null;
        this.installationPrice = null;
        console.log('Стоимость установки не найдена');
      }
    } catch (error) {
      console.error('Ошибка при проверке стоимости установки:', error);
      // Не показываем ошибку, если не удалось проверить
      this.installationPriceError = null;
      this.installationPrice = null;
    }
  }
,

  setProductStatus(product, statusCode) {
    product.status = statusCode;
    this.productStatusDropdownVisible = false;
  },

  isStockLookupProduct(product) {
    if (!product || !product.id || !product.name) return false;
    const DELIVERY_PRODUCT_ID = '989773504';
    const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
    if (product.id === DELIVERY_PRODUCT_ID || COMPLEX_PRODUCT_IDS.includes(String(product.id))) {
      return false;
    }
    const name = String(product.name).trim();
    if (name.length < 2) return false;
    return !/^(доставка|комплекс\s)/iu.test(name);
  },

  getKarvataStockState(product) {
    const id = product && product.id ? String(product.id) : '';
    const data = this.productStockData[id];
    if (!data || data.loading) {
      return { stock: null, reserve: 0, loading: !!(data && data.loading) };
    }
    const karvata = data.karvata || {};
    return {
      stock: karvata.stock != null ? karvata.stock : null,
      reserve: karvata.reserve || 0,
      order_reserve: karvata.order_reserve || 0,
      loading: false,
    };
  },

  isSelfPickupStockCheck() {
    const deliveryType = this.formData.deliveryTypes && this.formData.deliveryTypes.value;
    if (deliveryType !== 'self-delivery') {
      return false;
    }
    const magazinVal = (this.formData.site && this.formData.site.value)
      || (this.formData.magazin && this.formData.magazin.value);
    const shipmentVal = this.formData.shipmentStore && this.formData.shipmentStore.value;
    return !!(magazinVal || shipmentVal);
  },

  getPodZakazTargetMsStoreName() {
    if (!this.isSelfPickupStockCheck()) {
      return null;
    }

    const shipmentVal = this.formData.shipmentStore && this.formData.shipmentStore.value;
    if (shipmentVal && this.shipmentStoreToMsStore[shipmentVal]) {
      return this.shipmentStoreToMsStore[shipmentVal];
    }

    const magazinVal = (this.formData.site && this.formData.site.value)
      || (this.formData.magazin && this.formData.magazin.value);
    if (magazinVal && this.magazinToMsStore[magazinVal]) {
      return this.magazinToMsStore[magazinVal];
    }

    return null;
  },

  getStoreSourceAvailable(product, storeName) {
    if (!storeName) {
      return 0;
    }
    const source = this.getProductSources(product).find((item) => (
      item.type === 'store' && item.id === storeName
    ));
    if (!source) {
      return 0;
    }
    if (source.effective_available != null && source.effective_available !== '') {
      return Number(source.effective_available) || 0;
    }
    return Number(source.available) || 0;
  },

  getStoreSourceState(product, storeName) {
    const id = product && product.id ? String(product.id) : '';
    const data = this.productStockData[id];
    if (!data || data.loading) {
      return { stock: null, reserve: 0, loading: !!(data && data.loading) };
    }
    const source = this.getProductSources(product).find((item) => (
      item.type === 'store' && item.id === storeName
    ));
    if (!source) {
      return { stock: 0, reserve: 0, loading: false };
    }
    return {
      stock: Number(source.count) || 0,
      reserve: Number(source.reserve) || 0,
      order_reserve: Number(source.order_reserve) || 0,
      loading: false,
    };
  },

  getPrimaryStockLabel() {
    return this.getPodZakazTargetMsStoreName() || 'Карвата';
  },

  getPrimaryStockState(product) {
    const targetStore = this.getPodZakazTargetMsStoreName();
    if (targetStore && targetStore !== 'Карвата') {
      return this.getStoreSourceState(product, targetStore);
    }
    return this.getKarvataStockState(product);
  },

  getPrimaryStockAvailable(product) {
    const targetStore = this.getPodZakazTargetMsStoreName();
    if (targetStore && targetStore !== 'Карвата') {
      return this.getStoreSourceAvailable(product, targetStore);
    }
    return this.getKarvataAvailable(product);
  },

  getKarvataAvailable(product) {
    const data = this.getProductStockData(product);
    if (data.loading || !data.karvata) {
      const state = this.getKarvataStockState(product);
      if (state.stock == null) return 0;
      const stock = Number(state.stock) || 0;
      const reserve = Number(state.reserve) || 0;
      const orderReserve = Number(state.order_reserve) || 0;
      if (orderReserve > 0) {
        return Math.max(stock - reserve, 0, Math.min(orderReserve, stock));
      }
      return Math.max(stock - reserve, 0);
    }
    const karvata = data.karvata || {};
    if (karvata.effective_available != null && karvata.effective_available !== '') {
      return Number(karvata.effective_available) || 0;
    }
    return Number(karvata.available) || 0;
  },

  formatKarvataStock(product) {
    const state = this.getKarvataStockState(product);
    if (state.loading) return '…';
    if (state.stock == null) return '—';
    const available = this.getKarvataAvailable(product);
    const reserve = Number(state.reserve) || 0;
    const orderReserve = Number(state.order_reserve) || 0;
    if (orderReserve > 0 && available > 0 && reserve > 0) {
      return `${available} (${orderReserve} рез. заказ)`;
    }
    if (reserve > 0) {
      return `${available} (${reserve} рез.)`;
    }
    return String(available);
  },

  formatPrimaryStock(product) {
    if (!this.isProductStockLoaded(product)) {
      const id = product && product.id ? String(product.id) : '';
      const data = this.productStockData[id];
      if (data && data.loading) return '…';
      return '…';
    }
    const state = this.getPrimaryStockState(product);
    if (state.loading) return '…';
    if (state.stock == null) return '—';
    const available = this.getPrimaryStockAvailable(product);
    const reserve = Number(state.reserve) || 0;
    const orderReserve = Number(state.order_reserve) || 0;
    if (orderReserve > 0 && available > 0 && reserve > 0) {
      return `${available} (${orderReserve} рез. заказ)`;
    }
    if (reserve > 0) {
      return `${available} (${reserve} рез.)`;
    }
    return String(available);
  },

  isProductStockLoaded(product) {
    const id = product && product.id ? String(product.id) : '';
    if (!id) return false;
    const data = this.productStockData[id];
    // Реально загружено с API (есть ключ и loading закончен)
    return !!(data && data.loading === false && Object.prototype.hasOwnProperty.call(data, 'sources'));
  },

  getProductStockData(product) {
    const id = product && product.id ? String(product.id) : '';
    return this.productStockData[id] || { loading: false, karvata: null, sources: [], _missing: true };
  },

  getProductSources(product) {
    const data = this.getProductStockData(product);
    return Array.isArray(data.sources) ? data.sources : [];
  },

  formatStockQtyParts({ available, reserve, orderReserve }) {
    const avail = Number(available) || 0;
    const res = Number(reserve) || 0;
    const ord = Number(orderReserve) || 0;
    if (ord > 0 && avail > 0 && res > 0) {
      return `${avail} (${ord} рез. заказ)`;
    }
    if (res > 0) {
      return `${avail} (${res} рез.)`;
    }
    return String(avail);
  },

  getStockOverviewRows(product) {
    if (!product || !this.isProductStockLoaded(product)) return [];

    const primaryLabel = this.getPrimaryStockLabel();
    const rows = [];
    const seen = new Set();

    const pushRow = ({ id, label, available, reserve, orderReserve, primary }) => {
      const key = String(id || label || '');
      if (!key || seen.has(key)) return;
      seen.add(key);
      rows.push({
        id: key,
        label: label || key,
        available: Number(available) || 0,
        qtyText: this.formatStockQtyParts({ available, reserve, orderReserve }),
        primary: !!primary,
      });
    };

    // Текущий склад (плашка)
    pushRow({
      id: primaryLabel,
      label: primaryLabel,
      available: this.getPrimaryStockAvailable(product),
      reserve: Number(this.getPrimaryStockState(product).reserve) || 0,
      orderReserve: Number(this.getPrimaryStockState(product).order_reserve) || 0,
      primary: true,
    });

    // Карвата отдельно (в sources её нет) — если сейчас смотрим другой склад
    if (primaryLabel !== 'Карвата') {
      const karvata = this.getProductStockData(product).karvata || {};
      const available = karvata.effective_available != null && karvata.effective_available !== ''
        ? Number(karvata.effective_available) || 0
        : Number(karvata.available) || 0;
      pushRow({
        id: 'Карвата',
        label: 'Карвата',
        available,
        reserve: Number(karvata.reserve) || 0,
        orderReserve: Number(karvata.order_reserve) || 0,
        primary: false,
      });
    }

    // Остальные склады из API (Минск + регионы), только где есть остаток
    this.getProductSources(product)
      .filter((s) => s && s.type === 'store')
      .forEach((s) => {
        const label = s.label || s.id;
        if (label === primaryLabel || s.id === primaryLabel) return;
        const available = s.effective_available != null && s.effective_available !== ''
          ? Number(s.effective_available) || 0
          : Number(s.available) || 0;
        pushRow({
          id: s.id || label,
          label,
          available,
          reserve: Number(s.reserve) || 0,
          orderReserve: Number(s.order_reserve) || 0,
          primary: false,
        });
      });

    return rows;
  },

  openStockHover(event, product) {
    if (!product || !this.isStockLookupProduct(product)) return;
    if (this.stockHoverHideTimer) {
      clearTimeout(this.stockHoverHideTimer);
      this.stockHoverHideTimer = null;
    }
    const rect = event.currentTarget && event.currentTarget.getBoundingClientRect
      ? event.currentTarget.getBoundingClientRect()
      : null;
    const tipWidth = 280;
    let x = rect ? rect.left : (event.clientX || 12);
    let y = rect ? rect.bottom + 8 : (event.clientY || 12);
    if (x + tipWidth > window.innerWidth - 12) {
      x = Math.max(12, window.innerWidth - tipWidth - 12);
    }
    const estimatedHeight = 220;
    if (y + estimatedHeight > window.innerHeight - 12 && rect) {
      y = Math.max(12, rect.top - estimatedHeight - 8);
    }
    this.stockHoverProduct = product;
    this.stockHoverPosition = { x, y };
    this.stockHoverVisible = true;
  },

  keepStockHover() {
    if (this.stockHoverHideTimer) {
      clearTimeout(this.stockHoverHideTimer);
      this.stockHoverHideTimer = null;
    }
  },

  scheduleCloseStockHover() {
    if (this.stockHoverHideTimer) {
      clearTimeout(this.stockHoverHideTimer);
    }
    this.stockHoverHideTimer = setTimeout(() => {
      this.closeStockHover();
    }, 120);
  },

  closeStockHover() {
    if (this.stockHoverHideTimer) {
      clearTimeout(this.stockHoverHideTimer);
      this.stockHoverHideTimer = null;
    }
    this.stockHoverVisible = false;
    this.stockHoverProduct = null;
  },

  getSourceGroup(product, group) {
    return this.getProductSources(product).filter((s) => s.group === group);
  },

  showSourcePicker(product) {
    if (!this.isStockLookupProduct(product)) return false;
    // Пока остатки не подгрузились — не показываем «выбор источника» как будто товара нет
    if (!this.isProductStockLoaded(product)) return false;
    return this.getPrimaryStockAvailable(product) <= 0;
  },

  getStockTrackedProducts() {
    return (this.products || []).filter((product) => (
      this.isStockLookupProduct(product)
      && this.isPodZakazTrackedProduct(product)
      && !this.isExcludedFromTotalsStatus(product.status)
    ));
  },

  isPodZakazTrackedProduct(product) {
    const name = String(product && product.name || '');
    return /A\/h|А\/ч/i.test(name);
  },

  getProductRequiredQty(product) {
    return Math.max(Number(product && product.quantity) || 1, 1);
  },

  hasProductLocalStock(product) {
    if (!this.isStockLookupProduct(product) || this.isExcludedFromTotalsStatus(product.status)) {
      return true;
    }

    if (!this.isProductStockLoaded(product)) {
      return null;
    }

    const data = this.getProductStockData(product);
    if (data.loading) {
      return null;
    }

    const qty = this.getProductRequiredQty(product);
    const targetStore = this.getPodZakazTargetMsStoreName();

    if (targetStore) {
      if (targetStore === 'Карвата') {
        return this.getKarvataAvailable(product) >= qty;
      }
      return this.getStoreSourceAvailable(product, targetStore) >= qty;
    }

    if (this.getKarvataAvailable(product) >= qty) {
      return true;
    }

    const storeSources = this.getProductSources(product).filter((source) => (
      source.group === 'minsk' || source.group === 'regions'
    ));
    const maxStoreAvailable = storeSources.reduce((max, source) => (
      Math.max(max, Number(source.available) || 0)
    ), 0);

    return maxStoreAvailable >= qty;
  },

  getOutOfStockProducts() {
    return this.getStockTrackedProducts().filter((product) => this.hasProductLocalStock(product) === false);
  },

  getOrderStatusGroup(statusCode) {
    const code = String(statusCode || '');
    if (!code) {
      return null;
    }

    for (const group of this.statusGroupsOrder || []) {
      if ((group.options || []).some((option) => String(option.value) === code)) {
        return group.group;
      }
    }

    return null;
  },

  getCurrentOrderStatusCode() {
    return String((this.selectedStatusOrder && this.selectedStatusOrder.value) || this.orderStatusFetch || '');
  },

  isPodZakazEnforcementApplicable() {
    if (!this.isSelfPickupStockCheck()) {
      return false;
    }

    const orderNumber = String((this.formData && this.formData.number) || '').toLowerCase();
    if (orderNumber.includes('priemka')) {
      return false;
    }

    const excludedGroups = ['complete', 'cancel', 'assembling', 'dflkdslskl'];
    const statusGroup = this.getOrderStatusGroup(this.getCurrentOrderStatusCode());
    if (!statusGroup) {
      return true;
    }
    return !excludedGroups.includes(statusGroup);
  },

  getOriginalOrderStatusCode() {
    return String(this.orderStatusFetch || '');
  },

  isPodZakazStatusTransition(targetStatus) {
    const target = String(targetStatus || '');
    if (!target || !this.podZakazTriggerStatuses.includes(target)) {
      return false;
    }
    return target !== this.getOriginalOrderStatusCode();
  },

  hasOutOfStockTrackedProducts() {
    if (!this.isPodZakazEnforcementApplicable()) {
      return false;
    }

    const tracked = this.getStockTrackedProducts();
    if (!tracked.length) {
      return false;
    }

    for (const product of tracked) {
      const stockState = this.hasProductLocalStock(product);
      if (stockState === null) {
        continue;
      }
      if (stockState === false) {
        return true;
      }
    }

    return false;
  },

  shouldRedirectToPodZakaz(statusCode) {
    return this.isPodZakazStatusTransition(statusCode)
      && this.hasOutOfStockTrackedProducts();
  },

  getPodZakazStatusOption() {
    const group = this.statusGroupsOrder.find((item) => item.group === 'approval');
    return group ? group.options.find((option) => option.value === this.podZakazStatusValue) || null : null;
  },

  setSelectedOrderStatusFromOption(option) {
    const group = this.statusGroupsOrder.find((item) => (
      (item.options || []).some((entry) => entry.value === option.value)
    ));
    this.selectedStatusOrder = {
      value: option.value,
      label: option.label,
      color: group ? group.color : option.color,
      class: group ? group.group : option.class,
    };
  },

  validatePodZakazOrderStatusBeforeSave() {
    const targetStatus = this.getCurrentOrderStatusCode();
    if (!this.isPodZakazStatusTransition(targetStatus)) {
      return true;
    }

    if (!this.hasOutOfStockTrackedProducts()) {
      return true;
    }

    if (targetStatus === this.podZakazStatusValue) {
      return true;
    }

    const names = this.getOutOfStockProducts().map((product) => `"${product.name}"`).join(', ');
    const targetStore = this.getPodZakazTargetMsStoreName();
    const stockHint = targetStore
      ? `нет в магазине «${targetStore}»`
      : 'нет на складе и в магазинах';
    this.$toast.error(
      `Нельзя сохранить заказ: ${names} — ${stockHint}. Установите статус «---- товар под З А К А З ----».`,
      {
        timeout: 7000,
        position: 'bottom-right',
        style: { padding: '10px', minWidth: '350px', minHeight: '40px', display: 'flex', alignItems: 'center' },
      }
    );
    return false;
  },

  getSelectedSourcePick(product) {
    return this.productSourcePick[String(product.id)] || null;
  },

  getSelectedSourceLabel(product) {
    const pick = this.getSelectedSourcePick(product);
    if (!pick) return '';
    if (typeof pick === 'string') return pick;
    return pick.id || pick.label || '';
  },

  getSelectedSourceTriggerText(product) {
    const pick = this.getSelectedSourcePick(product);
    if (!pick) return 'Выберите магазин или поставщика';
    if (typeof pick === 'string') return pick.replace(/\s*\(\d+.*\)\s*$/, '');
    return pick.id || String(pick.label || '').replace(/\s*\(\d+.*\)\s*$/, '');
  },

  getSelectedSourceQty(product) {
    const pick = this.getSelectedSourcePick(product);
    if (!pick || typeof pick !== 'object') return '';
    if (pick.available != null && pick.available !== '') return pick.available;
    const match = String(pick.label || '').match(/\((\d+)/);
    return match ? match[1] : '';
  },

  isSourceSelected(product, opt) {
    const pick = this.productSourcePick[String(product.id)];
    if (!pick || typeof pick !== 'object') return false;
    return pick.type === opt.type && pick.id === opt.id;
  },

  toggleSourceDropdown(event, product) {
    const productId = String(product.id);
    if (this.sourceDropdownVisible && this.sourceDropdownProductId === productId) {
      this.closeSourceDropdown();
      return;
    }
    this.sourceDropdownProduct = product;
    this.sourceDropdownProductId = productId;
    this.sourceDropdownVisible = true;
    const rect = event.currentTarget.getBoundingClientRect();
    const width = Math.max(Math.round(rect.width), 260);
    const left = Math.min(rect.left, window.innerWidth - width - 12);
    this.sourceDropdownWidth = width;
    this.sourceDropdownPosition = {
      x: Math.max(12, left),
      y: rect.bottom + 6,
    };
    this.$nextTick(() => {
      const el = this.$refs.sourceDropdown;
      if (!el) return;
      const dropdownHeight = el.offsetHeight;
      let top = rect.bottom + 6;
      if (top + dropdownHeight > window.innerHeight - 12) {
        top = Math.max(12, rect.top - dropdownHeight - 6);
      }
      this.sourceDropdownPosition = {
        x: Math.max(12, left),
        y: top,
      };
    });
  },

  closeSourceDropdown() {
    this.sourceDropdownVisible = false;
    this.sourceDropdownProduct = null;
    this.sourceDropdownProductId = '';
  },

  pickProductSource(product, opt) {
    const payload = {
      type: opt.type,
      id: opt.id,
      label: `${opt.label} (${opt.available} шт.)`,
      available: opt.available,
    };
    this.$set(this.productSourcePick, String(product.id), payload);
    this.formData.location_zabor = this.buildLocationZaborValue();
    this.closeSourceDropdown();
  },

  scheduleKarvataStockFetch() {
    if (this.stockSourcesFetchTimer) {
      clearTimeout(this.stockSourcesFetchTimer);
    }
    this.stockSourcesFetchTimer = setTimeout(() => {
      this.fetchProductsStockSources();
    }, 300);
  },

  async fetchProductsStockSources() {
    const ids = [];
    const names = {};
    (this.products || []).forEach((product) => {
      if (!this.isStockLookupProduct(product)) return;
      const id = String(product.id);
      if (!ids.includes(id)) ids.push(id);
      if (product.name) {
        names[id] = String(product.name).trim();
      }
    });

    if (!ids.length) return;

    // Пометить только новые/неполные — и сразу loading для UX
    ids.forEach((id) => {
      this.$set(this.productStockData, id, {
        ...(this.productStockData[id] || {}),
        loading: true,
        sources: (this.productStockData[id] && this.productStockData[id].sources) || [],
      });
    });

    try {
      const payload = { ids, names };
      if (this.formData.moyskladUuid) {
        payload.moyskladOrderId = this.formData.moyskladUuid;
      }
      const response = await axios.post(
        ORDERS_API_BASE + '/product_stock_sources.php',
        payload,
        { timeout: 45000 }
      );
      const items = (response.data && response.data.items) || {};

      ids.forEach((id) => {
        const item = items[id] || {};
        this.$set(this.productStockData, id, {
          loading: false,
          karvata: item.karvata || { stock: 0, reserve: 0, available: 0 },
          sources: Array.isArray(item.sources) ? item.sources : [],
        });
      });
    } catch (error) {
      console.error('Ошибка загрузки остатков:', error);
      ids.forEach((id) => {
        this.$set(this.productStockData, id, {
          loading: false,
          karvata: { stock: null, reserve: 0, available: 0 },
          sources: [],
        });
      });
    }
  },

  onProductSourcePick(product, value) {
    if (!product || !product.id) return;
    this.$set(this.productSourcePick, String(product.id), value);
    this.formData.location_zabor = this.buildLocationZaborValue();
  },

  buildLocationZaborValue() {
    const payload = {};
    (this.products || []).forEach((product) => {
      const pick = this.productSourcePick[String(product.id)];
      if (!pick) return;
      if (typeof pick === 'object') {
        payload[String(product.id)] = pick.label || pick.id;
      } else {
        payload[String(product.id)] = pick;
      }
    });
    return Object.keys(payload).length ? JSON.stringify(payload) : '';
  },

  loadLocationZaborFromOrder(value) {
    this.productSourcePick = {};
    if (!value) {
      this.formData.location_zabor = '';
      return;
    }
    this.formData.location_zabor = value;
    try {
      const parsed = JSON.parse(value);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        Object.keys(parsed).forEach((id) => {
          const val = parsed[id];
          if (typeof val === 'object' && val !== null) {
            this.$set(this.productSourcePick, id, val);
          } else {
            this.$set(this.productSourcePick, id, { type: 'legacy', id: val, label: val });
          }
        });
        return;
      }
    } catch (e) {
      // legacy text
    }
    String(value).split('\n').forEach((line) => {
      const parts = line.split('—');
      if (parts.length < 2) return;
      const name = parts[0].trim();
      const source = parts.slice(1).join('—').trim();
      const product = (this.products || []).find((p) => String(p.name).trim() === name);
      if (product && source) {
        this.$set(this.productSourcePick, String(product.id), { type: 'legacy', id: source, label: source });
      }
    });
  },

  getProductStatusLabel(statusValue) {
    const found = this.productStatuses.find(s => s.value === statusValue);
    return found ? found.label : 'Статус не указан';
  },

  // Проверяет, является ли статус товара "отменяющим" (cancelStatus = true)
  isCancelStatus(statusValue) {
    const found = this.productStatuses.find(s => s.value === statusValue);
    return found && found.cancelStatus;
  },

  // Возвратный товар не должен участвовать в суммах/скидках
  isReturnedStatus(statusValue) {
    const found = this.productStatuses.find(s => s.value === statusValue);
    const code = String(statusValue || '').toLowerCase();
    const label = String((found && found.label) || '').toLowerCase();
    return code === 'returned' || label.includes('возврат');
  },

  // Общий фильтр для расчётов: отмены + возвраты
  isExcludedFromTotalsStatus(statusValue) {
    return this.isCancelStatus(statusValue) || this.isReturnedStatus(statusValue);
  },

  handleClickOutsideDropdown(event) {
  const dropdown = this.$refs.productStatusDropdown;

  if (dropdown && !dropdown.contains(event.target)) {
    this.productStatusDropdownVisible = false;
  }

  const sourceDropdown = this.$refs.sourceDropdown;
  if (sourceDropdown && !sourceDropdown.contains(event.target) && !event.target.closest('.zakaz-source-trigger')) {
    this.closeSourceDropdown();
  }

  // Закрываем дропдаун выбора комплекса, если клик был вне его
  const complexSelectDropdown = this.$el.querySelector('.footer-complex-select-dropdown');
  const complexSelectBtn = this.$el.querySelector('.footer-complex-select-btn');
  if (complexSelectDropdown && complexSelectBtn && 
      !complexSelectDropdown.contains(event.target) && 
      !complexSelectBtn.contains(event.target)) {
    this.isComplexSelectDropdownOpen = false;
  }

  this.closeComplexDropdown();
},

   

    

                isProductInOrder(productId) {
                    return this.products.some(product => product.id === productId);
                  },
               decreaseQuantity(product) {
    if (product.quantity > 1) {
        product.quantity--;
        this.updateProductTotal(product);
    }
},
increaseQuantity(product) {
    product.quantity++;
    this.updateProductTotal(product);
},
updateQuantity(product) {
    if (product.quantity < 1) {
        product.quantity = 1;
    }
    this.updateProductTotal(product);
},
updateProductTotal(product) {
    // Используйте displayPrice, которая учитывает скидку
    const total = (parseFloat(product.displayPrice) || 0) * (parseFloat(product.quantity) || 1);
    product.total = parseFloat(Math.max(total, 0).toFixed(2));
},
/** Количество в строке заказа (минимум 1), чтобы не делить на ноль */
getLineItemQuantity(product) {
  return Math.max(1, parseFloat(product && product.quantity) || 1);
},
/** Сумма строки доставки: цена за единицу × количество (для строки доставки в заказе) */
getDeliveryLineTotal(deliveryProduct, fallbackUnitPrice) {
  if (!deliveryProduct) return 0;
  const fb = Number(fallbackUnitPrice) || 0;
  const unit = Number(deliveryProduct.displayPrice || deliveryProduct.originalPrice || deliveryProduct.price || fb);
  return unit * this.getLineItemQuantity(deliveryProduct);
},
/**
 * Сколько рублей скидки на ОДНУ шт. основного товара нужно добавить,
 * чтобы суммарно по позиции «погасить» стоимость доставки (discountAmount действует на каждую штуку).
 */
deliveryDiscountPerMainProductUnit(deliveryProduct, mainProduct, fallbackUnitPrice) {
  const lineTotal = this.getDeliveryLineTotal(deliveryProduct, fallbackUnitPrice);
  const mainQty = this.getLineItemQuantity(mainProduct);
  return lineTotal / mainQty;
},

...mapActions('savedFormsModule', ['deleteForm', 'saveForm']),
deleteForm() {
  this.$store.dispatch('savedFormsModule/clearSavedForms');
  this.$store.commit('clearProducts', this.$route.params.orderId);// Очистка продуктов через Vuex мутацию
  this.$router.push('/orders');
},


handleDiscountInput(event) {
    const rawValue = event.target.value.replace(',', '.');
    const parsedValue = parseFloat(rawValue);

    this.discountAmount = isNaN(parsedValue) ? 0 : parsedValue;
  },


  async saveFormAndCollapse() {
  await this.createOrder(); // дождаться завершения

  
    const form = {
      id: this.formData.id,
      idorder: this.formData.id,
      number: this.formData.number,
      phone: this.formData.phone,
      created: this.formData.createdAt,
      site: this.formData.site,
      orderMethod: this.formData.orderMethod,
    };

    this.$store.dispatch('savedFormsModule/clearSavedForms');
    this.$store.dispatch('savedFormsModule/saveForm', form);
    localStorage.setItem('currentFormId', form.id);
    console.log('Сохранено:', this.$store.state.savedFormsModule.savedForms);
    
    this.$nextTick(() => {
      this.$router.push('/orders');
    });
  
},

   loadSavedForm() {
    // Получаем сохранённую форму из Vuex
    /*const savedForms = this.$store.state.savedFormsModule.savedForms;
    const currentFormId = localStorage.getItem('currentFormId'); // ID текущей формы
    const savedForm = savedForms.find(form => form.id === currentFormId);

    if (savedForm && currentFormId == this.formData.number) {
      // Восстанавливаем данные в форму
      this.formData = { ...savedForm.formData };
      //this.products = [...savedForm.products];
    } else {
      console.error('Сохранённая форма не найдена');
    }*/
  },
  handleBeforeUnload() {
      const orderId = this.$route.params.orderId;
      const user = {
        id: this.$store.state.user.id,
        label: this.$store.state.user.label,
        retailCrmId: this.$store.state.user.retailCrmId
      };
      const ws = this.ws();
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({ type: 'stopViewOrder', orderId, user }));
        
        this.$store.commit('clearProducts', this.$route.params.orderId);
        console.log('Отправлено сообщение о прекращении просмотра заказа');
      }
      else {
        this.$store.commit('clearProducts', this.$route.params.orderId);
        console.log('WebSocket недоступен, очистка только локальных данных');
      }
      
      // Очищаем список просматривающих заказ
      this.orderViewers = [];
    },


  toggleProduct(product) {
                    const index = this.products.findIndex(p => p.id === product.id);
                    if (index === -1) {
                      this.products.push({
                        ...product,
                        quantity: 1,
                        total: product.price,
                      });
                    } else {
                      this.products.splice(index, 1);
                    }
                  },
                  updateProductQuantity(productId, quantity) {
                    const product = this.products.find(p => p.id === productId);
                    if (product) {
                      product.quantity = quantity;
                      product.total = product.price * quantity;
                      product.total = Math.max(Math.round(product.total * 100) / 100, 0);
                    }
                  },

                  openPriceDropdown(product) {
                    this.selectedProduct = product;
                    
                    // Сохраняем оригинальную цену при первом открытии
                    if (product.originalPrice === undefined) {
                        product.originalPrice = product.price;
                    }

                    // Сохраняем цену до редактирования (реальная цена товара, которую можно изменить)
                    // Сохраняем цену до редактирования для пересчета скидки
                    // Используем displayPrice, так как именно он используется при расчете скидки "за счет скидки" (см. setDeliveryPaidBy)
                    // Если displayPrice нет, используем originalPrice (цена до скидок)
                    this.originalPriceBeforeEdit = Number(product.displayPrice || product.originalPrice || product.price || 0);

                    this.priceInput = product.price;
                    this.discountAmount = product.discountAmount || 0;  // Загружаем сохранённую скидку в рублях
                    this.discountPercent = product.discountPercent || 0; // Загружаем сохранённую скидку в процентах

                    const row = event.currentTarget.getBoundingClientRect();
                    this.dropdownPosition = { top: `${row.top + window.scrollY}px`, left: `${row.left + window.scrollX}px` };
                    this.priceDropdownVisible = true;
                },
                closePriceDropdown() {
                    this.priceDropdownVisible = false;
                    this.selectedProduct = null;
                    this.originalPriceBeforeEdit = null; // Сбрасываем сохраненную цену
                },


 // Метод для запроса расшифровки разговора
    fetchTranscription(call) {
      console.log(call.UniqueId);
  axios.get(`https://manager.1akb.by/getTranscription?id=${call.UniqueId}`)
    .then(response => {
      let transcription;
      try {
        // Парсим JSON строку из transcription
        const parsedTranscription = typeof response.data.transcription === 'string'
          ? JSON.parse(response.data.transcription)
          : response.data.transcription;
        
        // Проверяем, есть ли поле dialogue или segments
        if (parsedTranscription && Array.isArray(parsedTranscription)) {
          // Если это массив напрямую (новый формат)
          transcription = { dialogue: parsedTranscription, tags: response.data.tags || '' };
        } else if (parsedTranscription.dialogue && Array.isArray(parsedTranscription.dialogue)) {
          // Если есть поле dialogue
          transcription = parsedTranscription;
        } else if (parsedTranscription.segments && Array.isArray(parsedTranscription.segments)) {
          // Если есть поле segments
          transcription = { dialogue: parsedTranscription.segments, tags: response.data.tags || '' };
        } else {
          // Fallback
          transcription = { dialogue: [], tags: '' };
        }
      } catch (e) {
        console.error('Ошибка парсинга JSON:', e);
        transcription = { dialogue: [], tags: '' };
      }
      this.transcriptionData = transcription;
      this.currentCallTags = response.data.tags ? response.data.tags.split(',') : [];
      this.isTranscriptionModalOpen = true;
    })
    .catch(error => {
      console.error("Ошибка загрузки расшифровки: ", error);
    });
},
    // Метод закрытия модального окна расшифровки
    closeTranscriptionModal() {
      this.isTranscriptionModalOpen = false;
      
    },
    closeHintModal() {
      this.isHintModalOpen = false;
      this.clientResponseHintError = '';
    },
    getOrderContextForHint() {
      const products = (this.products || []).map((p) => ({
        name: p.name || p.displayName || '',
        quantity: p.quantity,
        price: p.price,
      }));
      return {
        carBrand: this.formData.carBrand || '',
        carModel: this.formData.carModel || '',
        carYear: this.formData.carYear || '',
        carName: this.formData.carName || '',
        carBodyType: this.formData.carBodyType || '',
        products,
      };
    },
    openCallHint() {
      const call = this.latestCallWithTranscription;
      if (!call) {
        this.isHintModalOpen = true;
        this.clientResponseHint = '';
        this.clientResponseHintTopics = [];
        this.hintCatalogPreview = [];
        this.clientResponseHintError = 'Расшифровка ещё не готова. Откройте историю звонков и подождите несколько минут.';
        return;
      }
      this.openCallHintForCall(call);
    },
    openCallHintForCall(call) {
      if (!call || !call.hasTranscription) {
        this.isHintModalOpen = true;
        this.clientResponseHintError = 'Сначала нужна расшифровка разговора.';
        return;
      }
      this.hintCallId = call.UniqueId;
      this.isHintModalOpen = true;
      this.hintLoading = true;
      this.clientResponseHint = '';
      this.clientResponseHintTopics = [];
      this.hintCatalogPreview = [];
      this.clientResponseHintError = '';
      this.fetchCallHint(call.UniqueId, call.transcription);
    },
    async fetchCallHint(callId, transcription) {
      const isSales = this.hintMode === 'sales';
      const url = isSales
        ? 'https://manager.1akb.by/call-manager-sales-hint'
        : 'https://manager.1akb.by/call-client-response-hint';
      const body = isSales
        ? { callId, transcription, orderContext: this.getOrderContextForHint() }
        : { callId, transcription };
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json().catch(() => ({}));
        if (res.status === 202 && data.pending) {
          this.clientResponseHintError = 'Расшифровка ещё обрабатывается. Попробуйте через 1–2 минуты.';
          return;
        }
        if (!res.ok) {
          throw new Error(data.error || 'Не удалось получить подсказку');
        }
        this.clientResponseHint = data.text || '';
        if (isSales) {
          this.clientResponseHintTopics = data.topics || [];
          this.hintCatalogPreview = data.catalog_preview || [];
        } else {
          this.clientResponseHintTopics = data.claims || [];
        }
      } catch (e) {
        this.clientResponseHintError = e.message || 'Ошибка загрузки подсказки';
      } finally {
        this.hintLoading = false;
      }
    },
formatTranscription(data) {
  // Если данные отсутствуют или не содержат поле dialogue, возвращаем сообщение-заглушку
  if (!data || !data.dialogue) {
    return '<div>Нет данных для отображения</div>';
  }
  console.log(data);
  let html = '<div class="dialogue">';
  data.dialogue.forEach(item => {

    if(item.speaker === 'manager'){
      item.speaker = 'Менеджер';
    }
    if(item.speaker === 'client'){
      item.speaker = 'Клиент';
    }

    // Определяем CSS-класс в зависимости от говорящего
    const speakerClass = item.speaker === 'Менеджер' ? 'manager' :
                         item.speaker === 'Клиент' ? 'buyer' : 'other';



    html += `<div class="dialogue-item ${speakerClass}">`;
    html += `<span class="speaker">${item.speaker}:</span> `;
    html += `<span class="message">${item.message}</span>`;
    html += `</div>`;
  });
  // Если присутствуют теги, добавляем их ниже диалога
  if (data.tags) {
    html += `<div class="dialogue-tags"><strong>Теги:</strong> ${data.tags}</div>`;
  }
  html += '</div>';
  return html;
},





/*applyPriceChange() {
    if (this.selectedProduct) {
        this.selectedProduct.discountAmount = this.discountAmount;
        this.selectedProduct.discountPercent = this.discountPercent;
        this.selectedProduct.displayPrice = this.calculateDiscountedPrice(this.selectedProduct);

        // Пересчитываем итоговую стоимость для выбранного продукта
        this.calculateProductTotal(this.selectedProduct);

        this.closePriceDropdown();

        // Обновляем products, чтобы Vue отслеживал изменение
        this.products = [...this.products];
    }
},*/

async handleSaveAndExitOrder(resolve) {
    await this.createOrderExit(); // сохраняем и уходим
    resolve(); // сообщаем, что закончили
  },

  

applyPriceChange() {
    if (this.selectedProduct) {


        console.log(this.selectedProduct);

        const DELIVERY_PRODUCT_ID = '989773504';
        const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
        const isDeliveryOrInstallation = this.selectedProduct.id === DELIVERY_PRODUCT_ID || COMPLEX_PRODUCT_IDS.includes(this.selectedProduct.id);
        
        // Используем сохраненную цену до редактирования для пересчета скидки
        // Используем displayPrice (или originalPrice если displayPrice нет), так как именно эта цена используется при установке скидки
        const oldPrice = this.originalPriceBeforeEdit || Number(this.selectedProduct.displayPrice || this.selectedProduct.originalPrice || this.selectedProduct.price || 0);
        
        // Новая цена из поля ввода (это будет originalPrice после применения)
        const newOriginalPrice = Number(this.priceInput || 0);

        // Устанавливаем новую цену товара
        this.selectedProduct.originalPrice = this.priceInput;
        this.selectedProduct.price = this.priceInput;

        // Считаем скидки и устанавливаем итоговую цену
        this.selectedProduct.discountAmount = this.discountAmount;
        this.selectedProduct.discountPercent = this.discountPercent;
        this.selectedProduct.displayPrice = this.calculateDiscountedPrice(this.selectedProduct);
        
        // Новая цена для пересчета скидки (используем displayPrice, как и в setDeliveryPaidBy)
        const newPrice = Number(this.selectedProduct.displayPrice || this.selectedProduct.originalPrice || 0);

        // Пересчитываем итоговую стоимость товара
        this.updateProductTotal(this.selectedProduct);
        
        // Сохраняем ID товара для использования после закрытия dropdown
        const selectedProductId = this.selectedProduct ? this.selectedProduct.id : null;
        
        // Если изменили цену доставки или установки, и выбрано "за счет скидки", пересчитываем скидку у основного товара
        // Делаем это ДО закрытия dropdown, пока selectedProduct доступен
        if (isDeliveryOrInstallation && selectedProductId && Math.abs(newPrice - oldPrice) > 0.01) {
          // Получаем список товаров
          let products = this.$route.params.orderId 
            ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
            : this.products;
          
          // Находим товар с наибольшей ценой (исключая доставку и комплексы)
const productsWithoutDelivery = products.filter(p => 
            p.id !== DELIVERY_PRODUCT_ID && 
            !COMPLEX_PRODUCT_IDS.includes(p.id) &&
            !this.isExcludedFromTotalsStatus(p.status)
            );
          
          let maxPriceProduct = null;
          if (productsWithoutDelivery.length > 0) {
            maxPriceProduct = productsWithoutDelivery[0];
            let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
            
            for (let i = 1; i < productsWithoutDelivery.length; i++) {
              const product = productsWithoutDelivery[i];
              const productPrice = parseFloat(product.originalPrice || product.price || 0);
              if (productPrice > maxPrice) {
                maxPrice = productPrice;
                maxPriceProduct = product;
              }
            }
          }
          
          if (maxPriceProduct) {
            let currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
            
            // Если это доставка и выбрано "за счет скидки"
            if (selectedProductId === DELIVERY_PRODUCT_ID && this.formData.deliveryPaidBy === 'discount') {
              const mainQty = this.getLineItemQuantity(maxPriceProduct);
              const delQty = this.getLineItemQuantity(this.selectedProduct);
              const oldLine = oldPrice * delQty;
              const newLine = newPrice * delQty;
              currentDiscount = Math.max(0, currentDiscount - oldLine / mainQty);
              currentDiscount = currentDiscount + newLine / mainQty;
              
              maxPriceProduct.discountAmount = currentDiscount;
              maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
              this.updateProductTotal(maxPriceProduct);
            }
            
            // Если это установка и выбрано "за счет скидки"
            if (COMPLEX_PRODUCT_IDS.includes(selectedProductId) && this.formData.installationPaidBy === 'discount') {
              // Вычитаем старую цену установки (displayPrice, который использовался при установке скидки)
              currentDiscount = Math.max(0, currentDiscount - oldPrice);
              // Добавляем новую цену установки (новый displayPrice)
              currentDiscount = currentDiscount + newPrice;
              
              maxPriceProduct.discountAmount = currentDiscount;
              maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
              this.updateProductTotal(maxPriceProduct);
            }
            
            // Обновляем товар
            if (!this.$route.params.orderId) {
              const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
              if (index !== -1) {
                this.$set(this.products, index, maxPriceProduct);
              }
            } else {
              // Если используется store, обновляем через store
              products = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
              const productInStore = products.find(p => p.id === maxPriceProduct.id);
              if (productInStore) {
                productInStore.discountAmount = maxPriceProduct.discountAmount;
                productInStore.displayPrice = maxPriceProduct.displayPrice;
                this.updateProductTotal(productInStore);
              }
            }
          }
        }

        // Закрываем выпадающее меню
        this.closePriceDropdown();

        // Обновляем массив товаров, чтобы Vue отследил изменения
        this.products = [...this.products];
    }
},
    // Метод для получения списка менеджеров
                fetchManagers() {
                    axios.get(ORDERS_API_BASE + '/manager.php')
                        .then(response => {
                            this.managers = sortManagersByLabel(response.data);
                        })
                        .catch(error => {
                            console.error('Ошибка при получении менеджеров:', error);
                        });
                },
                async fetchManagersUpdate(){
                    try {
                      const response = await fetch('https://manager.1akb.by/users-list');
                      
                      if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                      }
                      
                      const rows = await response.json();
                      this.managers_update = sortManagersByLabel(rows);

                    } catch (error) {
                      console.error('Ошибка при загрузке списка пользователей:', error);
                    }
                },
                fetchCurier() {
                    axios.get(ORDERS_API_BASE + '/curier.php')
                        .then(response => {
                            this.curiers = response.data; // массив менеджеров
                        })
                        .catch(error => {
                            console.error('Ошибка при получении менеджеров:', error);
                        });
                },
                fetchStores() {
                    axios.get(ORDERS_API_BASE + '/store.php')
                        .then(response => {
                            this.sites = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении магазинов:', error);
                        });
                },
                fetchProductStatus() {
                    axios.get(ORDERS_API_BASE + '/product_status.php')
                        .then(response => {
                            this.productStatuses = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении магазинов:', error);
                        });
                },
                fetchOrderMethods() {
                    axios.get(ORDERS_API_BASE + '/sposob.php')
                        .then(response => {
                            this.orderMethods = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                fetchSeller() {
                    axios.get(ORDERS_API_BASE + '/seller.php')
                        .then(response => {
                            this.seller = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                fetchPredoplata() {
                    axios.get(ORDERS_API_BASE + '/vozim.php')
                        .then(response => {
                            this.predoplata = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                fetchBezoplaty() {
                    axios.get(ORDERS_API_BASE + '/dostavka_bez_oplaty.php')
                        .then(response => {
                            this.dostavka_bez_oplaty = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                 fetchObzvon_klienta() {
                    axios.get(ORDERS_API_BASE + '/obzvon_klienta.php')
                        .then(response => {
                            this.obzvon_klientaList = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                
                
                fetchPayment() {
                    axios.get(ORDERS_API_BASE + '/payment.php')
                      .then(response => {
                        this.paymentTypes = response.data.paymentTypes;
                      })
                      .catch(error => {
                        console.error('Ошибка при получении способов оформления:', error);
                      });
                  },
                    getPaymentStatuses(paymentType) {
                      // Найти объект типа оплаты по value
                      const selectedType = this.paymentTypes.find(type => type.value === paymentType);
                      // Вернуть список статусов, если объект найден, иначе пустой массив
                      return selectedType && selectedType.paymentStatuses ? selectedType.paymentStatuses : [];
                    },
                    getDgh66hhhhhhh() {
                    fetch(ORDERS_API_BASE + '/dgh66hhhhhhh.php')
                    .then(response => response.json())
                    .then(data => {
                       this.dgh66hhhhhhhList = data;
                    })
                    .catch(error => {
                      console.error('Ошибка при получении статусов:', error);
                    });
                  },
                  getOcenka() {
                    fetch(ORDERS_API_BASE + '/ocenka.php')
                    .then(response => response.json())
                    .then(data => {
                       this.ocenka_manageruList = data;
                    })
                    .catch(error => {
                      console.error('Ошибка при получении статусов:', error);
                    });
                  },

                  

                  getOcenkaKU() {
                    fetch(ORDERS_API_BASE + '/ocenkaku.php')
                    .then(response => response.json())
                    .then(data => {
                       this.ocenochka_kureruList = data;
                    })
                    .catch(error => {
                      console.error('Ошибка при получении статусов:', error);
                    });
                  },
                  getManagers() {
                    fetch(ORDERS_API_BASE + '/managers.php')
                    .then(response => response.json())
                    .then(data => {

                       this.manager_new = sortManagersByLabel(data.map(manager => {
                          // Разбиваем label по пробелу
                          const [name, surname] = manager.label.split(' ');

                          return {
                            ...manager, // Фамилия (второе слово, если есть)
                            displaName: surname + ' ' + name
                          };
                        }));
                    })
                    .catch(error => {
                      console.error('Ошибка при получении менеджеров:', error);
                    });
                  },
                  getOcenkaPR() {
                    fetch(ORDERS_API_BASE + '/ocenkapr.php')
                    .then(response => response.json())
                    .then(data => {
                       this.ocenkaprodavcuList = data;
                    })
                    .catch(error => {
                      console.error('Ошибка при получении статусов:', error);
                    });
                  },
                  getProverka() {
                    fetch(ORDERS_API_BASE + '/proverka.php')
                    .then(response => response.json())
                    .then(data => {
                       this.proverkazakazamenedgeroList = data;
                    })
                    .catch(error => {
                      console.error('Ошибка при получении статусов:', error);
                    });
                  },
                  formatStatusLabel(status) {
                    const labels = {
                      'not-paid': 'Не оплачен',
                      'invoice': 'Выставлен счет',
                      'payment-start': 'Начало оплаты',
                      'paid': 'Оплачен',
                      'fail': 'Ошибка',
                      'credit-approved': 'Кредит одобрен',
                      'credit-check': 'Проверка кредита',
                    };
                    return labels[status] || status;
                  },
                fetchShipmentStore() {
                    axios.get(ORDERS_API_BASE + '/sklad.php')
                        .then(response => {
                            this.shipmentStores = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                fetchOrderTypes() {
                    axios.get(ORDERS_API_BASE + '/ordertype.php')
                        .then(response => {
                            this.orderTypes = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },
                fetchDeliveryTypes() {
                    axios.get(ORDERS_API_BASE + '/delivery.php')
                        .then(response => {
                            this.deliveryTypes = response.data;
                        })
                        .catch(error => {
                            console.error('Ошибка при получении способов оформления:', error);
                        });
                },

                initializeData() {
                  
                  this.isInitialized = true;
                },

                validateSelectionLink() {
                  if (this.formData.selectionLink && this.formData.selectionLink.trim() !== '') {
                    this.errors.selectionLink = null;
                  } else {
                    this.errors.selectionLink = 'Обязательное поле';
                  }
                },

                async checkInstallationPrice() {
                  // Сбрасываем ошибку при очистке поля
                  if (!this.formData.selectionLink || this.formData.selectionLink.trim() === '') {
                    this.installationPriceError = null;
                    this.installationPrice = null;
                    return;
                  }

                  try {
                    const response = await fetch(`${ORDERS_API_BASE}/check_installation_price.php?link=${encodeURIComponent(this.formData.selectionLink)}`);
                    const data = await response.json();

                    if (data.success && data.hasInstallationPrice) {
                      this.installationPrice = data.price;
                      this.installationPriceError = data.message || `Сложная установка. Стоимость: ${data.price} руб.`;
                    } else {
                      this.installationPriceError = null;
                      this.installationPrice = null;
                    }
                  } catch (error) {
                    console.error('Ошибка при проверке стоимости установки:', error);
                    // Не показываем ошибку, если не удалось проверить
                    this.installationPriceError = null;
                    this.installationPrice = null;
                  }
                }
              },
              watch: {
                // Удален watcher для showDeliveryBlock, чтобы избежать зацикливания при загрузке заказа


              totalPrice: 'resetManualTotal',
              totalDiscount: 'resetManualTotal',
              deliveryCost: 'resetManualTotal',
              'formData.tradeInAmountNew': 'resetManualTotal',
              products: {
                handler(newProducts, oldProducts) {
                  this.resetManualTotal();
                  // deep не ставим: quantity/price меняются часто.
                  // Остатки подгружаем по смене состава (id-набор) и явно в addOrUpdateProduct.
                  const nextIds = (newProducts || []).map((p) => String(p.id)).sort().join(',');
                  const prevIds = (oldProducts || []).map((p) => String(p.id)).sort().join(',');
                  if (nextIds !== prevIds) {
                    this.scheduleKarvataStockFetch();
                  }
                  
                  // Проверяем наличие товаров доставки и установки, снимаем выделения если их нет
                  if (this.isLoadingOrder) {
                    return;
                  }
                  
                  const DELIVERY_PRODUCT_ID = '989773504';
                  const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
                  
                  // Получаем текущий список товаров
                  const products = this.$route.params.orderId 
                    ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
                    : newProducts || [];
                  
                  // Получаем старый список товаров для сравнения
                  const oldProductsList = oldProducts || [];
                  
                  // Пересчет скидки при изменении цены товара доставки
                  if (this.formData.deliveryPaidBy === 'discount') {
                    const deliveryProduct = products.find(p => p.id === DELIVERY_PRODUCT_ID);
                    const oldDeliveryProduct = oldProductsList.find(p => p.id === DELIVERY_PRODUCT_ID);
                    
                    if (deliveryProduct && oldDeliveryProduct) {
                      const newPrice = Number(deliveryProduct.displayPrice || deliveryProduct.originalPrice || deliveryProduct.price || 0);
                      const oldPrice = Number(oldDeliveryProduct.displayPrice || oldDeliveryProduct.originalPrice || oldDeliveryProduct.price || 0);
                      
                      // Если цена изменилась
                      if (Math.abs(newPrice - oldPrice) > 0.01) {
                        // Находим товар с наибольшей ценой
                        const productsFiltered = products.filter(p => p.id !== DELIVERY_PRODUCT_ID && !COMPLEX_PRODUCT_IDS.includes(p.id) && !this.isExcludedFromTotalsStatus(p.status));
                        let maxPriceProduct = productsFiltered.length > 0 ? productsFiltered.reduce((max, p) => 
                          (parseFloat(p.originalPrice || p.price || 0) > parseFloat(max.originalPrice || max.price || 0) ? p : max)
                        ) : null;
                        
                        if (maxPriceProduct) {
                          // Получаем текущую скидку (на одну шт. основного товара)
                          let currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
                          const mainQty = this.getLineItemQuantity(maxPriceProduct);
                          const oldLine = oldPrice * this.getLineItemQuantity(oldDeliveryProduct);
                          const newLine = newPrice * this.getLineItemQuantity(deliveryProduct);
                          
                          currentDiscount = Math.max(0, currentDiscount - oldLine / mainQty);
                          currentDiscount = currentDiscount + newLine / mainQty;
                          
                          maxPriceProduct.discountAmount = currentDiscount;
                          
                          // Пересчитываем отображаемую цену товара
                          maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
                          
                          // Пересчитываем итоговую стоимость товара
                          this.updateProductTotal(maxPriceProduct);
                          
                          // Обновляем массив товаров
                          if (!this.$route.params.orderId) {
                            const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                            if (index !== -1) {
                              this.$set(this.products, index, maxPriceProduct);
                            }
                          } else {
                            // Если используется store, нужно обновить товар через store
                            const updatedProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
                            const productInStore = updatedProducts.find(p => p.id === maxPriceProduct.id);
                            if (productInStore) {
                              productInStore.discountAmount = maxPriceProduct.discountAmount;
                              productInStore.displayPrice = maxPriceProduct.displayPrice;
                              this.updateProductTotal(productInStore);
                            }
                          }
                        }
                      }
                    }
                  }
                  
                  // Пересчет скидки при изменении цены товара установки
                  if (this.formData.installationPaidBy === 'discount' && this.formData.installationComplex) {
                    const complexProductIds = {
                      complex1: '989773501',
                      complex2: '989773505',
                      complex3: '989773503'
                    };
                    const installationProductId = complexProductIds[this.formData.installationComplex];
                    
                    if (installationProductId) {
                      const installationProduct = products.find(p => p.id === installationProductId);
                      const oldInstallationProduct = oldProductsList.find(p => p.id === installationProductId);
                      
                      if (installationProduct && oldInstallationProduct) {
                        const newPrice = Number(installationProduct.displayPrice || installationProduct.originalPrice || installationProduct.price || 0);
                        const oldPrice = Number(oldInstallationProduct.displayPrice || oldInstallationProduct.originalPrice || oldInstallationProduct.price || 0);
                        
                        // Если цена изменилась
                        if (Math.abs(newPrice - oldPrice) > 0.01) {
                          // Находим товар с наибольшей ценой
                          const productsFiltered = products.filter(p => p.id !== DELIVERY_PRODUCT_ID && !COMPLEX_PRODUCT_IDS.includes(p.id) && !this.isExcludedFromTotalsStatus(p.status));
                          let maxPriceProduct = productsFiltered.length > 0 ? productsFiltered.reduce((max, p) => 
                            (parseFloat(p.originalPrice || p.price || 0) > parseFloat(max.originalPrice || max.price || 0) ? p : max)
                          ) : null;
                          
                          if (maxPriceProduct) {
                            // Получаем текущую скидку
                            let currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
                            
                            // Вычитаем старую цену установки из скидки
                            currentDiscount = Math.max(0, currentDiscount - oldPrice);
                            
                            // Добавляем новую цену установки к скидке
                            currentDiscount = currentDiscount + newPrice;
                            
                            // Устанавливаем пересчитанную скидку
                            maxPriceProduct.discountAmount = currentDiscount;
                            
                            // Пересчитываем отображаемую цену товара
                            maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
                            
                            // Пересчитываем итоговую стоимость товара
                            this.updateProductTotal(maxPriceProduct);
                            
                            // Обновляем массив товаров
                            if (!this.$route.params.orderId) {
                              const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                              if (index !== -1) {
                                this.$set(this.products, index, maxPriceProduct);
                              }
                            } else {
                              // Если используется store, нужно обновить товар через store
                              const updatedProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
                              const productInStore = updatedProducts.find(p => p.id === maxPriceProduct.id);
                              if (productInStore) {
                                productInStore.discountAmount = maxPriceProduct.discountAmount;
                                productInStore.displayPrice = maxPriceProduct.displayPrice;
                                this.updateProductTotal(productInStore);
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  
                  // Проверяем наличие товара доставки
                  const hasDeliveryProduct = products.some(p => p.id === DELIVERY_PRODUCT_ID);
                  
                  if (!hasDeliveryProduct && this.formData.deliveryPaidBy) {
                    // Товар доставки удален - убираем скидку с первого товара, если была выбрана "За счет скидки"
                    if (this.formData.deliveryPaidBy === 'discount') {
                      // Пытаемся найти удаленный товар доставки в старом списке, чтобы узнать его реальную стоимость
                      const oldProductsList = oldProducts || [];
                      const deletedDeliveryProduct = oldProductsList.find(p => p.id === DELIVERY_PRODUCT_ID);
                      const fallbackDel = { displayPrice: 10, originalPrice: 10, price: 10, quantity: 1 };
                      
                      // Находим товар с наибольшей ценой (исключая доставку и комплексы)
const productsWithoutDelivery = products.filter(p => 
            p.id !== DELIVERY_PRODUCT_ID && 
            !COMPLEX_PRODUCT_IDS.includes(p.id) &&
            !this.isExcludedFromTotalsStatus(p.status)
            );
                      
                      let maxPriceProduct = null;
                      if (productsWithoutDelivery.length > 0) {
                        maxPriceProduct = productsWithoutDelivery[0];
                        let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
                        
                        for (let i = 1; i < productsWithoutDelivery.length; i++) {
                          const product = productsWithoutDelivery[i];
                          const productPrice = parseFloat(product.originalPrice || product.price || 0);
                          if (productPrice > maxPrice) {
                            maxPrice = productPrice;
                            maxPriceProduct = product;
                          }
                        }
                      }
                      
                      if (maxPriceProduct) {
                        const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
                        const perMain = this.deliveryDiscountPerMainProductUnit(
                          deletedDeliveryProduct || fallbackDel,
                          maxPriceProduct,
                          10
                        );
                        maxPriceProduct.discountAmount = Math.max(0, currentDiscount - perMain);
                        
                        // Пересчитываем отображаемую цену товара
                        maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
                        
                        // Пересчитываем итоговую стоимость товара
                        this.updateProductTotal(maxPriceProduct);
                        
                        // Обновляем массив товаров, чтобы Vue отследил изменения
                        if (!this.$route.params.orderId) {
                          const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                          if (index !== -1) {
                            this.$set(this.products, index, maxPriceProduct);
                          }
                        } else {
                          // Если используется store, нужно обновить товар через store
                          const updatedProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
                          const productInStore = updatedProducts.find(p => p.id === maxPriceProduct.id);
                          if (productInStore) {
                            productInStore.discountAmount = maxPriceProduct.discountAmount;
                            productInStore.displayPrice = maxPriceProduct.displayPrice;
                            this.updateProductTotal(productInStore);
                          }
                        }
                      }
                    }
                    
                    // Снимаем выделение способа оплаты
                    this.formData.deliveryPaidBy = null;
                  }
                  
                  // Проверяем наличие товаров установки (комплексов)
                  const hasInstallationProduct = products.some(p => COMPLEX_PRODUCT_IDS.includes(p.id));
                  if (!hasInstallationProduct) {
                    // Товары установки удалены - убираем скидку с первого товара, если была выбрана "За счет скидки"
                    if (this.formData.installationPaidBy === 'discount' && this.formData.installationComplex) {
                      // Определяем ID удаленного товара комплекса
                      const complexProductIds = {
                        complex1: '989773501',
                        complex2: '989773505',
                        complex3: '989773503'
                      };
                      const deletedComplexId = complexProductIds[this.formData.installationComplex];
                      
                      if (deletedComplexId) {
                        // Пытаемся найти удаленный товар установки в старом списке, чтобы узнать его реальную стоимость
                        const oldProductsList = oldProducts || [];
                        const deletedInstallationProduct = oldProductsList.find(p => p.id === deletedComplexId);
                        const installationPrice = deletedInstallationProduct 
                          ? Number(deletedInstallationProduct.displayPrice || deletedInstallationProduct.originalPrice || deletedInstallationProduct.price || 0)
                          : 0;
                        
                        // Находим товар с наибольшей ценой (исключая доставку и комплексы)
const productsWithoutDelivery = products.filter(p => 
            p.id !== DELIVERY_PRODUCT_ID && 
            !COMPLEX_PRODUCT_IDS.includes(p.id) &&
            !this.isExcludedFromTotalsStatus(p.status)
            );
                        
                        let maxPriceProduct = null;
                        if (productsWithoutDelivery.length > 0) {
                          maxPriceProduct = productsWithoutDelivery[0];
                          let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
                          
                          for (let i = 1; i < productsWithoutDelivery.length; i++) {
                            const product = productsWithoutDelivery[i];
                            const productPrice = parseFloat(product.originalPrice || product.price || 0);
                            if (productPrice > maxPrice) {
                              maxPrice = productPrice;
                              maxPriceProduct = product;
                            }
                          }
                        }
                        
                        if (maxPriceProduct && installationPrice > 0) {
                          const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
                          // Вычитаем реальную стоимость установки из скидки
                          maxPriceProduct.discountAmount = Math.max(0, currentDiscount - installationPrice);
                          
                          // Пересчитываем отображаемую цену товара
                          maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
                          
                          // Пересчитываем итоговую стоимость товара
                          this.updateProductTotal(maxPriceProduct);
                          
                          // Обновляем массив товаров, чтобы Vue отследил изменения
                          if (!this.$route.params.orderId) {
                            const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                            if (index !== -1) {
                              this.$set(this.products, index, maxPriceProduct);
                            }
                          } else {
                            // Если используется store, нужно обновить товар через store
                            const updatedProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
                            const productInStore = updatedProducts.find(p => p.id === maxPriceProduct.id);
                            if (productInStore) {
                              productInStore.discountAmount = maxPriceProduct.discountAmount;
                              productInStore.displayPrice = maxPriceProduct.displayPrice;
                              this.updateProductTotal(productInStore);
                            }
                          }
                        }
                      }
                    }
                    
                    // Снимаем выделение комплекса и способа оплаты ТОЛЬКО если товар был удален ВРУЧНУЮ
                    // Не сбрасываем, если мы сами меняем комплекс программно (changeInstallationComplex)
                    // КРИТИЧНО: Проверяем флаг ДО всех операций
                    if (!this.isChangingComplex) {
                      // Проверяем, что товар действительно отсутствует во всех комплексах
                      const allComplexProductIds = ['989773501', '989773505', '989773503'];
                      const hasAnyComplexProduct = products.some(p => allComplexProductIds.includes(p.id));
                      
                      // Сбрасываем только если НЕТ ни одного товара комплекса (т.е. были удалены вручную)
                      // И только если значения еще не были установлены программно
                      if (!hasAnyComplexProduct) {
                        // Дополнительная проверка: не сбрасываем, если значения были установлены недавно
                        // (защита от race condition)
                        const currentComplex = this.formData.installationComplex;
                        const currentPaidBy = this.formData.installationPaidBy;
                        
                        // Сбрасываем только если значения действительно должны быть null
                        if (currentComplex && !hasAnyComplexProduct) {
                          Vue.set(this.formData, 'installationComplex', null);
                        }
                        if (currentPaidBy && !hasAnyComplexProduct) {
                          Vue.set(this.formData, 'installationPaidBy', null);
                        }
                      }
                    }
                  }
                  
                  // Проверяем, остались ли товары (кроме доставки и комплексов)
                  // DELIVERY_PRODUCT_ID и COMPLEX_PRODUCT_IDS уже объявлены в начале watcher'а
                  const regularProducts = products.filter(p => 
                    p.id !== DELIVERY_PRODUCT_ID && 
                    !COMPLEX_PRODUCT_IDS.includes(p.id)
                  );
                  
                  // Если не осталось обычных товаров, очищаем емкость в зачет
                  if (regularProducts.length === 0) {
                    this.formData.batteryCapacityNew = '';
                    this.formData.tradeInAmountNew = '0.00';
                    this.previousTradeInAmount = 0;
                    this.previousCapacityDiscount = 0;
                    this.capacityWeightDifference = 0;
                    this.capacityWeightKg = 0;
                  }
                },
                deep: true
              },

               // Отслеживаем изменение типа доставки
                'formData.deliveryTypes'(newVal, oldVal) {
                  // Пропускаем обработку во время загрузки заказа, чтобы избежать зацикливания
                  if (this.isLoadingOrder) {
                    return;
                  }
                  
                  // Пропускаем, если новое значение не установлено
                  if (!newVal || !newVal.value) {
                    return;
                  }
                  
                  // Пропускаем, если значение не изменилось (только объект изменился)
                  if (oldVal && newVal && oldVal.value === newVal.value) {
                    return;
                  }

                  // Для vozim.by / экспресс — дата доставки не раньше сегодня
                  if (newVal.value === 'vozimby' || newVal.value === 'rb') {
                    this.ensureVozimDeliveryDate({ silent: true });
                  }
                  
                  const DELIVERY_PRODUCT_ID = '989773504';
                  
                  // Определяем тип доставки для правильной дефолтной цены
                  const deliveryType = newVal ? newVal.value : null;
                  const oldDeliveryType = oldVal ? oldVal.value : null;
                  const DEFAULT_DELIVERY_PRICE = this.getDefaultDeliveryPrice(deliveryType);
                  
                  // Определяем цену для старого типа доставки (для пересчета скидки)
                  const OLD_DELIVERY_PRICE = this.getDefaultDeliveryPrice(oldDeliveryType);
                  
                  // Проверяем, показывается ли блок доставки
                  const showDelivery = this.showDeliveryBlock;
                  
                  // Если блок доставки показывается, обновляем цену товара доставки при переключении типа
                  if (showDelivery) {
                    const products = this.$route.params.orderId 
                      ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
                      : this.products;
                    
                    const deliveryProduct = products.find(p => p.id === DELIVERY_PRODUCT_ID);
                    
                    // Если товар доставки существует и тип доставки изменился, обновляем цену
                    if (deliveryProduct && oldDeliveryType && oldDeliveryType !== deliveryType) {
                      // Проверяем, что переключаемся между типами, для которых действуют разные цены
                      const typesWithDifferentPrices = ['vozimby', 'courier', 'redirect'];
                      if (typesWithDifferentPrices.includes(deliveryType) || typesWithDifferentPrices.includes(oldDeliveryType)) {
                        const oldPrice = Number(deliveryProduct.displayPrice || deliveryProduct.originalPrice || deliveryProduct.price || OLD_DELIVERY_PRICE);
                        const newPrice = DEFAULT_DELIVERY_PRICE;
                        
                        // Обновляем цены товара доставки
                        deliveryProduct.price = newPrice;
                        deliveryProduct.originalPrice = newPrice;
                        deliveryProduct.displayPrice = newPrice;
                        deliveryProduct.total = newPrice * (deliveryProduct.quantity || 1);
                        
                        // Пересчитываем итоговую стоимость товара
                        this.updateProductTotal(deliveryProduct);
                        
                        // Если выбрано "за счет скидки", пересчитываем скидку на товаре с максимальной ценой
                        if (this.formData.deliveryPaidBy === 'discount') {
                          const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
                          const productsFiltered = products.filter(p => p.id !== DELIVERY_PRODUCT_ID && !COMPLEX_PRODUCT_IDS.includes(p.id) && !this.isExcludedFromTotalsStatus(p.status));
                          const maxPriceProduct = productsFiltered.length > 0 ? productsFiltered.reduce((max, p) => 
                            (parseFloat(p.originalPrice || p.price || 0) > parseFloat(max.originalPrice || max.price || 0) ? p : max)
                          ) : null;
                          
                          if (maxPriceProduct) {
                            let currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
                            const mainQty = this.getLineItemQuantity(maxPriceProduct);
                            const oldLine = oldPrice * this.getLineItemQuantity(deliveryProduct);
                            const newLine = newPrice * this.getLineItemQuantity(deliveryProduct);
                            
                            currentDiscount = Math.max(0, currentDiscount - oldLine / mainQty);
                            currentDiscount = currentDiscount + newLine / mainQty;
                            
                            maxPriceProduct.discountAmount = currentDiscount;
                            maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
                            this.updateProductTotal(maxPriceProduct);
                            
                            // Обновляем массив товаров
                            if (!this.$route.params.orderId) {
                              const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                              if (index !== -1) {
                                this.$set(this.products, index, maxPriceProduct);
                              }
                            } else {
                              const updatedProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
                              const productInStore = updatedProducts.find(p => p.id === maxPriceProduct.id);
                              if (productInStore) {
                                productInStore.discountAmount = maxPriceProduct.discountAmount;
                                productInStore.displayPrice = maxPriceProduct.displayPrice;
                                this.updateProductTotal(productInStore);
                              }
                            }
                          }
                        }
                        
                        // Обновляем товар доставки в массиве
                        if (!this.$route.params.orderId) {
                          const index = this.products.findIndex(p => p.id === DELIVERY_PRODUCT_ID);
                          if (index !== -1) {
                            this.$set(this.products, index, deliveryProduct);
                          }
                        } else {
                          const updatedProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
                          const productInStore = updatedProducts.find(p => p.id === DELIVERY_PRODUCT_ID);
                          if (productInStore) {
                            productInStore.price = deliveryProduct.price;
                            productInStore.originalPrice = deliveryProduct.originalPrice;
                            productInStore.displayPrice = deliveryProduct.displayPrice;
                            productInStore.total = deliveryProduct.total;
                            this.updateProductTotal(productInStore);
                          }
                        }
                      }
                    }
                  }
                  
                  // Товар доставки больше не добавляется здесь - он добавляется только при выборе способа оплаты
                  if (!showDelivery) {
                    // Блок доставки скрыт - удаляем товар доставки и убираем скидку с первого товара
                    const products = this.$route.params.orderId 
                      ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
                      : this.products;
                    
                    const deliveryProductIndex = products.findIndex(p => p.id === DELIVERY_PRODUCT_ID);
                    
                    if (deliveryProductIndex !== -1) {
                      // Сохраняем товар доставки перед удалением (для пересчёта скидки на основной товар)
                      const deliveryProduct = products[deliveryProductIndex];
                      const deliveryLineTotal = this.getDeliveryLineTotal(deliveryProduct, DEFAULT_DELIVERY_PRICE);
                      
                      // Удаляем товар доставки
                      if (this.$route.params.orderId) {
                        this.$store.commit('removeProduct', {
                          orderId: this.$route.params.orderId,
                          productId: DELIVERY_PRODUCT_ID
                        });
                      } else {
                        this.products.splice(deliveryProductIndex, 1);
                      }
                      
                      // Убираем скидку с первого товара, если она была добавлена из-за "За счет скидки"
                      if (this.formData.deliveryPaidBy === 'discount') {
                        // Находим первый товар в заказе (не товар доставки)
                        const updatedProducts = this.$route.params.orderId 
                          ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
                          : this.products;
                        
                        // Находим товар с наибольшей ценой (исключая доставку и комплексы)
                        const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
                        const productsWithoutDelivery = updatedProducts.filter(p => 
                          p.id !== DELIVERY_PRODUCT_ID && 
                          !COMPLEX_PRODUCT_IDS.includes(p.id) &&
                          !this.isExcludedFromTotalsStatus(p.status)
                        );
                        
                        let maxPriceProduct = null;
                        if (productsWithoutDelivery.length > 0) {
                          maxPriceProduct = productsWithoutDelivery[0];
                          let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
                          
                          for (let i = 1; i < productsWithoutDelivery.length; i++) {
                            const product = productsWithoutDelivery[i];
                            const productPrice = parseFloat(product.originalPrice || product.price || 0);
                            if (productPrice > maxPrice) {
                              maxPrice = productPrice;
                              maxPriceProduct = product;
                            }
                          }
                        }
                        
                        if (maxPriceProduct) {
                          const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
                          const perMain = this.deliveryDiscountPerMainProductUnit(
                            deliveryProduct,
                            maxPriceProduct,
                            DEFAULT_DELIVERY_PRICE
                          );
                          const mainQty = this.getLineItemQuantity(maxPriceProduct);
                          if (currentDiscount * mainQty >= deliveryLineTotal - 0.01) {
                            maxPriceProduct.discountAmount = Math.max(0, currentDiscount - perMain);
                          
                            // Пересчитываем отображаемую цену товара
                            maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
                            
                            // Пересчитываем итоговую стоимость товара
                            this.updateProductTotal(maxPriceProduct);
                            
                            // Обновляем массив товаров, чтобы Vue отследил изменения
                            if (!this.$route.params.orderId) {
                              const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                              if (index !== -1) {
                                this.$set(this.products, index, maxPriceProduct);
                              }
                            }
                          }
                        }
                      }
                    }
                    
                    // Сбрасываем способ оплаты доставки
                    this.formData.deliveryPaidBy = null;
                  }
                  
                  // Проверяем, показывается ли блок установки
                  const showInstallation = this.showInstallationBlock;
                  
                  if (!showInstallation) {
                    // Блок установки скрыт - удаляем товары комплексов и убираем скидку
                    const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
                    const products = this.$route.params.orderId 
                      ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
                      : this.products;
                    
                    // Удаляем все товары комплексов
                    COMPLEX_PRODUCT_IDS.forEach(complexProductId => {
                      const complexProductIndex = products.findIndex(p => p.id === complexProductId);
                      
                      if (complexProductIndex !== -1) {
                        // Если был выбран "За счет скидки", убираем скидку с товара с максимальной ценой
                        if (this.formData.installationPaidBy === 'discount') {
                          const complexProduct = products[complexProductIndex];
                          const complexPrice = Number(complexProduct.displayPrice || complexProduct.originalPrice || complexProduct.price || 0);
                          
                          // Находим товар с наибольшей ценой (не доставка и не комплексы)
                          const DELIVERY_PRODUCT_ID = '989773504';
                          const productsFiltered = products.filter(p => p.id !== DELIVERY_PRODUCT_ID && !COMPLEX_PRODUCT_IDS.includes(p.id) && !this.isExcludedFromTotalsStatus(p.status));
                          const maxPriceProduct = productsFiltered.length > 0 ? productsFiltered.reduce((max, p) => 
                            (parseFloat(p.originalPrice || p.price || 0) > parseFloat(max.originalPrice || max.price || 0) ? p : max)
                          ) : null;
                          
                          if (maxPriceProduct && complexPrice > 0) {
                            const currentDiscount = Number(maxPriceProduct.discountAmount) || 0;
                            maxPriceProduct.discountAmount = Math.max(0, currentDiscount - complexPrice);
                            maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
                            this.updateProductTotal(maxPriceProduct);
                            
                            if (!this.$route.params.orderId) {
                              const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
                              if (index !== -1) {
                                this.$set(this.products, index, maxPriceProduct);
                              }
                            } else {
                              const storeProducts = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
                              const productInStore = storeProducts.find(p => p.id === maxPriceProduct.id);
                              
                              if (productInStore) {
                                productInStore.discountAmount = maxPriceProduct.discountAmount;
                                productInStore.displayPrice = maxPriceProduct.displayPrice;
                                this.updateProductTotal(productInStore);
                              }
                            }
                          }
                        }
                        
                        // Удаляем товар комплекса
                        if (this.$route.params.orderId) {
                          this.$store.commit('removeProduct', {
                            orderId: this.$route.params.orderId,
                            productId: complexProductId
                          });
                        } else {
                          const index = this.products.findIndex(p => p.id === complexProductId);
                          if (index !== -1) {
                            this.products.splice(index, 1);
                          }
                        }
                      }
                    });
                    
                    // Очищаем выбор комплекса и способа оплаты
                    this.formData.installationComplex = null;
                    this.formData.installationPaidBy = null;
                    this.isComplexSelectDropdownOpen = false;
                    this.closeComplexDropdown();
                  }
              },

               'formData.phone'(newVal) {
                  this.updateFormattedPhone();
                },

                 'formData.selectionLink'(newVal) {
                    this.validateSelectionLink();
                    this.checkInstallationPrice();
                    this.getPopularBatteries();
                  },

                  'formData.carBodyType'() {
                    this.updateCorpusMatchStatus();
                  },

                  'formData.carBrand'() { this.scheduleAiFitCheck(); },
                  'formData.carModel'() { this.scheduleAiFitCheck(); },
                  'formData.carName'() { this.scheduleAiFitCheck(); },
                  'formData.carYear'() { this.scheduleAiFitCheck(); },
                  'formData.fuelType'() { this.scheduleAiFitCheck(); },
                  'formData.auto'() { this.scheduleAiFitCheck(); },

                  products: {
                    deep: true,
                    handler() {
                      this.updateCorpusMatchStatus();
                    }
                  },

                  // Синхронизация полей менеджера (удален приоритет старого поля над новым)

                  'formData.manager_new'(newVal, oldVal) {
                    // Если manager_new не пустое, ищем соответствующего менеджера в массиве managers
                    if (newVal && newVal.label) {
                      const correspondingManager = this.managers.find(m => m.label === newVal.label);
                      if (correspondingManager) {
                        this.formData.manager = correspondingManager;
                      }
                    }
                  },

                  orderViewers(newViewers) {
                    console.log('Список зрителей изменился:', newViewers);
                    // Здесь можно запускать дополнительную логику
                  },
                  grandTotal(newTotal, oldTotal) {
                  if (this.isFirstGrandTotalCall) {
                    this.isFirstGrandTotalCall = false;
                    return;
                  }
                  // Не трогаем платежи/API во время load/reload заказа
                  if (!this.isInitialized || this.isLoadingOrder || this.isAdjustingPayments) return;

                  // Игнор float-шума (1800.04 vs 1800.039999999)
                  const next = Math.round((Number(newTotal) || 0) * 100) / 100;
                  const prev = Math.round((Number(oldTotal) || 0) * 100) / 100;
                  if (next === prev) return;

                  this.adjustPaymentsAfterTotalChange(next);
                  this.updateBonusAmount();

                  this.manualOverride = false;
                  // Только синхронизация платежей. createOrder()+fetchOrder() здесь
                  // давали цикл: toast «Платежи обновлены» → reload → grandTotal → снова save.
                  if (this.grandTotalPaymentsTimer) {
                    clearTimeout(this.grandTotalPaymentsTimer);
                  }
                  this.grandTotalPaymentsTimer = setTimeout(() => {
                    if (this.isLoadingOrder || !this.isInitialized) return;
                    this.persistPaymentsAfterTotalChange();
                  }, 1100);
                },
  'formData.tradeInAmountNew': function (newTradeInAmount) {
    const DELIVERY_PRODUCT_ID = '989773504';
    const COMPLEX_PRODUCT_IDS = ['989773501', '989773505', '989773503'];
    
    const newTradeIn = Number(newTradeInAmount) || 0;
    const previousTradeIn = Number(this.previousTradeInAmount) || 0;
    
    // Вычисляем разницу между новым и предыдущим значением
    const tradeInDifference = newTradeIn - previousTradeIn;
    
    // Если разницы нет, ничего не делаем
    if (tradeInDifference === 0) {
      return;
    }
    
    // Получаем актуальный список товаров
    let products = this.$route.params.orderId 
      ? (this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [])
      : this.products;
    
    // Находим товар с наибольшей ценой (исключая доставку и комплексы)
const productsWithoutDelivery = products.filter(p => 
            p.id !== DELIVERY_PRODUCT_ID && 
            !COMPLEX_PRODUCT_IDS.includes(p.id) &&
            !this.isExcludedFromTotalsStatus(p.status)
            );
    
    if (productsWithoutDelivery.length === 0) {
      // Если нет товаров, просто сохраняем новое значение
      this.previousTradeInAmount = newTradeIn;
      return;
    }
    
    // Находим товар с наибольшей originalPrice
    let maxPriceProduct = productsWithoutDelivery[0];
    let maxPrice = parseFloat(maxPriceProduct.originalPrice || maxPriceProduct.price || 0);
    
    for (let i = 1; i < productsWithoutDelivery.length; i++) {
      const product = productsWithoutDelivery[i];
      const productPrice = parseFloat(product.originalPrice || product.price || 0);
      if (productPrice > maxPrice) {
        maxPrice = productPrice;
        maxPriceProduct = product;
      }
    }
    
    // discountAmount хранится ЗА ОДНУ штуку и в итоге умножается на quantity.
    // Сумма за лом — общая на заказ, поэтому разницу распределяем на единицу:
    // иначе при qty >= 2 лом вычитается несколько раз.
    const quantity = this.getLineItemQuantity(maxPriceProduct);
    const currentDiscountPerUnit = Number(maxPriceProduct.discountAmount) || 0;
    const currentTotalDiscountOnProduct = currentDiscountPerUnit * quantity;
    const newTotalDiscountOnProduct = Math.max(0, currentTotalDiscountOnProduct + tradeInDifference);
    const newDiscountPerUnit = parseFloat((newTotalDiscountOnProduct / quantity).toFixed(2));
    
    // Обновляем скидку товара (за одну штуку)
    maxPriceProduct.discountAmount = newDiscountPerUnit;
    
    // Пересчитываем отображаемую цену товара
    maxPriceProduct.displayPrice = this.calculateDiscountedPrice(maxPriceProduct);
    
    // Пересчитываем итоговую стоимость товара
    this.updateProductTotal(maxPriceProduct);
    
    // Обновляем массив товаров, чтобы Vue отследил изменения
    if (this.$route.params.orderId) {
      const productsInStore = this.$store.getters.getProductsByOrderId(this.$route.params.orderId) || [];
      const productInStore = productsInStore.find(p => p.id === maxPriceProduct.id);
      if (productInStore) {
        productInStore.discountAmount = maxPriceProduct.discountAmount;
        productInStore.displayPrice = maxPriceProduct.displayPrice;
        this.updateProductTotal(productInStore);
      }
    } else {
      const index = this.products.findIndex(p => p.id === maxPriceProduct.id);
      if (index !== -1) {
        this.$set(this.products, index, maxPriceProduct);
      }
    }
    
    // Сохраняем новое значение для следующего пересчёта
    this.previousTradeInAmount = newTradeIn;
    
    // Пересчитываем общую скидку
    this.updateTotalDiscount();
  }
            },
  
  mounted() {

      this.$root.$on('save-and-exit-order', this.handleSaveAndExitOrder);
      this.validateSelectionLink(); // при загрузке сразу проверить

      
  
      Promise.all([
         this.fetchOrderStatuses([parseInt(this.$route.params.orderId)], [String(this.$route.params.orderId)])
          .then(statuses => {
            console.log(statuses);
          }),
          this.fetchManagers(),
          this.fetchManagersUpdate(),
          this.fetchCurier(),
          this.fetchPayment(),
          this.fetchStores(),
          this.fetchOrderMethods(),
          this.fetchSeller(),
          this.fetchShipmentStore(),
          this.fetchOrderTypes(),
          this.fetchRegions(),
          this.fetchProductStatus(),
          this.fetchPredoplata(),
          this.fetchBezoplaty(),
          this.getOcenkaKU(),
          this.getOcenkaPR(),
          this.getOcenka(),
          this.getManagers(),
          this.getProverka(),
          this.getDgh66hhhhhhh(),
          this.fetchObzvon_klienta(),
          this.fetchDeliveryTypes(),
          this.fetchRetailStatuses()
        ]).then(() => {
          // Теперь загружаем заказ, когда все данные уже есть
          setTimeout(() => {

          this.fetchOrder(this.$route.params.orderId, this.$route.params.site);
          this.fetchTasksByOrderId(this.$route.params.orderId);
          
          setTimeout(() => {

            // Теперь, когда заказ загружен — вызываем
            //  if (this.customerInfo.id) {
            //   this.fetchCustomerDouble(this.customerInfo.id);
            // };
            if (this.customerInfo.phone) {
              this.fetchCustomerDouble(this.customerInfo.phone);

            };
           
          this.loadSavedForm();
          
          this.fetchClientBonus(this.formData.phone);
          
          this.selectManager();
          }, 800);


         document.addEventListener('click', this.handleClickOutsideDropdown);
         
         // Добавляем обработчик скролла для навигации
         window.addEventListener('scroll', this.handleScroll);


          const orderId = this.$route.params.orderId;
          const user = {
            id: this.$store.state.user.id,
            label: this.$store.state.user.label,
            retailCrmId: this.$store.state.user.retailCrmId
          };

          // Получаем WebSocket (например, через inject или другой способ)
          const ws = this.ws(); // Получаем WebSocket через inject
          console.log("WebSocket соединение:", ws);

          // Отправляем сообщение о том, что пользователь начинает просмотр заказа
          if (ws && ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify({ type: 'viewOrder', orderId, user }));
            console.log('отправлено');
            console.log(orderId);
            console.log(user);
          }

          // Обработчик входящих сообщений
          this.wsMessageHandler = (event) => {
            try {
              const data = JSON.parse(event.data);

              // Локальная фильтрация — обрабатываем только нужные типы
              if (data.type === 'orderViewers') {
                this.orderViewers = data.viewers;
                console.log('Текущие зрители:', data.viewers);
              }

              if (data.type === 'allOrderViewers') {
                console.log('Глобальное обновление:', data.data);
              }

            } catch (err) {
              console.error('Ошибка при обработке входящего сообщения:', err);
            }
          };
          
          ws.addEventListener('message', this.wsMessageHandler);


         this.initializeData();

        }, 1500);
    }).catch(error => {
      console.error('Ошибка при загрузке данных:', error);
    });


  },
  beforeDestroy() {
    // Удаляем обработчик скролла
    window.removeEventListener('scroll', this.handleScroll);
    // Очищаем обработчики событий
    document.removeEventListener('click', this.handleClickOutsideDropdown);
    document.removeEventListener('click', this.closeCopyDropdownOnOutsideClick);
    document.removeEventListener('click', this.closePrintDropdownOnOutsideClick);
    this.$root.$off('save-and-exit-order', this.handleSaveAndExitOrder);
    if (this.grandTotalPaymentsTimer) {
      clearTimeout(this.grandTotalPaymentsTimer);
      this.grandTotalPaymentsTimer = null;
    }
    
    // Очищаем список просматривающих заказ
    this.orderViewers = [];
    
    // Удаляем обработчик WebSocket сообщений
    const ws = this.ws();
    if (ws && this.wsMessageHandler) {
      ws.removeEventListener('message', this.wsMessageHandler);
      this.wsMessageHandler = null;
    }
    
    // Отправляем сообщение о прекращении просмотра заказа через WebSocket
    const orderId = this.$route.params.orderId;
    const user = {
      id: this.$store.state.user.id,
      label: this.$store.state.user.label,
      retailCrmId: this.$store.state.user.retailCrmId
    };
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: 'stopViewOrder', orderId, user }));
      console.log('Отправлено сообщение о прекращении просмотра заказа при уничтожении компонента');
    }
  },
  beforeRouteLeave(to, from, next) {
    this.handleBeforeUnload();
    next();
  }


};
</script>

<style scoped>



.omnica-button.omnica-button_transcription {
    padding: 6px;
}
.brak-hint-label {
  display: inline-block;
  margin-right: 12px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  text-transform: lowercase;
  color: #6b7280;
  background: #f3f4f6;
  border: 1px dashed #9ca3af;
  border-radius: 4px;
  cursor: pointer;
  vertical-align: middle;
  user-select: none;
}
.brak-hint-label_ready {
  color: #0d6e3f;
  background: #e8f5e9;
  border-color: #66bb6a;
}
.brak-hint-label_loading {
  opacity: 0.7;
  pointer-events: none;
}
.omnica-button.omnica-button_hint {
  margin-left: 6px;
  padding: 4px 8px;
  font-size: 11px;
  background: #fff8e1;
  border: 1px solid #ffc107;
  color: #6d4c00;
  border-radius: 4px;
  cursor: pointer;
}
.omnica-button.omnica-button_hint:hover {
  background: #ffecb3;
}
.client-hint-title {
  margin: 0;
  font-size: 18px;
}
.client-hint-body {
  white-space: pre-wrap;
  line-height: 1.5;
}
.client-hint-text {
  margin-top: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 6px;
  font-size: 14px;
}
.client-hint-claims {
  margin-bottom: 8px;
}
.client-hint-claims .tag-item {
  margin-left: 6px;
}
.client-hint-catalog {
  margin-bottom: 12px;
  font-size: 13px;
}
.client-hint-catalog ul {
  margin: 6px 0 0 18px;
  padding: 0;
}
.client-hint-status {
  padding: 16px 0;
  color: #555;
}
.client-hint-error {
  color: #c62828;
}
.omnica-button.omnica-button_transcription:hover {
    background: #0078d7;
    color: #fff;
 }
.custom-status-color-new {
  color:#fff !important;
}
.custom-status-color-5asjkdhgfilu333 {
  color: #168561 !important;
}
.custom-status-color-dffddsdfsdd {
  color: #bc6b01 !important;
}
.custom-status-color-otmenaskomentom,
.custom-status-color-otmena-dubl{
  color: #b73232 !important;
}
.custom-status-color-send-to-delivery,
.custom-status-color-dskjdslksd {
  color: #0044b7 !important;
}
.custom-status-color-assembling {
  color: #4a2aa5 !important;
}

.grid__box .bill.cleared.mr10.custom {
  max-width: 100% !important;
}

.order-head {
    padding: 32px 0 24px;
}



.tagbutclose:hover {
  transition: 0.3s;
  transform: rotate(180deg);
}

.tagbutclose:hover svg path{
  fill: #000;
}

.order-head__flex {
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
}

.order-head>div {
    color: #1e2248;
    font-size: 12px;
}


.order-num {
    font-size: 24px;
    font-weight: 500;
}

.s-and-a {
    font-size: 12px;
    line-height: 14px;
    margin: 0 0 0 24px;
}

.s-and-a__discr {
    color: #636f7f !important;
    font-style: normal !important;
}

.s-and-a .value {
    font-weight: 600;
}

.s-and-a .value, .s-and-a.gemmated span {
    color: #1e2248;
    font-size: 14px;
    line-height: 20px;
}

.order-num, .order-num span {
    color: #1e2248;
}

.order-head {


}

.order-head__flex {
    align-items: flex-end;
    display: flex;
}

.order-head>div {
    color: #1e2248;
    font-size: 12px;
        width: 100%;
}


.order-num {
    font-size: 24px;
    font-weight: 500;
}


.order-num, .order-num span {
    color: #1e2248;
}

.mx-datepicker {
    position: relative;
    display: inline-block;
    width: 212px;
}

.mx-icon-calendar, .mx-icon-clear {
    position: absolute;
    top: 16px!important;
    right: -10px;
    -webkit-transform: translateY(-50%);
    transform: translateY(-42%);
    font-size: 16px;
    line-height: 1;
    color: rgba(0, 0, 0, .5);
    vertical-align: middle;
}
.btn.white {
    margin-right: 10px;
    
}

.loader-overlay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.order-table-footer {
    display: flex;
    padding: 0 24px;
    border-top: solid 0px #dee2e6;
}

.order-empty {
    padding: 10px;
}

.order-table-footer__left {
    display: block;
    flex-grow: 1;
    padding: 24px 24px 24px 0;
}

.footer-delivery-split-container {
    display: flex;
    gap: 24px;
}

.footer-delivery-left-half {
    flex: 1;
    min-width: 0;
}

.footer-delivery-right-half {
    flex: 1;
    min-width: 0;
}

.footer-payment-labels {
    display: flex;
    gap: 12px;
    margin-bottom: 8px;
    border-bottom: solid 1px #e9ecef;
    padding: 3px 0px;
}

.footer-payment-label {
    flex: 1;
    font-size: 13px;
    font-weight: 600;
    color: #000000;
    text-align: left;
}

.footer-dashed-blocks-row {
    display: flex;
    gap: 12px;
    margin-top: 8px;
}

.footer-dashed-blocks-row:first-of-type {
    margin-top: 0;
}

.footer-dashed-block {
    flex: 1;
    min-height: 40px;
    border: 1px dashed #dee2e6;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    color: #868e96;
    cursor: pointer;
    transition: all 0.2s;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    background: #f8f9fb;
}

.footer-dashed-block:hover {
    border-color: #005eeb;
    color: #005eeb;
    background: #f0f7ff;
}

.footer-dashed-block-disabled {
    opacity: 0.45;
    cursor: not-allowed;
    pointer-events: none;
}

.footer-dashed-block-disabled:hover {
    border-color: #dee2e6;
    color: #868e96;
    background: #f8f9fb;
}

.footer-dashed-block-filled {
    border: 2px solid #005eeb;
    background: #005eeb;
    color: #ffffff;
}

.footer-dashed-block-filled:hover {
    border-color: #0048c4;
    background: #0048c4;
    color: #ffffff;
}

.footer-dashed-block-with-dropdown {
    position: relative;
}

.footer-edit-complex-btn {
    position: absolute;
    right: 4px;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    padding: 0;
    border: none;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.7;
    transition: opacity 0.2s, background 0.2s;
}

.footer-edit-complex-btn:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.5);
}

.footer-edit-complex-btn svg {
    width: 12px;
    height: 12px;
    stroke: currentColor;
}

.footer-dashed-block-filled .footer-edit-complex-btn {
    color: #ffffff;
}

.footer-dashed-block-with-dropdown {
    position: relative;
}

.footer-dashed-block-with-dropdown {
    position: relative;
}

.footer-complex-display {
    width: 100%;
    padding: 8px 32px 8px 12px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.15);
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.2s ease;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.15);
    position: relative;
}

.footer-complex-display::after {
    content: '';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid currentColor;
    opacity: 0.7;
}

.footer-complex-display-title {
    font-size: 13px;
    font-weight: 600;
}

.footer-complex-display-subtitle {
    font-size: 11px;
    line-height: 1.3;
    opacity: 0.8;
}

.footer-complex-display:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: translateY(-1px);
}

.footer-complex-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 12px 24px rgba(17, 24, 39, 0.18);
    padding: 6px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    z-index: 10;
}

.footer-complex-option {
    border: none;
    background: transparent;
    text-align: left;
    padding: 10px 12px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.2s ease;
    color: #1e2248;
}

.footer-complex-option:hover {
    background: #f1f4ff;
    transform: translateY(-1px);
}

.footer-complex-option.is-active {
    background: #e7efff;
    box-shadow: inset 0 0 0 1px #005eeb;
}

.footer-complex-option-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 13px;
}

.footer-complex-option-price {
    color: #005eeb;
}

.footer-complex-option-desc {
    font-size: 11px;
    color: #4f566b;
    line-height: 1.3;
}

.footer-complex-select-btn {
    width: 100%;
    max-width: 280px;
    padding: 10px 12px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background: #ffffff;
    color: #495057;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.2s ease;
    text-align: left;
}

.footer-complex-select-btn-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
}

.footer-complex-select-btn-title {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
}

.footer-complex-select-btn-desc {
    font-size: 11px;
    font-weight: 400;
    line-height: 1.3;
    opacity: 0.8;
}

.footer-complex-select-btn:hover {
    border-color: #005eeb;
    background: #f0f7ff;
    color: #005eeb;
}

.footer-complex-select-btn.is-active {
    border-color: #005eeb;
    background: #005eeb;
    color: #ffffff;
}

.footer-complex-select-btn.is-active .footer-complex-select-btn-desc {
    opacity: 0.9;
}

.footer-complex-select-btn.is-active svg {
    stroke: #ffffff;
}

.footer-complex-select-btn svg {
    flex-shrink: 0;
    stroke: currentColor;
    transition: transform 0.2s ease;
}

.footer-complex-select-dropdown {
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 12px 24px rgba(17, 24, 39, 0.18);
    padding: 6px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    z-index: 10;
    max-height: 300px;
    overflow-y: auto;
}

.footer-complex-select-option {
    border: none;
    background: transparent;
    text-align: left;
    padding: 10px 12px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    cursor: pointer;
    transition: background 0.2s ease, transform 0.2s ease;
    color: #1e2248;
}

.footer-complex-select-option:hover {
    background: #f1f4ff;
    transform: translateY(-1px);
}

.footer-complex-select-option.is-active {
    background: #e7efff;
    box-shadow: inset 0 0 0 1px #005eeb;
}

.order-table-footer__right {
    padding: 24px 0;
}

.footer-section-block {
    margin-bottom: 16px;
}

.footer-section-block:last-child {
    margin-bottom: 0;
}

.footer-section-title {
    font-size: 13px;
    font-weight: 600;
    color: #1e2248;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid #e9ecef;
}

.footer-section-content {
    display: flex;
    flex-direction: row;
    gap: 12px;
    flex-wrap: wrap;
}

.footer-checkbox-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px 8px;
    margin: -4px -8px;
    border-radius: 4px;
    font-size: 12px;
    color: #495057;
    transition: background-color 0.2s, color 0.2s;
    white-space: nowrap;
    font-weight: 600;
    margin-right: 15px;
}

.footer-checkbox-item:hover {
    background-color: #f8f9fa;
}

.footer-checkbox-item:hover {
    color: #1e2248;
}

.footer-checkbox-item input[type="checkbox"],
.footer-checkbox-item input[type="radio"] {
    margin-right: 8px;
    cursor: pointer;
    flex-shrink: 0;
    width: 16px;
    height: 16px;
}

.footer-checkbox-item-text {
    align-items: flex-start;
    line-height: 1.4;
}

.footer-checkbox-item-text input[type="checkbox"] {
    margin-top: 2px;
}

.footer-checkbox-item-text span {
    flex: 1;
}

.footer-section-content-compact {
    display: flex;
    flex-direction: row;
    gap: 12px;
    flex-wrap: wrap;
}

.footer-checkbox-item-compact {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    padding: 4px 6px;
    margin: -4px -6px;
    border-radius: 4px;
    transition: background-color 0.2s;
    font-size: 11px;
    line-height: 1.4;
    flex: 1;
    min-width: 200px;
    max-width: 300px;
}

.footer-checkbox-item-compact:hover {
    background-color: #f8f9fa;
}

.footer-checkbox-item-compact input[type="radio"] {
    margin-right: 6px;
    margin-top: 2px;
    cursor: pointer;
    flex-shrink: 0;
    width: 14px;
    height: 14px;
}

.footer-checkbox-text {
    flex: 1;
    color: #495057;
}

.footer-checkbox-text strong {
    color: #1e2248;
    font-weight: 600;
    white-space: nowrap;
    font-size: 12px;
}

.footer-select-field {
    width: 100%;
    max-width: 300px;
}

.complex-price {
    color: #005eeb;
    font-weight: 600;
    margin-left: 8px;
    font-size: 12px;
}

.order-extra-block__option {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1e2248;
}

.order-extra-block__option input {
    margin-right: 8px;
}

.order-extra-block__placeholder {
    margin: 0;
    font-size: 13px;
    color: #868e96;
}

.order-table-footer__right {
    border-left: 1px solid #dee2e6;
    padding-left: 72px;
}

.m-box.order-products-table-box .patch-target {
    transition: .3s;
}

.custom-status-color-stoffnksajn12212 {
  color: #fff !important;
}


.order-table-footer__list {
    list-style: none;
    padding: 0;
}

.order-table-footer__list_info {
    min-width: 240px;
}

.order-table-footer__list:not(:last-child) {
    margin-bottom: 14px;
}

.order-table-footer__total {
    color: #1e2248;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.55555556;
    text-align: right;
}



.order-table-footer__list-item {
    align-items: center;
    display: flex;
}


.order-table-footer__list-item:not(:last-child) {
    margin-bottom: 8px;
}



.order-table-footer__text_full {
    flex-grow: 1;
}

.order-table-footer__text_muted {
    color: #636f7f;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
    text-align: right;
}



.order-table-footer__text {
    color: #0d0f1f;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.order-table-footer__text_charge, .order-table-footer__text_price, .order-table-footer__text_writeoff {
    min-width: 74px;
    text-align: right;
}

.order-table-footer__text+.order-table-footer__text {
    margin-left: 16px;
}

p {
    margin:0px;
}

.header-main {
    display: table;
    empty-cells: hide;
    padding: 32px 0 24px;
    width: 100%;
}



.header-main .hm-left {
    width: auto;
}

.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}



.header-main .hm-left, .header-main .hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
}

.header-main .hm-right{
    white-space: nowrap;
    width: 1%;
}

.btn-close-order {
    background: none;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 14px;
    font-size: 0;
    font-weight: 400;
    height: 21px;
    line-height: 20px;
    line-height: 17px;
    overflow: hidden;
    padding: 8px;
    position: relative;
    text-decoration: none;
    text-overflow: ellipsis;
    text-shadow: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
    width: 21px;
}

.btn-close-order:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    height: 21px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 21px;
}

.list-box-two {
        display: flex;
    justify-content: space-between;
}

textarea.input-field {
    display: block;
    font-family: inherit;
    height: 140px!important;
    line-height: 18px;
    padding-top: 5px;
    resize: none;
}










table td {
    empty-cells: show;
}

.modern-table tr td {
    border-bottom: 1px solid #dee2e6;
    color: #1e2248;
    font-size: 12px;
    padding: 8px 5px;
    text-align: right;
    vertical-align: middle;
}
.modern-table tr td.select, .modern-table tr td.title, .modern-table tr th.select, .modern-table tr th.title {
    text-align: left;
}
.modern-table tr:last-child td {
    border-bottom-width: 0;
}

.modern-table.order-products tr td, .modern-table.order-products tr th {
    padding-left: 10px;
    padding-right: 10px;
}

.modern-table.order-products tr td {
    padding: 15px 10px;
    vertical-align: top;
}

.modern-table.order-products tr td.bord, .modern-table.order-products tr th.bord {
    border-right: 1px solid #dee2e6;
}

.modern-table.order-products tr td.title {
    font-size: 13px;
    padding-left: 0;
}

.modern-table.order-products tr:last-child td {
    border-bottom-width: 1px;
}



.qty-btn, .add-btn {
    margin: 0 4px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border: none;
    cursor: pointer;
    color: #ffffff;
    border-radius: 5px;
    transition: background 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.qty-btn-increase {
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
}

.qty-btn-decrease {
    color: #000000;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    box-shadow: none;
    font-weight: 600;
}

.order-price__dropdown {
    position: absolute;
    background: #fff;
    border: 1px solid #ccc;
    padding: 15px;
    border-radius: 5px;
    z-index: 10;
    width: 300px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.order-price__caption {
    font-weight: bold;
    margin-bottom: 5px;
}



.order-price__input-wrap {
    display: flex;
    align-items: center;
    gap: 5px;
}

.order-price__controls {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.order-price__input_size_l {
    flex-grow: 1;
}

.order-price__error-wrap {
    min-height: 24px;
}

.order-discount__currency {
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    margin-left: 4px;
}

.order-price__controls_column {
    flex-direction: column;
}

.order-price__caption {
    color: #636f7f;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
    margin-bottom: 8px;
}

.order-price__controls {
    display: flex;
    font-style: normal;
    margin-bottom: 0;
}

.order-price__input-wrap {
    align-items: center;
    display: flex;
    position: relative;
}

.order-price__input {
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    border-radius: 6px;
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    height: 30px;
    height: 36px;
    line-height: 1.42857143;
    outline: none;
    padding: 0 16px;
    width: 88px;
}

.order-price__button:not(:last-child) {
    margin-right: 16px;
}

.order-price__controls button {
    color: #ffffff;
}

.btn.order-price__cancel {
    background-color: #fff;
    background-image: linear-gradient(180deg, #fff, #e9ecee);
    border: 1px solid #dee2e6;
    text-shadow: none;
    color: black;
}

.order-price__value {
    border-bottom: 1px dotted;
    color: #0052cc;
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}
.order-price__value_column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
}
.order-price__value_column .order-price__old {
    text-decoration: line-through;
    color: #888;
    font-size: 12px;
}
.order-price__value_column .original-price {
    margin-left: 0;
    font-size: 12px;
}

.modern-order-table .value.patch-target, .modern-order-table .value.price__value {
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.modern-order-table .subtotal .value.patch-target {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.42857143;
    margin-bottom: 12px;
    position: relative;
    white-space: nowrap;
}



.order-row__top {
    display: none;
}

.order-row__title {
    align-items: center;
    color: #636f7f;
    display: inline-flex;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.42857143;
}

.order-row__title:not(:last-child) {
    margin-right: 24px;
}

.order-discount, .order-discount__input-wrap {
    display: flex;
    position: relative;
}



.order-discount, .order-discount__input-wrap {
    display: flex;
    position: relative;
}

.order-discount__input-wrap {
    align-items: center;
}

.order-discount__input {
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    height: 30px;
    line-height: 1.42857143;
    outline: none;
    padding: 0 16px;
    width: 72px;
}

.order-discount__currency {
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    margin-left: 4px;
}

.order-discount__input-wrap+.order-discount__input-wrap {
    margin-left: 16px;
}

.modern-order-table .min-input.quantity {
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: none;
    color: #1e2248;
    font-size: 14px!important;
    font-weight: 400;
    height: 30px!important;
    line-height: 1.42857143;
    outline: none;
    padding: 0 8px;
    width: 44px;
    text-align:right;
}

.button_quantity {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.inline-tooltip__target.js-subtotal-value {
        font-size: 14px;
    font-weight: 500;
    line-height: 1.42857143;
    margin-bottom: 12px;
    position: relative;
    white-space: nowrap;
}




.order-table-footer__list-item {
    align-items: center;
    display: flex;
}

.order-table-footer__list-item:not(:last-child) {
    margin-bottom: 8px;
}

.order-table-footer__text_full {
    flex-grow: 1;
}





.order-table-footer__text {
    color: #0d0f1f;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.order-table-footer__text_charge, .order-table-footer__text_price, .order-table-footer__text_writeoff {
    min-width: 74px;
    text-align: right;
}

.order-table-footer__text+.order-table-footer__text {
    margin-left: 16px;
}


.order-table-footer__total {
    color: #1e2248;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.55555556;
    text-align: right;
}

.order-table-footer__text_muted {
    color: #636f7f;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
    text-align: right;
}

.modern-order-table .subtotal .info-btn-group {
    bottom: 15px;
    margin-right: 0;
    margin-top: 0;
    position: absolute;
    right: 15px;
}

.info-btn {
    min-width: 30px;
}

.info-btn, .info-btn__switch {
    display: inline-block;
    height: 30px;
    position: relative;
    vertical-align: top;
    width: 30px;
}

.info-btn__switch {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: 20px 14px;
    border: 1px solid transparent;
    cursor: pointer;
    margin: 0 !important;
}



.info-btn__switch_trash {
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 11 14%27%3E%3Cg fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%23E6E6E6%27%3E%3Cpath d=%27M1 2h9c.6 0 1 .4 1 1s-.4 1-1 1H1c-.6 0-1-.4-1-1s.4-1 1-1zM3.5 0h4c.3 0 .5.2.5.5s-.2.5-.5.5h-4C3.2 1 3 .8 3 .5s.2-.5.5-.5zM2 5v7c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2V5H2zm3 6.5c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4zm2 0c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5s.5.2.5.5v4z%27/%3E%3C/g%3E%3C/svg%3E");
}

.modern-order-table .info-btn__switch_trash {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%238A96A6' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
    background-size: 16px;
}

.modern-order-table .info-btn__switch_trash:hover:not(.disabled) {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.info-btn__tooltip {
    background-color: #3a3a3a;
    border-radius: 2px;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .15);
    color: #fff !important;
    font-size: 12px;
    left: 50%;
    line-height: 15px;
    margin-left: 0 !important;
    opacity: 0;
    padding: 3px 0;
    position: absolute;
    text-align: center;
    top: calc(100% + 4px);
    transform: translate3d(-50%, 0, 0);
    transition: .15s ease;
    visibility: hidden;
    width: 130px;
    z-index: 100;
}

#app {
    padding-bottom: 150px;
}



.gray-bg, .red-bg {
    background: #f9fafb;
    border-radius: 5px;
    display: inline-block;
    float: left;
    padding: 5px 10px 7px;
}

.m-box .gray-bg {
    background-color: #f4f6f8;
}




.gray-bg input, .red-bg input {
    background: none;
    border: none;
    border-bottom: 1px solid #ccc;
    color: #005eeb;
    display: inline-block;
    font-size: 13px;
    max-width: 72px;
    text-align: right;
}

.gray-bg input.short, .red-bg input.short {
    max-width: 52px;
}

.gray-bg input.center, .red-bg input.center {
    text-align: center;
}


.dropdown, .dropdown_hover {
    display: inline-block;
    position: relative;
}
.select-time-btn {
    float: none;
    margin-left: 5px;
}


.dropdown>a, .kpi-filter .date-selector>a {
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    color: #0052cc;
    text-decoration: none;
}

.select-time-btn>a {
    border-bottom: 1px dotted;
    display: inline-block;
    text-decoration: none;
}




.dropdown .dropdown-wrapper, .dropdown ul, .dropdown_hover .dropdown-wrapper, .dropdown_hover ul {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, .12);
    
    float: left;
    font-weight: 400;
    left: 0;
    list-style: none;
    margin: 0;
    min-width: 170px;
    opacity: .99;
    padding: 0;
    position: absolute;
    z-index: 1800;
}

.dropdown.down>.dropdown-wrapper, .dropdown.down>.ul-scroll-dropdown-wrapper, .dropdown.down>ul, .dropdown_hover.down>.dropdown-wrapper, .dropdown_hover.down>.ul-scroll-dropdown-wrapper, .dropdown_hover.down>ul {
    margin-top: 6px;
    top: 100%;
}

.select-time-btn.dropdown ul {
    left: -9px;
}

.dropdown .dropdown-wrapper>li, .dropdown ul>li, .dropdown_hover .dropdown-wrapper>li, .dropdown_hover ul>li {
    display: block;
    font-size: 18px;
    line-height: 1.2;
    white-space: nowrap;
}

.dropdown .dropdown-wrapper>li>a, .dropdown ul>li>a, .dropdown_hover .dropdown-wrapper>li>a, .dropdown_hover ul>li>a {
    display: block;
    font-size: 14px;
    line-height: inherit;
    overflow: hidden;
    padding: 9px 20px;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dropdown .dropdown-wrapper>li:first-child>a, .dropdown ul>li:first-child>a, .dropdown_hover .dropdown-wrapper>li:first-child>a, .dropdown_hover ul>li:first-child>a {
    border-radius: 2px 2px 0 0;
}





.dropdown .dropdown-wrapper:after, .dropdown .dropdown-wrapper:before, .dropdown .ul-scroll-dropdown-wrapper:after, .dropdown .ul-scroll-dropdown-wrapper:before, .dropdown ul:after, .dropdown ul:before, .dropdown_hover .dropdown-wrapper:after, .dropdown_hover .dropdown-wrapper:before, .dropdown_hover .ul-scroll-dropdown-wrapper:after, .dropdown_hover .ul-scroll-dropdown-wrapper:before, .dropdown_hover ul:after, .dropdown_hover ul:before {
    border-color: transparent;
    border-style: solid;
    content: "";
    display: block;
    height: 0;
    left: 10px;
    position: absolute;
    width: 0;
    z-index: 1;
}
.dropdown .dropdown-wrapper:before, .dropdown .ul-scroll-dropdown-wrapper:before, .dropdown ul:before, .dropdown_hover .dropdown-wrapper:before, .dropdown_hover .ul-scroll-dropdown-wrapper:before, .dropdown_hover ul:before {
    border-bottom-color: #d9d9d9;
    border-width: 0 5.5px 6px;
}

.dropdown .dropdown-wrapper:after, .dropdown .dropdown-wrapper:before, .dropdown .ul-scroll-dropdown-wrapper:after, .dropdown .ul-scroll-dropdown-wrapper:before, .dropdown ul:after, .dropdown ul:before, .dropdown_hover .dropdown-wrapper:after, .dropdown_hover .dropdown-wrapper:before, .dropdown_hover .ul-scroll-dropdown-wrapper:after, .dropdown_hover .ul-scroll-dropdown-wrapper:before, .dropdown_hover ul:after, .dropdown_hover ul:before {
    z-index: 1801;
}

.dropdown.down>.dropdown-wrapper:after, .dropdown.down>.dropdown-wrapper:before, .dropdown.down>.ul-scroll-dropdown-wrapper:after, .dropdown.down>.ul-scroll-dropdown-wrapper:before, .dropdown.down>ul:after, .dropdown.down>ul:before, .dropdown_hover.down>.dropdown-wrapper:after, .dropdown_hover.down>.dropdown-wrapper:before, .dropdown_hover.down>.ul-scroll-dropdown-wrapper:after, .dropdown_hover.down>.ul-scroll-dropdown-wrapper:before, .dropdown_hover.down>ul:after, .dropdown_hover.down>ul:before {
    bottom: 100%;
    top: auto;
}


.input-group .checkbox-list, .input-group .chosen-container, .input-group.courier-group, .input-group .input-field, .input-group .v-select {
    max-width: 463px;
    width: 100%;
    height: 32px;
    border: 1px solid hsla(0, 0%, 48.2%, .25882352941176473) !important;
    border-radius: 4px !important;
}

#wrongSelection {
    width:20px;
}

#discountCard {
    width:20px;
}

.original-price {
    text-decoration: line-through;
    color: #888;
    margin-left: 5px;
}

.input-group .v-select.vs--single.vs--searchable{
    border:solid 0px!important;
}

.modern-table .acc-tovar {
    background: none;
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    font-size: 12px;
    font-size: 11px;
    font-weight: 400;
    height: 26px;
    line-height: "normal";
    margin-top: 12px;
    padding: 6px 10px 5px;
    text-decoration: none;
    text-shadow: none;
    user-select: none;
    vertical-align: middle;
    white-space: nowrap;
}



.modern-table .acc-tovar, .modern-table .acc-tovar:focus {
    outline: none;
}

.modern-table .acc-tovar, .modern-table .acc-tovar:active, .modern-table .acc-tovar:hover {
    color: #636f7f;
}

.qty-btn:hover {
  opacity:.5;
}

.acc-tovar:hover {
    color: #636f7f;
    background-color: #f6f6f6;
}


.order-products .acc-tovar {
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        line-height: 14px;
        max-height: 16px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
    }

.order-product-gtd {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0 6px;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f3f6fb;
  border: 1px solid #d9e2ef;
  font-size: 12px;
  line-height: 1.3;
  color: #1f2a37;
}

.order-product-gtd__label {
  font-weight: 600;
  color: #5b6b7c;
  letter-spacing: 0.02em;
}

.order-product-gtd__value {
  font-weight: 700;
  color: #0b57a8;
  font-variant-numeric: tabular-nums;
}


    .modern-table .acc-tovar:before {
        background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 10%27%3E%3Cg fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%23B2B2B2%27 %3E%3Cpath d=%27M0 0h8v2H0V0zM0 4h8v2H0V4zM0 8h8v2H0V8z%27/%3E%3C/g%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: contain;
        content: "";
        display: inline-block;
        height: 10px;
        margin-right: 5px;
        vertical-align: -1px;
        width: 10px;
    }


.original-price {
    text-decoration: line-through;
    color: #888;
    margin-left: 5px;
}

.input-group .v-select.vs--single.vs--searchable{
    border:solid 0px!important;
}










.m-box.head>.status {
    margin-top: 3px;
}


.m-box.simple.head .head__col {
    border-right: 0;
    display: table-cell;
    font-size: 12px;
    padding-left: 20px;
    padding-right: 21px;
    vertical-align: middle;
    white-space: nowrap;
}

    .m-box.simple.head .head__col {
        padding: 0 12px;
    }

.m-box.simple.head .head__col:last-child {
    border-right: none;
}

.m-box.simple.head .head__col.status {
    padding-left: 0;
    padding-right: 10px;
}

.m-box.simple.head .head__col.status {
    padding-right: 0;
}


.dib {
    display: inline-block !important;
}

.align-middle {
    vertical-align: middle !important;
}





.pseudo-select-colors {
    border-spacing: 1px 0;
    display: flex;
    list-style: none;
    margin-left: 2px;
    margin-top: 2px;
    padding: 0;
    width: 208px;
}

.pseudo-select-colors {
    padding: 0 2px;
}

.m-box.simple.head .pseudo-select-colors {
    margin-top: 0;
}

.pseudo-select-colors>li {
    border-radius: 2px 2px 0 0;
    flex-grow: 1;
    height: 6px;
    position: relative;
    z-index: 4;
}

.pseudo-select-colors>li:not(:last-child) {
    margin-right: 1px;
}

.pseudo-select-colors>li.active {
    height: 7px;
}

.batch-menu .options>li.new, .pseudo-select #select.new, .pseudo-select-colors>li.new {
    background-color: #fea530;
    color: #fff;
}

.pseudo-select-colors>li.active {
    height: 8px;
}

.pseudo-select {
    font: 12px / 20px -apple-system, BlinkMacSystemFont, Segoe UI, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Roboto, sans-serif;
    position: relative;
    z-index: 150;
    border-radius:4px;
    height: 36px;
    display: flex;
    align-items: center;
}

.cancel.pseudo-select #select{
    color: #b73232;
}

.approval.pseudo-select #select{
    color: #bc6b01;
}

.delivery.pseudo-select #select{
    color: #0044b7;
}

.new.pseudo-select #select{
    color: #ffffff;
}
.sto12f.pseudo-select .stat-wrap {
  color:#fff !important;
}
.sto12f.pseudo-select .stat-img {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.approval.pseudo-select .stat-img {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23E18001'%3E%3Cpath fill-rule='evenodd' d='M18 2a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a3 3 0 0 0-2.15.85l-3 3a.49.49 0 0 1-.35.15.5.5 0 0 1-.5-.5V6a4 4 0 0 1 4-4h12zM8 16h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v11.88l.46-.42A5 5 0 0 1 8 16zm-1.5-3h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zm11-4h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.approval.pseudo-select #select:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23E18001'%3E%3Cpath d='M16.14 12.94a.5.5 0 0 1 0 .71l-.2.2a.49.49 0 0 1-.36.15H8.42a.49.49 0 0 1-.36-.15l-.2-.2a.5.5 0 0 1 0-.71l3.79-3.79a.48.48 0 0 1 .7 0l3.79 3.79Z'/%3E%3C/svg%3E");
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23E18001'%3E%3Cpath d='M16.14 12.94a.5.5 0 0 1 0 .71l-.2.2a.49.49 0 0 1-.36.15H8.42a.49.49 0 0 1-.36-.15l-.2-.2a.5.5 0 0 1 0-.71l3.79-3.79a.48.48 0 0 1 .7 0l3.79 3.79z'/%3E%3C/svg%3E");
}

.delivery.pseudo-select .stat-img {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%230052CC'%3E%3Cpath fill-rule='evenodd' d='M3.169 2.445a1 1 0 0 1 1.386-.277l3 2A1 1 0 0 1 8.001 5v11.17A3.008 3.008 0 0 1 9.83 18H18a1 1 0 1 1 0 2H9.83A3.001 3.001 0 1 1 6 16.17V5.536L3.447 3.832a1 1 0 0 1-.277-1.387zM7 18h-.01a1 1 0 1 0 .02 0H7zM9 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V7zm4 0h-2v8h8V7h-2v3h-4V7z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.cancel.pseudo-select .stat-img {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23DD4040'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm2.56-11.09.53.53a.48.48 0 0 1 0 .7L13.24 12l1.85 1.86a.48.48 0 0 1 0 .7l-.53.53a.48.48 0 0 1-.7 0L12 13.24l-1.86 1.85a.48.48 0 0 1-.7 0l-.53-.53a.48.48 0 0 1 0-.7L10.76 12l-1.85-1.86a.48.48 0 0 1 0-.7l.53-.53a.48.48 0 0 1 .7 0L12 10.76l1.86-1.85a.48.48 0 0 1 .7 0z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.new.pseudo-select .stat-img {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12.5 4h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zm-6.255 6.334A6 6 0 0 1 12 6a6 6 0 0 1 3.2 11.07 1.48 1.48 0 0 0-.7 1.27v.16a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.16a1.5 1.5 0 0 0-.7-1.27 6 6 0 0 1-2.555-6.736zM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm2 9.59a1 1 0 0 0 .29.7l.42.42a1 1 0 0 0 .7.29h1.18a1 1 0 0 0 .7-.29l.42-.42a1 1 0 0 0 .29-.7V21h-4v.59zM20.13 4.58l-.71-.71a.48.48 0 0 0-.7 0L17.3 5.28a.51.51 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.48.48 0 0 0 .01-.7zM5.28 3.87 6.7 5.28a.51.51 0 0 1 0 .72l-.7.7a.51.51 0 0 1-.72 0L3.87 5.28a.48.48 0 0 1 0-.7l.71-.71a.48.48 0 0 1 .7 0zM22.5 11h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-21 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.delivery.pseudo-select #select:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%230052CC'%3E%3Cpath d='M16.14 12.94a.5.5 0 0 1 0 .71l-.2.2a.49.49 0 0 1-.36.15H8.42a.49.49 0 0 1-.36-.15l-.2-.2a.5.5 0 0 1 0-.71l3.79-3.79a.48.48 0 0 1 .7 0l3.79 3.79Z'/%3E%3C/svg%3E");
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%230052CC'%3E%3Cpath d='M16.14 12.94a.5.5 0 0 1 0 .71l-.2.2a.49.49 0 0 1-.36.15H8.42a.49.49 0 0 1-.36-.15l-.2-.2a.5.5 0 0 1 0-.71l3.79-3.79a.48.48 0 0 1 .7 0l3.79 3.79z'/%3E%3C/svg%3E");
}

.cancel.pseudo-select #select:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23DD4040'%3E%3Cpath d='M16.14 12.94a.5.5 0 0 1 0 .71l-.2.2a.49.49 0 0 1-.36.15H8.42a.49.49 0 0 1-.36-.15l-.2-.2a.5.5 0 0 1 0-.71l3.79-3.79a.48.48 0 0 1 .7 0l3.79 3.79Z'/%3E%3C/svg%3E");
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23DD4040'%3E%3Cpath d='M16.14 12.94a.5.5 0 0 1 0 .71l-.2.2a.49.49 0 0 1-.36.15H8.42a.49.49 0 0 1-.36-.15l-.2-.2a.5.5 0 0 1 0-.71l3.79-3.79a.48.48 0 0 1 .7 0l3.79 3.79z'/%3E%3C/svg%3E");
}

.dflkdslskl.pseudo-select .stat-img {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.dflkdslskl.pseudo-select #select {
    color: #ffffff;
}



.pseudo-select #select {
    background-color: transparent;
    border-radius: 3px;
    color: #1e2248;
    cursor: pointer;
    font-weight: 600;
    line-height: 32px;
    position: relative;
    width: 230px;
    padding-right: 35px;
}

.pseudo-select #select {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.batch-menu .options>li.new, .pseudo-select #select.new, .pseudo-select-colors>li.new {
    background-color: #fea530;
    color: #fff;
}

.pseudo-select #select:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath d='M16.14 12.94a.5.5 0 0 1 0 .71l-.2.2a.49.49 0 0 1-.36.15H8.42a.49.49 0 0 1-.36-.15l-.2-.2a.5.5 0 0 1 0-.71l3.79-3.79a.48.48 0 0 1 .7 0l3.79 3.79Z'/%3E%3C/svg%3E");
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath d='M16.14 12.94a.5.5 0 0 1 0 .71l-.2.2a.49.49 0 0 1-.36.15H8.42a.49.49 0 0 1-.36-.15l-.2-.2a.5.5 0 0 1 0-.71l3.79-3.79a.48.48 0 0 1 .7 0l3.79 3.79z'/%3E%3C/svg%3E");
    background-size: 100%;
    content: "";
    display: block;
    height: 20px;
    margin-top: -10px;
    position: absolute;
    right: 8px;
    top: 50%;
    transform: rotate(180deg);
    width: 20px;
}


.pseudo-select #select .stat-wrap {
    overflow: hidden;
    padding-left: 36px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size:14px;
}

/* Стили для заблокированного статуса */
.pseudo-select #select.status-locked {
    cursor: not-allowed;
    opacity: 0.7;
}

.pseudo-select #select.status-locked:before {
    opacity: 0.5;
}

.status-lock-icon {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #dc3545;
    background: rgba(220, 53, 69, 0.1);
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}



.batch-box .dropdown .options li.group .icon:before, .batch-box .dropdown .options__custom-fields li.group .icon:before, .pseudo-select #select .stat-img {
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
    height: 16px;
    left: 12px;
    margin-top: -8px;
    position: absolute;
    top: 50%;
    width: 16px;
}

.batch-box .dropdown .options li.group.new .icon:before, .pseudo-select #select.new.check .stat-img {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12.5 4h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zm-6.255 6.334A6 6 0 0 1 12 6a6 6 0 0 1 3.2 11.07 1.48 1.48 0 0 0-.7 1.27v.16a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.16a1.5 1.5 0 0 0-.7-1.27 6 6 0 0 1-2.555-6.736zM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm2 9.59a1 1 0 0 0 .29.7l.42.42a1 1 0 0 0 .7.29h1.18a1 1 0 0 0 .7-.29l.42-.42a1 1 0 0 0 .29-.7V21h-4v.59zM20.13 4.58l-.71-.71a.48.48 0 0 0-.7 0L17.3 5.28a.51.51 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.48.48 0 0 0 .01-.7zM5.28 3.87 6.7 5.28a.51.51 0 0 1 0 .72l-.7.7a.51.51 0 0 1-.72 0L3.87 5.28a.48.48 0 0 1 0-.7l.71-.71a.48.48 0 0 1 .7 0zM22.5 11h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-21 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
}




.pseudo-select .options {
    background: #fff;
    border: 4px solid #fff;
    border-radius: 4px;
    box-shadow: 0 8px 16px rgba(30, 34, 72, .16);
    padding-left:0px;
    left: 0;
    margin-top: 4px;
    max-height: 325px;
    overflow-x: hidden;
    position: absolute;
    right: 0;
    top: 100%;
    z-index: 150;
}


.m-box.simple.head .message-indic, .m-box.simple.head .order-actions ul, .m-box.simple.head .pseudo-select .options {
    white-space: normal;
}

.pseudo-select .options__status {
    color: #000;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
    list-style: none;
    padding: 6px 0 6px 32px;
    position: relative;
}

.order-actions__list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: inline-block;
}

.order-actions__list > li {
    display: inline-block;
    position: relative;
}

.order-actions__list .print > a {
    color: #0052cc;
    text-decoration: none;
    border-bottom: 1px dotted;
    cursor: pointer;
}

.order-actions__list .print .dropdown-wrapper.ul-scroll-dropdown-wrapper {
    display: block !important;
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 6px;
    z-index: 1800;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-shadow: 0 3px 15px rgba(0, 0, 0, .12);
    min-width: 200px;
}

.order-actions__list .print .dropdown-wrapper.ul-scroll-dropdown-wrapper ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.order-actions__list .print .dropdown-wrapper.ul-scroll-dropdown-wrapper ul li {
    display: block;
}

.order-actions__list .print .dropdown-wrapper.ul-scroll-dropdown-wrapper ul li a {
    display: block;
    padding: 9px 20px;
    text-decoration: none;
    color: #333;
    font-size: 14px;
    line-height: 1.2;
}

.order-actions__list .print .dropdown-wrapper.ul-scroll-dropdown-wrapper ul li a:hover {
    background-color: #f5f5f5;
}

.sto12f .options__status {
  color: #fff!important;
}

.pseudo-select .options__status:hover:not(.disabled) {
    background-color: color(srgb 0 0 0 / 0.06);
    border-radius: 4px;
}

.pseudo-select .options__group {
    border-radius: 4px;
    padding: 0 4px 4px;
    list-style:none;
}

.pseudo-select .options__group:not(:last-child) {
    margin-bottom: 4px;
}



.pseudo-select .options__status.disabled {
    background-position: top 8px left 8px;
    background-repeat: no-repeat;
    background-size: 16px;
    color: #000;
    cursor: default;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.42857143;
    padding: 6px 0 6px 32px;
}


.pseudo-select .options__status.disabled.approval {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23E18001'%3E%3Cpath fill-rule='evenodd' d='M18 2a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H8a3 3 0 0 0-2.15.85l-3 3a.49.49 0 0 1-.35.15.5.5 0 0 1-.5-.5V6a4 4 0 0 1 4-4h12zM8 16h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v11.88l.46-.42A5 5 0 0 1 8 16zm-1.5-3h7a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zm11-4h-11a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
    color: #bc6b01;
}

.pseudo-select .options__status.approval {
    color: #bc6b01;
}




.pseudo-select .options__status.delivery {
    color: #0044b7;
}

.pseudo-select .options__status.disabled {
    background-position: top 8px left 8px;
    background-repeat: no-repeat;
    background-size: 16px;
    color: #000;
    cursor: default;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.42857143;
    padding: 6px 0 6px 32px;
}

.pseudo-select .options__status.disabled.delivery {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%230052CC'%3E%3Cpath fill-rule='evenodd' d='M3.169 2.445a1 1 0 0 1 1.386-.277l3 2A1 1 0 0 1 8.001 5v11.17A3.008 3.008 0 0 1 9.83 18H18a1 1 0 1 1 0 2H9.83A3.001 3.001 0 1 1 6 16.17V5.536L3.447 3.832a1 1 0 0 1-.277-1.387zM7 18h-.01a1 1 0 1 0 .02 0H7zM9 7a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2V7zm4 0h-2v8h8V7h-2v3h-4V7z' clip-rule='evenodd'/%3E%3C/svg%3E");
    color: #0044b7;
}


.batch-box .dropdown .options li.group.cancel .icon:before, .pseudo-select #select.cancel.check .stat-img {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23DD4040'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm2.56-11.09.53.53a.48.48 0 0 1 0 .7L13.24 12l1.85 1.86a.48.48 0 0 1 0 .7l-.53.53a.48.48 0 0 1-.7 0L12 13.24l-1.86 1.85a.48.48 0 0 1-.7 0l-.53-.53a.48.48 0 0 1 0-.7L10.76 12l-1.85-1.86a.48.48 0 0 1 0-.7l.53-.53a.48.48 0 0 1 .7 0L12 10.76l1.86-1.85a.48.48 0 0 1 .7 0z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.pseudo-select .options__status.cancel {
    color: #a70000;
}

.pseudo-select .options__status.disabled.cancel {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23DD4040'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm2.56-11.09.53.53a.48.48 0 0 1 0 .7L13.24 12l1.85 1.86a.48.48 0 0 1 0 .7l-.53.53a.48.48 0 0 1-.7 0L12 13.24l-1.86 1.85a.48.48 0 0 1-.7 0l-.53-.53a.48.48 0 0 1 0-.7L10.76 12l-1.85-1.86a.48.48 0 0 1 0-.7l.53-.53a.48.48 0 0 1 .7 0L12 10.76l1.86-1.85a.48.48 0 0 1 .7 0z' clip-rule='evenodd'/%3E%3C/svg%3E");
    color: #a70000;
}

.pseudo-select .options__status.new {
    color: #ffffff;
}




.pseudo-select .options__status.disabled.new {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M12.5 4h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zm-6.255 6.334A6 6 0 0 1 12 6a6 6 0 0 1 3.2 11.07 1.48 1.48 0 0 0-.7 1.27v.16a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.16a1.5 1.5 0 0 0-.7-1.27 6 6 0 0 1-2.555-6.736zM8 12a4 4 0 1 0 8 0 4 4 0 0 0-8 0zm2 9.59a1 1 0 0 0 .29.7l.42.42a1 1 0 0 0 .7.29h1.18a1 1 0 0 0 .7-.29l.42-.42a1 1 0 0 0 .29-.7V21h-4v.59zM20.13 4.58l-.71-.71a.48.48 0 0 0-.7 0L17.3 5.28a.51.51 0 0 0 0 .71l.7.71a.51.51 0 0 0 .71 0l1.41-1.42a.48.48 0 0 0 .01-.7zM5.28 3.87 6.7 5.28a.51.51 0 0 1 0 .72l-.7.7a.51.51 0 0 1-.72 0L3.87 5.28a.48.48 0 0 1 0-.7l.71-.71a.48.48 0 0 1 .7 0zM22.5 11h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm-21 0h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z' clip-rule='evenodd'/%3E%3C/svg%3E");
    color: #ffffff;
}


.complete.pseudo-select .stat-img{
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%2319976E'%3E%3Cpath fill-rule='evenodd' d='M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 12 2zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm3.12-11.51a.5.5 0 0 1 .7 0l.5.53a.5.5 0 0 1 0 .71l-5.62 5.62a.48.48 0 0 1-.7 0l-2.35-2.37a.5.5 0 0 1 0-.71l.53-.53a.48.48 0 0 1 .7 0l1.5 1.49 4.74-4.74z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.complete.pseudo-select #select {
    color: #168561;
}

.brak12.pseudo-select .stat-img {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24'  fill='%236528D7'%3E%3Cpath fill-rule='evenodd'  d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}
.brak12.pseudo-select {
  background: rgba(101,40,215,0.1);
  color: #4a2aa5 !important;
}


.assembling.pseudo-select .stat-img{
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%236528D7'%3E%3Cpath fill-rule='evenodd' d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12a10 10 0 0 0 10 10zm0-18a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm-.19 14a.77.77 0 0 1-.53-.22l-3.13-3.13a.5.5 0 0 1 0-.71l.71-.71a.49.49 0 0 1 .7 0L11 14.67V6.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v8.17l1.44-1.45a.5.5 0 0 1 .71 0l.7.71a.5.5 0 0 1 0 .71l-3.13 3.14a.75.75 0 0 1-.53.22h-.38z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.assembling.pseudo-select #select {
    color: #4a2aa5;
}


.right_head {
    display: none; /* Скрываем старый блок, содержимое перенесено в m-box simple head */
}

.right_head_sticky {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  flex-shrink: 0;
  padding-left: 20px;
}

.right_head_sticky .status.head__col {
  margin: 0;
  padding: 0;
  border-right: none;
  display: block !important;
  width: auto !important;
  vertical-align: middle;
}

.right_head_sticky .hm-right {
  display: flex !important;
  align-items: center;
  gap: 8px;
  margin-left: 0;
  white-space: nowrap;
  float: none !important;
  vertical-align: middle;
}

.left_head {
        width: 75%;
            display: flex;
    align-items: flex-end;
}

.sticky-saved-orders {
    display:none;
}

.vs__dropdown-toggle {
    border: 1px solid rgba(60, 60, 60, .26);
}

.hm-right {
    display: table-cell;
    float: none;
    vertical-align: top;
    white-space: nowrap;
    margin-left: 20px;
}

.btn-close-order:hover {
    opacity:.5;
}

.call-button {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' style='shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;fill-rule:evenodd;clip-rule:evenodd'%3e%3cpath fill='%23fefffe' d='M277.5-.5h12c104.845 23.53 175.679 85.864 212.5 187a503.138 503.138 0 0 1 9.5 37v9c-5.458 10.198-13.458 12.698-24 7.5l-3.5-3.5C469.001 156.906 426.834 96.74 357.5 56c-26.136-14.045-53.802-23.712-83-29-9.874-10.441-8.874-19.608 3-27.5Z' style='opacity:.958'/%3e%3cpath fill='%23fefffe' d='M381.5 511.5h-28c-28.815-4.324-56.481-12.824-83-25.5C163.94 433.773 83.44 354.94 29 249.5c-14.802-29.566-24.635-60.566-29.5-93v-26c1.952-13.678 6.785-26.345 14.5-38A545.237 545.237 0 0 1 69.5 37c21.868-12.567 42.534-10.9 62 5a1855.233 1855.233 0 0 1 71.5 73.5c12.766 23.757 9.766 45.423-9 65L160.5 214c12.934 25.7 29.434 48.867 49.5 69.5 24.901 27.093 53.567 49.093 86 66a965.629 965.629 0 0 0 37.5-36.5c23.285-18.265 46.285-17.931 69 1l61.5 61.5c19.631 21.462 21.631 44.462 6 69a1765.816 1765.816 0 0 1-49.5 50.5c-11.803 8.539-24.803 14.039-39 16.5Zm-285-453c4.683.439 9.016 1.939 13 4.5l66.5 66.5c7.154 10.304 6.154 19.971-3 29a1101.106 1101.106 0 0 1-40 39c-4.129 5.699-5.462 12.032-4 19a226.895 226.895 0 0 0 25 47c28.999 39.668 63.833 73.168 104.5 100.5l30 16c9.672 3.236 18.338 1.57 26-5l41-41c8.557-6.189 16.89-5.855 25 1a3173.43 3173.43 0 0 1 66.5 67.5c4.667 7.333 4.667 14.667 0 22a1564.09 1564.09 0 0 1-46.5 47.5c-13.749 8.883-28.749 11.883-45 9a214.824 214.824 0 0 1-55-15C185.258 414.758 101.091 331.925 48 217.5c-10.483-23.434-16.65-47.934-18.5-73.5-.395-13.058 3.105-24.891 10.5-35.5L85.5 63c3.553-2.12 7.22-3.62 11-4.5Z' style='opacity:.959'/%3e%3cpath fill='%23fefffe' d='M277.5 91.5c66.203 12.096 111.203 49.596 135 112.5 4.165 10.819 5.998 21.985 5.5 33.5-4.462 8.479-11.296 11.313-20.5 8.5a25.55 25.55 0 0 1-6.5-5.5c-9.644-50.491-37.478-86.991-83.5-109.5a195.367 195.367 0 0 0-35-10c-11.123-8.204-11.79-17.204-2-27 2.427-.902 4.76-1.736 7-2.5Z' style='opacity:.955'/%3e%3c/svg%3e");
    width: 30px;
    height: 30px;
    position: absolute;
    left: 85px;
    background-repeat: no-repeat;
    background-color: #21b889;
    background-position: center;
    background-size: 70%;
    border-radius: 3px!important;
    display: block;
    right: -13px;
    top: 22px;
    cursor:pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

/* Состояние наведения */
.call-button:hover {
  //background-color: #45a049; /* Более темный зеленый */
  transform: scale(1.05); /* Легкое увеличение */
}

/* Состояние клика */
.call-button:active {
  //background-color: #388e3c; /* Еще темнее */
  transform: scale(0.95); /* Легкое уменьшение */
}


.auto_podbor {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='630' height='630' contentScriptType='text/ecmascript' version='1.0'%3e%3cimage xlink:actuate='onLoad' xlink:href='data:image/png;base64,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' xlink:show='embed' xlink:type='simple' width='472.5' height='472.5' preserveAspectRatio='none' transform='scale(1.33333)'/%3e%3c/svg%3e");
    width: 30px;
    height: 30px;
    position: absolute;
    left: 85px;
    background-repeat: no-repeat;
    background-color: #0d6efd;
    background-position: center;
    background-size: 85%;
    border-radius: 3px!important;
    display: block;
    right: -13px;
    top: 25px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;

}


/* Состояние наведения */
.auto_podbor:hover {
  //background-color: #45a049; /* Более темный зеленый */
  transform: scale(1.05); /* Легкое увеличение */
}

/* Состояние клика */
.auto_podbor:active {
  //background-color: #388e3c; /* Еще темнее */
  transform: scale(0.95); /* Легкое уменьшение */
}
.modal {
  display: none; /* По умолчанию скрыто */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex; /* Центрирование содержимого */
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.car-selector-overlay {
  position: fixed;
  inset: 0;
  z-index: 10040;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  flex-direction: column;
}

.car-selector-modal-shell {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: 100vh;
  background: #e8edf4;
  box-shadow: 0 12px 48px rgba(15, 23, 42, 0.22);
}

.car-selector-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04);
}

.car-selector-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.car-selector-modal-close {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: #f3f4f6;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  color: #374151;
}

.car-selector-modal-close:hover {
  background: #e5e7eb;
}

.car-selector-modal-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}


.divider-title {
   
    margin: 0 20px 15px;
    position: relative;
    width: calc(100% - 40px);
}

.payment .divider-title {
    margin-bottom: 0;
}


.divider-title:before {
    background: #005eeb;
    content: "";
    display: block;
    height: 1px;
    left: 0;
    position: absolute;
    top: 50%;
    width: 100%;
}

.controls {
    margin-left: 120px;
    position: relative;
}

.divider-title .controls {
    background: #fff;
    color: #005eeb;
    display: inline-block;
    font-size: 10px;
    letter-spacing: 1px;
    line-height: 1.6;
    padding: 0 10px;
    position: relative;
    text-align: center;
    text-transform: uppercase;
    z-index: 1;
}

.bk__footer {
    border-bottom: none;
    font-size: 12px;
    margin: 12px 20px 0 140px;
    padding-bottom: 23px;
    width: 100%;
}

.bk__footer_dark {
    background: #fdfdfd;
    border-top: 1px solid #ebebeb;
    margin: 0;
    padding: 32px 20px;
}

.bk__footer_dark {
    background: #f9fafb;
}

.m-box .bk .bk__footer_dark {
    border-radius: 0 0 4px 4px;
}


.bk__footer:after, .bk__footer:before {
    content: " ";
    display: table;
}

#order-payment .bk {
    padding-bottom: 0px;
}

.controls {
    margin-left: 120px;
    position: relative;
}

.dropdown, .dropdown_hover {
    display: inline-block;
    position: relative;
}




.dropdown>a, .kpi-filter .date-selector>a {
    border-bottom-style: dotted;
    border-bottom-width: 1px;
    color: #0052cc;
    text-decoration: none;
}

.add-payment-type>a, .add-rule-action>a, .add-segment-action>a {
    border-bottom: none;
    display: inline-block;
    padding-left: 24px;
    position: relative;
    text-decoration: none;
}


.add-payment-type>a:before, .add-rule-action>a:before, .add-segment-action>a:before {
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 10%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%2322C993%27 d=%27M10 4H6V0H4v4H0v2h4v4h2V6h4z%27/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    bottom: 0;
    content: "";
    display: block;
    height: 10px;
    left: 0;
    margin-bottom: auto;
    margin-left: 4px;
    margin-top: auto;
    position: absolute;
    right: auto;
    top: 0;
    width: 10px;
}

.add-payment-type>a>span, .add-rule-action>a>span, .add-segment-action>a>span {
    border-bottom: 1px dotted;
    color: #005eeb;
}

.dropdown .ul-scroll-dropdown-wrapper, .dropdown_hover .ul-scroll-dropdown-wrapper {
    border-radius: 2px;
    display: none;
    position: absolute;
    z-index: 1800;
}




.dropdown .dropdown-wrapper, .dropdown ul, .dropdown_hover .dropdown-wrapper, .dropdown_hover ul {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-shadow: 0 3px 15px rgb(0 0 0 / 12%);
    
    float: left;
    font-weight: 400;
    left: 0;
    list-style: none;
    margin: 0;
    min-width: 170px;
    opacity: .99;
    padding: 0;
    position: absolute;
    z-index: 1800;
}
.dropdown-with-hints {
    width: auto;
}

.add-payment-type.dropdown ul {
    max-height: 250px;
    overflow: auto;
}

.dropdown .ul-scroll-dropdown-wrapper>ul, .dropdown_hover .ul-scroll-dropdown-wrapper>ul {
    float: none;
    margin-top: 0;
    position: relative;
}


#shipmentWithoutPayment {
    width: 20px;
}

#link_oplata {
    width: 20px;
}

.info_pay_block  {
    margin-bottom: 20px;
}


.payment__content-wrapper {
    display: inline-block;
    position: relative;
    width: 100%;
}

.tr-delete {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23AFB9C3' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
    display: block;
    float: right;
    height: 15px;
    margin: 7px 0 0;
    width: 15px;
}

.payment .tr-delete {
    display: block;
    height: 20px;
    margin: 0;
    position: absolute;
    right: 35px;
    top: 20px;
    width: 20px;
    z-index: 1;
}


.tr-delete:hover {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' fill-rule='evenodd' d='M20 5.5v-1a.5.5 0 0 0-.5-.5H15V3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v1H4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5Zm-4.662 14.64a1 1 0 0 0 .998-.94L17 8h2l-.85 12.14a2 2 0 0 1-2 1.86H7.87a2 2 0 0 1-2-1.86L5 8h2l.664 11.2a1 1 0 0 0 .998.94h6.676Z' clip-rule='evenodd'/%3E%3C/svg%3E");
    opacity: 1;
}



.dropdown-with-hints li {
    position: relative;
}

.dropdown .dropdown-wrapper>li, .dropdown ul>li, .dropdown_hover .dropdown-wrapper>li, .dropdown_hover ul>li {
    display: block;
    font-size: 18px;
    line-height: 1.2;
    white-space: nowrap;
}



.dropdown .dropdown-wrapper>li>a, .dropdown ul>li>a, .dropdown_hover .dropdown-wrapper>li>a, .dropdown_hover ul>li>a {
    display: block;
    font-size: 14px;
    line-height: inherit;
    overflow: hidden;
    padding: 9px 20px;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.dropdown .dropdown-wrapper>li:first-child>a, .dropdown ul>li:first-child>a, .dropdown_hover .dropdown-wrapper>li:first-child>a, .dropdown_hover ul>li:first-child>a {
    border-radius: 2px 2px 0 0;
}



.dropdown-with-hints__hint {
    display: none;
}

.dropdown .dropdown-wrapper>li>div, .dropdown ul>li>div, .dropdown_hover .dropdown-wrapper>li>div, .dropdown_hover ul>li>div {
    padding: 0 20px;
}

.dropdown-with-hints__tooltip {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 16px rgb(30 34 72 / 16%);
    color: #1e2248;
    display: none;
    font-size: 14px;
    font-weight: 400;
    height: 164px;
    line-height: 1.42857143;
    padding: 12px 16px;
    white-space: normal;
    width: 292px;
}


.dropdown .dropdown-wrapper:after, .dropdown .ul-scroll-dropdown-wrapper:after, .dropdown ul:after, .dropdown_hover .dropdown-wrapper:after, .dropdown_hover .ul-scroll-dropdown-wrapper:after, .dropdown_hover ul:after {
    border-bottom-color: #fff;
    border-width: 0 4.5px 5px;
    margin-left: 1px;
}

a {
  font-size: 12px;
  text-decoration: none;
}
.is-invalid {
    border: 2px solid red;
}

.is-valid {
    border: 2px solid green;
}

.error-message {
    color: red;
    font-size: 12px;
    position: absolute;
    right: 5px;
}

.success-message {
    color: #20ac82;
    font-size: 12px;
    position: absolute;
    right: 5px;
}

.corpus-match-group {
    align-items: flex-start !important;
}

.corpus-match-field {
    flex: 1 1 auto;
    min-width: 0;
    max-width: 463px;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.corpus-match-field .input-field {
    float: none;
    width: 100%;
    max-width: 100%;
}

.podbor-actions-row {
    clear: left;
    float: left;
    position: absolute;
    top: 58px;
    right: 24px;
    z-index: 99;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    max-width: calc(100% - 48px);
}

.corpus-match-hints {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-top: 6px;
    width: 100%;
}

.corpus-match-hints--inline {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 0;
    width: auto;
}

.corpus-match-hint {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    font-size: 11px;
    line-height: 1.35;
    width: 100%;
}

.corpus-match-hints--inline .corpus-match-hint {
    align-items: center;
    width: auto;
    white-space: nowrap;
    cursor: default;
    background: #f4f6f8;
    border-radius: 3px;
    padding: 2px 8px;
}

.corpus-match-hint__icon {
    flex: 0 0 auto;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
}

.corpus-match-hint__text {
    flex: 1 1 auto;
}

.corpus-match-hints--inline .corpus-match-hint__text {
    flex: 0 0 auto;
}

.corpus-match-hint__reason {
    opacity: 0.85;
}

.corpus-match-hint--ok {
    color: #1f9d6a;
}

.corpus-match-hint--bad {
    color: #d32f2f;
}

.corpus-match-hint--warn {
    color: #c67a12;
}

.corpus-match-hint--loading {
    color: #6b7280;
}


.corporate-info-controls {
    margin: 54px 20px -7px 195px;
}

.form-container {
    margin-left: 124px;
}


.corporate-info-controls.no-corp {
    margin-top: 4px;
    width: 100%;
}





.corporate-info-controls__spacing {
    margin-top: 16px;
}


.tag-plank {
    background: #f6f6f6;
    border-radius: 4px;
    display: inline-block;
    font-size: 14px;
    line-height: 1.42857143;
    margin-right: 18px;
    padding: 5px 14px;
    vertical-align: middle;
}

.tag-plank_external-link {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='12' fill='none'%3E%3Cpath fill='%23005EEB' d='M11.166 6.484v4.849H.666V2.12h6v.97h-5v7.272h8.5V6.484h1Zm1.5-5.818h-5.5l2 1.94-3.5 3.442 1.4 1.357 3.5-3.442 2.1 2.036V.666Z'/%3E%3C/svg%3E");
    background-position: center right 17px;
    background-repeat: no-repeat;
    padding-right: 38px;
}


.corporate-info-controls__btn-cancel {
    margin-right: 30px;
}

.corporate-info-controls__spacing {
    margin-top: 16px;
}

.popconfirm {
    display: inline-block;
    position: relative;
    vertical-align: middle;
}


.btn-square {
    background-position: 50%;
    background-repeat: no-repeat;
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    cursor: pointer;
    display: inline-block;
    height: 30px;
    vertical-align: middle;
    width: 30px;
}

.btn-square_cancel {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23AFB9C3' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-size: 16px;
}





.customer-products-link {
    outline: 0 none;
    padding-left: 23px;
    position: relative;
    text-decoration: none;
}

.bk__foot-item {
    display: inline-block;
    line-height: 1.2;
    margin: 0 25px 0 0;
    vertical-align: middle;
}

.corporate-info-controls__spacing {
    margin-top: 16px;
}


.customer-products-link:before {
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 13 15%27%3E%3Cg fill=%27%23005EEB%27%3E%3Cpath d=%27M6.5 1c1.2 0 2.3.9 2.5 2.2V4H4V3.1C4.2 1.9 5.3 1 6.5 1m0-1C4.8 0 3.3 1 3.1 3H3v2h7V3h-.1c-.2-2-1.7-3-3.4-3z%27/%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 d=%27M4 6c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zM9 6c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z%27/%3E%3Cpath d=%27M11 5v.1l1 8.9H1l1-8.9V5h9m0-1H2c-.6 0-1 .4-1 1l-1 9c0 .6.4 1 1 1h11c.6 0 1-.4 1-1l-1-9c0-.6-.4-1-1-1z%27/%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    bottom: 0;
    content: "";
    display: block;
    height: 16px;
    left: 0;
    margin-bottom: auto;
    margin-top: auto;
    position: absolute;
    right: auto;
    top: 0;
    width: 13px;
}

.customer-products-link>span {
    border-bottom: 1px dotted;
}

.purchase-history-btn {
  color: #0052cc;
  font-weight: 600;
}

.purchase-history-badge {
  display: inline-block;
  margin-left: 6px;
  min-width: 18px;
  padding: 1px 6px;
  border-radius: 10px;
  background: #0052cc;
  color: #fff;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  border-bottom: none !important;
  vertical-align: middle;
}

.purchase-history-modal .purchase-history-modal__content {
  max-width: 820px;
  width: 92vw;
  max-height: 85vh;
  overflow: auto;
  padding-bottom: 20px;
}

.purchase-history-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.purchase-history-modal__header h1 {
  margin: 0;
  flex: 1;
}

.purchase-history-empty {
  padding: 40px 24px;
  text-align: center;
  color: #636f7f;
  font-size: 15px;
}

.purchase-history-section {
  padding: 0 20px 12px;
}

.purchase-history-count {
  display: inline-block;
  margin-left: 8px;
  color: #636f7f;
  font-weight: 500;
  font-size: 13px;
}

.purchase-history-card {
  margin-bottom: 14px;
  padding: 14px 16px;
}

.purchase-history-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.purchase-history-card__meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.purchase-history-card__number {
  color: #0052cc;
  font-weight: 700;
  font-size: 15px;
  text-decoration: none;
}

.purchase-history-card__number:hover {
  text-decoration: underline;
}

.purchase-history-card__date {
  color: #636f7f;
  font-size: 13px;
}

.purchase-history-card__status {
  flex-shrink: 0;
  padding: 4px 8px;
  border-radius: 4px;
  color: #fff;
}

.purchase-history-card__address {
  margin-bottom: 10px;
  color: #4a5568;
  font-size: 13px;
}

.purchase-history-card .customer-basket-table-footer_order {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #edf0f3;
}




.bk__foot-item {
    display: inline-block;
    line-height: 1.2;
    margin: 0 25px 0 0;
    vertical-align: middle;
}

.corporate-info-controls__spacing {
    margin-top: 16px;
}


.bk__client-orders-item {
    color: #636f7f;
}


/**/


.grid__box {
    background-color: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    margin-bottom: 16px;
    padding: 24px;
    position: relative;
    transition: .3s;
}

.grid__col_info .grid__box {
    padding: 16px;
}


.grid__box-header {
    border-bottom: 1px solid #dee2e6;
    font-size: 13px;
    line-height: 1.23;
    margin: -16px 0 16px;
    padding: 17px 0;
}

.grid__row {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
}




.customer-basket-title {
    color: #1e2248;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.grid__box-header .grid__col {
    align-items: center;
    align-self: center;
    display: flex;
}


.grid__box-header .grid__col:first-child {
    padding-right: 16px;
}


.customer-basket-title b {
    font-weight: 500;
}



.nowrap {
    white-space: nowrap;
}

.grid__box-header .grid__col:first-child a {
    word-break: break-word;
}


.bill {
    border-radius: 4px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    overflow: hidden;
    padding: 0 12px 0 40px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
}


.bill, .bill.short {
    min-width: 130px;
}

.bill.custom, .status-tbl tr.custom {
    background: #eef1f3;
    color: #636f7f;
}
.bill.custom-status-color-17, .status-tbl tr.custom-status-color-17 {
    background-color: #afb9c3;
    color: #fff;
}

.grid__box-header .bill, .timeline-item .bill {
    height: 24px;
    line-height: 24px;
    margin-bottom: -4px;
    margin-left: 8px;
    margin-right: 0!important;
    margin-top: -4px;
    min-width: 0;
    padding: 0 10px 0 24px;
    width: auto;
}

.grid__box-header .bill, .timeline-item .bill {
    max-width: 160px;
}





.bill .img-st {
    background-position: 50%;
    background-repeat: no-repeat;
    height: 24px;
    left: 13px;
    margin-top: -12px;
    position: absolute;
    top: 50%;
    width: 24px;
}

.bill .img-st, .bill .img-st+.st-text, .status-tbl tr .img-st, .status-tbl tr .img-st+.st-text {
    vertical-align: middle;
}


.bill.custom .img-st, .status-tbl tr.custom .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23636F7F'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}

.bill.custom-status-color-17 .img-st, .status-tbl tr.custom-status-color-17 .img-st {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M16.004 8A4 4 0 1 1 8 7.998 4 4 0 0 1 16.004 8Zm-2 0a2 2 0 1 0-4.001 0 2 2 0 0 0 4 0Zm5.892 10.55-1.89-3.89A3.001 3.001 0 0 0 15.263 13H8.742a3.001 3.001 0 0 0-2.691 1.66L4.11 18.55A1 1 0 0 0 5 20h14.006a1 1 0 0 0 .89-1.45Zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 0 0-.9-.55H8.741a1 1 0 0 0-.9.55Z' clip-rule='evenodd'/%3E%3C/svg%3E");
}


.grid__box-header .bill .img-st, .timeline-item .bill .img-st {
    background-size: 16px;
    left: 3px;
}



.tbl-st-txt {
    color: #1e2248;
    display: inline;
    padding-left: 8px;
}


.bill .tbl-st-txt {
    color: inherit;
}

.grid__box-header .bill .tbl-st-txt, .timeline-item .bill .tbl-st-txt {
    padding-left: 4px;
}

.grid__box-header .grid__col {
    align-items: center;
    align-self: center;
    display: flex;
}

.grid__chaining {
    align-items: center;
    display: flex;
    font-size: 12px;
    line-height: 16px;
    margin-top: 2px;
}





.ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
}

.grid__chaining-item {
    display: flex;
    min-width: 60px;
    padding-right: 14px;
    position: relative;
    white-space: nowrap;
}

.grid li {
    list-style: none;
}

.grid__chaining-item.ellipsis {
    max-width: 165px;
}


.customer-basket-store {
    align-items: center;
    display: flex;
}

.grid__ico {
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    flex-shrink: 0;
    height: 12px;
    width: 12px;
}



.customer-basket-table {
    font-size: 13px;
    line-height: 1.23;
}


.customer-basket-table_order {
    margin: -16px -16px 0;
    width: calc(100% + 32px);
}




.customer-basket-table__td {
    padding: 8px 0;
    vertical-align: top;
}

.customer-basket-table__td:first-child {
    padding-left: 16px;
}

.customer-basket-table__td:last-child, .customer-basket-table__td:not(:last-child) {
    padding-right: 16px;
}
.customer-basket-table-product {
    display: flex;
    position: relative;
}

.customer-basket-table-product__thumb {
    height: 32px;
    object-fit: cover;
    width: 32px;
}

.customer-basket-table-product__main {
    margin-left: 8px;
}

.customer-basket-table-product__title {
    text-decoration: none;
}

.customer-basket-table-product__title:before {
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}

.customer-basket-table-product__info {
    color: #636f7f;
    margin-top: 4px;
}

.customer-basket-table__td_count, .customer-basket-table__td_price {
    text-align: right;
    white-space: nowrap;
    width: 96px;
}

.customer-basket-table__td:last-child, .customer-basket-table__td:not(:last-child) {
    padding-right: 16px;
}

.customer-basket-table__td_price {
    width: 112px;
}


.customer-basket-table-price__wrap {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    position: relative;
}

.customer-basket-table-price__value {
    font-weight: 500;
}



.customer-basket-table-footer {
    display: flex;
    font-size: 13px;
    line-height: 1.23;
    padding: 16px 0;
    position: relative;
    text-align: right;
}

.customer-basket-table-footer_order {
    margin: 0 -16px -16px;
}

.customer-basket-table-footer:before {
    border-top: 1px solid #dee2e6;
    content: "";
    left: 16px;
    position: absolute;
    right: 16px;
    top: 0;
}

.customer-basket-table-footer__main {
    align-items: center;
    display: flex;
    flex-grow: 1;
    padding-left: 16px;
    padding-right: 16px;
}

.customer-basket-table-footer__title {
    margin-left: auto;
}

.customer-basket-table-footer__price {
    padding-right: 16px;
    width: 112px;
}



.grid__empty-tab, .grid__title {
    color: #636f7f;
    text-align: center;
}



.grid__title {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 2px;
    line-height: 1.45;
    margin: 32px 0 24px;
    text-transform: uppercase;
}

.hm-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.hm-left h1 {
    font-size: 24px;
    font-weight: 500;
    letter-spacing: -.3px;
    line-height: 32px;
    margin-top: 10px;
}

.block-address-btn {
      position: relative;
    width: 100%;
}

.block-address-btn .address-btn-copy{
  border: none;
    background: transparent;
    color: #015eeb;
    font-size: 11px;
    display: block;
    position: absolute;
    bottom: 2px;
    width: 100%;
    left: 65px;
    transition: all 0.3s ease; /* Плавный переход для всех свойств */
}

</style>


<style>

.car-selector-overlay .vs__dropdown-toggle {
    min-width: 200px;
}

input::placeholder {
    color: #a9a9a9!important; /* Цвет */
    opacity: 1; /* Убедитесь, что непрозрачность установлена */
}

input::-webkit-input-placeholder { color: #a9a9a9; } /* Chrome, Safari, Edge */
input::-moz-placeholder { color: #a9a9a9; }          /* Firefox 19+ */
input:-ms-input-placeholder { color: #a9a9a9; }      /* Internet Explorer */
input:-moz-placeholder { color: #a9a9a9; } 


.double_widget_btn, .sex_widget_btn {
    bottom: auto;
    color: #005eeb;
    font-size: 11px;
    height: 30px;
    left: 420px;
    line-height: 30px;
    margin-left: 30px;
    padding: 0;
    position: absolute;
    text-align: left;
    text-decoration: none;
    top: 20px;
    white-space: nowrap;
    z-index: 1;
    cursor: pointer;
}

.open-menu .double_widget_btn, .open-menu .sex_widget_btn {
    left: calc(100% - 85px);
}

.open-menu .double_widget_btn, .open-menu .sex_widget_btn {
    left: calc(100% - 85px);
    transition: left .25s linear .05s;
}

.double_widget_btn, .sex_widget_btn {
    left: 515px;
    margin-left: 30px;
}

.double_widget_btn>span, .sex_widget_btn>span {
    border-bottom: 1px dotted;
}

.black-red-loader:after, .double_widget_btn:after {
    content: "";
    z-index: 2000;
}

.double_widget_btn:hover>span, .sex_widget_btn:hover>span {
    border-bottom: 1px solid;
}

.auto_mark {
 position: absolute;
    bottom: -17px;
    left: 127px;
    font-size: 10px;
    background: hwb(0deg 96% 4%);
    padding: 1px 6px;
    border-radius: 2px!important;
    color: #005eeb;
    z-index: 1;
}

.auto_mark a{
 font-size: 10px;
 cursor: pointer;
}

.hide {
  display: none;
}



.message-indic, .task-tbl-commentary {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='%23AFB9C3'%3E%3Cpath d='M16 16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v15.5a.5.5 0 0 0 .5.5.49.49 0 0 0 .35-.15l3-3A3 3 0 0 1 6 16h10Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
    display: block;
    height: 13px;
    margin: 0px 10px 0 0;
    position: relative;
    width: 15px;
}

.m-box.simple.head .message-indic, .m-box.simple.head .order-actions ul, .m-box.simple.head .pseudo-select .options {
    white-space: normal;
}

.m-box.simple.head .message-indic {
    margin-top: 3px;
}

.popup-comment-box {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    box-shadow: 0 3px 15px rgb(0 0 0 / 12%);
    cursor: default;
  
    padding: 15px;
    position: absolute;
    right: 25px;
    top: -15px;
    width: 426px;
    z-index: 99;
}

.message-indic:hover, .task-tbl-commentary:hover {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='%23005EEB'%3E%3Cpath d='M16 16a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v15.5a.5.5 0 0 0 .5.5.49.49 0 0 0 .35-.15l3-3A3 3 0 0 1 6 16h10Z'/%3E%3C/svg%3E");
}




.pb10 {
    padding-bottom: 10px!important;
}

.fs11 {
    font-size: 11px!important;
}

.gray, .gray-link {
    color: #636f7f!important;
}






.fs12 {
    font-size: 12px!important;
}


.lh18 {
    line-height: 18px!important;
}

.black {
    color: #1e2248;
}

.popup-comment-box .comment-text {
    overflow-x: hidden;
    text-overflow: ellipsis;
}

.popup-comment-box:after {
    background: #fff;
    border-color: #d9d9d9;
    border-style: solid;
    border-width: 1px 1px 0 0;
    content: "";
    height: 8px;
    position: absolute;
    right: -5px;
    top: 16px;
    transform: rotate(45deg);
    width: 8px;
}




.omnica-modal-window {
    background: #fff;
    border-radius: 8px;
    color: #1e2248;
    display: flex;
    flex-direction: column;
    margin: auto;
    min-height: 150px;
    position: relative;
    width: 250px;
}


.omnica-modal-window_popup {
    padding: 0;
    width: 880px;
}


.omnica-modal-window__header {
    border-radius: 8px 8px 0 0;
}

.omnica-modal-window_popup .omnica-modal-window__header {
    border-bottom: 1px solid #dee2e6;
    padding: 18px 48px 18px 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.omnica-modal-window__title {
    font-size: 24px;
    font-weight: 500;
    line-height: 1.33333333;
}

.omnica-modal-window_popup .omnica-modal-window__close {
    color: #afb9c3;
    height: 32px;
    right: 18px;
    top: 18px;
    width: 32px;
}


.window_ouF8f .omnica-modal-window__content {
    min-height: 208px;
}

.m-6, .mb-6, .my-6 {
    margin-bottom: 24px!important;
}

.status-modal-agreement-date .mx-datepicker {
  width: 100%;
}

.status-modal-agreement-date .input-field,
.status-modal-agreement-date .mx-input {
  width: 100%;
  box-sizing: border-box;
}

.status-modal-agreement-date .error-message {
  display: block;
  margin-top: 6px;
  color: #dc2626;
  font-size: 12px;
}





.UiText-text_gray-3-JE {
   

    color: #636f7f;
}


.UiText-text_small-QTWp {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.UiText-text_accent-nhXJ {
    font-weight: 500;
}

.text_X0OGL {
    margin-bottom: 4px;
}
.status_gL3ii {
    align-items: center;
    border-radius: 4px;
    display: inline-flex;
    height: 32px;
    max-width: 100%;
    padding: 0 12px;
}

.status_gL3ii.md_ZnSCb {
    height: 32px;
    padding: 0px;
}



.UiText-text_small-QTWp {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.title_I6f5a {
    color: inherit;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.text_comment_x9UJJ {
    display: flex;
    justify-content: space-between;
}

.text_X0OGL {
    margin-bottom: 4px;
}




.UiText-text_gray-3-JE {
    color: #636f7f;
}

.UiText-text_small-QTWp {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.UiText-text_accent-nhXJ {
    font-weight: 500;
}

.UiText-text_tiny-1_wc {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
}

.UiTextarea-textarea-wrap-2K2Y {
    position: relative;
}

.UiTextarea-textarea-2DUR {
    height: 100%;
    min-width: 256px;
    overflow: hidden;
    padding: 0;
    position: relative;
    transition: .25s ease;
}

.UiTextarea-textarea_default-26FY {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    min-height: 96px;
}

.UiTextarea-textarea__area-1IwX {
    appearance: none;
    border: none!important;
    box-shadow: none;
    flex: 1 0 1px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Roboto,sans-serif;
    font-size: 16px;
    font-weight: 400;
    height: 100%;
    line-height: normal;
    min-height: inherit;
    min-width: inherit;
    position: relative;
    resize: none;
    width: 100%;
}

.UiTextarea-textarea_default-26FY .UiTextarea-textarea__area-1IwX {
    background: #fff;
    border-radius: 6px;
    color: #1e2248;
    padding: 8px 16px;
}



.omnica-modal-window__footer {
    border-radius: 0 0 8px 8px;
}


.omnica-modal-window__footer {
    background: #f9fafb;
    display: flex;
    font-size: 0;
    justify-content: flex-end;
    min-height: 80px;
    padding: 24px 47px;
}


.omnica-button {
    --omnica-button-text-color: #1e2248;
    appearance: none;
    background-image: none;
    border: none;
    border-radius: 6px;
    box-sizing: border-box;
    color: var(--omnica-button-text-color);
    cursor: pointer;
    display: inline-block;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Roboto,sans-serif;
    line-height: normal;
    padding: 0 20px;
    text-align: center;
    text-decoration: none;
    touch-action: manipulation;
    transition: color .25s ease,background .25s ease,box-shadow .25s ease,border .25s ease,width 0s;
    user-select: none;
    vertical-align: top;
    white-space: nowrap;
}

.omnica-button, .omnica-button:active, .omnica-button:focus {
    box-shadow: none;
    outline: none!important;
}

.omnica-button_primary {
    --omnica-button-background-color: #005eeb;
    --omnica-button-background-color-active: #0052cc;
    --omnica-button-background-color-disabled: #b8dbff;
    --omnica-button-background-image: linear-gradient(180deg,#0068ff,#005bd5);
    --omnica-button-text-color: #fff;
    background-color: var(--omnica-button-background-color);
    background-image: var(--omnica-button-background-image);
    font-weight: 500;
}

.omnica-button_sm {
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    height: 36px;
    line-height: normal;
    min-width: 96px;
    padding: 0 20px;
}

.omnica-button_primary.omnica-button_success {
    --omnica-button-background-color: #22c993;
    --omnica-button-background-color-active: #20a77f;
    --omnica-button-background-color-disabled: #b7ebd8;
    --omnica-button-background-image: linear-gradient(180deg,#22c993,#20a77f);
}

.omnica-button_sm.omnica-button_has-leading-icon {
    padding-left: 12px;
}

.omnica-button__inner {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
}

.omnica-button_sm .omnica-button__icon {
    height: 20px;
    min-width: 20px;
    width: 20px;
}



.omnica-button__icon+.omnica-button__text, .omnica-button__text+.omnica-button__icon {
    margin-left: 8px;
}


.omnica-button_ellipsis .omnica-button__text {
    overflow: hidden;
    text-overflow: ellipsis;
}

.omnica-modal-window__content {
   font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    padding: 32px 48px 32px 32px;
    overflow-y: auto;
    max-height: 61vh;
}





.UiIcon-icon-2pR- {
    display: block;
    height: auto;
    transition: .25s ease;
    width: 100%;
}

.omnica-button svg {
    fill: currentColor;
}

.omnica-button__icon svg {
    height: 100%;
    transition: .25s ease;
    width: 100%;
}

.omnica-button_secondary {
    background-color: #f4f6f8;
    background-image: linear-gradient(180deg,#fff,#e9ecee);
    border: 1px solid #dee2e6;
    margin-left: 20px;
}


.phone-history-link:before {
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 13 13%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%233E85B0%27 d=%27M6.5 3c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5S6 6.8 6 6.5v-3c0-.3.2-.5.5-.5z%27/%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%233E85B0%27 d=%27M6.5 6h3c.3 0 .5.2.5.5s-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z%27/%3E%3Cpath fill=%27%233E85B0%27 d=%27M6.5 1c3 0 5.5 2.5 5.5 5.5S9.5 12 6.5 12 1 9.5 1 6.5 3.5 1 6.5 1m0-1C2.9 0 0 2.9 0 6.5S2.9 13 6.5 13 13 10.1 13 6.5 10.1 0 6.5 0z%27/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    bottom: 0;
    content: "";
    display: block;
    height: 13px;
    left: 0;
    margin-bottom: auto;
    margin-left: 10px;
    margin-top: auto;
    position: absolute;
    right: auto;
    top: 0;
    width: 13px;
}

.phone-history-link span {
    border-bottom: 1px dotted;
    float: left;
}



.phone-history-link:after, .phone-history-link:before {
    content: " ";
    display: table;
}

.phone-history-link:after {
    clear: both;
}



.phone-history-link {
    background-color: #f4f6f8;
    border-radius: 3px;
    font-size: 11px;
    padding: 2px 13px 2px 34px;
    position: relative;
    text-decoration: none;
    white-space: nowrap;
}

.phone-history-link {
  cursor: pointer;
}

.input-group .phone-history-link {
    clear: left;
    float: left;
    left: 125px;
    position: absolute;
    top: 60px;
    z-index: 99;
    
}


.phone-history-link:hover:before {
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 13 13%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%23FF4C4C%27 d=%27M6.5 3c.3 0 .5.2.5.5v3c0 .3-.2.5-.5.5S6 6.8 6 6.5v-3c0-.3.2-.5.5-.5z%27/%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%23FF4C4C%27 d=%27M6.5 6h3c.3 0 .5.2.5.5s-.2.5-.5.5h-3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5z%27/%3E%3Cpath fill=%27%23FF4C4C%27 d=%27M6.5 1c3 0 5.5 2.5 5.5 5.5S9.5 12 6.5 12 1 9.5 1 6.5 3.5 1 6.5 1m0-1C2.9 0 0 2.9 0 6.5S2.9 13 6.5 13 13 10.1 13 6.5 10.1 0 6.5 0z%27/%3E%3C/svg%3E");
}

.phone-history-link:hover span {
    border-bottom-color: transparent;
}

.omnica-modal-window-container {
    align-items: center;
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    padding: 56px 0;
    position: absolute!important;
    right: 0;
    top: 0;
}

.omnica-modal {
    background: rgba(45,51,108,.4);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    transition: background-color .3s ease;
    z-index: 1000;
}

.omnica-modal-window_popup {
    width: 960px;
}


.container_vCNle {
    max-width: 100%;
    position: relative;
    width: 100%;
}

.hidden_gvfVe {
    position: absolute;
    visibility: hidden;
    z-index: -1;
}

.table_AJsNp {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
}

.table-has-tags_VblEH tr {
    cursor: pointer;
}



.UiText-text_tiny-1_wc {
    font-size: 12px;
    font-weight: 400;
    line-height: 1.16666667;
}

.cell_eOMiF {
    background-color: #f9fafb;
    border-bottom: 1px solid #dee2e6;
    color: #8a96a6;
    padding: 12px;
    text-align: left;
}

.cell_left_yyJOq {
    text-align: left;
}

.cell_left_eorMY {
    text-align: left;
}


.cell_eOMiF:first-child {
    padding-left: 32px;
}

.UiText-text_black-1BwQ {
    color: #1e2248;
}

.UiText-text_small-QTWp {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
}

.cell_OWup9 {
    border-bottom: 1px solid #dee2e6;
    padding: 16px 12px;
}

.cell_middle_su8IT {
    vertical-align: middle;
}

.cell_OWup9:not(.cell_without-padding_LRpPc):first-child {
    padding-left: 32px;
}

/* Ячейка с записью звонка */
.call-record-cell {
  min-width: 280px;
  padding: 8px 12px !important;
}

/* Контейнер аудиоплеера */
.audio-player-container {
  width: 100%;
}

/* Кастомный плеер */
.custom-audio-player {
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 6px 10px;
  min-width: 240px;
}

/* Кнопки плеера */
.player-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.player-btn-play {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  width: 28px;
  height: 28px;
  box-shadow: 0 1px 3px rgba(0, 123, 255, 0.3);
}

.player-btn-play:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004094 100%);
  transform: scale(1.08);
  box-shadow: 0 2px 5px rgba(0, 123, 255, 0.4);
}

.player-btn-download {
  background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
  color: white;
  width: 24px;
  height: 24px;
  box-shadow: 0 1px 3px rgba(40, 167, 69, 0.3);
}

.player-btn-download:hover {
  background: linear-gradient(135deg, #1e7e34 0%, #155724 100%);
  transform: scale(1.08);
  box-shadow: 0 2px 5px rgba(40, 167, 69, 0.4);
}

/* Время */
.player-time {
  font-size: 11px;
  font-weight: 500;
  color: #495057;
  min-width: 32px;
  text-align: center;
  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
}

.player-duration {
  color: #6c757d;
}

/* Прогресс-бар */
.player-progress-wrap {
  position: relative;
  flex: 1;
  height: 6px;
  min-width: 80px;
}

.player-progress {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 6px;
  background: transparent;
  cursor: pointer;
  position: relative;
  z-index: 2;
  margin: 0;
}

.player-progress::-webkit-slider-runnable-track {
  width: 100%;
  height: 6px;
  background: #dee2e6;
  border-radius: 3px;
}

.player-progress::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  background: #007bff;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: transform 0.1s ease;
}

.player-progress::-webkit-slider-thumb:hover {
  transform: scale(1.2);
}

.player-progress::-moz-range-track {
  width: 100%;
  height: 6px;
  background: #dee2e6;
  border-radius: 3px;
}

.player-progress::-moz-range-thumb {
  width: 14px;
  height: 14px;
  background: #007bff;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.player-progress-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 6px;
  background: linear-gradient(90deg, #007bff, #0056b3);
  border-radius: 3px;
  pointer-events: none;
  z-index: 1;
}

/* Кастомный выбор скорости */
.player-speed-wrap {
  position: relative;
  flex-shrink: 0;
}

.player-speed-btn {
  font-size: 9px;
  font-weight: 600;
  padding: 3px 6px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
  color: #495057;
  cursor: pointer;
  min-width: 32px;
  text-align: center;
  transition: all 0.15s ease;
}

.player-speed-btn:hover {
  border-color: #007bff;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.player-speed-menu {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 4px;
  margin-bottom: 4px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 48px;
}

.speed-option {
  font-size: 10px;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #495057;
  cursor: pointer;
  text-align: center;
  transition: all 0.1s ease;
  white-space: nowrap;
}

.speed-option:hover {
  background: #e9ecef;
}

.speed-option.active {
  background: #007bff;
  color: white;
  font-weight: 600;
}

/* Нет записи */
.no-record {
  color: #6c757d;
  font-size: 12px;
  font-style: italic;
}

/* Модальное окно истории звонков - расширенное */
.omnica-modal-window_wide {
  width: 1250px !important;
  max-width: 95vw !important;
}

.call-history .omnica-modal-window__content {
  padding: 20px 24px;
  overflow-x: auto;
  max-height: 70vh;
}

/* Стили для таблицы звонков */
.calls-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  min-width: 1100px;
}

.calls-table th {
  white-space: nowrap;
  padding: 10px 8px !important;
  font-size: 12px;
  background: #f8f9fa;
}

.calls-table td {
  vertical-align: middle;
  padding: 10px 8px !important;
  font-size: 13px;
  border-bottom: 1px solid #eee;
}

.calls-table td.call-record-cell {
  white-space: normal;
  overflow: visible;
  min-width: 280px;
}

.calls-table tr:hover {
  background: #f8f9fa;
}

/* Старые стили для совместимости */
.play-button {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}
.play-button:hover {
  color: #007bff;
}

.download-call-btn {
  margin-left: 8px;
  font-size: 12px;
  padding: 2px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #f5f5f5;
}
.download-call-btn:hover {
  background: #e8e8e8;
  color: #333;
}

.loader-container-call {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px; /* Высота лоадера */
}

.calls-empty-message {
  padding: 40px 20px;
  text-align: center;
  color: #666;
  font-size: 15px;
}

.spinner-call {
  width: 50px; /* Размер спиннера */
  height: 50px;
  border: 6px solid #f3f3f3; /* Светлый цвет */
  border-top: 6px solid #007bff; /* Цвет вращающейся части */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}



.inside-task-manager {
  position: relative;
}

.inside-task-manager {
  margin-left: 10px;
}


 .inside-task-manager-creator {
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 17 16%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%23a8aabc%27 d=%27M5 5V4h1v1H5zM7 5V4h5v1H7zM5 7V6h1v1H5zM7 7V6h5v1H7zM5 9V8h1v1H5zM7 9V8h5v1H7z%27/%3E%3Cpath fill=%27%23a8aabc%27 d=%27M15 1c.6 0 1 .4 1 1v9c0 .6-.4 1-1 1H3.7l-.3.2L1 14V2c0-.6.4-1 1-1h13m0-1H2C.9 0 0 .9 0 2v14l4-3h11c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z%27/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  height: 16px;
  margin-right: 10px;
  position: relative;
  vertical-align: middle;
  width: 17px;
}


.inside-task-manager__text {
  vertical-align: middle;
}


.inside-task-manager .inside-task-manager-count {
  color: #ccc;
  vertical-align: middle;
}






.btn_plus {
  background-position: 50%;
  background-repeat: no-repeat;
  border: 1px solid #d8d8d8;
  border-radius: 3px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  overflow: hidden;
  padding: 0;
  position: relative;
  text-indent: 1000em;
  vertical-align: middle;
  white-space: nowrap;
  width: 30px;
}

.btn.white {
  background-color: #fff;
  background-image: linear-gradient(180deg,#fff,#e9ecee);
  border: 1px solid #dee2e6;
  text-shadow: none;
}

.btn.white, .btn.white.active, .btn.white:active, .btn.white:hover {
  color: #1e2248;
  text-decoration: none;
}

.inside-task-manager .btn_plus {
  height: 28px;
  margin-left: 12px;
  width: 28px;
}


.inside-task-manager .btn_plus {
  margin-left: 8px;
}

.btn_plus::before {
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 10%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%2322C993%27 d=%27M10 4H6V0H4v4H0v2h4v4h2V6h4z%27/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  bottom: 0;
  content: "";
  display: block;
  height: 10px;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 10px;
}


.order-head-wrap {
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-height: 20px;
}

.order-header {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin: 0;
  transition: margin .2s linear;
  padding: 10px 4px;
}

.order-navigation {
  background: #f5f5f5;
  border-bottom: 1px solid #dee2e6;
  padding: 6px 12px;
  overflow-x: auto;
  display: flex;
  align-items: center;
  gap: 12px;
}

.order-navigation__order-number {
  font-size: 14px;
  font-weight: 600;
  color: #1e2248;
  white-space: nowrap;
  flex-shrink: 0;
}

.order-navigation__order-number span {
  color: #005eeb;
}

.order-navigation__list {
  display: flex;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  flex: 1;
}

.order-navigation__item {
  display: inline-block;
  padding: 4px 10px;
  color: #1e2248;
  text-decoration: none;
  border-radius: 2px;
  transition: background-color 0.2s, color 0.2s;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}

.order-navigation__item:hover {
  background-color: #e9ecef;
  color: #005eeb;
}

.order-navigation__item.active {
  background-color: #005eeb;
  color: #fff;
}




.m-box.simple {
  background-color: #fff;
  border-radius: 3px;
  clear: none;
}

.m-box.simple.head {
  border-bottom-width: 0;
  border-radius: 4px 4px 0 0;
  display: flex;
  align-items: center;
  height: 51px;
  margin-bottom: 0;
  min-height: 0;
  overflow: visible;
  padding: 0;
  width: 100%;
}

.m-box.simple.head, .m-box.simple.head .head__col_controls {
  height: 30px;
}

.m-box.simple.head {
  font-size: 12px;
  white-space: nowrap;
}


.pystoHistoy {
  text-align: center;
  padding-bottom: 40px;
}



.modal.z {
  background-color: rgba(45,51,108,.4);
}
.modal.z .modal-content{
  background: #fff !important;
  border-radius: 8px;
}
.modal.z h1 {
    padding: 20px;
    color: #0052cc;
    font-size: 20px;
    border-bottom: 2px solid #0052cc;
}

.input-group.updated .input-field {
    
  background-color: #e5fcae!important;
  border-color: #d1e79b!important;
  transition: background-color 0.3s ease; /* Плавный переход */
}

.input-group.updated .vs__dropdown-toggle {
  background-color: #e5fcae!important;
  border-color: #d1e79b!important;
  transition: background-color 0.3s ease; /* Плавный переход */
}

.input-group.street-not-in-directory .vs__dropdown-toggle,
.input-group.street-not-in-directory.updated .vs__dropdown-toggle {
  background-color: #ffe5e5 !important;
  border-color: #e57373 !important;
}

.input-group.street-not-in-directory .input-field,
.input-group.street-not-in-directory.updated .input-field {
  background-color: #ffe5e5 !important;
  border-color: #e57373 !important;
}

.visitor-lookup-inline {
  margin-left: 8px;
}
.visitor-lookup-inline__row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.visitor-lookup-inline__input {
  width: 72px;
  height: 28px;
  border: 1px solid #cbd5e1;
  border-radius: 5px;
  padding: 0 8px;
  font-size: 13px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
.visitor-lookup-inline__input:focus {
  outline: none;
  border-color: #0b5fff;
  box-shadow: 0 0 0 2px rgba(11, 95, 255, 0.15);
}
.visitor-lookup-inline__btn {
  height: 28px;
  border: none;
  border-radius: 5px;
  background: #0b5fff;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 0 12px;
  cursor: pointer;
}

.personal-offer-meta {
  margin-top: 12px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 16px;
  width: 100%;
  clear: both;
}

.personal-offer-meta .input-group,
.personal-offer-meta .personal-offer-meta__item {
  float: none;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  flex-wrap: nowrap;
  gap: 4px;
  box-sizing: border-box;
}

.personal-offer-meta .input-group label {
  float: none;
  width: auto;
  max-width: 100%;
  min-height: 1.3em;
  padding: 0;
  margin: 0;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.personal-offer-meta .input-group .input-field {
  float: none;
  width: 100%;
  max-width: 100%;
  height: 32px;
  box-sizing: border-box;
}

@media (max-width: 900px) {
  .personal-offer-meta {
    grid-template-columns: 1fr;
  }
}

.input-group.street-field-group {
  align-items: flex-start;
}

.street-field-control {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 463px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.street-field-control .v-select,
.street-field-control .input-field {
  max-width: 100%;
  width: 100%;
}

.street-field-control .split-address-btn {
  right: -90px;
}

.street-directory-hint {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-top: 4px;
  padding: 0;
  font-size: 11px;
  line-height: 1.35;
  color: #c62828;
  box-sizing: border-box;
}

.street-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
  width: 100%;
}

.street-suggestion-btn {
  border: 1px solid #e57373;
  background: #fff;
  color: #8b0000;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 11px;
  cursor: pointer;
  line-height: 1.4;
}

.street-suggestion-btn:hover {
  background: #ffebee;
  border-color: #c62828;
}

.city-suggestions .street-suggestion-btn {
  text-align: left;
  max-width: 100%;
  white-space: normal;
}

.split-address-btn {
  position: absolute;
right: -72px;
width: 82px;
  text-align: left;
  background: transparent;
  border: none;
  line-height: 12px;
  
  font-size: 12px;
  top: 20px;
  cursor: pointer;
  border-bottom: 1px dotted;
  color: #005eeb;
  cursor: pointer;
  font-size: 10px;
}

.split-address-btn:hover {
  border-bottom: none;
}

.attachments-btn {
  background: none;
  border: none;
  color: #0052cc;
  cursor: pointer;
  display: inline-block;
  padding: 0;
  text-decoration: none;
  user-select: none;
}

.m-box.simple.head .attachments-btn, .m-box.simple.head .history-btn {
  margin-left: 4px;
}



.attachments-icon_history {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' fill='%23005EEB'%3E%3Cpath fill-rule='evenodd' d='M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 10 0Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm.88-13.5v5.14l3.63 3.63a.51.51 0 0 1 0 .71l-.53.53a.51.51 0 0 1-.71 0l-4-4a.53.53 0 0 1-.15-.35V4.5a.5.5 0 0 1 .5-.5h.76a.5.5 0 0 1 .5.5Z' clip-rule='evenodd'/%3E%3C/svg%3E");
  background-position: 50%;
  background-size: 15px;
  background-repeat: no-repeat;
background-size: contain;
display: inline-block;
height: 14px;
vertical-align: baseline;
width: 14px;
}

.attachments-btn__icon, .attachments-btn__text {
  vertical-align: middle;
}

.attachments-btn__icon {
  margin-top: 0;
}


.attachments-btn__text {
  display: inline-block;
  max-width: 92px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachments-btn__icon + .attachments-btn__text {
  margin-left: 5px;
  position: relative;
}

.attachments-btn:hover .attachments-btn__text {
  color: #005eeb;
  text-decoration: underline;
}

.inside-task-manager .inside-task-manager-count {
    color: #0d6efd;
    vertical-align: middle;
    margin-left: 5px;
}

#ncorrectBonus {
  width: 20px;
}

.order-viewers {
  margin-left: 20px;
    color: red;
    line-height: 14px;
}


.transcription-modal {
  position: fixed;
  top: 0;
  right: 0;
  width: 600px;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0,0,0,0.2);
  overflow-y: auto;
  transition: transform 0.3s ease-out;
  transform: translateX(0);
  z-index: 1000;
}

.transcription-modal-content {
  padding: 20px;
}

.transcription-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.transcription-modal-header svg{
      width: 25px;
    height: 25px;
}


.transcription-modal-header svg path{
     fill: #afb9c3;
}

.transcription-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-item {
 background: #fff9c2;
    padding: 4px 9px;
    border-radius: 4px;
    font-size: 12px;
}

.tegi-dialoga-tags,
.call-tags-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tegi-dialoga-empty {
  color: #868e96;
  font-size: 12px;
}

.tag-item_inline {
  display: inline-block;
}

.close-button {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.transcription-modal-body h3{
  font-size: 20px;
    margin-top: -25px;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 25px;
    margin-bottom: 25px;
}


.dialogue {
  display: flex;
    flex-direction: column;
}
.dialogue-item {
  margin-bottom: 8px;
  padding: 10px;
  border-radius: 4px;
}
.dialogue-item.manager {
  background-color: #d0e3ff;
  text-align: right;
  align-self: flex-end;
}
.dialogue-item.buyer {
  background-color: #f3f4f9;
  align-self: flex-start;
}
.speaker {
  font-weight: bold;
    width: 100%;
    display: block;
}
.dialogue-tags {
  margin-top: 15px;
  font-style: italic;
}

.in-reserve-class {
  opacity: .3;
}


.saved-success {
  transition: background-color 0.3s ease;
  background-color: #fbffd3 !important; /* светло-зелёный */
}

.success-messages {
  animation: fadeInOut 4s ease;
}

@keyframes fadeInOut {
  0% { opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { opacity: 0; }
}

.save-box .btn__block {
  position: relative;
}

.save-box .btn-sync-ms {
  margin-left: 8px;
}

.save-box .btn-sync-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #dee2e6;
  border-top-color: #005eeb;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
  margin-right: 6px;
}

.product-status-dropdown {
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
  max-height: 540px;
  overflow-y: auto;
  width: 220px;
}

.product-status-dropdown-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.product-status-dropdown-list li {
  padding: 8px 10px;
  cursor: pointer;
}

.product-status-dropdown-list li:hover,
.product-status-dropdown-list li.active {
  background-color: #007BFF;
  color: white;
}

.product-status-cell {
  position: relative;
  vertical-align: top;
  min-width: 168px;
}

.product-status-stack {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  min-width: 0;
}

.product-status-karvata {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  padding: 4px 10px 4px 8px;
  border-radius: 999px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #166534;
  font-size: 12px;
  line-height: 1.2;
  max-width: 100%;
  cursor: help;
}

.product-status-karvata--zero {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b91c1c;
}

.product-status-karvata__icon {
  display: inline-flex;
  opacity: 0.75;
}

.product-status-karvata__label {
  font-weight: 600;
}

.product-status-karvata__qty {
  font-weight: 700;
}

.product-status-karvata__qty--loading {
  font-weight: 400;
  opacity: 0.6;
}

.stock-hover-tooltip {
  width: 280px;
  max-height: min(360px, calc(100vh - 24px));
  overflow: auto;
  background: #fff;
  border: 1px solid #dbe3ee;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
  padding: 10px 0 8px;
}

.stock-hover-tooltip__title {
  padding: 0 12px 8px;
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  border-bottom: 1px solid #eef2f7;
  margin-bottom: 4px;
}

.stock-hover-tooltip__empty {
  padding: 10px 12px;
  font-size: 12px;
  color: #64748b;
}

.stock-hover-tooltip__list {
  display: flex;
  flex-direction: column;
}

.stock-hover-tooltip__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 12px;
  font-size: 12px;
  color: #1e293b;
}

.stock-hover-tooltip__row--primary {
  background: #f0fdf4;
  color: #166534;
}

.stock-hover-tooltip__row--zero {
  color: #94a3b8;
}

.stock-hover-tooltip__label {
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stock-hover-tooltip__row--primary .stock-hover-tooltip__label {
  font-weight: 700;
}

.stock-hover-tooltip__qty {
  flex: 0 0 auto;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.product-status-link {
  display: inline-flex;
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: transparent;
  color: #2563eb;
  font-size: 13px;
  line-height: 1.35;
  text-align: left;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

.product-status-link:hover {
  color: #1d4ed8;
}

.zakaz-source-picker {
  width: 100%;
  min-width: 0;
}

.zakaz-source-trigger {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #dbe3ee;
  border-radius: 10px;
  background: #fff;
  color: #334155;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  box-sizing: border-box;
}

.zakaz-source-trigger:hover {
  border-color: #93c5fd;
  background: #f8fbff;
}

.zakaz-source-trigger--open,
.zakaz-source-trigger--filled {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.14);
}

.zakaz-source-trigger__leading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #eff6ff;
  color: #2563eb;
  flex-shrink: 0;
}

.zakaz-source-trigger__body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  min-width: 0;
  overflow: hidden;
}

.zakaz-source-trigger__caption {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
  line-height: 1;
}

.zakaz-source-trigger__value {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.zakaz-source-trigger:not(.zakaz-source-trigger--filled) .zakaz-source-trigger__value {
  font-weight: 500;
  color: #64748b;
}

.zakaz-source-trigger__badge {
  flex-shrink: 0;
  padding: 3px 8px;
  border-radius: 999px;
  background: #ecfdf5;
  color: #059669;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}

.zakaz-source-trigger__chevron {
  flex-shrink: 0;
  color: #94a3b8;
  transition: transform 0.15s ease;
}

.zakaz-source-trigger--open .zakaz-source-trigger__chevron {
  transform: rotate(180deg);
  color: #2563eb;
}

.zakaz-source-trigger--compact {
  grid-template-columns: auto 1fr auto;
}

.zakaz-source-dropdown {
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);
}

.zakaz-source-dropdown__header {
  padding: 10px 12px 8px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
}

.zakaz-source-dropdown__body {
  max-height: 280px;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.zakaz-source-dropdown__body::-webkit-scrollbar {
  width: 6px;
}

.zakaz-source-dropdown__body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
}

.zakaz-source-empty {
  padding: 14px 12px;
  font-size: 12px;
  line-height: 1.45;
  color: #94a3b8;
}

.zakaz-source-group {
  padding: 6px 0;
}

.zakaz-source-group + .zakaz-source-group {
  border-top: 1px solid #f1f5f9;
}

.zakaz-source-group__title {
  padding: 4px 12px 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.zakaz-source-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-width: 0;
  padding: 8px 12px;
  border: 0;
  background: transparent;
  color: #1e293b;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  box-sizing: border-box;
}

.zakaz-source-option:hover {
  background: #f8fafc;
}

.zakaz-source-option--active {
  background: #eff6ff;
}

.zakaz-source-option--active .zakaz-source-option__label {
  color: #1d4ed8;
  font-weight: 600;
}

.zakaz-source-option__label {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.zakaz-source-option__qty {
  flex: 0 0 auto;
  padding: 3px 8px;
  border-radius: 999px;
  background: #f0fdf4;
  color: #16a34a;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.zakaz-source-option--active .zakaz-source-option__qty {
  background: #dbeafe;
  color: #1d4ed8;
}


.product-status-dropdown::before {
  border-color: transparent;
    border-bottom-color: transparent;
  border-style: solid;
  content: "";
  display: block;
  height: 0;
  left: 10px;
  position: absolute;
  width: 0;
  z-index: 1;
  border-bottom-color: #d9d9d9;
border-width: 0 5.5px 6px;

bottom: 100%;
top: auto;
}


.btn-show-batteries {
  position: static;
  float: none;
  clear: none;
  right: auto;
  top: auto;
  z-index: auto;
  background-color: #f4f6f8;
  border-radius: 3px;
  font-size: 11px;
  padding: 2px 10px 2px 10px;
  text-decoration: none;
  white-space: nowrap;
  border: 0px;
  cursor: pointer;
}

.btn-show-batteries:hover {
  opacity: .5;
}






.btn-close-modal {
  width: 35px;
  height: 35px;
  position: relative;
  border-radius: 6px;
  cursor: pointer;
  background-color: #fff;
  background-image: linear-gradient(180deg, #fff, #e9ecee);
  border: 1px solid #dee2e6;
  text-shadow: none;
}

.btn-close-modal::before {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
  background-position: 50%;
  background-repeat: no-repeat;
  bottom: 0;
  content: "";
  height: 24px;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  width: 24px;
}


.spinner_podbor {
  width: 10px;
  height: 10px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top-color: #3498db; /* Цвет спиннера */
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.capacity-buttons {
  width: 100%;
  text-align: left;
  display: flex;
  margin-bottom: 10px;
}

.capacity-btn {
margin-right: 8px;
padding: 0px 8px;
border: 0px solid #c8deff;
cursor: pointer;
border-radius: 2px;
font-size: 12px;
font-weight: 600;
color: #000;
background-color: #fff;
background-image: linear-gradient(180deg,#fff,#e9ecee);
border: 1px solid #dee2e6;
text-shadow: none;
position: relative;
padding-left: 22px;
}

.capacity-btn:last-child {
  margin-right: 0px;
}


.capacity-btn::before {
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 10%27%3E%3Cpath fill-rule=%27evenodd%27 clip-rule=%27evenodd%27 fill=%27%2322C993%27 d=%27M10 4H6V0H4v4H0v2h4v4h2V6h4z%27/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-size: contain;
  bottom: 0;
  content: "";
  display: block;
  height: 46%;
  left: -9px;
  margin: auto;
  position: absolute;
  right: 0;
  top: 2px;
  width: 46%;
}

.capacity-btn:hover {
  background: #e0e0e0;
}

.capacity-btn-clear {
  padding-left: 8px;
  font-size: 18px;
  line-height: 1;
  color: red;
}

.capacity-btn-clear::before {
  display: none;
}

.input-group {
  float: left;
padding: 20px 20px 0;
position: relative;
width: 46%;
display: flex;
align-items: center;
flex-wrap:nowrap;
}


.helper-text {
  color: #3c3c3c;
  font-size: 10px;
  margin-right: 10px;
  line-height: 10px;
}
.error-text {
  position: absolute;
  top: 4px;
  right: 23px;
  font-size: 10px;
  color: red;
}

.helper-block .apply-button {
  font-size: 13px;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0px;
  text-align: left;
  color: #0d6efd;
  text-transform: uppercase;
  font-weight: 700;
  margin-top: 0px;
}

.helper-block .apply-button:hover {
  opacity: .5;
}

.helper-block {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
  position: absolute;
  width: 230px;
  background: #e3eefd;
  padding: 10px;
  right: 23px;
  top: calc(100% + -82px);
  border-radius: 8px !important;
  z-index: 10;
}

.helper-block .error-text {
  position: relative;
  top: auto;
  right: auto;
  font-size: 10px;
  color: #d32f2f;
  line-height: 1.4;
  padding-right: 25px;
}

.bonus-message {
  font-size: 12px;
  padding: 5px 10px;
    background: #21b889;
    color: #fff;
    border-radius: 5px;
}

.helper-close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 20px;
  height: 20px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.helper-close-button:hover {
  color: #333;
}

.order-navigation {
  background: #f5f5f5;
  border-bottom: 1px solid #dee2e6;
  padding: 6px 12px;
  overflow-x: auto;
  display: flex;
  align-items: center;
  gap: 12px;
}

.order-navigation__order-number {
  font-size: 14px;
  font-weight: 600;
  color: #1e2248;
  white-space: nowrap;
  flex-shrink: 0;
}

.order-navigation__order-number span {
  color: #005eeb;
}

.order-navigation__list {
  display: flex;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  flex: 1;
}

.order-navigation__item {
  display: inline-block;
  padding: 4px 10px;
  color: #1e2248;
  text-decoration: none;
  border-radius: 2px;
  transition: background-color 0.2s, color 0.2s;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}

.order-navigation__item:hover {
  background-color: #e9ecef;
  color: #005eeb;
}

.order-navigation__item.active {
  background-color: #005eeb;
  color: #fff;
}

.copy_order {
  position: relative;
  margin-left: 25px;
  color: #005eeb;
  cursor: pointer;
  display: inline-block;
}

.copy_order:hover {
  text-decoration: underline;
}

.copy_order__dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 1900;
  min-width: 320px;
  max-width: 420px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  padding: 6px 0;
  text-decoration: none;
}

.copy_order__option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  padding: 10px 16px;
  cursor: pointer;
  color: #333;
}

.copy_order__option:hover {
  background: #f5f8ff;
}

.copy_order__option-title {
  font-size: 14px;
  font-weight: 600;
  color: #005eeb;
  line-height: 1.2;
}

.copy_order__option-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.35;
  text-decoration: none;
}


.whereClient {
  /* display: none; */

    font-weight: 400;
    background: #f4f6f8;
    margin-right: 20px;
    border-radius: 5px;
    padding: 5px 15px;
    font-size: 11px;
    cursor: pointer;
    transition: 0.3s;
    position: relative;
}


.whereClient:hover {
  background: #eee;
}

.whereClient .whereBlock {
    position: absolute;
    z-index: 999;
    right:0px;
    width: 450px;
    background: #ffff;
    top: 35px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    padding: 15px;
    font-size: 12px;
    transition: box-shadow 0.3s ease;
    max-height: 320px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
}

.whereBlock__title {
  font-weight: 600;
  margin-bottom: 6px;
  color: #334;
}

.whereBlock__pre {
  margin: 0 0 10px;
  font-family: inherit;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
  color: #223;
}

.visited-products-section {
  margin-bottom: 18px;
  border: 1px solid #e6ebf2;
  border-radius: 14px;
  background: linear-gradient(180deg, #fbfcfe 0%, #f5f8fc 100%);
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(24, 39, 75, 0.04);
}

.visited-products-section > .collapse-section__head,
.visited-products-section > .collapse-section__body {
  padding-left: 16px;
  padding-right: 16px;
}

.visited-products-section > .collapse-section__head {
  padding-top: 14px;
  padding-bottom: 6px;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.visited-products-section > .collapse-section__body {
  padding-bottom: 14px;
}

.visited-products-title {
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #152033 !important;
}

.visited-products-title__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #e8f0ff;
  color: #2f6fed;
  flex-shrink: 0;
}

.visited-products-title__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 999px;
  background: #2f6fed;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.visited-products-nav {
  display: inline-flex;
  gap: 6px;
  flex-shrink: 0;
}

.visited-products-nav__btn {
  width: 30px;
  height: 30px;
  border: 1px solid #d5deea;
  border-radius: 8px;
  background: #fff;
  color: #152033;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.visited-products-nav__btn:hover {
  border-color: #2f6fed;
  background: #f3f7ff;
  color: #2f6fed;
}

.visited-products-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 8px;
  color: #667788;
  font-size: 13px;
}

.visited-products-loading__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2f6fed;
  animation: visitedPulse 1s ease-in-out infinite;
}

@keyframes visitedPulse {
  0%, 100% { opacity: 0.35; transform: scale(0.85); }
  50% { opacity: 1; transform: scale(1); }
}

.visited-products-carousel {
  display: flex;
  gap: 10px;
  padding: 4px 2px 8px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
}

.visited-products-carousel::-webkit-scrollbar {
  height: 6px;
}

.visited-products-carousel::-webkit-scrollbar-thumb {
  background: #c5d0e0;
  border-radius: 999px;
}

.visited-product-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  background: #fff;
  border: 1px solid #e3e9f1;
  border-radius: 10px;
  padding: 8px;
  box-sizing: border-box;
  flex: 0 0 calc((100% - 40px) / 5);
  width: calc((100% - 40px) / 5);
  min-width: 140px;
  scroll-snap-align: start;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.visited-product-card:hover {
  border-color: #c9d7ee;
  box-shadow: 0 4px 12px rgba(31, 63, 120, 0.08);
}

.visited-product-card--in-order {
  border-color: #7ad9b4;
  background: linear-gradient(180deg, #f4fcf8 0%, #eefaf4 100%);
}

.visited-product-card--in-order:hover {
  border-color: #4fc99a;
}

.visited-product-card__image {
  width: 100%;
  height: 72px;
  border-radius: 8px;
  background: #f4f7fb;
  border: 1px solid #edf1f6;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.visited-product-card__image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  padding: 4px;
  box-sizing: border-box;
}

.visited-product-card__name {
  color: #152033;
  font-size: 11px;
  font-weight: 650;
  line-height: 1.3;
  text-decoration: none;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 2.6em;
}

.visited-product-card__name:hover {
  color: #2f6fed;
}

.visited-product-card__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  font-size: 10px;
  color: #5b6b7c;
  min-height: 14px;
}

.visited-product-card__price {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-top: auto;
}

.visited-product-card__price-now {
  font-size: 13px;
  font-weight: 750;
  color: #111827;
}

.visited-product-card__old {
  font-size: 10px;
  font-weight: 500;
  color: #9aa5b1;
  text-decoration: line-through;
}

.visited-product-card__btn {
  border: 0;
  background: #2f6fed;
  color: #fff;
  border-radius: 7px;
  padding: 6px 8px;
  font-size: 11px;
  font-weight: 650;
  cursor: pointer;
  white-space: nowrap;
  width: 100%;
  transition: background 0.15s ease;
}

.visited-product-card__btn:hover {
  background: #1f5bd0;
}

.visited-product-card__btn--in {
  background: #1fba86;
}

.visited-product-card__btn--in:hover {
  background: #169a6e;
}

.visited-pages-block {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e6ebf2;
}

.visited-pages-block__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 700;
  color: #3a4a5c;
}

.visited-pages-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.visited-page-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  height: 100%;
  padding: 8px 10px;
  border: 1px solid #e6ebf2;
  border-radius: 8px;
  background: #fff;
  box-sizing: border-box;
}

.visited-page-item__title {
  color: #152033;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.3;
  text-decoration: none;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  word-break: break-word;
}

.visited-page-item__title:hover {
  color: #2f6fed;
}

.visited-page-item__path {
  margin-top: auto;
  color: #7a8799;
  font-size: 10px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 1100px) {
  .visited-pages-list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .visited-product-card {
    flex-basis: calc((100% - 30px) / 4);
    width: calc((100% - 30px) / 4);
  }
}

@media (max-width: 900px) {
  .visited-pages-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .visited-product-card {
    flex-basis: calc((100% - 20px) / 3);
    width: calc((100% - 20px) / 3);
  }
}

@media (max-width: 640px) {
  .visited-product-card {
    flex-basis: calc((100% - 10px) / 2);
    width: calc((100% - 10px) / 2);
  }
}

.order-form-wrapper {
  max-width: 1160px;
  margin: 0 auto;
}

/* Компактное оформление полей адреса */
.address-details-compact {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.address-details-compact .input-group {
  flex: 0 0 calc(50% - 60px) !important;
  float: none !important;
}

/* Стили для чекбокса "Не менять" в платежах */
.payment-fixed-checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
}

.payment-fixed-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  flex-shrink: 0;
}

.payment-fixed-checkbox span {
  font-size: 14px;
  line-height: 1.4;
}

.pomoshch-ii-group {
  align-items: flex-start;
}

.pomoshch-ii-wrap {
  position: relative;
  max-width: 463px;
  width: 100%;
  flex: 1;
  min-width: 0;
}

.pomoshch-ii-field {
  height: auto !important;
  min-height: 100px;
  padding: 32px 10px 10px;
  line-height: 1.4;
  resize: vertical;
  box-sizing: border-box;
}

.pomoshch-ii-ai-btn {
  border: none;
  border-radius: 6px;
  padding: 5px 10px;
  background: #005eeb;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 94, 235, 0.25);
  transition: background 0.15s ease;
}

.pomoshch-ii-ai-btn:hover {
  background: #0049c2;
}

.order-list-with-client {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
}

.order-list-with-client__main {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

.order-client-side {
  width: 100%;
  order: -1;
}

.order-client-side__card {
  background: #f7f9fc;
  border: 1px solid #e3e8f0;
  border-radius: 10px;
  padding: 12px 14px;
  box-shadow: 0 1px 2px rgba(21, 32, 51, 0.04);
}

.order-client-side__head {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6b7a90;
  margin-bottom: 10px;
}

.order-client-side__grid {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 8px 4px;
}

.order-client-side__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 110px;
  max-width: 220px;
  padding: 6px 10px;
  border-radius: 6px;
}

.order-client-side__item--name {
  min-width: 120px;
}

.order-client-side__item--wide {
  max-width: 320px;
  flex: 1 1 200px;
}

.order-client-side__item--accent {
  background: #fff8e8;
}

.order-client-side__name {
  font-size: 15px;
  font-weight: 700;
  color: #152033;
  line-height: 1.3;
  word-break: break-word;
}

.order-client-side__name a {
  color: #005eeb;
  text-decoration: none;
}

.order-client-side__name a:hover {
  text-decoration: underline;
}

.order-client-side__label {
  color: #7a8799;
  font-size: 11px;
  line-height: 1.2;
}

.order-client-side__value {
  color: #152033;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
  word-break: break-word;
}

.order-client-side__value--phone {
  color: #005eeb;
  cursor: pointer;
}

.order-client-side__code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  letter-spacing: 0.04em;
}

.order-client-side__footer {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e8edf5;
}

.order-client-side__comment {
  flex: 1 1 auto;
  min-width: 0;
}

.order-client-side__comment-text {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.4;
  color: #3a4a5c;
  max-height: 72px;
  overflow: auto;
  white-space: pre-wrap;
}

.order-client-side__history-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #d5deeb;
  background: #fff;
  color: #152033;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.order-client-side__history-btn:hover {
  border-color: #005eeb;
  color: #005eeb;
}

.order-client-side__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #005eeb;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

@media (max-width: 900px) {
  .order-client-side__item {
    min-width: calc(50% - 8px);
    max-width: none;
  }

  .order-client-side__footer {
    flex-direction: column;
  }

  .order-client-side__history-btn {
    width: 100%;
  }
}

.wb-fulfill-panel {
  margin-top: 12px;
  padding: 12px;
  border: 1px solid #d6e4f5;
  border-radius: 8px;
  background: #f7fbff;
}
.wb-fulfill-hint {
  display: inline-block;
  margin-left: 8px;
  font-size: 12px;
  color: #5a6b7d;
}
.wb-fulfill-docs__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  margin: 8px 0;
}
.wb-fulfill-vg {
  font-size: 13px;
  margin-bottom: 8px;
}
.wb-fulfill-block {
  margin-bottom: 12px;
}
.wb-fulfill-block__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 6px;
}
.wb-fulfill-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.wb-fulfill-item {
  width: 120px;
  text-align: center;
}
.wb-fulfill-item img {
  width: 120px;
  height: 80px;
  object-fit: contain;
  background: #fff;
  border: 1px solid #dde5ef;
}
.wb-fulfill-cap {
  font-size: 11px;
  color: #445;
  margin-top: 2px;
}
.wb-fulfill-empty {
  font-size: 12px;
  color: #7a8796;
}

</style>